import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild,
  Renderer2,
  ChangeDetectorRef,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { TaskCloudCalendarHeaderComponent } from './task-cloud-calendar-header.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import {
  interval,
  from,
  map,
  mergeMap,
  shareReplay,
  toArray,
  Observable,
  of,
  startWith,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  firstValueFrom,
  take,
  timeout,
  catchError,
  forkJoin,
} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CollectionPopupComponent } from '../shared/collection-popup/collection-popup.component';
import { MatRadioChange } from '@angular/material/radio';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { CountrycheckComponent } from '../taskcost/countrycheck/countrycheck.component';
import { ConfirmDialog } from '../taskcost/confirmdialog';
import { ThemeService } from 'src/app/services/theme.service';
import { DatePipe, Location } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';
import { PopupService } from 'src/app/services/popup.service';
import { WarningPopup } from '../shared/warning-popup/warning-popup';
import * as JSZip from 'jszip';
import * as toGeoJSON from 'togeojson';
import { OpenconfirmwarningComponent } from '../newtask/openconfirmwarning/openconfirmwarning.component';
var turf = require('@turf/turf');
var geoParse = require('wellknown');
import { baseLayers, overlays } from '../../config/baseLayer';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-arrowheads';
import 'leaflet-geometryutil';
import 'leaflet-polylinedecorator';
import { MatExpansionPanel } from '@angular/material/expansion';
import { BudgetpopupComponent } from '../newtask/budgetpopup/budgetpopup.component';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { UserService } from 'src/app/services/user.service';
import { OperatorPopupComponent } from '../taskcost/operator-popup/operator-popup.component';
import {
  MAX_RF_COLLECTION,
  MIN_RF_COLLECTION,
  OUTCOME_BASED_WORKFLOW,
  OPERATORS,
  feedsConfig,
  PIXXEL_RADIUS,
  SENTINEL_AGREEMENT_FEED_IDS,
  RF_RADIUS,
  TLE_BASED_TASKING_WORKFLOW,
  TIP_CUE_WORKFLOW,
  CHANGE_DETECTION_WORKFLOW,
  USER,
  DISPLAYORDER,
  DAYS_OF_WEEK,
} from 'src/app/services/constants';
import { TaskcostSensorPreviewComponent } from '../shared/data-preview-component/taskcost-sensor-preview/taskcost-sensor-preview.component';
import { TaskcostComponent } from '../taskcost/taskcost.component';
import { FilterPopupComponent } from '../collections/filter-popup/filter-popup.component';
import { MapLocationDialogComponent } from '../shared/map-location-dialog/map-location-dialog.component';
import { ConfirmPopupComponent } from '../shared/confirm-popup/confirm-popup.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HelperService } from 'src/app/services/helper.service';
import { MgrsHelperService } from 'src/app/services/mgrs-helper.service';
import { STRINGCONSTANTS } from 'src/app/shared/constants/app-strings.constants';
import { SENSOR_RESOLUTION_WARNING_MESSAGES } from 'src/app/shared/constants/sensor-resolution-warning-messages';
import { WARNING_MESSAGES } from 'src/app/shared/constants/warning-popup-message';
import { buildRecurringWeekDates } from 'src/app/shared/utils/recurring-week-dates.util';
import { isUmbraScanMode } from 'src/app/components/shared/utils/umbra-scan';
import { calculateArea } from 'src/app/services/geo-area.helper';
import { SharedDataService } from '../shared/shared-data-service';
import { MatSelect } from '@angular/material/select';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { QuestionsData } from 'src/app/shared/models/task-model';
import { QuestionItem } from 'src/app/shared/models/task-model';
import { allowedValueValidator } from 'src/app/shared/validator/check-question-validity.validator';
import {
  FeedGeojsonUploadDialogComponent,
  FeedGeojsonUploadResult,
} from './feed-geojson-upload-dialog/feed-geojson-upload-dialog.component';
import { FeedSentinelAgreementDialogComponent } from './feed-sentinel-agreement-dialog/feed-sentinel-agreement-dialog.component';
import { TleHelperService } from 'src/app/services/tle-helper.service';

import { LocalTimePickerDialogComponent } from '../shared/local-time-picker-dialog/local-time-picker-dialog.component';
import {
  buildLeafletTaskStripPreview,
  createLeafletTaskStripState,
  isLeafletTaskStripAvailable,
  LEAFLET_TASK_STRIP_SWATH_KM,
  LeafletTaskStripPreview,
  LeafletTaskStripState,
} from './leaflet-task-strip.utils';
export interface ProjectModel {
  project: string;
  _id: number;
  customerid: any;
}

interface CloudCoverItem {
  date: string;
  cloudcover: number;
  icon?: string;
  description?: string;
}

interface HourlyCloudCoverItem {
  datetime: string;
  time: string;
  cloudcover: number;
}

interface TlePassSelection {
  id: string;
  satelliteName: string;
  requestName: string;
  noradId: string;
  sensorIds?: Array<string | number>;
  operatorKey: string;
  passOrder: number;
  timestamp: string;
  distanceKm: number;
  lineColor: string;
  swathWidthKm: number;
  onaDegrees: number;
  selected: boolean;
  path?: L.LatLngTuple[];
  layer?: L.Polyline | L.CircleMarker;
  layers?: Array<L.Polyline | L.CircleMarker>;
  labelLayer?: L.Marker;
  previewPass?: string;
  obfuscateName?: string | null;
  resolutionOptions?: TlePassResolutionOption[];
  selectedResolution?: TlePassResolutionOption | null;
  selectedResolutionValue?: string | number | null;
  resolutionLoading?: boolean;
  resolutionError?: string | null;
  resolutionLoaded?: boolean;
  previewOnly?: boolean;
}

interface TlePreviewPassCandidate {
  satelliteName: string;
  requestName: string;
  noradId: string;
  sensorIds: Array<string | number>;
  operatorKey: string;
  satellitePassKey: string;
  lineColor: string;
  captureWidthKm: number | null;
  passGroup: Array<{ point: L.LatLngTuple; timeStamp?: string }>;
  displaySegments: TleDisplaySegment[];
  passDistance: number;
  passTimestamp: string;
  passTimeValue: number;
  obfuscateName?: string | null;
  fallbackTime?: string;
}

interface TleTargetHoverEntry {
  sensorName: string;
  displayName: string;
  passOrder: number;
  timestamp: string;
  name: string;
  noradId: string;
  sensorIds: Array<string | number>;
  operatorKey: string;
  distanceKm: number;
  obfuscateName?: string | null;
}

interface TleNearestFallbackPreviewContext {
  satelliteName: string;
  requestName: string;
  noradId: string;
  sensorIds: Array<string | number>;
  operatorKey: string;
  satellitePassKey: string;
  lineColor: string;
  passTimestamp: string;
  passTimeValue: number;
  passDistance: number;
  obfuscateName?: string | null;
}

interface TleLocationOption {
  id: string | number;
  name: string;
  latitude: number;
  longitude: number;
  noraid?: string | number | null;
  description?: string | null;
}

interface TleParentLocationOption {
  id: string | number;
  name: string;
  subLocations: TleLocationOption[];
}

interface TlePassResolutionOption {
  value: string | number;
  label: string;
  raw: any;
}

interface TleDisplaySegment {
  points: L.LatLngTuple[];
  trackPoints: Array<{ point: L.LatLngTuple; timeStamp?: string }>;
}

interface TlePassSelection {
  id: string;
  satelliteName: string;
  requestName: string;
  noradId: string;
  sensorIds?: Array<string | number>;
  operatorKey: string;
  passOrder: number;
  timestamp: string;
  distanceKm: number;
  lineColor: string;
  swathWidthKm: number;
  onaDegrees: number;
  selected: boolean;
  path?: L.LatLngTuple[];
  layer?: L.Polyline | L.CircleMarker;
  layers?: Array<L.Polyline | L.CircleMarker>;
  labelLayer?: L.Marker;
  previewPass?: string;
  obfuscateName?: string | null;
  resolutionOptions?: TlePassResolutionOption[];
  selectedResolution?: TlePassResolutionOption | null;
  selectedResolutionValue?: string | number | null;
  resolutionLoading?: boolean;
  resolutionError?: string | null;
  resolutionLoaded?: boolean;
  previewOnly?: boolean;
}

interface TlePreviewPassCandidate {
  satelliteName: string;
  requestName: string;
  noradId: string;
  sensorIds: Array<string | number>;
  operatorKey: string;
  satellitePassKey: string;
  lineColor: string;
  captureWidthKm: number | null;
  passGroup: Array<{ point: L.LatLngTuple; timeStamp?: string }>;
  displaySegments: TleDisplaySegment[];
  passDistance: number;
  passTimestamp: string;
  passTimeValue: number;
  obfuscateName?: string | null;
  fallbackTime?: string;
}

interface TleTargetHoverEntry {
  sensorName: string;
  displayName: string;
  passOrder: number;
  timestamp: string;
  name: string;
  noradId: string;
  sensorIds: Array<string | number>;
  operatorKey: string;
  distanceKm: number;
  obfuscateName?: string | null;
}

interface TleNearestFallbackPreviewContext {
  satelliteName: string;
  requestName: string;
  noradId: string;
  sensorIds: Array<string | number>;
  operatorKey: string;
  satellitePassKey: string;
  lineColor: string;
  passTimestamp: string;
  passTimeValue: number;
  passDistance: number;
  obfuscateName?: string | null;
}

const normalizeOperatorKey = (value: any): string =>
  String(value ?? '').replace(/\s+/g, '').toLowerCase();

@Component({
  selector: 'app-leaflet-task',
  templateUrl: './leaflet-task.component.html',
  styleUrls: ['./leaflet-task.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class LeafletTaskComponent implements OnInit, OnDestroy {
  private map: L.Map;
  private readonly tleHelperService = new TleHelperService();

  @Input() target: any = { geoJSON: '', area: 0 };
  @Input() accept = '.topojson, .geojson, .kml';
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('llInput') llInput: ElementRef;
  @ViewChild('taskingPanel') taskingPanel?: MatExpansionPanel;
  @ViewChild('cloudPanel') cloudPanel: MatExpansionPanel;
  @ViewChild('sensorPanel') sensorPanel!: MatExpansionPanel;
  @ViewChild('outcomePanel') outcomePanel?: MatExpansionPanel;
  @ViewChild('sensorList') sensorList!: TaskcostComponent;
  @ViewChild('tqSensorList') tqSensorList!: TaskcostComponent;
  @ViewChild('signalSelect') signalSelect: MatSelect;
  private rfSignalSelectOriginalClose: (() => void) | null = null;
  isBroRFSelected: boolean;
  drawingMode = '';
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  jumpLocation: any;
  locationInvalid = true;
  keyIn = false;
  dateFlag = false;
  tleRangeError = false;
  tleStartRangeError = false;
  tleToiError = false;
  isFirst = true;
  showAllCoordinates = false;
  isUploadedAOI = false;
  accuracy = 15;
  jsonData = '';
  fileAttr = 'Choose File';
  acceptFile = '.topojson, .geojson, .kml';
  MYENTITY;
  drawingOn = false; // AT21 = false; satllogic = false;
  viewer: any;
  scene: any = null;
  longLatStr: string = '';
  latlonOverlay = document.createElement('div');
  satEntity;
  datafile: any;
  imgUrls: any;
  dataForm: FormGroup | any;
  options: any;
  compassOverlay: any;
  currentUser: any;
  projName: any;
  taskName: any;
  mapLoading: boolean = false;
  taskTarget: any;
  frequency: any;
  taskArea: 0;
  formGroup: any = FormGroup;
  tleSensor: {
    resolution: { key: string; name: string }[];
    sensor: { sensorName: string; obfuscateName: string; sensorId: string }[];
  } = {
    resolution: [],
    sensor: [],
  };
  tleSensorForm: any = FormGroup;
  readonly tleMaxMinutesAhead: number = 4320;
  showtleClick: boolean = false;
  showtleDisabled: boolean = false;
  taskparams: any;
  date: any;
  readonly specificDayOptions = DAYS_OF_WEEK;
  readonly specificDayOptionDisabled = (day: string) =>
    this.isSpecificDayDisabled(day);
  proceed = false;
  frequencyOption = [
    { id: 0, name: 'Specific Date', selected: true },
    { id: 1, name: 'Recurrent', selected: false },
    { id: 2, name: 'Period', selected: false },
    { id: 3, name: 'Specific Day', selected: false },
  ];

  selectedOption = 0;
  freqOption = 'Daily';
  showResults = false;
  cloudCoverByDate = new Map<string, CloudCoverItem>();
  readonly cloudCoverCalendarHeader = TaskCloudCalendarHeaderComponent;
  eligibleWeekDays = new Set<number>();
  cloudCoverLoading = false;
  cloudCoverLoadError = false;
  private cloudCoverRequestKey = '';
  private cloudCoverSubscription?: Subscription;
  private cloudCoverForecastCache = new Map<string, Observable<Map<string, CloudCoverItem>>>();

  cloudCoverDateClass = (date: Date, view: string) => this.getCloudCoverDateClass(date, view);
  readonly cloudCoverDayTooltip = (day: string) =>
    this.target?.geoJSON && this.eligibleWeekDays.has(this.specificDayOptions.indexOf(day))
      ? 'Cloud cover below 20% at every hour from 6 AM through 6 PM (target local time) for all targets on this day in the current week.'
      : '';
  DateRange = 30;
  monthRange = 13;
  minDate: Date | null;
  maxDate: Date | null;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  defaultWindow = 30; //30 days
  sensors: any = this.apiService.selectSensors;
  TASKFREQUENCY: any;
  purposeOption: any;
  intentOption: any;
  useCaseOption: any;
  strategyOptions: any;
  selectedSensorTypes: any;
  allComplete: boolean = false;
  state: any;
  showSensors = false;
  tasking: FormGroup;
  panelOpenState = true;
  isExpanded = true;
  taskid: any;
  retaskTaskId: any;
  retaskSensorId: any;
  retaskOption: any;
  sendParentTaskId: boolean = false;
  coordinates: string;
  ph: string;
  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  taskMap: any;
  chkNum = 0;
  dailyCount: any;
  todayDate: Date;
  clickFrequency: boolean = false;
  others: boolean = false;
  description: any;
  purposeTask: any;
  fortnightlyRangeError = false;
  changeDetectionToiRangeError = false;
  private lastChangeDetectionToiWarningKey: string | null = null;
  projectData: ProjectModel[] = [];
  filteredProjects: Observable<ProjectModel[]>;
  readonly tleParentLocationControl = new FormControl<TleParentLocationOption | null>(null, Validators.required);
  readonly tleSubLocationControl = new FormControl<TleLocationOption | null>(null, Validators.required);
  tleParentLocationOptions: TleParentLocationOption[] = [];
  tleSubLocationOptions: TleLocationOption[] = [];
  selectedTleLocation: TleLocationOption | null = null;
  buttonDisable: boolean = false;
  callCounter: any = 0;
  satellites: any[] = [];
  satelliteEntity: any;
  entityValues: any;
  orbitalPath: any;
  randomColor: string;
  subDaily: boolean = false;
  taskStrategy: any;
  tipAndCueBasedOn: string;
  smallBoatToiWarningOpen = false;
  tipAndCueEndSelectedByUser = false;
  observationSection: boolean = false;
  observationOptions: any;
  rulesOptions: any;
  observations: any;
  ruleBased: any;
  parentVal: any;
  observation: any;
  rule: any;
  observationData: any;
  pointArray: any[] = [];
  pointEntities: any[] = [];
  isDrawingEnabled: boolean = false;
  retask: boolean;
  selectedTasks: any;
  polygons: number[][][] = [];
  weatherData: any = [];
  cloudclicked: boolean;
  outComeForm: any = FormGroup;
  SensorsTypes: any = [];
  demoView: boolean = false;
  outComesensor: any;
  outComeError: boolean = true;
  isOutcomeSarSensor: boolean = false;
  expectedAge: any;
  filteredSensorTypes: any[];
  allocatedSensorTypes: Set<string> = new Set();
  outComeSubmit: boolean = false;
  darkTheme: boolean;
  tooltipImagePath: string;
  isInIframe: boolean;
  isChecked: boolean = false;
  hourly: boolean = true;
  timeError: number;
  isPast: boolean = false;
  measurmentTooltipEntities: any[] = [];
  measurmentEntities: any[] = [];
  entityId = '';
  drawStarted = false;
  drawCompleted = false;
  isSearched = false;
  pinDisable: boolean = false;
  handler: any;
  restrictedUser: boolean = false;
  shapeSelected: boolean = false;
  lattitude = 41.2;
  longitude = 74.66;
  marker: any;
  isEndPast: boolean = false;
  budget: boolean;
  selectedSensorObfuscatedName: any;
  budgetForm: any = FormGroup;
  budgetInputs: any = {
    resolutionArr: [],
    cloudCoverKeys: [],
    holdbackArr: [],
    tierArr: [],
    rfSignals: [],
    rawIQData: false,
  };
  showResolution: boolean = true;
  selectedCategory: string;
  cloudCoverOptions: string[] = [];
  resolutionOptions: string[] = [];
  taskingTierOptions: string[] = [];
  rfSignalOptions: any[] = [];
  rfCollectionOptions: any[] = [];
  holdBackOptions: string[] = [];
  budgetSensorType: any;
  selectedFrequencyID: number;
  currentLocalTime: string;
  tleSubmit: boolean = false;
  updateFrequencyOption: boolean = false;
  signalOfInterest: boolean = false;
  rfSelectedSignals: any[] = [];
  audioSelections: any[] = [];
  taskableGroup = L.featureGroup();
  satTrackingClicked: boolean = false;
  private nearestTlePassTimestamp: string | null = null;
  private tleTargetHoverEntries: TleTargetHoverEntry[] = [];
  private tleTargetHoverCloseTimeout: ReturnType<typeof setTimeout> | null =
    null;
  tleAvailablePasses: TlePassSelection[] = [];
  tleSelectedPasses: TlePassSelection[] = [];
  tlePreviewOnlyMode: boolean = false;
  showTlePreviewBanner: boolean = true;
  private tleNearestFallbackPending: boolean = false;
  private tleNearestFallbackPreviewContext: TleNearestFallbackPreviewContext | null = null;
  userDetails: any;
  isFeedTask: boolean = false;
  insightsList: string[] = [];
  filteredInsights: QuestionItem[] = [];
  selectedFeed: any = null;
  isSatelliteFetchLoading: boolean = false;
  private timeSubscription: Subscription;
  private satelliteDataSubscription: Subscription | null = null;
  private satelliteDataRequestId = 0;
  private satLayer: L.LayerGroup | null = null;
  private markersAndDivs: Array<{ div: HTMLDivElement; layer: L.Marker }> = [];
  private numberBadgeMarkers: L.Marker[] = [];
  private numberPaneCreated = false;
  private satRenderer?: L.SVG;
  private satellitePaneSyncBound = false;
  private destroy$ = new Subject<void>();
  questionsData: QuestionItem[] = [];
  isFeedTaskSubmitted: boolean = false;
  showPreview: boolean = false;
  nearestPointCoordinate: { lat: number; lng: number } | null = null;
  private lastTargetGeoJSON: string | null = null;
  private hadSelectedTarget = false;
  private tleSwathRadiusKm: number | null = null;
  private tleSwathCircle: L.Circle | null = null;
  private tleSwathWarningOpen = false;

  taskPoint: number = 0;
  totalTaskNumber: number = 0;
  layerData: any;
  subStrategyOptions: any[] = [
    {
      name: 'Tip and cue with user-picked sensors',

      value: 'Tip-and-Cue',

      description:
        'Users configure two sensor types in sequenced tasking and make the required sensor choices. ',
    },

    {
      name: 'Tip and cue automated',

      value: 'Tip-and-Cue-Outcome',

      description:
        'Users configure two sensor types in sequenced tasking, and the platform chooses the sensors. ',
    },
  ];

  subStrategy: any;

  sensorTypesTipnCue: any[] = [
    {
      name: 'MSI',

      value: 'MSI',
    },

    {
      name: 'SAR',

      value: 'SAR',
    },

    {
      name: 'AIS',

      value: 'AIS',
    },
  ];
  tipCueWorkflow = TIP_CUE_WORKFLOW;
  outcomeBasedWorkflow = OUTCOME_BASED_WORKFLOW;
  tleBasedTaskingWorkflow = TLE_BASED_TASKING_WORKFLOW;
  changeDetectionWorkflow = CHANGE_DETECTION_WORKFLOW;
  subUser = USER;
  isDrawControlClicked = false;
  updateFrequencies: any[] = [...(this.apiService.updateFrequencies || [])];
  weatherResolutionOptions: any[] = [];
  weatherVariableOptions: any[] = [];
  weatherVariableTooltipFn = (option: any): string => option?.description ?? '';
  private allocatedAisOperators: Set<string> = new Set();
  private aisAllocationFetched: boolean = false;
  outcomePopUpData: any = {};
  rfCircleLayer: any[] = [];
  invalidForm: boolean = true;

  cueingSensorResolution: any;

  tippingSensorResolution: any;

  cueingSensorCloudCover: any;

  tippingSensorCloudCover: any;

  feeds: any;

  feedList: any;
  userTimezone: string;
  userid: any;
  updatedIntentOption = false;
  duplicateDetected: boolean = false;
  imagingSensor: string = STRINGCONSTANTS.IMAGING_SENSOR;
  nonImagingSensor = STRINGCONSTANTS.NON_IMAGING_SENSOR;
  recurrentDays: boolean = false;
  specificDay: any;

  @ViewChild('map', { static: true }) mapContainer!: ElementRef;

  @ViewChild('fullscreenDiv', { static: false }) fullscreenDiv!: ElementRef;

  toggleFullscreen() {
    const elem = this.mapContainer.nativeElement;

    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen().then(() => {
          this.map.invalidateSize(); // Ensure map resizes correctly
        });
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.map.invalidateSize(); // Resize map back to original size
        });
      }
    }
  }

  isFullscreen = false;
  onFullscreenChange() {
    this.isFullscreen = !!document.fullscreenElement;
    this.map.invalidateSize(); // Ensure the map resizes correctly
  }

  private drawControl!: any;
  private drawnItems = new L.FeatureGroup();
  private drawTooltip: HTMLDivElement | null = null;
  private isFirstVertexPlaced = false;

  private selectedDrawControl: any = '';

  private geoJsonLayer: any;
  private tirLayer: L.GeoJSON | null = null;
  private searchMarker: any = null;
  private satelliteLayerGroup: L.LayerGroup | null = null;
  private satelliteMarkers: L.Marker[] = [];
  private satelliteSegments: L.Polyline[] = [];

  isResetClicked = false;
  isDrawStarted = false;
  startPoint: any;
  lastDrawingLatLng: L.LatLng | null = null;
  lastVertexAdditionTime: number = 0;
  private readonly polygonPolylineDoubleClickThresholdMs = 300;
  private readonly duplicateVertexDistanceMeters = 1;
  private polygonPolylinePatchedHandler: any = null;
  zoomLevel = 3;
  mapDistance = 0;

  latLngDMS = '';
  private searchedAoiDMS: string | null = null;
  position: any;

  eventLayers: any[] = [];
  controlOrder = [
    'target',
    'intent',
    'frequency',
    'date',
    'sensorType',
    'updateFrequency',
    'rfSignals',
    'rawIQData',
    'taskingTier',
    'start',
    'end',
    'endTime',
    'startTime',
  ];
  selectedSignals: any = [];
  selectedDisplay: any = '';
  aisType = 'AIS';
  weatherType = 'Weather';
  rfType = 'RF';
  prevValue: any;
  minRFCollection: number = MIN_RF_COLLECTION;
  maxRFCollection: number = MAX_RF_COLLECTION;
  RFCollections: number[] = [];
  suppressDrawCancel = false;
  readonly stripSwathKm = LEAFLET_TASK_STRIP_SWATH_KM;
  stripState: LeafletTaskStripState = createLeafletTaskStripState();
  private stripPreviewLayer: L.Polygon | null = null;
  intentPanelOpen = false;
  tirEnabled = false;
  tirSensorLabel: string | null = null;
  private intentPanelAutoOpened = false;

   // Tip-and-Cue eligibility for allocated users
  tipAndCueEligible: boolean = false;
  tipAndCueEligibilityChecked: boolean = false;
  hasTippingSensors: boolean = false;
  hasCueingSensors: boolean = false;

  // Sensor category eligibility for budget mode
  hasImagingSensors: boolean = false;
  hasNonImagingSensors: boolean = false;
  sensorCategoryCheckLoading: boolean = false;

  displayQuestion = (item: QuestionItem): string => {
    return item ? item.question : '';
  };
  constructor(
    private el: ElementRef,
    private apiService: ApiService,
    public dialog: MatDialog,
    private http: HttpClient,
    private route: ActivatedRoute,
    private dataService: DataService,
    private renderer: Renderer2,
    private themeService: ThemeService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private utilsService: UtilsService,
    private userService: UserService,
    private popupService: PopupService,
    private spinnerService: NgxSpinnerService,
    private changDetectionRef: ChangeDetectorRef,
    private router: Router,
    private helperService: HelperService,
    private sharedDataService: SharedDataService,
    private cdr: ChangeDetectorRef,
    private location: Location,
    private mgrsHelperService: MgrsHelperService,
  ) {
    this.isInIframe = this.themeService.isInIframe();
    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
      this.tooltipImagePath = this.darkTheme
        ? '../../../assets/images/union-dark.svg'
        : '../../../assets/images/union.svg';
    });
    if (environment.demoView === 'true') {
      this.demoView = true;
    } else {
      this.demoView = false;
    }
    this.retask = false;
    this.budget = false;
    if (this.route.snapshot.url.join('/').includes('retask')) {
      this.retask = true;
      this.retaskTaskId = this.route.snapshot.queryParamMap.get('taskId');
      this.retaskSensorId = this.route.snapshot.queryParamMap.get('sensorId');
      this.retaskOption = this.route.snapshot.queryParamMap.get('option');
    } else {
      this.retask = false;
    }
    this.target['isRetask']= this.retask;
    if (this.route.snapshot.url.join('/').includes('newbudget')) {
      this.budget = true;
    } else {
      this.budget = false;
    }

    if (!this.ph) {
      this.ph = 'init';
    }
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });

    this.formGroup = new FormGroup({
      project: new FormControl(this.projName, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(25),
      ]),
      taskname: new FormControl(this.taskName, [
        Validators.required,
        Validators.minLength(5),
      ]),
      strategyRadio: new FormControl('', [Validators.required]),
      tipAndCueBasedOn: new FormControl(this.tipAndCueBasedOn),
      description: new FormControl(this.description, [
        Validators.maxLength(50),
      ]),
      target: new FormControl({ value: null, disabled: true }, [
        Validators.required,
      ]),
      feeds: new FormControl(this.feeds),
      observation: new FormControl(this.observation),
      observationData: new FormControl(this.observationData),
      rule: new FormControl(this.rule),
      purpose: new FormControl(this.purposeTask, [Validators.required]),
      frequency: new FormControl(this.frequency, [Validators.required]),
      jumplocation: new FormControl(this.jumpLocation),
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
      projectId: new FormControl(''),
      intent: new FormControl('', [Validators.required]),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      useCase: new FormControl(''),
      subStrategyRadio: new FormControl('', [Validators.required]),
      useCaseDescription: new FormControl('', [Validators.maxLength(50)]),
      specificDay: new FormControl(''),
      searchControl: new FormControl(''),
      priority: new FormControl('fastest'),
    });

    this.updateFormControls(this.taskStrategy);
    // Add the subscription to strategyRadio changes

    this.formGroup.get('strategyRadio').valueChanges.subscribe((strategy) => {
      if (strategy === 'Tip-and-Cue') {
        // Set Validators for subStrategyRadio if the strategy is 'Tip-and-Cue'

        this.formGroup
          .get('subStrategyRadio')
          .setValidators([Validators.required]);
      } else {
        // Clear Validators if the strategy is anything else

        this.formGroup.get('subStrategyRadio').clearValidators();
      }

      // Update the validity after changing validators

      this.formGroup.get('subStrategyRadio').updateValueAndValidity();
    });
    this.formGroup.get('strategyRadio')?.valueChanges.subscribe((strategy) => {
      const intentControl = this.formGroup.get('intent');
      if (strategy === 'Outcome By Platform') {
        intentControl.clearValidators();
        intentControl.updateValueAndValidity();
      }
      this.updateFormControls(strategy);
    });

    this.authService.user.subscribe((user) => (this.currentUser = user));
    this.userid = this.currentUser.id;
    this.loadUserDetails(this.userid);
    this.outComeForm = new FormGroup({
      tipAndCueBasedOn: new FormControl('Observation'),
      sensorType: new FormControl(),
      resolution: new FormControl(),
      intent: new FormControl(),
      cloudCover: new FormControl(),
      latency: new FormControl('', [
        Validators.required,
        Validators.min(24),
        Validators.pattern(/^[0-9]\d*$/),
      ]),
      budget: new FormControl('', [
        Validators.required,
        Validators.min(
          this.currentUser?.pointsEligible ? this.convertToPoints(150) : 150
        ),
        Validators.pattern(/^[0-9]\d*(\.\d+)?$/),
      ]),
      tippingSensorType: new FormControl(),

      cueingSensorType: new FormControl(),

      observation: new FormControl(),

      rule: new FormControl(),

      observationData: new FormControl(),

      tippingSensorResolution: new FormControl(),

      cueingSensorResolution: new FormControl(),
      updateFrequency: new FormControl(),
      tippingCloudCover: new FormControl(),

      cueingCloudCover: new FormControl(),
    });

    this.budgetForm = new FormGroup({
      target: new FormControl({ value: null, disabled: true }, [
        Validators.required,
      ]),
      frequency: new FormControl(this.frequency, [Validators.required]),
      specificDay: new FormControl(''),
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      resolution: new FormControl(''),
      taskingTier: new FormControl(''),
      cloudCover: new FormControl(''),
      holdBack: new FormControl(''),
      sensorType: new FormControl('', [Validators.required]),
      intent: new FormControl('', [Validators.required]),
      sensorCategory: new FormControl(this.imagingSensor, [
        Validators.required,
      ]),
      updateFrequency: new FormControl(),
      weatherResolution: new FormControl(''),
      weatherVariables: new FormControl([]),
      rfSignals: new FormControl([]),
      rawIQData: new FormControl(false),
    });
    this.tleSensorForm = new FormGroup({
      scenario: new FormControl('T-Mins Ahead', [Validators.required]),
      minutesAhead: new FormControl(90, [
        Validators.required,
        Validators.min(90),
        Validators.max(this.tleMaxMinutesAhead),
      ]),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
    });

    this.selectedCategory = this.budgetForm.get('sensorCategory')?.value;
    this.outComeForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldEmpty()) {
        this.outComeError = true;
      } else {
        this.outComeError = false;
      }
    });
    this.outComeForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldNull()) {
        this.invalidForm = true;
      } else {
        this.invalidForm = false;
      }
    });

    this.getProjects();
    this.filteredProjects = this.formGroup.get('project').valueChanges.pipe(
      startWith(null),
      map((data: string) =>
        data ? this._filter(data) : this.projectData.slice()
      )
    );

    this.setUTCTodayDate();
  }

  getProjects() {
    this.apiService.getProjects().subscribe((res: any) => {
      this.projectData = res.result;
    });
  }

  private _filter(value: string): ProjectModel[] {
    const filterValue = value.toString().toLocaleLowerCase();
    return this.projectData.filter(
      (data) => data.project?.toLocaleLowerCase().indexOf(filterValue) === 0
    );
  }

  setProjectid(value) {
    this.formGroup.controls.projectId.setValue(value._id);
    this.target.projectId = value._id;
    this.projName = value.project;
    this.updateTarget(this.target, '0');
  }

  updateFormControls(taskStrategy: string): void {
    const useCaseControl = this.formGroup.get('useCase');
    if (taskStrategy === 'Help Select Sensor(s)') {
      useCaseControl?.setValidators(Validators.required);
    } else {
      useCaseControl?.clearValidators();
    }
    useCaseControl?.updateValueAndValidity();
  }

  mapFontColor = 'white';

  async ngOnInit() {
    this.TASKFREQUENCY = this.apiService.TASKFREQUENCY;
    this.purposeOption = this.apiService.purposeOption;
    this.isFeedTask = this.route.snapshot.queryParamMap.get('mode')?this.route.snapshot.queryParamMap.get('mode') === 'feed' : false;
    if (this.isFeedTask) {
    this.formGroup.get('searchControl')?.setValidators([Validators.required]);
    this.formGroup.get('priority')?.setValidators([Validators.required])
    this.formGroup.get('priority')?.setValue('fastest');
    this.formGroup.get('purpose')?.clearValidators();
    this.formGroup.get('strategyRadio')?.clearValidators();
    } else {
    this.formGroup.get('searchControl')?.clearValidators();
    }
    this.formGroup.get('searchControl')?.updateValueAndValidity();
    this.formGroup.get('purpose')?.updateValueAndValidity();
    this.formGroup.get('strategyRadio')?.updateValueAndValidity();
    this.formGroup.get('priority')?.updateValueAndValidity();
    console.log('formContol', this.formGroup.controls);

    await this.loadInitialDropdownData();
    const planTaskFeatureKeys =
      this.currentUser?.planDetails?.features.map((f) => f.key) || [];
    this.strategyOptions =this.apiService.strategyOptions.filter((option) => 
      planTaskFeatureKeys.includes(option.taskStrategyFeature)
    );
    this.dailyCount = this.apiService.dailyCount;

    if (this.retask) {
      await this.loadRetaskTask();
    }

    this.filteredSensorTypes = this.SensorsTypes.filter(
      (item) => item.feasibility === true
    );
    this.timeSubscription = interval(30000).subscribe(() => {
      this.updateCurrentLocalTime();
      this.loadCloudCoverEligibility();
    });
    this.loadCloudCoverEligibility();

    this.sharedDataService.getData().subscribe((data) => {
      if (data) {
        this.userDetails = data;
      }
    });


    if(this.isFeedTask){
     this.loadInsightsList();
    }

    this.showPreview = this.route.snapshot.queryParamMap.get('preview') == 'true' ? true : false;
  }

  private async loadInitialDropdownData(): Promise<void> {

    const observationRes: any =
      await firstValueFrom(
        this.apiService.getObservations()
      );
    this.observationOptions = observationRes?.observations;

    this.rulesOptions = observationRes?.ruleBased;

    const purposeRes: any =
      await firstValueFrom(
        this.apiService.getPurpose()
      );

    this.purposeOption = this.utilsService.sortPurposeOptions(
        purposeRes?.purposeList
      );
    this.intentOption = await firstValueFrom(
        this.apiService.intentOption()
      );
  }
  

  isDarkMode = false;

  ngAfterViewInit() {
    this.initializeMap();
    this.initializeDrawingTools();
    this.setupEventListeners();
    if (this.retask) {
      this.disableEnableDrawControls(false, '');
    }

    this.dataService.darkTheme.subscribe((res: any) => {
      this.isDarkMode = res;
    });
    delete (L.Icon.Default.prototype as any)._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
      iconUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
      shadowUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    });
    this.initGeoSearchControl();
    this.handleSearchDisable();
    this.updateSearchControlDisabledState();
    if (this.retask || this.taskStrategy === 'TLE Based Tasking') {
      this.updateMapSearchAndResetControlState(true);
    }
  }
  ngAfterViewChecked(): void {
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.tleSubmit = this.shouldEnableCancelButton(
        this.target,
        this.tleSensorForm
      );
    }
  }

  get nearestTlePassDisplay(): string {
    if (!this.tleSelectedPasses.length || !this.nearestTlePassTimestamp) {
      return '';
    }

    return `${this.tleSelectedPasses.length} pass${
      this.tleSelectedPasses.length === 1 ? '' : 'es'
    } selected. First pass: ${moment.utc(this.nearestTlePassTimestamp)
      .utc()
      .format('DD MMM YYYY HH:mm [UTC]')}`;
  }

  get hasSelectedTlePasses(): boolean {
    return this.tleSelectedPasses.length > 0;
  }

  get tlePassPanelTitle(): string {
    return `Selected Passes (${this.tleSelectedPasses.length})`;
  }

  get tlePassPanelSubtitle(): string {
    return this.tlePreviewOnlyMode
      ? ''
      : 'Click any pass or orbit path on the map to add it here.';
  }

  get tlePreviewBannerTitle(): string {
    return 'Nearest Pass Preview';
  }

  get tlePreviewBannerSubtitle(): string {
    return 'Showing the nearest pass only. This preview cannot be selected for tasking.';
  }

  get tlePassPanelEmptyMessage(): string {
    return this.tlePreviewOnlyMode
      ? ''
      : 'No passes selected yet.';
  }

  private hasSelectedTlePassResolution(pass: TlePassSelection): boolean {
    return !!pass?.selectedResolution;
  }

  private hasValidSelectedTlePassResolutions(): boolean {
    return (
      this.tleSelectedPasses.length > 0 &&
      this.tleSelectedPasses.every(
        (pass) =>
          !pass.resolutionLoading &&
          !pass.resolutionError &&
          this.hasSelectedTlePassResolution(pass)
      )
    );
  }

  showTlePassResolutionValidation(pass: TlePassSelection): boolean {
    return (
      !pass?.resolutionLoading &&
      !pass?.resolutionError &&
      (pass?.resolutionOptions?.length || 0) > 1 &&
      !this.hasSelectedTlePassResolution(pass)
    );
  }

  getTlePassResolutionLabel(pass: TlePassSelection): string {
    if (!pass?.resolutionOptions?.length) {
      return '';
    }

    return pass.selectedResolution?.label || pass.resolutionOptions[0]?.label || '';
  }

  onTlePassResolutionChange(
    pass: TlePassSelection,
    resolutionOption: TlePassResolutionOption | null
  ): void {
    pass.selectedResolution = resolutionOption;
    pass.selectedResolutionValue = resolutionOption?.value ?? null;
    pass.resolutionError = null;
  }

  private loadTlePassResolutions(pass: TlePassSelection): void {
    const resolutionSensorIds = pass?.sensorIds || [];

    if (!resolutionSensorIds.length || pass.resolutionLoading) {
      return;
    }

    if (pass.resolutionLoaded) {
      return;
    }

    pass.resolutionLoading = true;
    pass.resolutionError = null;

    this.apiService
      .getTlePassResolutions(resolutionSensorIds)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const resolutionOptions = this.mapTlePassResolutionOptions(response);
          const currentSelection = pass.selectedResolutionValue;

          pass.resolutionOptions = resolutionOptions;
          pass.resolutionLoaded = true;
          pass.resolutionLoading = false;

          if (!resolutionOptions.length) {
            pass.selectedResolution = null;
            pass.selectedResolutionValue = null;
            pass.resolutionError = 'Unable to load resolutions.';
            return;
          }

          if (resolutionOptions.length === 1) {
            pass.selectedResolution = resolutionOptions[0];
            pass.selectedResolutionValue = resolutionOptions[0].value;
            return;
          }

          const matchedOption = resolutionOptions.find(
            (option) => `${option.value}` === `${currentSelection}`
          );

          pass.selectedResolution = matchedOption || null;
          pass.selectedResolutionValue = matchedOption?.value ?? null;
        },
        error: () => {
          pass.resolutionOptions = [];
          pass.selectedResolution = null;
          pass.selectedResolutionValue = null;
          pass.resolutionLoaded = false;
          pass.resolutionLoading = false;
          pass.resolutionError = 'Unable to load resolutions.';
        },
      });
  }

  private mapTlePassResolutionOptions(
    response: any
  ): TlePassResolutionOption[] {
    const rawOptions = Array.isArray(response)
      ? response
      : Array.isArray(response?.resolutions)
      ? response.resolutions
      : Array.isArray(response?.data)
      ? response.data
      : [];

    return rawOptions
      .map((option: any) => {
        const value =
          option?.value ??
          option?.resolution_value ??
          option?.resolutionValue ??
          option?.resolution ??
          option;

        if (value === null || value === undefined || `${value}`.trim() === '') {
          return null;
        }

        const label = `${value}`.trim();

        return {
          value,
          label,
          raw: option,
        };
      })
      .filter(
        (option): option is TlePassResolutionOption => option !== null
      )
      .sort((first, second) => {
        const firstValue = parseFloat(`${first.value}`);
        const secondValue = parseFloat(`${second.value}`);

        if (!Number.isNaN(firstValue) && !Number.isNaN(secondValue)) {
          return firstValue - secondValue;
        }

        return `${first.label}`.localeCompare(`${second.label}`);
      });
  }

  ngDoCheck() {
    const hasSelectedTarget = this.hasSelectedTargetValue();
    if (!hasSelectedTarget && this.hadSelectedTarget) {
      if (this.sensorPanel?.expanded) {
        this.sensorPanel.close();
      }
      if (this.outcomePanel?.expanded) {
        this.outcomePanel.close();
      }
      this.panelOpenState = false;
      this.syncTargetControlWithState();
    }
    this.hadSelectedTarget = hasSelectedTarget;

    if (
      this.selectedCategory === this.nonImagingSensor &&
      ((this.target.geoJSON != null &&
        this.target?.geoJSON !== this.prevValue) ||
        this.target.geoJSON === '')
    ) {
      this.prevValue = this.target.geoJSON;
      this.resetControlsBelow('target');
    }
  }

  ngOnDestroy(): void {
    this.cloudCoverSubscription?.unsubscribe();
    this.cloudCoverForecastCache.clear();
    this.removeDrawTooltip();
    this.clearTleTargetHoverTooltip();
    this.unbindSatellitePaneSync();
    this.map.remove();
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
    this.clearSatelliteFetchState();

    this.destroy$.next();
    this.destroy$.complete();
  }

  private async initializeMap() {
    this.map = L.map(this.mapContainer.nativeElement, {
      worldCopyJump: true,
      maxBounds: [
      [-90, -180],
      [90, 180]
      ],
      maxBoundsViscosity: 1.0,
      zoom: this.zoomLevel,
      maxZoom: 18,
      minZoom: 7,
      layers: [
        environment.enableSentinelBaseMap === 'true' && baseLayers['Sentinel']
          ? baseLayers['Sentinel']
          : baseLayers['Openstreetmap'],
      ],
      attributionControl: false,
    });

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');

    setTimeout(() => {
      this.map.invalidateSize(true);
      this.changDetectionRef.detectChanges();
    }, 300);

    L.control
      .layers(baseLayers, overlays, {
        collapsed: false, // Optionally control whether the control is collapsed by default
        position: 'topright', // Optionally set the position of the control
      })
      .addTo(this.map);

   if (!this.retask && !this.currentUser?.isTaskableAoi) {
       this.loadLocationFromNominatim();
   }

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',
      shadowSize: [41, 41],
      shadowAnchor: [12, 41],
    });

    setTimeout(() => {
      const layersControlElement = document.querySelector(
        '.leaflet-control-layers'
      );
      if (layersControlElement) {
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        container?.classList.remove('leaflet-control-layers-expanded');
      }
    }, 0);

    this.map.on('baselayerchange', (event: any) => {
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      layerBtn.classList.remove('highlight-border');
      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (container) {
        container.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      const element = document.querySelector('#homeButton');
      if (element) {
        this.renderer.setStyle(element, 'z-index', '500');
      }
      if (event.name === 'Openstreetmap') {
        this.mapFontColor = 'black';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        if (environment.enableSentinelBaseMap === 'true') {
          myAttrControl.removeAttribution(
            '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
          );
        }
        myAttrControl.addAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        const elements = document.querySelectorAll('[id^="custom-div"]');
        elements.forEach((element: any) => {
          element.style.color = this.mapFontColor;
        });
        this.map.setMinZoom(1);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 1) {
         this.map.setZoom(1);
        }
        if (this.map.getZoom() > 18) {
        this.map.setZoom(18);
      }
      if (environment.enableSentinelBaseMap === 'true' && this.map.hasLayer(baseLayers['Sentinel'])) {
       this.map.removeLayer(baseLayers['Sentinel']);
      }
      } else if (environment.enableSentinelBaseMap === 'true') {
        this.mapFontColor = 'white';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        myAttrControl.addAttribution(
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
        );
        const elements = document.querySelectorAll('[id^="custom-div"]');
        elements.forEach((element: any) => {
          element.style.color = this.mapFontColor;
        });
        this.map.setMinZoom(7);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 7) {
        this.map.setZoom(7);
        }
       if (this.map.getZoom() > 18) {
       this.map.setZoom(18);
       }
      }
    });

    this.map.createPane('left');
    this.map.createPane('right');
    this.map.on('baselayerchange', (e: any) => {
      this.map.off('layerremove');
      this.map.off('layeradd');
    });
    this.map.on('layeradd', (e: any) => {});
    this.map.on('layerremove', (e: any) => {
      this.map.off('layerremove');
    });

    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.addEventListener('click', (e) => {
        this.removeHighlight();
        let layerBtn: any = document.querySelector(
          '.leaflet-control-layers-toggle'
        );
        layerBtn.classList.add('highlight-border');
        if (document.querySelector('.leaflet-control-layers-expanded')) {
          document
            .querySelector('.leaflet-control-layers-toggle')
            ?.setAttribute('style', 'top:-48px !important');
        }

        const searchBtnParentEl = document.querySelector(
          '.leaflet-geosearch-button'
        ) as HTMLElement;
        const searchInput = document.querySelector(
          '.leaflet-geosearch-button form input'
        ) as HTMLInputElement;
        if (!searchInput.value && !searchInput.classList.contains('active')) {
          searchBtnParentEl.classList.remove('active');
        }
      });

    this.map.on('click', function () {
      //clearing search input
      const searchInput: any = document.querySelector(
        '.leaflet-control-geocoder-form input'
      );
      if (searchInput?.value) {
        searchInput.value = '';
      }

      let links = document.querySelectorAll('.leaflet-draw-toolbar span a');
      links.forEach((s: any) => s.classList.remove('highlight-border'));
      let homeBtn: any = document.querySelector('#homeButton');
      homeBtn.classList.remove('highlight-border');
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      layerBtn.classList.remove('highlight-border');
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }

      const searchBtnParentEl = document.querySelector(
        '.leaflet-geosearch-button'
      ) as HTMLElement;
      searchBtnParentEl.classList.remove('active');
    });

    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);
    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);
    this.authService.user.subscribe((user) => {
      this.currentUser = user;
      if (this.currentUser?.isTaskableAoi && !this.retask) {
        this.restrictedUser = true;
        let targetData = this.currentUser?.taskableAoi;
        let type: any, coordinates: any;
        const allTaskableAois = targetData.map((item) => item.taskableAoi);
        allTaskableAois.forEach((item) => {
          type = item?.type.toUpperCase();
          coordinates = item.coordinates;
          if (type === 'POLYGON') {
            this.drawTaskableAOI(coordinates);
          }
        });
        this.taskableGroup.addTo(this.map);
        this.map.fitBounds(this.taskableGroup.getBounds());
      } else this.restrictedUser = false;
    });
    this.calculateZoomLevel();
    this.map.whenReady(() => {
    this.map.invalidateSize(true);
    });
    this.changDetectionRef.detectChanges();
  }

  isPolygonClosed(polygonCoords: number[][]) {
    const first = polygonCoords[0];
    const last = polygonCoords[polygonCoords.length - 1];
    const isClosed = first[0] === last[0] && first[1] === last[1];
    return isClosed;
  }

  loadLocationFromNominatim(): void {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(this.currentUser?.country)}`;
    const defaultLocation: [number, number] = [20.5937, 78.9629];
    
    this.http.get<any[]>(url).pipe(
      take(1),
      timeout(5000),
      catchError((error) => {
        return of([{ lat: defaultLocation[0], lon: defaultLocation[1] }]);
      })
    ).subscribe({
      next: (data: any) => {
        if (data && data.length > 0) {
          const lat = Number(data[0].lat);
          const lon = Number(data[0].lon);
          this.map.setView([lat, lon], 9);
        } else {
          this.map.setView(defaultLocation, 9);
        }
      },
      error: (error) => {
        this.map.setView(defaultLocation, 9);
      }
    });
  }

  isCordinateBasedSearch = false;
  suppressNextGeo = false;
  /* Init geoSearchControl */
  private initGeoSearchControl(): void {
    /* Configure GeoSearchControl */
    const provider = new OpenStreetMapProvider();
    const originalProviderSearch = provider.search.bind(provider);
    provider.search = ((searchArguments: any) => {
      const rawQuery =
        typeof searchArguments === 'string'
          ? searchArguments
          : searchArguments?.query;
      const mgrsCoordinate =
        typeof rawQuery === 'string'
          ? this.mgrsHelperService.convertMGRSToLatLng(rawQuery)
          : null;

      if (!mgrsCoordinate) {
        return originalProviderSearch(searchArguments);
      }

      const convertedQuery = `${mgrsCoordinate.lng}, ${mgrsCoordinate.lat}`;
      return originalProviderSearch(
        typeof searchArguments === 'string'
          ? convertedQuery
          : { ...searchArguments, query: convertedQuery }
      );
    }) as typeof provider.search;
    const searchControl = (GeoSearchControl as any)({
      provider: provider,
      style: 'button',
      position: 'topright',
      searchLabel: 'Enter an address or landmark...',
      showMarker: false,
      showPopup: false,
      keepResult: true,
      autoClose: false,
    });
    this.map.addControl(searchControl);
    const searchFormEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    const searchInputEl = searchFormEl.querySelector(
      'input'
    ) as HTMLInputElement;

    if (this.route.snapshot.url.join('/').includes('retask')) {
      document
        .querySelector('.leaflet-geosearch-button')
        ?.setAttribute('style', 'pointer-events: none !important');
    }

    const leafletBarElement = document.querySelector(
      '.leaflet-bar-part.leaflet-bar-part-single'
    );
    if (leafletBarElement) {
      leafletBarElement.setAttribute(
        'title',
        '• Search by location\n• Input Lng, Lat for a point\n• Input Lng, Lat pairs separated by semicolon for an area\n• Search by 15-character MGRS coordinate system'
      );
    }
    let searchBtnParentEl: any;
    searchInputEl.addEventListener('keydown', (event: any) => {
      if (event.key === 'Enter') {
        const query = event.target.value;
        const mgrsCoordinate = this.mgrsHelperService.convertMGRSToLatLng(query);

        if (mgrsCoordinate) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          
          this.isCordinateBasedSearch = true;
          this.lattitude = mgrsCoordinate.lat;
          this.longitude = mgrsCoordinate.lng;
          this.resultHandler({
            location: {
              lat: mgrsCoordinate.lat,
              lng: mgrsCoordinate.lng,
            },
          }, true);
          return;
        }
        const coordinate = this.helperService.parseCoordinatePair(query, 'lng-lat');
        if (coordinate) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          this.isCordinateBasedSearch = true;
          this.lattitude = coordinate.lat;
          this.longitude = coordinate.lng;
          this.resultHandler({ location: coordinate }, true);
          return;
        }
        const inputStatus = this.isValidInput(query);
        const coordPairs = query
          .split(';')
          .map((pair) => pair.trim())
          .filter(Boolean);

        searchBtnParentEl = document.querySelector('.results');
        if (coordPairs.length === 1) {
          const coords = event.target.value
            .trim()
            .split(',')
            .map((coord) => coord.trim());
          if (
            (coords.length === 2 || coords.length === 3) &&
            !coords.includes('')
          ) {
            searchBtnParentEl = document.querySelector('.results');
            if (searchBtnParentEl) {
              searchBtnParentEl.style.display = 'none';
            }
            const lng = parseFloat(coords[0]);
            const lat = parseFloat(coords[1]);
            if (
              this.helperService.validateCoordinates(lng, lat) &&
              !isNaN(lng) &&
              !isNaN(lat)
            ) {
              this.isCordinateBasedSearch = true;
              const res: object = { location: { lng: lng, lat: lat } };
              // this.triggerResetButtonClick();
              this.lattitude = lat;
              this.longitude = lng;
              this.resultHandler(res,true)
            } else {
              const message = `Please enter the longitude followed by the latitude.`;
              this.popupService
                .openPopup(WarningPopup, message, '', '50%')
                .afterClosed()
                .subscribe((result) => {
                  if (result === 1) {
                    this.resetMap();
                    this.disableEnableDrawControls(true, '');
                  }
                });
              return;
            }
          } else {
            if (searchBtnParentEl) {
              searchBtnParentEl.style.display = 'block';
            }
            if (inputStatus === 'invalid' || coords.length !== 1) {
              const message = `Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'`;
              this.openPopupNoMapMove(WarningPopup, message, '', '50%');
              return;
            }
          }
        } else {
          if (
            coordPairs.length > 1 &&
            this.taskStrategy === 'TLE Based Tasking'
          ) {
            this.suppressNextGeo = true;
            const message =
              'TLE-based tasking supports only point of interest (POI) now';
            this.popupService
              .openPopup(CollectionPopupComponent, message, '', '40%')
              .afterClosed()
              .subscribe((result) => {
                if (result === 1) {
                  this.resetMap();
                }
              });
            return;
          } else if (coordPairs.length == 2) {
            this.suppressNextGeo = true;
            const message = `Not enough coordinates to draw an AOI polygon. Three or more pairs are required for a polygon.`;
            this.openPopupNoMapMove(WarningPopup, message, '', '50%');
            return;
          } else if (coordPairs.length > 2) {
            // --- MULTIPLE COORDINATE PAIRS (POLYGON) ---
            if (searchBtnParentEl) searchBtnParentEl.style.display = 'none';

            const polygonCoords = coordPairs.map((pair) => {
              const [latStr, lngStr] = pair.split(',').map((s) => s.trim());
              const lat = parseFloat(latStr);
              const lng = parseFloat(lngStr);
              return [lng, lat]; // [lng, lat]
            });
            if (
              !this.isPolygonClosed(polygonCoords) ||
              polygonCoords.length < 4
            ) {
              const message =
                'First and last coordinates must be the same to form a closed polygon.';
              this.openPopupNoMapMove(WarningPopup, message, '', '50%');
              return;
            }
            for (const [lng, lat] of polygonCoords) {
              if (!this.helperService.validateCoordinates(lat, lng)) {
                this.suppressNextGeo = true;
                const message =
                  "Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'";
                this.openPopupNoMapMove(WarningPopup, message, '', '50%');
                return;
              }
            }

            let firstPairKey: string | null = null;
            this.duplicateDetected = false;
            const accuracy = 15;
            const validCoords: number[][] = []; // store as numeric pairs

            for (const [lng, lat] of polygonCoords) {
              const formatted = `${lng} ${lat}`;
              if (!firstPairKey) {
                firstPairKey = formatted;
              } else if (formatted === firstPairKey) {
                validCoords.push([lng, lat]);
                this.duplicateDetected = true;
                break; // Stop processing further pairs
              }
              validCoords.push([lng, lat]);
            }
            this.isCordinateBasedSearch = true;

            if (
              this.duplicateDetected &&
              validCoords.length !== polygonCoords.length
            ) {
              const message =
                'All the subsequent coordinates are ignored when the polygon is complete.';
              this.popupService
                .openPopup(WarningPopup, message, 'duplicateDetected', '50%')
                .afterClosed()
                .subscribe((result) => {
                  if (result === 1) {
                    const turfPolygon = turf.polygon([validCoords]);
                    const areaSqM = turf.area(turfPolygon);
                    this.target.area = (areaSqM / 1e6).toFixed(2);
                    this.resultHandler(validCoords,true);
                  }
                });
              return;
            }

            this.triggerResetButtonClick();
            this.resultHandler(polygonCoords, true);
          }
        }
      }
    }, true);

    var searchEventHandler = (e) => {
      if (this.suppressNextGeo) {
        this.suppressNextGeo = false;
        return;
      }
      this.resetMap();
    if( this.lattitude == 41.2 && this.longitude == 74.66){
      this.lattitude = e.location.raw.lat;
      this.longitude = e.location.raw.lon;
    }
    let isInside = false;
          this.pointArray.push(`POINT (${this.longitude} ${this.lattitude})`);

      if (this.currentUser?.isTaskableAoi) {
        isInside = this.currentUser.taskableAoi.some((aoi) =>
          this.utilsService.pointInPolygon(
            geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
            aoi.taskableAoi.coordinates[0]
          )
        );
      }

      if (!this.currentUser?.isTaskableAoi || isInside) {
        this.target.geoJSON = this.pointArray[0];
        this.latLngDMS = this.decimalToDMS(
          e.location.lat,
          this.normalizeLng(e.location.lng)
        );
        this.disableEnableDrawControls(
          false,
          '',
          this.taskStrategy === 'TLE Based Tasking' ? 'TLE' : ''
        );
        this.marker = L.marker([this.lattitude, this.longitude]).addTo(
          this.map
        );
         this.getCountryAndPlace(this.lattitude, this.longitude, 'search');
         this.map.flyTo([this.lattitude, this.longitude], this.zoomLevel);
         this.lattitude = 41.2; 
         this.longitude = 74.66;
      } else {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      }
    };
    this.map.on('geosearch/showlocation', searchEventHandler);

    /* Custom reset button */
    const resetBtn = L.DomUtil.create('button');
    resetBtn.setAttribute('class', 'reset_btn');
    resetBtn.setAttribute('type', 'button');
    resetBtn.innerHTML = 'x';
    const formEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    formEl?.appendChild(resetBtn);

    resetBtn.addEventListener('click', (event: any) => {
      event.preventDefault();
      event.stopPropagation();
      this.resetSearchInput();
    });

    this.initHoverOnSearchBox();

    /** Custom search button */
    const searchEl = document.querySelector(
      '.leaflet-control-geosearch'
    ) as HTMLFormElement;
    const searchInput = formEl.querySelector('input') as HTMLInputElement;
    const searchBtnEl = L.DomUtil.create('button');
    searchBtnEl.setAttribute('class', 'searchBtn');
    searchBtnEl.setAttribute('type', 'button');
    searchEl.append(searchBtnEl);
    const handleSearchIconClick = (event: Event) => {
      event.preventDefault();
      event.stopPropagation();

      const query = (searchInput.value || '').trim();
      if (!query) {
        this.showAndHideSearchInput(true);
        searchInput.classList.add('active');
        searchInput.focus();
        return;
      }

      searchInput.dispatchEvent(
        new KeyboardEvent('keydown', {
          key: 'Enter',
          code: 'Enter',
          bubbles: true,
          cancelable: true,
        })
      );
      this.showAndHideSearchInput(true);
      searchInput.classList.add('active');
      searchInput.focus();
    };
    searchBtnEl.addEventListener('click', handleSearchIconClick);
    const searchIconTrigger = document.querySelector(
      '.leaflet-geosearch-button > a.leaflet-bar-part.leaflet-bar-part-single'
    ) as HTMLElement;
    searchIconTrigger?.addEventListener('click', handleSearchIconClick, true);

    /** Search show when input focus */
    searchInput.addEventListener('focus', (event: any) => {
      searchInput.classList.add('active');
      const resetBtn = formEl.querySelector('.reset_btn') as HTMLButtonElement;
      resetBtn.style.display = 'block';
    });

  }

  private restoreMapMoveFns: null | (() => void) = null;

  private freezeMapMove() {
    if (this.restoreMapMoveFns) return;

    const m: any = this.map;

    const original = {
      setView: m.setView,
      panTo: m.panTo,
      flyTo: m.flyTo,
      fitBounds: m.fitBounds,
      flyToBounds: m.flyToBounds,
      panInsideBounds: m.panInsideBounds,
    };

    const block = function () {
      return m;
    };

    m.setView = block;
    m.panTo = block;
    m.flyTo = block;
    m.fitBounds = block;
    m.flyToBounds = block;
    m.panInsideBounds = block;

    this.restoreMapMoveFns = () => {
      m.setView = original.setView;
      m.panTo = original.panTo;
      m.flyTo = original.flyTo;
      m.fitBounds = original.fitBounds;
      m.flyToBounds = original.flyToBounds;
      m.panInsideBounds = original.panInsideBounds;
      this.restoreMapMoveFns = null;
    };
  }

  private unfreezeMapMove() {
    this.restoreMapMoveFns?.();
  }

  private openPopupNoMapMove(
    component: any,
    message: string,
    tag = '',
    width = '50%'
  ) {
    this.freezeMapMove();
    return this.popupService
      .openPopup(component, message, tag, width)
      .afterClosed()
      .subscribe((result) => {
        this.unfreezeMapMove();
        if (result === 1) this.resetMap();
      });
  }

  private resultHandler(e: any, preserveSearchText = false): void {
    // Clear previous layers and markers
    this.clearRFCircleLayers();
    this.layerData = null;
    this.zoomLevel = 14;
    this.removeHighlight();
    this.resetMap(undefined, preserveSearchText);
    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = null;
      this.eventLayers = [];
    }

    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }

    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }

    this.pointArray = [];
    this.target.geoJSON = [];
    this.searchedAoiDMS = null;
    this.markersAndDivs.forEach((customDivs) => {
      customDivs.div.remove();
    });
    this.markersAndDivs = [];
    let isInside = false;
    // --- Handle POLYGON input ---
    if (Array.isArray(e)) {
      // e is polygonCoords [[lat, lng], ...]
      const wktCoords = e.map(([lat, lng]) => `${lng} ${lat}`).join(', ');
      const wkt = `POLYGON ((${wktCoords}))`;
      const polygon = L.polygon(e, {
        color: 'blue',
        weight: 2,
        fillOpacity: 0.3,
      }).addTo(this.map);
      this.geoJsonLayer = polygon;
      this.map.fitBounds(polygon.getBounds());

      this.latLngDMS = e.map(
        ([lat, lng]: [number, number]) =>
          this.decimalToDMS(lat, this.normalizeLng(lng))
      )
      .join('; ');
      this.searchedAoiDMS = this.latLngDMS;

      this.target.geoJSON = wkt;
      const turfCoords: number[][] = e.map(([lat, lng]: [number, number]) => [
        lng,
        lat,
      ]);
      this.target.area = calculateArea(turfCoords);
      let polygonAccepted = true;
      if (this.currentUser?.isTaskableAoi) {
        isInside = this.currentUser.taskableAoi.some((aoi) =>
          this.utilsService.polygonInsidePolygonAOI(
            turfCoords,
            aoi.taskableAoi.coordinates[0] // AOI polygon (already [lng,lat])
          )
        );
        if (!isInside) {
          polygonAccepted = false;
          const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          this.resetMap();
          this.disableEnableDrawControls(true, '');
          let targetData = this.currentUser?.taskableAoi;
          let type: any, coordinates: any;
          const allTaskableAois = targetData.map((item) => item.taskableAoi);
          allTaskableAois.forEach((item) => {
            type = item?.type.toUpperCase();
            coordinates = item.coordinates;
            if (type === 'POLYGON') {
              this.drawTaskableAOI(coordinates);
            }
          });
          this.taskableGroup.addTo(this.map);
          this.map.fitBounds(this.taskableGroup.getBounds());
        }
      }
      // A polygon loaded from search needs the same water/place lookup the
      // drawn-AOI path performs. Without it `target.openWater` stays unset, so
      // the Tip-and-Cue observation list is never reloaded for open water and
      // silently falls back to the land list. Skipped when the polygon was
      // rejected, since resetMap() has already cleared target.geoJSON.
      if (polygonAccepted) {
        this.getCountryAndPlace(0, 0, geoParse(this.target.geoJSON));
      }
    } else if (e.location?.lat && e.location?.lng) {
      // --- Handle POINT input ---
      this.target.area = 0;
      this.pointArray.push(`POINT (${e.location.lng} ${e.location.lat})`);
      this.lattitude = e.location.lat;
      this.longitude = e.location.lng;

      if (this.currentUser?.isTaskableAoi) {
        isInside = this.currentUser.taskableAoi.some((aoi) =>
          this.utilsService.pointInPolygon(
            geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
            aoi.taskableAoi.coordinates[0]
          )
        );
      }

      if (!this.currentUser?.isTaskableAoi || isInside) {
        this.target.geoJSON = this.pointArray[0];
        this.latLngDMS = this.decimalToDMS(
          e.location?.lat,
          this.normalizeLng(e.location?.lng)
        );
        this.disableEnableDrawControls(
          false,
          '',
          this.taskStrategy === 'TLE Based Tasking' ? 'TLE' : ''
        );
        this.marker = L.marker([e.location.lat, e.location.lng]).addTo(
          this.map
        );
        this.getCountryAndPlace(e.location.lat, e.location.lng, 'search');
        this.map.flyTo([e.location.lat, e.location.lng], this.zoomLevel);
      } else {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      }
    } else if (e.location.raw.lon && e.location.raw.lat) {
      this.pointArray.push(
        `POINT (${e.location.raw.lon} ${e.location.raw.lat})`
      );
      this.lattitude = e.location.raw.lat;
      this.longitude = e.location.raw.lon;
      let isInside = false;
      if (this.currentUser?.isTaskableAoi) {
        isInside = this.currentUser.taskableAoi.some((aoi) =>
          this.utilsService.pointInPolygon(
            geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
            aoi.taskableAoi.coordinates[0]
          )
        );
      }
      if (!this.currentUser?.isTaskableAoi || isInside) {
        this.target.geoJSON = this.pointArray[0];
        this.disableEnableDrawControls(
          false,
          '',
          this.taskStrategy === 'TLE Based Tasking' ? 'TLE' : ''
        );
        this.marker = L.marker([e.location.raw.lat, e.location.raw.lon]).addTo(
          this.map
        );
        this.getCountryAndPlace(
          e.location.raw.lat,
          e.location.raw.lon,
          'search'
        );
        this.map.flyTo(
          [e.location.raw.lat, e.location.raw.lon],
          this.zoomLevel
        );
      } else {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      }
    }
    this.updateTarget(this.target, '1');
    this.clearSatllite();
    this.isCordinateBasedSearch = false;
  }

  isValidInput(input: string): any {
    const trimmed = input.trim();
    // Disallow trailing semicolon
    if (trimmed.endsWith(';')) return 'invalid';

    if (this.mgrsHelperService.isMGRS(trimmed)) return 'mgrs';

    const singleCoordRegex = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/;
    const multipleCoordsRegex =
      /^(-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)(\s*;\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)*$/;
    const placeNameRegex = /^[a-zA-Z0-9\s.,'\-]+$/;

    // Just a number like "150.96" or "150.96,"
    const numberOnlyRegex = /^-?\d+(\.\d+)?$/;
    const endsWithCommaOnly = /^-?\d+(\.\d+)?,$/;

    if (singleCoordRegex.test(trimmed) || multipleCoordsRegex.test(trimmed))
      return 'valid';

    if (numberOnlyRegex.test(trimmed) || endsWithCommaOnly.test(trimmed))
      return 'invalid';
    if (placeNameRegex.test(trimmed)) return 'place';

    return 'invalid';
  }

  initHoverOnSearchBox() {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    searchBtnParentEl.addEventListener('mouseenter', (event: any) => {
      if (!searchBtnParentEl.classList.contains('active')) {
        this.showAndHideSearchInput(true);
      }
    });
  }

  showAndHideSearchInput(show: boolean): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    if (show && searchBtnParentEl.classList.contains('disable-button')) {
      return;
    }
    if (!searchBtnParentEl) {
      return;
    }

    if (this.taskStrategy === 'TLE Based Tasking') {
      searchBtnParentEl.classList.remove('active');
      return;
    }

    if (show) {
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      searchBtnParentEl.classList.add('active');
      return;
    }
    const searchInput = document.querySelector(
      '.leaflet-geosearch-button form input'
    ) as HTMLInputElement;
    if (!searchInput.value && !searchInput.classList.contains('active')) {
      searchBtnParentEl.classList.remove('active');
    }
  }

  private updateMapSearchAndResetControlState(isDisabled: boolean): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement | null;
    const searchInput = document.querySelector(
      '.leaflet-geosearch-button form input'
    ) as HTMLInputElement | null;

    if (searchBtnParentEl) {
      searchBtnParentEl.classList.toggle('disable-button', isDisabled);
      if (isDisabled) {
        searchBtnParentEl.classList.remove('active');
      }
    }

    if (searchInput) {
      searchInput.disabled = isDisabled;
      if (isDisabled) {
        searchInput.blur();
      }
    }

    if (this.resetButton) {
      this.resetButton.classList.toggle('disable-button', isDisabled);
    }
  }

  /* Reset search input field. `activate` should only be true when the user
     interacts with the search control itself (e.g. its own clear button);
     other map controls must clear the input without opening/focusing search. */
  private resetSearchInput(activate = true): void {
    const searchFormEL = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLElement;
    const searchInput = searchFormEL.querySelector('input') as HTMLInputElement;
    const resultEl = searchFormEL.querySelector('.results') as HTMLElement;
    searchInput.value = '';
    this.searchedAoiDMS = null;
    if (resultEl) {
      resultEl.innerHTML = '';
      resultEl.classList.remove('active');
    }
    if (!activate) {
      searchInput.classList.remove('active');
      searchInput.blur();
      this.showAndHideSearchInput(false);
      return;
    }
    this.showAndHideSearchInput(true);
    searchInput.classList.add('active');
    searchInput.focus();
  }

  fileName: any = '';
  private initializeDrawingTools(): void {
    this.drawControl = new (L as any).Control.Draw({
      draw: {
        marker: true,
        rectangle: { showArea: false, title: 'Draw area of interest (AOI) as rectangle' },
        circle: true,
        polygon: true,
        polyline: true,
        circlemarker: false,
      },
    });
    this.map.addControl(this.drawControl);
    this.customizeToolbar();
    this.map.addLayer(this.drawnItems);
    this.map.on('layeradd', (e: any) => {});
    this.map.on('layerremove', (e: any) => {});
  }

  resetButton: any;
  private addCustomButtons(): void {
    const toolbar = (this.drawControl as any)._toolbars.draw;
    const buttonContainer = toolbar._toolbarContainer;
    const uploadButton: any = L.DomUtil.create(
      'input',
      'leaflet-draw-draw-delete'
    );
    uploadButton.type = 'file';
    uploadButton.style.display = 'none';
    uploadButton.accept = '.topojson, .geojson, .kml';
    const filUploadButton: any = L.DomUtil.create(
      'a',
      'leaflet-draw-draw-delete'
    );
    filUploadButton.href = '#';
    filUploadButton.innerHTML =
      '<img src="../../../assets/map-icons/upload-file.svg">';
    filUploadButton.title = 'Upload kml/json file for area of interest(AOI)';
    filUploadButton.style.backgroundColor = 'white';
    filUploadButton.style.cursor = 'pointer';
    filUploadButton.style.display = 'flex';
    filUploadButton.style.justifyContent = 'center';
    filUploadButton.style.alignItems = 'center';
    filUploadButton.classList.add('toolbar-upload-control');
    const spanContainer: any = L.DomUtil.create('span');
    spanContainer.title = filUploadButton.title;
    spanContainer.style.position = 'relative';
    spanContainer.appendChild(filUploadButton);
    filUploadButton.addEventListener('click', (event: any) => {
      if (this.retask) {
        event.preventDefault();
        return;
      }

      if (this.drawControl._toolbars.draw._activeMode) {
        this.drawControl._toolbars.draw._activeMode.handler.disable();
      }
      event.preventDefault();
      uploadButton.value = '';
      uploadButton.click();
    });
    uploadButton.addEventListener('change', (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.isUploadedAOI = true;
        this.showAllCoordinates = false;
        const reader = new FileReader();
        reader.onload = async (e: any) => {
          if (this.geoJsonLayer) {
            this.map.removeLayer(this.geoJsonLayer);
            this.geoJsonLayer = null;
            this.eventLayers = [];
          }
          const content = e.target.result as string;
          const extension = file.name.split('.').pop().toLowerCase();
          this.fileName = extension;
          const omnivore: any = await import('@mapbox/leaflet-omnivore');
          if (extension == 'kml') {
            const kmlContent = e.target.result as string;
            this.geoJsonLayer = omnivore.kml.parse(kmlContent);
            this.position = this.geoJsonLayer;
            this.layerData = this.geoJsonLayer;
            if (!this.validateChangeDetectionUploadedAoi(this.geoJsonLayer)) {
              return;
            }
            if (
              this.geoJsonLayer.getLayers().length > 1 &&
              !this.isChangeDetectionStrategy()
            ) {
              this.openDialog();
              this.geoJsonLayer = null;
              this.disableEnableDrawControls(true, '');
              return;
            }
            if (this.isChangeDetectionStrategy()) {
              if (!this.applyChangeDetectionUploadedAoiTarget(this.geoJsonLayer)) {
                return;
              }
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'Polygon'
            ) {
              this.createCZML('polygon', this.geoJsonLayer.getLayers()[0]);
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'MultiPolygon'
            ) {
              this.createCZML('MultiPolygon', this.geoJsonLayer.getLayers()[0]);
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type == 'Point'
            ) {
            }
            this.map.fitBounds(this.geoJsonLayer.getBounds());
            this.geoJsonLayer.addTo(this.map);
            if (this.isChangeDetectionStrategy()) {
              this.disableEnableDrawControls(true, 'fileupload');
            } else {
              this.disableEnableDrawControls(false, '');
            }
          } else if (extension === 'kmz') {
            const zip = new JSZip();
            const content = await zip.loadAsync(file);
            const kmlFile = content.file('doc.kml');
            if (kmlFile) {
              const kmlText = await kmlFile.async('string');
              const parser = new DOMParser();
              const kml = parser.parseFromString(kmlText, 'text/xml');
              this.geoJsonLayer = omnivore.kml.parse(kml);
              this.position = this.geoJsonLayer;
              this.layerData = this.geoJsonLayer;
              if (!this.validateChangeDetectionUploadedAoi(this.geoJsonLayer)) {
                return;
              }
              const geoJson1 = toGeoJSON.kml(kml);
              const totalLayers = geoJson1.features[0].geometry.geometries
                ? geoJson1.features[0].geometry.geometries.length
                : geoJson1.features[0].geometry.coordinates.length;
              if (totalLayers > 1 && !this.isChangeDetectionStrategy()) {
                this.openDialog();
                this.geoJsonLayer = null;
                this.setMapView(this.lattitude, this.longitude);
                this.disableEnableDrawControls(true, '');
              } else {
                if (this.isChangeDetectionStrategy()) {
                  if (!this.applyChangeDetectionUploadedAoiTarget(this.geoJsonLayer)) {
                    return;
                  }
                } else if (
                  this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
                  'Polygon'
                ) {
                  this.createCZML('polygon', this.geoJsonLayer.getLayers()[0]);
                }
                const geoJson = toGeoJSON.kml(kml);
                this.geoJsonLayer = L.geoJSON(geoJson);
                this.map.fitBounds(this.geoJsonLayer.getBounds());
                this.geoJsonLayer.addTo(this.map);
                if (this.isChangeDetectionStrategy()) {
                  this.disableEnableDrawControls(true, 'fileupload');
                }
              }
            } else {
            }
          } else if (
            file.name.split('.').pop().toLowerCase() == 'json' ||
            file.name.split('.').pop().toLowerCase() == 'geojson'
          ) {
            this.geoJsonLayer = L.geoJSON(JSON.parse(content));
            this.position = this.geoJsonLayer;
            this.layerData = this.geoJsonLayer;
            if (!this.validateChangeDetectionUploadedAoi(this.geoJsonLayer)) {
              return;
            }
            if (
              this.geoJsonLayer.getLayers().length > 1 &&
              !this.isChangeDetectionStrategy()
            ) {
              this.openDialog();
              this.geoJsonLayer = null;
              this.disableEnableDrawControls(true, '');
              return;
            }
            if (this.isChangeDetectionStrategy()) {
              if (!this.applyChangeDetectionUploadedAoiTarget(this.geoJsonLayer)) {
                return;
              }
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type == 'Point'
            ) {
              this.createPoints(this.geoJsonLayer.getLayers());
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'MultiPolygon'
            ) {
              this.createCZML('MultiPolygon', this.geoJsonLayer.getLayers()[0]);
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'Polygon'
            ) {
              this.createCZML('polygon', this.geoJsonLayer.getLayers()[0]);
            }

            if (this.geoJsonLayer) {
              this.map.fitBounds(this.geoJsonLayer.getBounds());
              this.eventLayers = [];
              this.eventLayers.push(this.geoJsonLayer.getBounds());
              this.geoJsonLayer.addTo(this.map);
              if (this.isChangeDetectionStrategy()) {
                this.disableEnableDrawControls(true, 'fileupload');
              }
            }
          }
        };
        reader.readAsText(file);
        if (!this.isChangeDetectionStrategy()) {
          this.disableEnableDrawControls(true, 'fileupload');
        }
      }
    });
    const spanContainer2: any = L.DomUtil.create('span');
    spanContainer.title = filUploadButton.title;
    spanContainer.style.position = 'relative';
    const resetButton: any = L.DomUtil.create('a', 'leaflet-draw-draw-delete');
    resetButton.href = '#';
    resetButton.innerHTML = '<img src="../../../assets/map-icons/reset.svg" >';
    resetButton.title = 'Clear';
    resetButton.style.backgroundColor = 'white';
    resetButton.style.cursor = 'pointer';
    resetButton.style.display = 'flex';
    resetButton.style.justifyContent = 'center';
    resetButton.style.alignItems = 'center';
    resetButton.classList.add('custom-button-leaflet');
    resetButton.classList.add('leaflet-draw-reset-button');
    resetButton.classList.add('toolbar-reset-control');
    if (this.route.snapshot.url.join('/').includes('retask')) {
      resetButton.classList.add('disable-button');
    }
    resetButton.addEventListener('click', (event: any) => {
      this.isUploadedAOI = false;
      this.showAllCoordinates = false;
      if (this.retask) {
        event.preventDefault();
        return;
      }

      const searchBtnParentEl = document.querySelector(
        '.leaflet-geosearch-button'
      ) as HTMLElement;
      searchBtnParentEl.classList.remove('active');
      this.isDrawControlClicked = false;
      this.selectedDrawControl = '';
      this.isResetClicked = true;
      
      this.eventLayers = [];

      this.pointArray = [];
      this.pointEntities = [];
      this.target.multiTarget = [];
      this.target.geoJSON = null;
      this.clearTipAndCueSelectionWithoutTarget();
      this.target.area = null;
      this.target.targetPoints = null;
      this.target.geotargets = null;
      this.resetStripState();
      this.callCounter = 0;
      this.shapeSelected = false;
      this.position = null;
      this.layerData = null;
      if (this.marker) {
        this.map.removeLayer(this.marker);
        this.marker = null;
      }
      if (this.geoJsonLayer) {
        this.map.removeLayer(this.geoJsonLayer);
        this.geoJsonLayer = null;
      }

      this.markersAndDivs.forEach((customDivs) => {
        customDivs.div.remove();
      });
      if (this.numberBadgeMarkers && this.numberBadgeMarkers.length > 0) {
        this.numberBadgeMarkers.forEach((badge) => {
          if (this.map && badge) {
            this.map.removeLayer(badge);
          }
        });
        this.numberBadgeMarkers = [];
      }

      this.markersAndDivs = [];
      this.map.off('mousemove', this.updateTooltipPosition);
      this.map.off('touchmove', this.updateTooltipPosition);
      this.map.off('click', this.setTooltip);
      if (this.drawControl._toolbars.draw._activeMode) {
        this.drawControl._toolbars.draw._activeMode.handler.disable();
      }
      event.preventDefault();
      if (this.taskStrategy === 'TLE Based Tasking') {
        this.disableEnableDrawControls(false, '', 'TLE');
      } else {
        this.disableEnableDrawControls(true, 'reset');
      }

      resetButton.className =
        'leaflet-draw-draw-delete leaflet-draw-toolbar-button-enabled custom-button-leaflet toolbar-reset-control';
      if (this.isChangeDetectionStrategy()) {
        this.disableEnableDrawControls(true, 'reset');
      }
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
      }
      this.removeDrawTooltip();
      this.clearSearchResults();
      this.clearTLEOnly();
      this.clearRFCircleLayers();
      this.polylines.forEach((polyline: any, i: any) => {
        if (polyline?.image) {
          this.map.removeLayer(polyline?.image);
        }
        if (polyline?.polyline) {
          this.map.removeLayer(polyline?.polyline);
        }
        if (polyline?.text) {
          this.map.removeLayer(polyline?.text);
        }
      });
      this.polylines = [];
      event.stopPropagation();
      if (this.selectedCategory === this.nonImagingSensor) {
        this.updateFrequencyOption = false;
        this.budgetSensorType = [];
        const sensorCategoryControl = this.budgetForm.get('sensorCategory');
        this.resetForm();
        sensorCategoryControl?.setValue(this.selectedCategory);
        this.showResolution =
          this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
      }
    });

    this.resetButton = resetButton;

    spanContainer2.appendChild(resetButton);
    buttonContainer.appendChild(spanContainer);
    buttonContainer.appendChild(spanContainer2);
    const toolbar1: any = document.querySelector('.leaflet-draw-toolbar');
    const links: any[] = toolbar1.querySelectorAll('a');
    links.forEach((link: any, index: any) => {
      link.classList.add('custom-button-leaflet');
    });

    if (this.route.snapshot.url.join('/').includes('retask')) {
      this.disableEnableDrawControls(false, '');
    }
  }

  triggerResetButtonClick() {
    this.resetButton.click(); // This will simulate a click on the button
  }

  private validateChangeDetectionUploadedAoi(layer: any): boolean {
    if (!this.isChangeDetectionStrategy()) {
      return true;
    }

    const layers =
      layer && typeof layer.getLayers === 'function' ? layer.getLayers() : [];
    const hasOnlySupportedPolygonGeometries =
      layers.length > 0 &&
      layers.every((uploadLayer: any) => {
        const geometryType =
          uploadLayer?.feature?.geometry?.type ||
          uploadLayer?.toGeoJSON?.()?.geometry?.type;
        return geometryType === 'Polygon' || geometryType === 'MultiPolygon';
      });

    if (hasOnlySupportedPolygonGeometries) {
      return true;
    }

    const message =
      'Please upload a Polygon or MultiPolygon AOI file for Change Detection.';
    this.popupService.openPopup(WarningPopup, message, '', '50%');
    this.clearInvalidChangeDetectionUpload();
    return false;
  }

  private clearInvalidChangeDetectionUpload(): void {
    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = null;
    }
    this.position = null;
    this.layerData = null;
    this.eventLayers = [];
    this.fileName = '';
    this.target.fileName = '';
    this.target.area = null;
    this.target.geoJSON = null;
    this.target.geotargets = null;
    this.target.multiTarget = [];
    this.updateTarget(this.target, '0');
    this.disableEnableDrawControls(false, '', 'change-detection');
  }

  private applyChangeDetectionUploadedAoiTarget(layer: any): boolean {
    const geoJson = layer?.toGeoJSON?.();
    const uploadLayers =
      layer && typeof layer.getLayers === 'function' ? layer.getLayers() : [];
    const polygonRings = this.getUploadedAoiPolygonRings(uploadLayers);

    if (!geoJson || polygonRings.length === 0) {
      return false;
    }

    const firstPoint = polygonRings[0]?.[0]?.[0];
    const targetWkt =
      polygonRings.length === 1
        ? this.polygonRingsToWkt(polygonRings[0])
        : this.multiPolygonRingsToWkt(polygonRings);

    this.target.polygon = true;
    this.target.geoJSON = targetWkt;
    this.target.area = (turf.area(geoJson) / 1000000).toFixed(2);
    this.target.fileName = this.fileName;

    if (firstPoint) {
      this.getCountryAndPlace(
        firstPoint.lat,
        firstPoint.lng,
        geoParse(this.target.geoJSON)
      );
    }

    return true;
  }

  private getUploadedAoiPolygonRings(layers: any[]): L.LatLng[][][] {
    return layers.reduce((polygonRings: L.LatLng[][][], uploadLayer: any) => {
      const geometryType =
        uploadLayer?.feature?.geometry?.type ||
        uploadLayer?.toGeoJSON?.()?.geometry?.type;
      const latLngs = uploadLayer?.getLatLngs?.();

      if (!Array.isArray(latLngs)) {
        return polygonRings;
      }

      if (geometryType === 'Polygon') {
        const rings = this.normalizeUploadedPolygonRings(latLngs);
        return rings.length ? [...polygonRings, rings] : polygonRings;
      }

      if (geometryType === 'MultiPolygon') {
        const multiPolygonRings = latLngs
          .map((polygonLatLngs: any) =>
            this.normalizeUploadedPolygonRings(polygonLatLngs)
          )
          .filter((rings: L.LatLng[][]) => rings.length > 0);
        return [...polygonRings, ...multiPolygonRings];
      }

      return polygonRings;
    }, []);
  }

  private normalizeUploadedPolygonRings(rings: any[]): L.LatLng[][] {
    return rings
      .map((ring: any) => this.normalizePolygonRing(ring))
      .filter((ring: L.LatLng[]) => ring.length > 0);
  }

  private polygonRingsToWkt(rings: L.LatLng[][]): string {
    return `POLYGON (${this.ringsToWkt(rings)})`;
  }

  private multiPolygonRingsToWkt(polygons: L.LatLng[][][]): string {
    return `MULTIPOLYGON (${polygons
      .map((rings) => `(${this.ringsToWkt(rings)})`)
      .join(', ')})`;
  }

  private ringsToWkt(rings: L.LatLng[][]): string {
    return rings
      .map((ring) => `(${this.closedRingToWkt(ring)})`)
      .join(', ');
  }

  private closedRingToWkt(ring: L.LatLng[]): string {
    const accuracy = 15;
    const closedRing =
      ring.length > 0 &&
      ring[0].lng === ring[ring.length - 1].lng &&
      ring[0].lat === ring[ring.length - 1].lat
        ? ring
        : [...ring, ring[0]];

    return closedRing
      .map(
        (point) =>
          `${point.lng.toFixed(accuracy)} ${point.lat.toFixed(accuracy)}`
      )
      .join(', ');
  }

  private createPoints(layer) {
    for (let markerLayer of layer) {
      this.pointArray.push(
        `POINT (${markerLayer.getLatLng().lng} ${markerLayer.getLatLng().lat})`
      );
    }
    this.updatePointTargetStateFromPointArray();
    this.disableEnableDrawControls(false, '');
    let isInside = false;
    if (this.currentUser?.isTaskableAoi) {
      isInside = this.currentUser.taskableAoi.some((aoi) =>
        this.utilsService.pointInPolygon(
          geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
          aoi.taskableAoi.coordinates[0]
        )
      );
      if (!isInside) {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      } else {
        this.updatePointTargetStateFromPointArray();
      }
    }
  }

  private setupEventListeners(): void {
    this.map.on((L as any).Draw.Event.DRAWSTART, this.onDrawStart);
    this.map.on('draw:drawvertex', this.onDrawVertex);
    this.map.on((L as any).Draw.Event.CREATED, this.onDrawCreated);
    this.map.on('draw:drawstop', this.onDrawCancel);
    this.map.on('popupopen', this.handlePopupOpen);
    this.map.on('zoomend', this.HandleZoomEnd);
    this.map.on('geosearch/showlocation', this.handleGeoLocation);
    this.map.on('mousemove', this.handleMouseMove);
    this.map.on('move', this.handleMapMove);
    document.addEventListener(
      'fullscreenchange',
      this.onFullscreenChange.bind(this)
    );
    this.map.doubleClickZoom.disable();
  }

  customizeToolbar(): void {
    setTimeout(() => {
      const toolbar: any = document.querySelector('.leaflet-draw-toolbar');
      if (!toolbar) return;

      toolbar?.addEventListener('dblclick', (event) => {
        this.map.doubleClickZoom.disable();
      });

      const buttonDetails = [
        { className: 'leaflet-draw-draw-marker', title: 'Place point of interest(POI) as point' },
        {
          className: 'leaflet-draw-draw-rectangle',
          title: 'Draw area of interest(AOI) as rectangle',
        },
        { className: 'leaflet-draw-draw-circle', title: 'Draw area of interest(AOI) as circle' },
        {
          className: 'leaflet-draw-draw-polygon',
          title: 'Draw area of interest(AOI) as polygon',
        },
        {
          className: 'leaflet-draw-draw-polyline',
          title: 'Measure distance',
        },
      ];

      const orderedButtons = buttonDetails
        .map((detail, i) => {
          const button = toolbar.querySelector(`.${detail.className}`);
          if (button) {
            this.renderer.setAttribute(button, 'title', detail.title);
            const span = document.createElement('span');
            // span.setAttribute('title', detail.title);
            span.setAttribute('id', 'span' + i);
            span.appendChild(button);
            return span;
          }
          return null;
        })
        .filter((span) => span !== null);
      while (toolbar.firstChild) {
        toolbar.removeChild(toolbar.firstChild);
      }
      orderedButtons.forEach((span: any) => toolbar.appendChild(span));
      this.addCustomButtons();
      const toolbarButtons = document.querySelectorAll(
        '.leaflet-draw-toolbar span a'
      );
      toolbarButtons.forEach((span: any) => {
        span.addEventListener('click', (event: any) => {
          this.removeHighlight();
          toolbarButtons.forEach((s: any) =>
            s.classList.remove('highlight-border')
          );
          event.currentTarget.classList.add('highlight-border');
          let layerList: any = document.querySelector(
            '.leaflet-control-layers-expanded'
          );
          if (layerList) {
            layerList.classList.remove('leaflet-control-layers-expanded');
            document
              .querySelector('.leaflet-control-layers-toggle')
              ?.setAttribute('style', 'top:0px !important');
          }
        });
      });
    }, 10);
  }

  removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if (homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector(
      '.leaflet-control-layers-toggle'
    );
    if (layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }

  onDrawStart = (event: any) => {
    this.isUploadedAOI = false;
    this.showAllCoordinates = false;
    this.removeHighlight();
    this.isDrawControlClicked = true;
    this.callCounter = 0;
    this.isFirstVertexPlaced = false;
    this.isDrawStarted = false;
    this.removeDrawTooltip();
    this.selectedDrawControl = event.layerType;
    if (event.layerType === 'polyline' || event.layerType === 'polygon') {
      this.map.on('contextmenu', this.finishDrawableShapeOnShortcut);
      this.map.on('dblclick', this.finishDrawableShapeOnShortcut);
      this.enablePolygonPolylineDoubleClickPrevention();
    }
    if (event.layerType === 'circle') {
      this.enableCircleClickDrawMode();
    }
    if (event.layerType === 'rectangle' || event.layerType === 'circle') {
      this.map.on('mousedown touchstart', this.handleMouseDown);
    }
  };

  onDrawVertex = (event: any) => {
    const shouldTrackVertices =
      this.selectedDrawControl === 'polygon' ||
      this.selectedDrawControl === 'polyline';
    const lastLatLng = shouldTrackVertices
      ? this.getLastDrawVertexLatLng(event)
      : null;

    if (this.selectedDrawControl === 'polygon') {
      this.syncPolygonFinishClickState();
    }

    if (lastLatLng) {
      this.setTooltip({ latlng: lastLatLng });
    }

    if (lastLatLng && !this.isFirstVertexPlaced) {
      this.isFirstVertexPlaced = true;
      this.map.off('mousemove', this.updateTooltipPosition);
      this.map.off('touchmove', this.updateTooltipPosition);
      this.map.on('mousemove', this.updateTooltipPosition);
      this.map.on('touchmove', this.updateTooltipPosition);
    }
  };

  private enablePolygonPolylineDoubleClickPrevention(): void {
    /**
     * Prevents duplicate marker addition on double-click for polygon/polyline.
     * When double-clicking, both individual clicks add vertices before dblclick fires.
     * Solution: Track time between vertex additions and skip the second click if within
     * the double-click threshold (~300ms).
     */
    if (
      !this.map ||
      (this.selectedDrawControl !== 'polygon' &&
        this.selectedDrawControl !== 'polyline')
    ) {
      return;
    }

    this.lastVertexAdditionTime = 0;

    const activeHandler = (this.drawControl as any)?._toolbars?.draw?._activeMode
      ?.handler;
    if (!activeHandler) {
      return;
    }

    if (
      this.polygonPolylinePatchedHandler &&
      this.polygonPolylinePatchedHandler !== activeHandler
    ) {
      this.disablePolygonPolylineDoubleClickPrevention();
    }

    if (activeHandler._eeDoubleClickVertexPatchApplied) {
      this.polygonPolylinePatchedHandler = activeHandler;
      return;
    }

    const addVertexMethodName =
      typeof activeHandler.addVertex === 'function'
        ? 'addVertex'
        : typeof activeHandler._addVertex === 'function'
        ? '_addVertex'
        : null;

    if (!addVertexMethodName) {
      return;
    }

    const originalAddVertex = activeHandler[addVertexMethodName];
    if (typeof originalAddVertex !== 'function') {
      return;
    }

    activeHandler._eeOriginalAddVertex = originalAddVertex;
    activeHandler._eePatchedAddVertexMethod = addVertexMethodName;

    activeHandler[addVertexMethodName] = (latlng: any) => {
      const now = Date.now();
      const timeSinceLastVertex = now - this.lastVertexAdditionTime;
      const markers = activeHandler?._markers || [];
      const lastMarker = markers[markers.length - 1];
      const lastMarkerLatLng = lastMarker?.getLatLng?.();

      const hasSameLocation =
        !!latlng &&
        !!lastMarkerLatLng &&
        typeof lastMarkerLatLng.distanceTo === 'function' &&
        lastMarkerLatLng.distanceTo(latlng) <=
          this.duplicateVertexDistanceMeters;

      if (
        timeSinceLastVertex > 0 &&
        timeSinceLastVertex <= this.polygonPolylineDoubleClickThresholdMs &&
        hasSameLocation
      ) {
        return;
      }

      this.lastVertexAdditionTime = now;
      return originalAddVertex.call(activeHandler, latlng);
    };

    activeHandler._eeDoubleClickVertexPatchApplied = true;
    this.polygonPolylinePatchedHandler = activeHandler;
  }

  private disablePolygonPolylineDoubleClickPrevention(): void {
    const handler = this.polygonPolylinePatchedHandler;
    if (!handler) {
      return;
    }

    const methodName = handler._eePatchedAddVertexMethod;
    const originalAddVertex = handler._eeOriginalAddVertex;

    if (methodName && typeof originalAddVertex === 'function') {
      handler[methodName] = originalAddVertex;
    }

    delete handler._eeOriginalAddVertex;
    delete handler._eePatchedAddVertexMethod;
    delete handler._eeDoubleClickVertexPatchApplied;
    this.polygonPolylinePatchedHandler = null;
    this.lastVertexAdditionTime = 0;
  }

  private enableCircleClickDrawMode(): void {
    const activeHandler = (this.drawControl as any)?._toolbars?.draw?._activeMode?.handler;

    if (!activeHandler || activeHandler.type !== 'circle') {
      return;
    }

    activeHandler._isCurrentlyTwoClickDrawing = false;

    if (activeHandler._supportsClickCircleDraw) {
      return;
    }

    const originalMouseDown = activeHandler._onMouseDown;
    const originalMouseUp = activeHandler._onMouseUp;

    if (
      typeof originalMouseDown !== 'function' ||
      typeof originalMouseUp !== 'function'
    ) {
      return;
    }

    const patchedMouseDown = function (this: any, drawEvent: any) {
      if (this._isCurrentlyTwoClickDrawing) {
        drawEvent?.originalEvent?.preventDefault?.();
        drawEvent?.originalEvent?.stopPropagation?.();
        return;
      }

      return originalMouseDown.call(this, drawEvent);
    };

    const patchedMouseUp = function (this: any, drawEvent: any) {
      if (!this._shape) {
        this._isCurrentlyTwoClickDrawing = true;
        return;
      }

      this._isCurrentlyTwoClickDrawing = false;
      return originalMouseUp.call(this, drawEvent);
    };

    activeHandler._onMouseDown = patchedMouseDown;
    activeHandler._onMouseUp = patchedMouseUp;
    activeHandler._supportsClickCircleDraw = true;

    const activeMap = activeHandler._map || this.map;
    activeMap?.off?.('mousedown', originalMouseDown, activeHandler);
    activeMap?.off?.('touchstart', originalMouseDown, activeHandler);
    activeMap?.on?.('mousedown', patchedMouseDown, activeHandler);
    activeMap?.on?.('touchstart', patchedMouseDown, activeHandler);
  }

  private normalizeLatLng(lat: number, lng: number): L.LatLng {
  const normalizedLat = Math.max(-90, Math.min(90, lat));
  const normalizedLng = ((lng + 180) % 360 + 360) % 360 - 180;
  return L.latLng(normalizedLat, normalizedLng);
  }


  onDrawCreated = (event: any) => {
    this.isUploadedAOI = false;
    this.showAllCoordinates = false;
    this.removeHighlight();
    let layer = event.layer;
    if (layer.getLatLng) {
      const latlng = layer.getLatLng();
      const fixed = this.normalizeLatLng(latlng.lat, latlng.lng);
      layer.setLatLng(fixed);
    }
    if (layer.getLatLngs) {
      const latlngs = layer.getLatLngs();

      const normalizeArray = (coords: any[]): any[] =>
        coords.map((coord) =>
          Array.isArray(coord)
            ? normalizeArray(coord)
            : this.normalizeLatLng(coord.lat, coord.lng)
        );

      const fixedLatLngs = normalizeArray(latlngs);
      layer.setLatLngs(fixedLatLngs);
    }
    event.layer = layer;
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.position = layer;
    this.layerData = event;

    this.drawnItems.addLayer(this.position);

    this.isResetClicked = false;
    let isInside: any;
    if (event.layerType != 'marker' && event.layerType != 'polyline') {
      this.eventLayers = [];
    }
    if (event.layerType == 'rectangle' || event.layerType == 'polygon') {
      this.eventLayers.push(this.position.getLatLngs());
    } else if (event.layerType == 'circle') {
      let cordinates = this.circleToBoxCordinates(this.position);
      this.eventLayers.push(cordinates);
    } else if (event.layerType == 'marker') {
      this.getCountryAndPlace(
        this.position.getLatLng().lat,
        this.position.getLatLng().lng,
        'search'
      );
      this.clearSatllite();
      this.clearRFCircleLayers();
      this.pointArray = [];
      this.target.multiTarget = [];
      this.eventLayers.push(this.position);
      if (
        this.taskStrategy === 'TLE Based Tasking' &&
        this.eventLayers?.length > 1
      ) {
        this.eventLayers.pop();
        const msg =
          'For TLE Based Tasking, only one POI is allowed. Click the existing pin to remove it, then place a new one.';
        this.popupService.openPopup(WarningPopup, msg, '', '50%');
        if (this.map.hasLayer(this.position)) {
          this.map.removeLayer(this.position);
        }

        return;
      } else if (
        this.taskStrategy !== 'TLE Based Tasking' &&
        this.eventLayers.length > 3 &&
        !this.currentUser?.pointsEligible
      ) {
        const msg =
          'The maximum number of points for multiple points of interest (POIs) tasking is three.';
        const popupRef = this.popupService.openPopup(CollectionPopupComponent, msg, '', '50%');
        popupRef.afterClosed().subscribe(() => {
          this.removeLastPin(event);
        });
        return;
      }
      for (let markerLayer of this.eventLayers) {
        this.pointArray.push(
          `POINT (${markerLayer.getLatLng().lng} ${
            markerLayer.getLatLng().lat
          })`
        );
      }
      if (this.currentUser?.isTaskableAoi) {
        isInside = this.currentUser.taskableAoi.some((aoi) =>
          this.utilsService.pointInPolygon(
            geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
            aoi.taskableAoi.coordinates[0]
          )
        );
        if (!isInside) {
          this.eventLayers.pop();
          this.pointArray.pop();
          const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
          const popupRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
          popupRef.afterClosed().subscribe(() => {
            this.removeLastPin(event);
          })
          this.disableEnableDrawControls(true, '');
        } else {
          this.disableEnableDrawControls(false, event.layerType);
        }
      }
      this.updatePointTargetStateFromPointArray();
    }
    this.clearDrawingInteraction();
    if (event.layerType === 'marker') {
      const createdLayer = event.layer;
      const existingMarkers = Object.values((this.drawnItems as any)._layers)
        .filter((item: any) => item instanceof L.Marker);

      if (existingMarkers.length > 3 && !this.currentUser.pointsEligible) {
        this.suppressDrawCancel = true;
        const msg =
          'The maximum number of points for multiple points of interest (POIs) tasking is three.';
        this.popupService.openPopup(CollectionPopupComponent, msg, '', '50%');
        this.removeLastPin(event);

        if (this.map.hasLayer(createdLayer)) {
          this.map.removeLayer(createdLayer);
        }

        return;
      }

      this.generateMarkerNumber();
      createdLayer.on('click', this.markerClickListener.bind(this, createdLayer));
      createdLayer.on('mouseover', this.markerMouseOverListener.bind(this, createdLayer));
    } else if (event.layerType == 'polyline') {
      let totalDistance = this.calculatePolylineDistace(this.position);
      this.onPopupOpen(event, totalDistance / 1000);
    } else if (event.layerType == 'rectangle') {
      let totalDistance = this.calculateRectanglePerimater(
        this.position._bounds._northEast,
        this.position._bounds._southWest
      );
      this.onPopupOpen(event, totalDistance / 1000);
      this.createCZML('rectangle', this.position);
    } else if (event.layerType == 'polygon') {
      let totalDistance = this.calculatePolygonPerimeter(this.position);
      this.onPopupOpen(event, totalDistance / 1000);
      this.createCZML('polygon', this.position);
    } else if (event.layerType == 'circle') {
      let totalDistance = this.calculateCircleCircumference(this.position);
      this.onPopupOpen(event, totalDistance / 1000);
      this.createCZML('circle', this.position);
    }
    if (event.layerType != 'polyline') {
      if (!this.currentUser?.isTaskableAoi) {
        this.disableEnableDrawControls(false, event.layerType);
      }
    }
    if (event.layerType != 'polyline') {
      this.updateTarget(this.target, '1');
    }
    this.selectedDrawControl = '';
  };

  removeLastPin(event) {
    if (this.map.hasLayer(event.layer)) {
      this.map.removeLayer(event.layer);
    }
    const layerValue = this.drawnItems.getLayer(event.layer._leaflet_id);
    if (layerValue) {
      this.drawnItems.removeLayer(layerValue);
      this.eventLayers = this.eventLayers.filter((layer1: any) => {
        return layer1._leaflet_id != (layerValue as any)._leaflet_id;
      });
    }
  }
  private ensureNumberPane() {
    if (this.numberPaneCreated || !this.map) return;
    this.map.createPane('poi-number-pane');
    const pane = this.map.getPane('poi-number-pane')!;
    pane.style.zIndex = '650';
    pane.style.pointerEvents = 'none';
    this.numberPaneCreated = true;
  }

  private clearNumberBadges() {
    if (!this.map) return;
    this.numberBadgeMarkers.forEach((lb) => this.map.removeLayer(lb));
    this.numberBadgeMarkers = [];
  }

  private generateMarkerNumber(): void {
    this.ensureNumberPane();
    const markers: L.Marker[] = (this.eventLayers || []).filter(
      (l: any) => typeof (l as L.Marker)?.getLatLng === 'function'
    );

    this.clearNumberBadges();

    if (markers.length < 2) return;

    markers.forEach((m, i) => {
      const n = i + 1;

      const html = `
      <span
        style="
          position: relative;
          display: inline-block;
          font-weight: 500;
          font-size: 18px;
          line-height: 1;
          color: #292929;                 
          transform: translate(-50%, -100%);
          left: 50%;
          white-space: nowrap;
          pointer-events: none;
        "
      >${n}</span>
    `;

      const label = L.marker(m.getLatLng(), {
        interactive: false,
        pane: 'poi-number-pane',
        zIndexOffset: 1000,
        icon: L.divIcon({
          className: 'poi-number-divicon',
          html,
          iconSize: [1, 1],
          iconAnchor: [0, 45],
        }),
      });

      label.addTo(this.map);
      this.numberBadgeMarkers.push(label);
    });
  }

  private normalizePolygonRing(ring: any[]): any[] {
    if (!Array.isArray(ring) || ring.length === 0) {
      return [];
    }

    const deduped: any[] = [];
    for (const point of ring) {
      const previous = deduped[deduped.length - 1];
      const isSameAsPrevious =
        !!previous && previous.lat === point?.lat && previous.lng === point?.lng;

      if (!isSameAsPrevious) {
        deduped.push(point);
      }
    }

    if (deduped.length > 1) {
      const first = deduped[0];
      const last = deduped[deduped.length - 1];
      const isClosed = first.lat === last.lat && first.lng === last.lng;

      if (isClosed) {
        deduped.pop();
      }
    }

    return deduped;
  }

  createCZML(mode, layer) {
    let target: any = {};
    const accuracy = 15;
    let polyPts: any = [],
      aoi;
    let aoiWkt: any = 'POLYGON ((';
    let lng0 = 0,
      lat0 = 0;
    if (mode == 'polygon') {
      target.polygon = true;
      this.target.polygon = true;
      const ring = this.normalizePolygonRing(layer.getLatLngs()[0]);
      if (!ring.length) {
        return;
      }

      lng0 = ring[0].lng;
      lat0 = ring[0].lat;
      for (let i = 0; i < ring.length; i++) {
        aoiWkt =
          aoiWkt +
          `${ring[i].lng.toFixed(accuracy)} ${ring[i].lat.toFixed(accuracy)}, `;
      }
      aoiWkt =
        aoiWkt +
        `${ring[0].lng.toFixed(accuracy)} ${ring[0].lat.toFixed(accuracy)}`;
      aoi = layer.toGeoJSON();
    } else if (mode == 'MultiPolygon') {
      const ring = this.normalizePolygonRing(layer.getLatLngs()[0][0]);
      if (!ring.length) {
        return;
      }

      lng0 = ring[0].lng;
      lat0 = ring[0].lat;
      for (let i = 0; i < ring.length; i++) {
        aoiWkt =
          aoiWkt +
          `${ring[i].lng.toFixed(accuracy)} ${ring[i].lat.toFixed(accuracy)}, `;
      }
      aoiWkt =
        aoiWkt +
        `${ring[0].lng.toFixed(accuracy)} ${ring[0].lat.toFixed(accuracy)}`;
      aoi = layer.toGeoJSON();
    } else if (mode == 'rectangle') {
      let lng0 = layer.getBounds()._northEast.lng;
      let lat0 = layer.getBounds()._northEast.lat;
      let lng2 = layer.getBounds()._southWest.lng;
      let lat2 = layer.getBounds()._southWest.lat;
      aoi = layer.toGeoJSON();
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
    } else if (mode === 'circle') {
      
      this.target.circleData = {
        lat: this.position.getLatLng().lat,
        lng: this.position.getLatLng().lng,
        radius: this.position.getRadius()
      };
      
      let radius = layer.getRadius() / 1000;
      const circle = turf.circle(
        [layer.getLatLng().lng, layer.getLatLng().lat],
        radius,
        { steps: 64 }
      );
      aoi = turf.bboxPolygon(turf.bbox(circle));
      let lng0 = aoi.bbox[0];
      let lat0 = aoi.bbox[1];
      let lng2 = aoi.bbox[2];
      let lat2 = aoi.bbox[3];
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
    }
    aoiWkt = aoiWkt + `))`;

    if (!aoi) return;
    const areaVal = turf.area(aoi) / 1000000;
    let areaMsg = '';
    var aoiArea = areaVal.toFixed(2);
    this.target.geoJSON = aoiWkt;
    this.target.area = aoiArea;
    this.target.fileName = this.fileName;
    this.getCountryAndPlace(lat0, lng0, geoParse(this.target.geoJSON));

    if (this.currentUser?.isTaskableAoi) {
      let isInside = this.currentUser.taskableAoi.some((aoi) =>
        this.utilsService.comparePolygons(
          geoParse(this.target.geoJSON).coordinates[0],
          aoi.taskableAoi.coordinates[0]
        )
      );
      if (!isInside) {
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      } else {
        // this.updateTarget(target, '1');
        this.disableEnableDrawControls(false, '');
      }
    } else {
      this.updateTarget(this.target, '1');
    }
  }

  private getLastDrawVertexLatLng(event: any): L.LatLng | null {
    const vertexLayers = event?.layers?.getLayers?.() || [];
    const lastVertexLayer = vertexLayers[vertexLayers.length - 1];
    return lastVertexLayer?.getLatLng?.() ?? null;
  }

  private ensureDrawTooltip(latlng: L.LatLng | null | undefined): HTMLDivElement | null {
    if (!latlng || !this.map) {
      return null;
    }

    if (!this.drawTooltip) {
      const mapContainer = this.map.getContainer();
      this.drawTooltip = L.DomUtil.create(
        'div',
        'custom-tooltip custom-draw-tooltip-overlay',
        mapContainer
      ) as HTMLDivElement;
      this.drawTooltip.style.display = 'none';
      this.drawTooltip.style.opacity = '0';
    }

    this.positionDrawTooltip(latlng);

    return this.drawTooltip;
  }

  private getDrawTooltipPoint(source: any): L.Point | null {
    if (!this.map || !source) {
      return null;
    }

    if (source.containerPoint) {
      return source.containerPoint;
    }

    const latlng = source.latlng || source;
    if (!latlng) {
      return null;
    }

    return this.map.latLngToContainerPoint(latlng);
  }

  private positionDrawTooltip(source: any): void {
    if (!this.drawTooltip) {
      return;
    }

    const point = this.getDrawTooltipPoint(source);
    if (!point) {
      return;
    }

    this.drawTooltip.style.left = `${point.x + 18}px`;
    this.drawTooltip.style.top = `${point.y + 28}px`;
  }

  private showDrawTooltip(source: any, content: string): void {
    const latlng = source?.latlng || source;
    const tooltip = this.ensureDrawTooltip(latlng);
    if (!tooltip) {
      return;
    }

    this.positionDrawTooltip(source);
    tooltip.innerHTML = content;
    tooltip.style.display = 'block';
    tooltip.style.opacity = '1';
  }

  private hideDrawTooltip(): void {
    if (!this.drawTooltip) {
      return;
    }

    this.drawTooltip.style.display = 'none';
    this.drawTooltip.style.opacity = '0';
  }

  private removeDrawTooltip(): void {
    if (!this.drawTooltip) {
      return;
    }

    this.drawTooltip.remove();
    this.drawTooltip = null;
  }

  private setMarkerPointerEvents(marker: any, enabled: boolean): void {
    const pointerEvents = enabled ? '' : 'none';

    if (marker?._icon?.style) {
      marker._icon.style.pointerEvents = pointerEvents;
    }

    if (marker?._shadow?.style) {
      marker._shadow.style.pointerEvents = pointerEvents;
    }
  }

  private syncPolygonFinishClickState(): void {
    if (this.selectedDrawControl !== 'polygon') {
      return;
    }

    const activeHandler = (this.drawControl as any)?._toolbars?.draw?._activeMode?.handler;
    const markers = activeHandler?._markers;
    const firstMarker = markers?.[0];

    if (!activeHandler || !Array.isArray(markers) || !firstMarker) {
      return;
    }

    const shouldEnableFinishClick = markers.length >= 3;

    firstMarker.off?.('click', activeHandler._finishShape, activeHandler);
    this.setMarkerPointerEvents(firstMarker, shouldEnableFinishClick);

    if (shouldEnableFinishClick) {
      firstMarker.on?.('click', activeHandler._finishShape, activeHandler);
    }
  }

  private resetDrawingInteractionState(): void {
    this.isDrawControlClicked = false;
    this.isFirstVertexPlaced = false;
    this.isDrawStarted = false;
    this.selectedDrawControl = '';
    this.startPoint = null;
  }

  private clearDrawingInteraction(): void {
    this.disablePolygonPolylineDoubleClickPrevention();
    this.map.off('mousemove', this.updateTooltipPosition);
    this.map.off('mousemove', this.syncCircleTooltipFromMapMove);
    this.map.off('click', this.setTooltip);
    this.map.off('contextmenu', this.finishDrawableShapeOnShortcut);
    this.map.off('dblclick', this.finishDrawableShapeOnShortcut);
    this.map.off('touchstart', this.handleMouseDown);
    this.map.off('mousedown', this.handleMouseDown);
    this.map.off('touchmove', this.updateTooltipPosition);
    this.map.off('touchmove', this.syncCircleTooltipFromMapMove);
    this.removeDrawTooltip();
    this.resetDrawingInteractionState();
    this.lastDrawingLatLng = null;
    this.lastVertexAdditionTime = 0;
  }

  private getCircleAreaSqKmFromActiveHandlerShape(): number | null {
    const activeHandler = (this.drawControl as any)?._toolbars?.draw?._activeMode?.handler;
    if (!activeHandler || activeHandler.type !== 'circle') {
      return null;
    }

    const radiusMeters = Number(activeHandler?._shape?.getRadius?.());
    if (!Number.isFinite(radiusMeters)) {
      return null;
    }

    return Math.PI * Math.pow(radiusMeters / 1000, 2);
  }

  private getTooltipAreaLine(areaSqKm: number | null): string {
    if (areaSqKm === null || !Number.isFinite(areaSqKm)) {
      return '';
    }

    const roundedAreaSqKm = Number(areaSqKm.toFixed(2));
    if (roundedAreaSqKm <= 0) {
      return '';
    }

    return `Area: ${roundedAreaSqKm.toFixed(2)} sqkm<br>`;
  }

  private renderCircleTooltipFromActiveShape(latlng?: L.LatLng): void {
    if (this.selectedDrawControl !== 'circle' || !this.isDrawControlClicked) {
      return;
    }

    if (latlng) {
      this.lastDrawingLatLng = latlng;
    }

    const tooltipLatLng = this.lastDrawingLatLng;
    if (!tooltipLatLng) {
      return;
    }

    const areaSqKm = this.getCircleAreaSqKmFromActiveHandlerShape();
    const areaLine = this.getTooltipAreaLine(areaSqKm);

    this.showDrawTooltip(
      { latlng: tooltipLatLng },
      `${areaLine}Click to finish circle.`
    );
  }

  private syncCircleTooltipFromMapMove = (drawEvent: any): void => {
    this.renderCircleTooltipFromActiveShape(drawEvent?.latlng);
  };

  private syncCircleTooltipFromActiveHandler(drawEvent: any): void {
    this.renderCircleTooltipFromActiveShape(drawEvent?.latlng);
  }

  private updatePointTargetStateFromPointArray(): void {
    this.target.area = 0;
    this.target.fileName = '';
    this.target.geometryCentroid = null;
    this.target.polygon = false;
    this.target.targetPoints = null;
    this.target.geotargets = null;

    if (this.pointArray.length === 0) {
      this.target.geoJSON = null;
      this.target.multiTarget = [];
    } else if (this.pointArray.length === 1) {
      this.target.geoJSON = this.pointArray[0];
      this.target.multiTarget = [];
    } else {
      this.target.multiTarget = [...this.pointArray];
      this.target.geoJSON = this.pointArray.join(', ');
      this.target.geotargets = JSON.stringify(this.geoParsePoint(this.target.geoJSON));
    }

    this.syncStripState();
  }

  private syncStripState(): void {
    const preview = isLeafletTaskStripAvailable(this.pointArray)
      ? buildLeafletTaskStripPreview(this.pointArray, this.stripSwathKm)
      : null;

    const wasAvailable = this.stripState.available;

    this.stripState = {
      ...this.stripState,
      available: !!preview,
      enabled: preview ? this.stripState.enabled : false,
      lengthKm: preview?.lengthKm ?? null,
    };

    if (this.stripState.available && this.stripState.enabled && preview) {
      if (this.target) {
        this.target.stripValidRange = { min: 25, max: 100 };
      }
      this.renderStripPreview(preview);
    } else {
      this.clearStripPreview();
    }

    this.target.stripSettings = this.stripState.available
      ? {
          enabled: this.stripState.enabled,
          swathKm: this.stripSwathKm,
          lengthKm: this.stripState.lengthKm,
        }
      : null;

    this.target.scanArea =
      this.stripState.available && this.stripState.lengthKm != null
        ? Number(parseFloat(this.stripState.lengthKm.toFixed(2)) * this.stripSwathKm)
        : 0;

    // Auto-open the intent panel the first time strip becomes available
    if (this.stripState.available && !wasAvailable && !this.intentPanelAutoOpened) {
      this.intentPanelOpen = true;
      this.intentPanelAutoOpened = true;
    }
  }

  private renderStripPreview(preview: LeafletTaskStripPreview): void {
    this.clearStripPreview();
    const vr = this.target?.stripValidRange;
    const color = vr != null
      ? (preview.lengthKm >= vr.min && preview.lengthKm <= vr.max ? '#43a047' : '#e53935')
      : '#1e88e5';
    this.stripPreviewLayer = L.polygon(preview.polygonLatLngs, {
      color,
      weight: 2,
      fillOpacity: 0.2,
      dashArray: '6 4',
      interactive: false,
    }).addTo(this.map);
  }

  private clearStripPreview(): void {
    if (this.stripPreviewLayer && this.map?.hasLayer(this.stripPreviewLayer)) {
      this.map.removeLayer(this.stripPreviewLayer);
    }
    this.stripPreviewLayer = null;
  }

  private resetStripState(): void {
    this.stripState = createLeafletTaskStripState();
    this.clearStripPreview();
    this.target.stripSettings = null;
    this.target.stripValidRange = null;
    this.target.scanArea = 0;
    this.intentPanelAutoOpened = false;
  }

  onIntentPanelOpenChange(open: boolean): void {
    this.intentPanelOpen = open;
  }

  toggleShowCoordinates(): void {
    this.showAllCoordinates = !this.showAllCoordinates;
  }

  isCoordsOverflowing(element?: HTMLElement): boolean {
    if (!element) return false;
    return element.scrollHeight > (element.clientHeight + 4);
  }

  onStripPreviewChange(enabled: boolean): void {
    this.stripState = {
      ...this.stripState,
      enabled,
    };
    this.syncStripState();
    this.updateTarget(this.target, '0');
  }

  onTirEnabledChange(enabled: boolean): void {
    this.tirEnabled = enabled;
    if (enabled) {
      this.loadTirLayer();
    } else {
      this.clearTirLayer();
    }
  }

  closeTlePreviewBanner(): void {
    this.showTlePreviewBanner = false;
  }

  private loadTirLayer(): void {
    if (this.tirLayer) return;
    fetch('assets/json/HydrosatTaskingRegions.geojson')
      .then(res => res.json())
      .then(data => {
        this.tirLayer = L.geoJSON(data, {
          coordsToLatLng: (coords) => L.latLng(coords[1], coords[0]),
          style: {
            color: 'maroon',
            weight: 1,
            fillColor: 'maroon',
            fillOpacity: 0.55,
          },
        }).addTo(this.map);
      })
      .catch(err => console.error('Failed to load TIR layer:', err));
  }

  private clearTirLayer(): void {
    if (this.tirLayer) {
      this.map.removeLayer(this.tirLayer);
      this.tirLayer = null;
    }
  }

  onDrawCancel = (e: any) => {
    if (!this.suppressDrawCancel) {
      const hadActiveTooltip = !!this.drawTooltip;
      this.clearDrawingInteraction();

      if (hadActiveTooltip) {
      this.resetForm();
      }
    }
    this.suppressDrawCancel = false;
  };

  viewHome(event: any) {
    this.removeHighlight();

    /** reset search without activating the search box */
    this.resetSearchInput(false);

    let layerList: any = document.querySelector(
      '.leaflet-control-layers-expanded'
    );
    if (layerList) {
      layerList.classList.remove('leaflet-control-layers-expanded');
    }

    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.setAttribute('style', 'top:0px !important');

    let homeBtn: any = document.querySelector('#homeButton');
    homeBtn.classList.add('highlight-border');

    if (this.route.snapshot.url.join('/').includes('retask')) {
      this.focusRetaskTarget();
    } else if (this.layerData) {
      if (this.layerData?.layerType == 'marker') {
        this.map.setView(
          [this.position.getLatLng().lat, this.position.getLatLng().lng],
          5
        );
      } else if (this.position?.getBounds()) {
        this.map.fitBounds(this.position?.getBounds());
      } else if (
        this.position &&
        typeof this.position.getLatLng === 'function'
      ) {
        this.map.setView(
          [this.position.getLatLng().lat, this.position.getLatLng().lng],
          this.zoomLevel
        );
      } else if (
        this.position &&
        typeof this.position.getLatLngs() === 'object'
      ) {
        this.map.setView(
          [
            this.position.getLatLngs()[0][0].lat,
            this.position.getLatLngs()[0][0].lng,
          ],
          this.zoomLevel
        );
      }
    } else {
      if (this.marker && typeof this.marker.getLatLng === 'function') {
        const markerPosition = this.marker.getLatLng();
        this.map.setView(
          [markerPosition.lat, markerPosition.lng],
          this.zoomLevel
        );
      } else {
        this.zoomLevel = 3;
        this.setMapView(this.lattitude, this.longitude);
      }
    }
    this.calculateZoomLevel();
    event.stopPropagation();
  }

  handleGeoLocation = (result: any) => {
    this.selectedDrawControl = '';
    const coordinates: any = result.location;
    this.eventLayers = [];
    this.eventLayers.push(coordinates.x, coordinates.y);
    if (this.searchMarker) {
      this.map.removeLayer(this.searchMarker);
    }
    this.searchMarker = result.marker;
    this.map.addLayer(this.searchMarker);
    this.map.setView([coordinates.y, coordinates.x], this.zoomLevel);
  };

  onTleParentLocationChange(parent: TleParentLocationOption | null): void {
    this.tleSubLocationOptions = parent?.subLocations ?? [];
    this.tleSubLocationControl.setValue(null);
    this.tleSubLocationControl.markAsUntouched();
    this.selectedTleLocation = null;
    this.target.geoJSON = null;
    this.formGroup.get('target')?.setValue(null);
    this.resetTlePassSelectionState();
    this.showtleClick = false;
    this.showtleDisabled = false;
  }

  onTleSubLocationChange(location: TleLocationOption | null): void {
    if (!location) {
      return;
    }

    this.selectedTleLocation = location;

    this.resultHandler({
      location: {
        lat: location.latitude,
        lng: location.longitude,
      },
    });

    if (this.taskStrategy === 'TLE Based Tasking') {
      this.resetTlePassSelectionState();
      this.showtleClick = false;
      this.showtleDisabled = false;
    }
  }

  private loadTleLocations(): void {
    if (!this.userid) {
      this.setTleParentLocationOptions([]);
      return;
    }

    this.apiService
      .getTleLocations(String(this.userid))
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.setTleParentLocationOptions(this.mapTleLocationsResponse(response));
        },
        error: () => {
          this.setTleParentLocationOptions([]);
        },
      });
  }

  private mapTleLocationsResponse(response: any): TleParentLocationOption[] {
    const rawLocations = Array.isArray(response)
      ? response
      : Array.isArray(response?.tleLocations)
        ? response.tleLocations
      : Array.isArray(response?.response)
        ? response.response
      : Array.isArray(response?.data)
        ? response.data
      : Array.isArray(response?.result)
        ? response.result
      : [];

    return rawLocations
      .map((entry: any, index: number): TleParentLocationOption | null => {
        const name = String(entry?.name ?? entry?.country ?? entry?.location ?? '').trim();
        if (!name || entry?.active === false) {
          return null;
        }

        const rawSubLocations = Array.isArray(entry?.sub_locations) ? entry.sub_locations : [];
        const subLocations = rawSubLocations
          .map((sub: any, subIndex: number): TleLocationOption | null => {
            const latitude = Number(sub?.latitude ?? sub?.lat);
            const longitude = Number(sub?.longitude ?? sub?.lng ?? sub?.lon);
            const subName = String(sub?.name ?? '').trim();
            const description = typeof sub?.description === 'string' ? sub.description.trim() : '';

            if (!subName || Number.isNaN(latitude) || Number.isNaN(longitude)) {
              return null;
            }

            return {
              id: sub?._id ?? sub?.id ?? subIndex + 1,
              name: subName,
              latitude,
              longitude,
              description: description || null,
            };
          })
          .filter((sub: TleLocationOption | null): sub is TleLocationOption => !!sub);

        return {
          id: entry?._id ?? entry?.id ?? index + 1,
          name,
          subLocations,
        };
      })
      .filter((entry: TleParentLocationOption | null): entry is TleParentLocationOption => !!entry)
      .sort((left, right) => left.name.localeCompare(right.name));
  }

  private setTleParentLocationOptions(options: TleParentLocationOption[]): void {
    this.tleParentLocationOptions = [...options];
  }

  clearSelectedTleLocation(): void {
    this.selectedTleLocation = null;
    this.tleParentLocationControl.setValue(null);
    this.tleSubLocationControl.setValue(null);
    this.tleSubLocationOptions = [];
    this.target.geoJSON = null;
    this.formGroup.get('target')?.setValue(null);
    this.resetTlePassSelectionState();
    this.showtleClick = false;
    this.showtleDisabled = false;
  }

  handleMouseDown = (e: any) => {
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.setTooltip(e);
    this.map.on('mousemove touchmove', this.updateTooltipPosition);
  };

  private normalizeLng(lng: number): number {
  return ((lng + 180) % 360 + 360) % 360 - 180;
  }

  handleMouseMove = (e: any) => {
    const lat = e.latlng.lat;
    const lng = this.normalizeLng(e.latlng.lng);
    const hasActiveSearchedAoi =
      !!this.searchedAoiDMS &&
      !!this.geoJsonLayer &&
      !this.marker &&
      !this.searchMarker &&
      typeof this.target?.geoJSON === 'string' &&
      this.target.geoJSON.includes('POLYGON');
    this.latLngDMS = hasActiveSearchedAoi
      ? (this.searchedAoiDMS as string)
      : this.decimalToDMS(lat, lng);
    let isInside = false;
    if (this.currentUser?.taskableAoi?.length > 0) {
      isInside = this.currentUser.taskableAoi.some((aoi) =>
        this.utilsService.pointInPolygon(
          [lng, lat],
          aoi?.taskableAoi?.coordinates[0]
        )
      );
    }

    if (this.currentUser?.taskableAoi) {
      if (isInside && this.isDrawControlClicked == false) {
        const tooltip = this.ensureDrawTooltip(e?.latlng);
        if (tooltip) {
          this.positionDrawTooltip(e);
          this.hideDrawTooltip();
        }
      } else if (!isInside && this.isDrawControlClicked == false) {
        this.removeDrawTooltip();
      }
    }
  };

  handleMapMove = (e: any) => {
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.eventLayers.forEach((layer) => {
      this.updateDivPosition();
    });
  };

  customDiv: any;
  updateDivPosition = () => {
    this.markersAndDivs.forEach((item, index) => {
      if (item.layer && item.layer.getLatLng()) {
        var point = this.map.latLngToContainerPoint(item.layer.getLatLng());
        this.markersAndDivs[index].div.style.left = point.x - 5 + 'px';
        this.markersAndDivs[index].div.style.top = point.y - 65 + 'px';
      }
    });
  };

  updateTooltipPosition = (mouseEvent: any) => {
    if (!mouseEvent?.latlng) {
      return;
    }

    this.lastDrawingLatLng = mouseEvent.latlng;

    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.showDrawTooltip(
      mouseEvent,
      this.getDrawingTooltipContent(mouseEvent.latlng)
    );
  };

  setTooltip = (mouseEvent: any) => {
    if (!mouseEvent?.latlng) {
      return;
    }

    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.isDrawStarted = true;
    this.startPoint = mouseEvent.latlng;
    this.lastDrawingLatLng = mouseEvent.latlng;
    this.showDrawTooltip(
      mouseEvent,
      this.getDrawingTooltipContent(mouseEvent.latlng)
    );
  };

  private getDynamicDrawingAreaSqKm(currentLatLng: L.LatLng | null | undefined): number | null {
    if (!this.startPoint || !currentLatLng) {
      return null;
    }

    if (this.selectedDrawControl === 'rectangle') {
      return this.calculateRectangleAreaSqKm(this.startPoint, currentLatLng);
    }

    if (this.selectedDrawControl === 'circle') {
      return this.calculateCircleAreaSqKm(this.startPoint, currentLatLng);
    }

    return null;
  }

  private calculateRectangleAreaSqKm(startPoint: any, endPoint: any): number | null {
    const startLat = Number(startPoint?.lat);
    const startLng = Number(startPoint?.lng);
    const endLat = Number(endPoint?.lat);
    const endLng = Number(endPoint?.lng);

    if (![startLat, startLng, endLat, endLng].every(Number.isFinite)) {
      return null;
    }

    const rectangle = turf.polygon([
      [
        [startLng, startLat],
        [endLng, startLat],
        [endLng, endLat],
        [startLng, endLat],
        [startLng, startLat],
      ],
    ]);

    return turf.area(rectangle) / 1000000;
  }

  private calculateCircleAreaSqKm(startPoint: any, endPoint: L.LatLng): number | null {
    if (typeof startPoint?.distanceTo !== 'function') {
      return null;
    }

    const centerLat = Number(startPoint?.lat);
    const centerLng = Number(startPoint?.lng);

    const radiusMeters = startPoint.distanceTo(endPoint);

    if (![centerLat, centerLng, radiusMeters].every(Number.isFinite)) {
      return null;
    }

    const circle = turf.circle([centerLng, centerLat], radiusMeters / 1000, {
      steps: 64,
    });

    return turf.area(circle) / 1000000;
  }

  private getDrawingTooltipContent(currentLatLng?: L.LatLng): string {
    const areaSqKm = this.getDynamicDrawingAreaSqKm(currentLatLng);
    const areaLine = this.getTooltipAreaLine(areaSqKm);

    if (this.selectedDrawControl === 'polyline') {
      return 'Double click or right click to end measurement.';
    }

    if (this.selectedDrawControl === 'polygon') {
      return 'Double click or right click to end polygon.';
    }

    if (this.selectedDrawControl === 'rectangle') {
      return `${areaLine}Click to finish rectangle.`;
    }

    if (this.selectedDrawControl === 'circle') {
      return `${areaLine}Click to finish circle.`;
    }

    return 'Drawing...';
  }

  finishDrawableShapeOnShortcut = (event: any) => {
    const isPolyline = this.selectedDrawControl === 'polyline';
    const isPolygon = this.selectedDrawControl === 'polygon';

    if (!isPolyline && !isPolygon) {
      return;
    }

    event?.originalEvent?.preventDefault?.();
    event?.originalEvent?.stopPropagation?.();

    const activeHandler = (this.drawControl as any)?._toolbars?.draw?._activeMode?.handler;
    const markers = activeHandler?._markers || [];
    const minimumVertices = isPolygon ? 3 : 2;

    if (!activeHandler) {
      return;
    }

    if (isPolygon && markers.length < minimumVertices) {
      const message =
        'Not enough coordinates to draw an AOI polygon. Three or more pairs are required for a polygon.';
      this.openPopupNoMapMove(WarningPopup, message, '', '50%');
      return;
    }

    if (markers.length < minimumVertices) {
      return;
    }

    if (isPolygon && typeof activeHandler?._finishShape === 'function') {
      activeHandler._finishShape();
      return;
    }

    if (typeof activeHandler?.completeShape === 'function') {
      activeHandler.completeShape();
    }
  };

  markerMouseOverListener = (layer: any) => {
    layer.bindTooltip('Click to remove').openTooltip();
  };

  markerClickListener = (layer: any) => {
    this.clearRFCircleLayers();
    const layerValue = this.drawnItems.getLayer(layer._leaflet_id);
    if (layerValue) {
      this.drawnItems.removeLayer(layerValue);
    }
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.pointArray = [];
    let poiWkt = '';
    this.map.removeLayer(layer);
    this.eventLayers = this.eventLayers.filter((layer1: any) => {
      return layer1._leaflet_id != layer._leaflet_id;
    });
    for (let markerLayer of this.eventLayers) {
      this.pointArray.push(
        `POINT (${markerLayer.getLatLng().lng} ${markerLayer.getLatLng().lat})`
      );
    }
    this.pointEntities = [...this.pointArray];
    if (this.pointArray?.length === 1) {
      this.target.geoJSON = this.pointArray[0];
      this.target.multiTarget = [];
      this.target.geotargets = null;
    } else {
      this.target.multiTarget = this.pointArray;
      this.target.geoJSON = this.pointArray.join(',');
      const geoPoints = this.geoParsePoint(this.target.geoJSON);
      this.target.geotargets = JSON.stringify(geoPoints);
    }
    this.generateMarkerNumber();
    this.updatePointTargetStateFromPointArray();
    this.updateTarget(this.target, '1');
    if (this.pointArray.length === 0 && this.target.taskStrategy === "TLE Based Tasking") {
      this.disableEnableDrawControls(false, '', 'TLE');
    } else if (this.pointArray.length === 0) {
      this.disableEnableDrawControls(true, '');
    } else if (this.taskStrategy !== 'TLE Based Tasking') {
      this.disableEnableDrawControls(false, 'marker');
    }
  };

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    if (!this.map || typeof this.map.getZoom !== 'function' || typeof this.map.getBounds !== 'function') {
      return;
    }
    
    try {
      this.zoomLevel = this.map.getZoom();
      const bounds = this.map.getBounds();
      
      if (!bounds || (typeof bounds.isValid === 'function' && !bounds.isValid())) {
        this.mapDistance = 0;
        return;
      }
      
      const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
      this.mapDistance = isNaN(distance) ? 0 : distance / 1000;
    } catch (error) {
      this.mapDistance = 0;
    }
  };

  calculatePolylineDistace = (layer: any) => {
    let distance = 0;
    layer.getLatLngs().forEach((latLng: any, index: any, array: any[]) => {
      if (index < array.length - 1) {
        distance += latLng.distanceTo(array[index + 1]);
      }
    });
    return distance;
  };

  calculateRectangleDistace = (layer: any) => {
    const bounds = layer.getBounds();
    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();
    const northWest = L.latLng(northEast.lat, southWest.lng);
    const southEast = L.latLng(southWest.lat, northEast.lng);
    const north = northWest.distanceTo(northEast);
    const east = northEast.distanceTo(southEast);
    const south = southEast.distanceTo(southWest);
    const west = southWest.distanceTo(northWest);
    const perimeter = north + east + south + west;
    return perimeter;
  };

  calculateRectanglePerimater = (startPoint: any, endPoint: any) => {
    const northEast = L.latLng(startPoint.lat, endPoint.lng);
    const southWest = L.latLng(endPoint.lat, startPoint.lng);
    const width = startPoint.distanceTo(northEast);
    const height = startPoint.distanceTo(southWest);
    return 2 * (width + height);
  };

  calculatePolygonPerimeter(polygon: any) {
    const vertices = polygon.getLatLngs();
    let perimeter = 0;
    if (Array.isArray(vertices[0])) {
      vertices[0].forEach((point, index, arr) => {
        if (index < arr.length - 1) {
          perimeter += point.distanceTo(arr[index + 1]);
        }
      });
      perimeter += vertices[0][vertices[0].length - 1].distanceTo(
        vertices[0][0]
      );
    }
    return perimeter;
  }

  calculateCircleCircumference(circle: any) {
    const radius = circle.getRadius();
    const circumference = 2 * Math.PI * radius;
    return circumference;
  }

  disableEnableDrawControls(isEnable: boolean, layerType: any, strategy?: any) {
    const toolbar: any = document.querySelector('.leaflet-draw-toolbar');
    if (!toolbar) {
      return;
    }
    const links: HTMLElement[] = Array.from(toolbar.querySelectorAll('a'));
    const isTleTasking = this.taskStrategy === 'TLE Based Tasking';
    const isRetaskMode = this.retask;
    const isMarkerLockInNormalMode =
      !isEnable && layerType === 'marker' && !isTleTasking && !isRetaskMode;

    if (isRetaskMode) {
      links.forEach((link: any) => {
        link.classList.add('disable-button');
      });
      // Keep only measurement tool enabled in retask mode.
      const measurementButton = toolbar.querySelector(
        '.leaflet-draw-draw-polyline'
      );
      if (measurementButton) {
        measurementButton.classList.remove('disable-button');
      }
      this.updateMapSearchAndResetControlState(true);
      return;
    }
    const isUploadOnlyStrategy =
      strategy === 'change-detection' || this.isChangeDetectionStrategy();

    if (isUploadOnlyStrategy) {
      links.forEach((link: any) => {
        const isUploadControl = link.classList.contains('toolbar-upload-control');
        const isResetControl = link.classList.contains('toolbar-reset-control');
        const isMeasureControl = link.classList.contains('leaflet-draw-draw-polyline');
        const shouldDisableUpload = layerType === 'fileupload';
        link.classList.toggle(
          'disable-button',
          (shouldDisableUpload && isUploadControl) ||
            (!isUploadControl && !isResetControl && !isMeasureControl)
        );
      });
      return;
    }

    if (isEnable == true) {
      links.forEach((link: any, index: any) => {
        if (this.retask && link.classList.contains('toolbar-reset-control')) {
          return;
        }
        link.classList.remove('disable-button');
        if (layerType == 'fileupload') {
          // In file-upload mode, keep only measure (4) and reset (6) enabled.
          if (index !== 4 && index !== 6) {
            link.classList.add('disable-button');
          }
          links.forEach((link: any) => {
          const isPersistentControl =
            link.classList.contains('leaflet-draw-draw-polyline') ||
            link.classList.contains('toolbar-reset-control');
          if (!isPersistentControl) {
            link.classList.add('disable-button');
          }
        });
        }

        if (isTleTasking) {
          link.classList.add('disable-button');
        }
      });
    } else if (isMarkerLockInNormalMode) {
      links.forEach((link: any, index: any) => {
        // Keep pin, measure, and reset available after pin placement.
        if (index === 0 || index === 4 || index === 6) {
          link.classList.remove('disable-button');
        } else {
          link.classList.add('disable-button');
        }
      });
    } else {
      links.forEach((link: any, index: any) => {
        if (isTleTasking || strategy === 'TLE') {
          link.classList.add('disable-button');
          return;
        }

        if (
          index != 4 &&
          index != 6 &&
          !(index == 0 && strategy === 'TLE')
        ) {
          link.classList.add('disable-button');
        } else if (index == 0 && strategy === 'TLE') {
          link.classList.remove('disable-button');
        }
      });
    }

    // TLE tasking has no drawing tools, but distance measurement stays usable.
    if (isTleTasking || strategy === 'TLE') {
      const measurementButton = toolbar.querySelector(
        '.leaflet-draw-draw-polyline'
      );
      measurementButton?.classList.remove('disable-button');
    }

    this.updateMapSearchAndResetControlState(isTleTasking);
  }


  private isChangeDetectionStrategy(): boolean {
    return this.taskStrategy === 'change-detection';
  }

  private updateSearchControlDisabledState(): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    if (!searchBtnParentEl) {
      return;
    }

    const shouldDisable = this.isChangeDetectionStrategy();

    if (shouldDisable) {
      this.resetSearchInput(false);
      searchBtnParentEl.classList.add('disable-button');
      searchBtnParentEl.style.pointerEvents = 'none';
      return;
    }

    searchBtnParentEl.classList.remove('disable-button');
    searchBtnParentEl.style.pointerEvents = '';
  }

  circleToBoxCordinates(circle: any): any {
    const center = circle.getLatLng();
    const radius = circle.getRadius() / 1000;
    const circleTurf = turf.circle([center.lng, center.lat], radius, {
      steps: 64,
    });
    // const circleGeoJSON = turf.feature(circleTurf);
    let circleAOI: any = turf.bboxPolygon(turf.bbox(circleTurf));
    let circleLng0 = circleAOI.bbox[0];
    let circleLat0 = circleAOI.bbox[1];
    let circleLng1 = circleAOI.bbox[2];
    let circleLat1 = circleAOI.bbox[3];
    let circleBoxCordinates = '';
    let accuracy = 15;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng0.toFixed(accuracy)} ${circleLat0.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng1.toFixed(accuracy)} ${circleLat0.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng1.toFixed(accuracy)} ${circleLat1.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng0.toFixed(accuracy)} ${circleLat1.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng0.toFixed(accuracy)} ${circleLat0.toFixed(accuracy)}`;
    return circleBoxCordinates;
  }

  private onPopupOpen(event: any, totalDistance: any): void {
    const distanceLabel =
      event.layerType === 'circle' ? 'Circumference' : 'Total Distance';
    const popupContent = `<div class="distance-popup">${distanceLabel} : ${Number(
      totalDistance
    ).toFixed(2)} km <button class="closeButton" data-layer-type="${
      event.layerType
    }">Close</button></div>`;
    let specificLatLng = L.latLng(51.505, -0.09);
    if (event.layerType == 'polyline') {
      specificLatLng = event.layer._latlngs[event.layer._latlngs.length - 1];
    }
    if (event.layerType == 'rectangle') {
      specificLatLng = event.layer.getBounds().getNorthWest();
    }
    if (event.layerType == 'polygon') {
      specificLatLng = event.layer._latlngs[0][event.layer._latlngs.length - 1];
    }
    if (event.layerType == 'circle') {
      specificLatLng = event.layer._latlng;
    }
    event.layer
      .bindPopup(popupContent, {
        autoClose: false,
        closeOnClick: false,
        direction: 'auto',
        closeButton: false,
      })
      .addTo(this.map);
    event.layer.off('click');
    event.layer.openPopup(specificLatLng);
  }

  handlePopupOpen = (event: any) => {
    const closeButton = event.popup._container.querySelector('.closeButton');
    if (closeButton) {
      closeButton.onclick = (clickEvent: MouseEvent) => {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        const layer = event.popup._source;
        const layerType = closeButton.getAttribute('data-layer-type');

        if (layerType === 'polyline') {
          this.removePopupSourceLayer(layer);
          return;
        }

        layer?.closePopup?.();
      };
    }
  };

  private removePopupSourceLayer(layer: any): void {
    if (!layer) {
      return;
    }

    layer.closePopup?.();
    layer.unbindPopup?.();

    const layerId = layer?._leaflet_id;
    const layerValue = layerId ? this.drawnItems?.getLayer(layerId) : null;
    if (layerValue) {
      this.drawnItems.removeLayer(layerValue);
    }

    if (this.map?.hasLayer(layer)) {
      this.map.removeLayer(layer);
    }
  }

  private clearClosedAoiTarget(layer: any): void {
    const layerId = layer?._leaflet_id;

    this.eventLayers = [];
    this.target.area = null;
    this.target.geoJSON = null;
    this.target.geotargets = null;
    this.target.targetPoints = null;
    this.target.polygon = false;
    this.target.circleData = null;

    if (!layerId || this.position?._leaflet_id === layerId) {
      this.position = null;
      this.layerData = null;
    }

    this.updateTarget(this.target, '0');
  }

  private refreshDrawControlsAfterPopupClose(): void {
    if (this.target?.geoJSON) {
      this.disableEnableDrawControls(false, '');
      return;
    }

    if (this.taskStrategy === 'TLE Based Tasking') {
      this.disableEnableDrawControls(false, '', 'TLE');
    } else {
      this.disableEnableDrawControls(true, '');
    }
  }

  decimalToDMS(lat: number, lng: number): string {
    const convert = (decimal: number) => {
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(1);
      return `${degrees}° ${minutes}' ${seconds}"`;
    };
    const latitude = convert(lat) + (lat >= 0 ? ' N' : ' S');
    const longitude = convert(lng) + (lng >= 0 ? ' E' : ' W');
    return `Lng:${longitude}, Lat:${latitude}`;
  }

  clearSearchResults(preserveSearchText = false) {
    if (this.searchMarker) {
      this.map.removeLayer(this.searchMarker);
      this.searchMarker = null;
    }
    if (preserveSearchText) {
      return;
    }
    const input: any = document.querySelector('.glass ');
    if (input) {
      input.value = '';
    }
  }

  async selectRecord(rowData: any) {
    try {
      const res: any = await this.apiService
        .getObservations(rowData?.openWater)
        .toPromise();
      this.observationOptions = res?.observations;
      this.rulesOptions = res?.ruleBased;
      this.feedList = res?.feeds;
      this.formGroup
        .get('tipAndCueBasedOn')
        .setValue(rowData?.tipAndCueBasedOn);
      const ruleFilter = this.rulesOptions.filter(
        (el) => el.rule === rowData?.rule
      );
      this.formGroup.get('rule').setValue(ruleFilter[0]?.rule_key);

      if (rowData?.feeds)
        this.formGroup.get('feeds').setValue(rowData?.feeds[0]?.name);
      if (rowData?.observation)
        this.formGroup
          .get('observation')
          .setValue(rowData?.observation[0]?.name);
    } catch (error) {}
    this.formGroup.get('searchControl').setValue(rowData?.question);
    this.formGroup.get('priority').setValue(rowData?.taskPriority);
    this.formGroup.get('project').setValue(rowData?.project);
    let taskName = rowData?.taskname;
    this.formGroup.get('taskname').setValue(taskName);
    this.formGroup.controls.projectId.setValue(rowData?.projectid);
    this.formGroup.get('purpose').setValue(rowData?.purpose);
    const purposeFilter = this.purposeOption.filter(
      (el) => el.purpose === rowData.purpose
    );
    if (purposeFilter?.length > 0) {
      this.onPurposeChange(purposeFilter[0]);
    } else {
      let option = [
        {
          code: '8',
          purpose: rowData.purpose,
        },
      ];
      this.target.purposeOption = option[0];
    }

    const frequencyFilter = this.frequencyOption.filter(
      (el) => el.id === rowData.frequency
    );
    this.formGroup.get('frequency').setValue(frequencyFilter[0]?.name);
    this.onOptionChange(frequencyFilter[0]?.id);
    if (rowData.taskStrategy) {
      const strategyFilter = this.strategyOptions.filter(
        (el) =>
          el.value === rowData.taskStrategy ||
          (rowData.taskStrategy === 'Tip-and-Cue-Outcome' &&
            el.value === 'Tip-and-Cue')
      );
      this.formGroup.get('strategyRadio').setValue(strategyFilter[0]?.name);
      this.taskStrategy = strategyFilter[0]?.value;
    }
    if (this.taskStrategy === 'TLE Based Tasking') {
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      this.minDate = this.tleMinDate;
      this.maxDate = new Date(year, month - 1, day + 3);
      this.date = new FormControl(new Date(year, month - 1, day + 1));
      this.range = new FormGroup({
        start: new FormControl(this.tleMinDate),
        end: new FormControl(new Date(year, month - 1, day + 3)),
      });
      this.tleSensorForm.patchValue({
        scenario: 'Predicted (TOI)',
        minutesAhead: 90,
      });
      this.selectedSensorObfuscatedName = {
        sensorName: rowData.request[0]?.name || '',
        obfuscateName: rowData.request[0]?.obfuscateName || '',
        sensorId: rowData.request[0]?.sensorId || '',
        swath: rowData.request[0]?.swath || null,
      };
    }

    if (rowData?.intent?.intent_key) {
      const intentFilter = this.intentOption.filter(
        (el) => el.intent_key === rowData?.intent.intent_key
      );
      this.formGroup.get('intent').setValue(intentFilter[0]?.name);
    } else if (rowData?.intent?.key) {
      let intentFilter: any;
      const match = this.intentOption.find(
        (el) => el.intent_key === rowData?.intent.key
      );
      if (match) {
        intentFilter = this.intentOption.filter(
          (el) => el.intent_key === rowData?.intent.key
        );
        this.updatedIntentOption = match;
      } else {
        const internalUseItem = this.intentOption.find(
          (item: any) => item.intent_key === 'internalUse'
        );
        if (internalUseItem) {
          intentFilter = [internalUseItem];
          this.updatedIntentOption = internalUseItem;
        } else {
          intentFilter = [this.intentOption[0]];
          this.updatedIntentOption = this.intentOption[0];
        }
      }
      this.formGroup.get('intent').setValue(intentFilter[0]?.name);
    } else this.formGroup.get('intent').setValue(rowData?.intent);

    if (rowData?.useCase) {
      this.formGroup.get('useCase').setValue(rowData.useCase);
    }

    if (rowData?.useCaseDescription) {
      this.formGroup
        .get('useCaseDescription')
        .setValue(rowData.useCaseDescription);
    }
    this.selectedOption = rowData.frequency;
    this.clickFrequency = true;
    this.subDaily = false;
    if (rowData.frequency === 1) {
      this.target.freqOption = rowData?.repeatFrequency;
      if (this.target.freqOption === 'Sub-daily') {
        this.subDaily = true;
        this.target.subDailyCount = rowData?.subDailyCount;
      }
      if (this.target.freqOption === 'Days') {
        this.recurrentDays = true;
        this.target.recurringDays = this.retask
          ? []
          : Array.isArray(rowData?.recurringDays)
          ? [...rowData.recurringDays]
          : [];
      }
      if (this.target.freqOption === 'Number of collections') {
        this.target.noOfCollections = rowData?.noOfCollections ?? rowData?.noOfRepeats ?? 1;
      }
    }
    let targetData = JSON.parse(rowData.target);
    let type: any, coordinates: any;

    let targetPoints = rowData?.targetPoints
      ? JSON.parse(rowData.targetPoints)
      : null;

    const isLBandIncluded = rowData.request.some(
      (item) => item.operatorKey === OPERATORS.LBAND
    );
    if (targetData?.length > 1) {
      type = targetData[0]?.type.toUpperCase();
      this.createGeoJSONFile(targetData);
    } else {
      type = targetData?.type.toUpperCase();
      coordinates = JSON.parse(rowData.target).coordinates;
      if (type === 'POINT') {
        this.drawPoint(coordinates);
        if (isLBandIncluded) {
          this.drawRFCircle(coordinates, RF_RADIUS * 1000);
        }
      } else if (type === 'POLYGON') {
        this.drawpolygon(coordinates, rowData.area);
        if (isLBandIncluded && targetPoints) {
          let points = targetPoints[0]
            .replace('POINT (', '')
            .replace(')', '')
            .split(' ');
          let coordinates = [parseFloat(points[0]), parseFloat(points[1])];

          //  this.drawPoi(coordinates);
        }
      }
    }
    if (rowData?.taskSubStrategy) {
      const subStartegyFilter = this.subStrategyOptions.filter(
        (el) => el.value === rowData?.taskSubStrategy
      );

      this.formGroup
        .get('subStrategyRadio')
        .setValue(subStartegyFilter[0]?.name);
    }
    this.projName = rowData?.project;
    this.taskName = taskName;
    this.target.projectId = rowData?.projectid;
    this.target.selectedOption = this.selectedOption;
    this.target.fileName = rowData?.fileName;
    this.target.intent =
      this.updatedIntentOption == false
        ? rowData?.intent
        : this.updatedIntentOption;
    this.target.taskStrategy = rowData?.taskStrategy;
    this.taskStrategy = rowData?.taskStrategy;
    this.tipAndCueBasedOn = rowData?.tipAndCueBasedOn;
    this.target.tipAndCueBasedOn = rowData?.tipAndCueBasedOn;
    this.rule = rowData?.rule;
    this.target.rule = rowData?.rule;
    this.observation = rowData?.observation;
    this.target.observation = rowData?.observation;
    this.observationData = rowData?.observationData;
    this.target.observationData = rowData?.observationData;
    if (rowData?.observation) this.target.observation = rowData?.observation[0];
    this.target.useCase = rowData?.useCase;
    this.target.useCaseDescription = rowData?.useCaseDescription;
    this.updateTarget(this.target, '0');
  }

  private async loadRetaskTask() {
    const taskId = this.retaskTaskId || this.route.snapshot.queryParamMap.get('taskId');
    const sensorId = this.retaskSensorId || this.route.snapshot.queryParamMap.get('sensorId');

    if (!taskId) {
      return;
    }

    try {
      const response: any = await firstValueFrom(
        this.apiService.getTaskById(taskId, sensorId)
      );
      const task = response?.data;

      if (!task) {
        return;
      }

      const retaskTask = this.applyRetaskSensorSelection(task, sensorId);
      this.selectedTasks = retaskTask;
      this.retaskTaskId = retaskTask?.taskId || retaskTask?.id || taskId;
      this.retaskSensorId = sensorId 
      this.retaskOption = this.retaskOption || retaskTask?.retaskSelectionMode;
      this.sendParentTaskId = !!retaskTask?.sendParentTaskId;
      this.target['isRetask'] = true;
      this.target['sendParentTaskId'] = this.sendParentTaskId;
      this.target['parentTaskId'] = retaskTask?.parentTaskId;
      await this.selectRecord(retaskTask);
      this.focusRetaskTarget();
    } catch (error) {
      console.error('Failed to load retask task details', error);
    }
  }

  private applyRetaskSensorSelection(task: any, sensorId?: string): any {
    if (!task || !sensorId || !Array.isArray(task?.request)) {
      return task;
    }

    const filteredRequest = task.request.filter(
      (item: any) => String(item?.sensorId || item?.uuid || '') === String(sensorId)
    );

    if (!filteredRequest.length) {
      return task;
    }

    return {
      ...task,
      sensorId,
      uuid: sensorId,
      request: filteredRequest,
    };
  }

  private focusRetaskTarget() {
    if (!this.map || !this.selectedTasks?.target) {
      return;
    }

    const points = JSON.parse(this.selectedTasks.target);

    if (points && points['type'] == 'Polygon') {
      var latLngsArray = points['coordinates'][0].map(function (latlng) {
        return L.latLng(latlng[1], latlng[0]);
      });
      var bounds = L.latLngBounds(latLngsArray);
      this.map.fitBounds(bounds);
      this.map.setZoom(this.zoomLevel);
    } else if (points && points['type'] == 'Point') {
      this.map.setView(
        [points['coordinates'][1], points['coordinates'][0]],
        this.zoomLevel
      );
    } else if (Array.isArray(points) && points.length > 0) {
      const latLngs = points
        .filter((p: any) => p?.type === 'Point' && Array.isArray(p?.coordinates))
        .map((p: any) => L.latLng(p.coordinates[1], p.coordinates[0]));
      if (latLngs.length > 0) {
        this.map.fitBounds(L.latLngBounds(latLngs));
        this.map.setZoom(this.zoomLevel);
      }
    }
  }

  drawPoint(positionArray) {
    var longitude = parseFloat(positionArray[0]);
    var latitude = parseFloat(positionArray[1]);
    const accuracy = 15;
    let poiWkt = `POINT (${longitude.toFixed(accuracy)} ${latitude.toFixed(
      accuracy
    )})`;
    this.pointEntities.push({ poiWkt: poiWkt });
    this.target.geoJSON = poiWkt;
    this.formGroup.get('target').setValue(poiWkt);
    let marker = L.marker([latitude, longitude]).addTo(this.map);
    this.setMapView(latitude, longitude);
    this.getCountryAndPlace(latitude, longitude, 'search');
  }

  setMapView(lat, lng) {
    if (!this.retask) {
      const defaultLocation: [number, number] = [20.5937, 78.9629];
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(this.currentUser?.country)}`;
      
      this.http.get<any[]>(url).pipe(
        take(1),
        timeout(5000),
        catchError((error) => {
          return of([{ lat: defaultLocation[0], lon: defaultLocation[1] }]);
        })
      ).subscribe({
        next: (data: any) => {
          if (data && data.length > 0) {
            const lat = Number(data[0].lat)
            const lon = Number(data[0].lon);
            this.map.setView([lat, lon], 10);
          } else {
            this.map.setView(defaultLocation, 10);
          }
        },
        error: (error) => {
          this.map.setView(defaultLocation, 10);
        }
      });
    } else {
      this.focusRetaskTarget();
    }
  }

  drawpolygon(positionArray, area) {
    this.polygons.push(positionArray[0]);
    let aoiWkt: any = 'POLYGON ((';
    const accuracy = 15;
    let polyPts: any = [],
      aoi: any,
      lng0 = 0,
      lat0 = 0;

    let modifiedArray = positionArray[0].map((sub) => {
      return [sub[1], sub[0]];
    });

    var polygon = L.polygon(modifiedArray, { color: 'red' });

    if (polygon && this.map) {
      polygon.addTo(this.map);
      this.map.fitBounds(polygon.getBounds());
      this.rfCircleLayer.push(polygon);
    }

    for (let i = 0; i < positionArray[0]?.length - 1; i++) {
      let lng = positionArray[0][i][0];
      let lat = positionArray[0][i][1];
      if (i === 0) {
        lng0 = lng;
        lat0 = lat;
      }
      polyPts.push([lng, lat]);
      aoiWkt = aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
    }
    polyPts.push([lng0, lat0]);
    aoi = turf.polygon([polyPts]);
    aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
    aoiWkt = aoiWkt + `))`;
    this.target.geoJSON = aoiWkt;
    this.target.area = area;
    this.formGroup.get('target').setValue(aoiWkt);
    this.getCountryAndPlace(lat0, lng0, geoParse(this.target.geoJSON));
  }

  async createGeoJSONFile(features: any[]) {
    this.pointArray = [];
    const geoJSON: any = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
    const fpPos = features[0].coordinates;
    const lng = fpPos[0],
      lat = fpPos[1];
    this.map.setView([lat, lng]);
    L.geoJSON(geoJSON).addTo(this.map);

    for (let latlng of features) {
      this.pointArray.push(
        `POINT (${latlng.coordinates[0]} ${latlng.coordinates[1]})`
      );
    }
    this.updatePointTargetStateFromPointArray();
  }

  usecasedescChng(event: any) {
    this.target.useCaseDescription = event.target.value;
    this.updateTarget(this.target, '0');
  }

  descChng(event: any) {
    let option = [
      {
        code: '8',
        name: event.target.value,
      },
    ];
    this.target.purposeOption = option[0];
    this.updateTarget(this.target, '0');
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }

  get budgetFields() {
    return this.budgetForm.controls;
  }

  get outcomeFields() {
    return this.outComeForm.controls;
  }

  get fields() {
    return this.formGroup.controls;
  }
  get tleSensorFields() {
    return this.tleSensorForm.controls;
  }

  getTooltip(name: string) {
    if (name === 'Period') return 'Tasked once within the period specified. Use this frequency option when the time of interest (TOI) is over 24 hours across dates.';
    else if (name === 'Specific Date')
      return 'Tasked once on the date specified';
    else if (name === 'Recurrent')
      return 'Tasked repeatedly, either sub-daily, daily, weekly or monthly, within the period specified';
    else if(name === 'Specific Day')
      return 'Tasked once on the day specified';
    else if(name === 'Recurrent Days')
      return 'Tasked on selected days recurrently within the period'; 
    else return 'Description for ' + name.toLowerCase() + ' frequency';
  }

  private getLayerCount(layer: any): number {
    if (!layer) return 0;
    if (typeof layer.getLayers === 'function') return layer.getLayers().length; // Group/GeoJSON
    return 1; // Polygon/Polyline = single layer
  }

  updateTarget(target, idx ,isRestore = false) {
    const previousGeoJSON = this.lastTargetGeoJSON;
    target.area = target?.area ?? 0;
    this.target.area = target.area;
    const layerCount = this.getLayerCount(this.geoJsonLayer);
    if (idx !== 0 && target?.geoJSON && !target.geoJSON.includes('POINT')) {
      this.callCounter++;
    }
    this.target = {
      ...target,
      project: this.projName?.trim(),
      taskname: this.taskName?.trim(),
    };
    const hasTarget = this.hasSelectedTargetValue();
    const isTipAndCueFlow = this.taskStrategy === 'Tip-and-Cue' && this.subStrategy === 'Tip-and-Cue';

    if (isTipAndCueFlow && hasTarget && !this.target?.tipAndCueBasedOn) {
      this.tipAndCueBasedOn = 'Rules';
      this.target.tipAndCueBasedOn = 'Rules';
      this.formGroup?.get('tipAndCueBasedOn')?.setValue('Rules', { emitEvent: false });
    }

    this.clearTipAndCueSelectionWithoutTarget();
    if (  !isRestore &&
      idx !== 0 &&
      this.callCounter === 1 &&
      (!this.geoJsonLayer || layerCount === 1) && !this.retask
    ) {
      this.isAreaOk(target.area);
    }
    this.resetOutcome();
    this.apiService.updateTaskParams(this.target);
    this.weatherData = [];
    this.formGroup.controls.target.setValue(target?.geoJSON);
    this.lastTargetGeoJSON = target?.geoJSON ?? null;
    this.loadCloudCoverEligibility();
    this.closePanels();
  }

  onOptionChange(chosenOption: any) {
    if (this.isChangeDetectionStrategy() && chosenOption !== 'Recurrent') {
      chosenOption = 'Recurrent';
      this.formGroup.get('frequency')?.setValue(chosenOption, { emitEvent: false });
      this.budgetForm.get('frequency')?.setValue(chosenOption, { emitEvent: false });
    }
    this.resetDateDefault();
    this.tipAndCueEndSelectedByUser = false;
    this.target.freqOption = '';
    this.dateFlag = false;
    this.fortnightlyRangeError = false;
    this.changeDetectionToiRangeError = false;
    this.lastChangeDetectionToiWarningKey = null;
    this.subDaily = false;
    this.recurrentDays = false;
    this.target.noOfCollections = null;
    this.target.subDailyCount = '';
    this.target.recurringDays = [];
    const selectedFrequencyOption = this.getFrequencyOption(chosenOption);
    const id = selectedFrequencyOption?.id ?? -1;
    this.selectedFrequencyID = id;
    this.selectedOption = id;
    this.loadCloudCoverEligibility();
    this.clickFrequency = true;
    this.target.selectedOption = id;
    this.formGroup.get('startTime').setValue(null);
    this.formGroup.get('endTime').setValue(null);
    this.budgetForm.get('startTime').setValue(null);
    this.budgetForm.get('endTime').setValue(null);
    this.budgetForm.patchValue({
      resolution: '',
      sensorType: '',
      updateFrequency: '',
      taskingTier: '',
      cloudCover: '',
      holdBack: '',
      weatherResolution: '',
      weatherVariables: [],
    });
    this.updateFrequencyOption = false;
    this.weatherResolutionOptions = [];
    this.weatherVariableOptions = [];
    this.range.value.start = null;
    this.range.value.end = null;
    if (id === 1) {
      this.target.freqOption = this.isChangeDetectionStrategy() ? 'Weekly' : 'Daily';
      this.target.repeatOption = this.isChangeDetectionStrategy() ? 2 : 1;
    }

    this.syncSpecificDayValidators();
    
    if (id === 1 || id === 2 ) {
      this.range.value.start = this.date.value;
      const day = this.todayDate.getDate();
      const month = this.todayDate.getMonth() + 1;
      const year = this.todayDate.getFullYear();
      this.range.value.end = new Date(
        year,
        month - 1,
        day + this.defaultWindow
      );

        } else {
          this.range.value.start = this.date.value;
          this.range.value.end = this.date.value;
        }

    this.sensorList?.handleToiChangedReactionTimeWarnings();
  }

  handleDayChange(event: any){
    if (this.isSpecificDayDisabled(event)) return;
    const selectedDate = this.getDateFromDay(event);
    this.formGroup.get('specificDay')?.setValue(event);
    this.budgetForm.get('specificDay')?.setValue(event);
    this.target.freqOption = event;
    this.date.setValue(selectedDate);
    this.handleDateChange({ value: selectedDate }, 1);
  }

  handleDateChange(event: any, datePicker: any) {
    this.formGroup.get('startTime').setValue(null);
    this.formGroup.get('endTime').setValue(null);
    this.budgetForm.get('startTime').setValue(null);
    this.budgetForm.get('endTime').setValue(null);
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.tleSensorForm.get('startTime')?.setValue(null);
      this.tleSensorForm.get('endTime')?.setValue(null);
    }
    this.resetControlsBelow('date');
    if (datePicker === 1) {
      this.range.value.start = this.range.value.end =  event.value;
    } else if (datePicker === 2) {
      if (this.taskStrategy === 'TLE Based Tasking') {
        this.clearTLEOnly();
        this.showtleDisabled = false;
        this.showtleClick = false;
      }
      this.range.value.start = event.value;
      this.range.get('end')?.setValue(null, { emitEvent: false });
      this.range.value.end = null;
    } else if (datePicker === 3) {
      if (this.taskStrategy === 'TLE Based Tasking') {
        this.showtleDisabled = false;
        this.showtleClick = false;
        this.clearTLEOnly();
      }
      this.range.value.end = event.value;
      this.tipAndCueEndSelectedByUser = !!event.value;
    }
    this.showtleClick = false;

    if (this.range.value.start !== null && this.range.value.end !== null) {
      const condition =
        this.taskStrategy === 'TLE Based Tasking'
          ? this.range.value.start <= this.range.value.end
          : this.range.value.start < this.range.value.end;
      if (condition) {
        this.dateFlag = false;
      } else {
        this.dateFlag = true;
      }
      if (this.taskStrategy === 'TLE Based Tasking') {
        const startDate = new Date(this.range.value.start);
        const endDate = new Date(this.range.value.end);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        const now = new Date();
        const maxAllowedStart = new Date();
        maxAllowedStart.setHours(now.getHours() + 72);

        if (startDate.getTime() > maxAllowedStart.getTime()) {
          this.tleStartRangeError = true;
        } else {
          this.tleStartRangeError = false;
        }

        const timeDifferenceMs = endDate.getTime() - startDate.getTime();
        const timeDifferenceDays = timeDifferenceMs / (1000 * 60 * 60 * 24);

        if (timeDifferenceDays > 3) {
          this.tleRangeError = true;
        } else {
          this.tleRangeError = false;
        }
      }
      if (this.selectedOption === 1 && this.subDaily) {
        this.dateFlag = false;
      }
    } else {
      this.dateFlag = false;
    }

    this.updateFortnightlyRangeError();
    this.updateChangeDetectionToiRangeError(true);
    this.target['openWindow'] = this.range.value.start;

    // If sensors are already selected, re-check reaction time vs new TOI lead time.
    this.sensorList?.handleToiChangedReactionTimeWarnings();

    if (datePicker === 3) {
      this.enforceSmallBoatTipAndCueWindow();
    }

    this.updateTarget(this.target, '0');
  }

  freqChange(chosenOption: any) {
    if (this.isRepeatOptionDisabled(chosenOption)) {
      chosenOption = this.getDefaultChangeDetectionRepeatOption();
    }
    this.subDaily = false;
    this.recurrentDays = false;
    this.fortnightlyRangeError = false;
    this.target.noOfCollections = null;
    this.target.subDailyCount = '';
    this.target.recurringDays = [];
    this.target.freqOption = chosenOption.name;
    this.target.repeatOption = chosenOption.value;
    if (this.target.repeatOption === 4) {
      this.subDaily = true;
      this.target.subDailyCount = 1;
    }
    if(this.target.repeatOption === 5){
      this.recurrentDays = true;
    }
    if (this.target.freqOption === 'Number of collections') {
      this.target.noOfCollections = 1;
    }

    this.updateFortnightlyRangeError();
    this.updateChangeDetectionToiRangeError();

    this.sensorList?.handleToiChangedReactionTimeWarnings();
    this.updateTarget(this.target, '0');
  }

  recurrentCountChange(chosenOption: any) {
    this.target.subDailyCount = chosenOption.label;
    this.updateTarget(this.target, '0');
  }

  onNumberOfCollectionsChange(value: any) {
    const parsedValue = Number(value);
    this.target.noOfCollections = Number.isNaN(parsedValue) ? value : parsedValue;
    this.updateTarget(this.target, '0');
  }

  get selectedRepeatOption() {
    return (
      this.TASKFREQUENCY?.find((option: any) => option.name === this.target?.freqOption) ||
      (this.isChangeDetectionStrategy()
        ? this.getDefaultChangeDetectionRepeatOption()
        : this.TASKFREQUENCY?.find((option: any) => option.name === 'Daily'))
    );
  }

  private getDefaultChangeDetectionRepeatOption() {
    return (
      this.TASKFREQUENCY?.find((option: any) => option.name === 'Weekly') ||
      { name: 'Weekly', value: 2 }
    );
  }

  isRepeatOptionDisabled(option: any): boolean {
    if (!this.isChangeDetectionStrategy()) {
      return false;
    }

    return !['Weekly', 'Fortnightly', 'Monthly'].includes(option?.name);
  }

  private getRecurringDaysPayload(): string[] | null {
    const selectedFrequency = this.target?.selectedOption ?? this.selectedOption;

    if (selectedFrequency !== 1 || this.target?.freqOption !== 'Days') {
      return null;
    }

    return Array.isArray(this.target?.recurringDays)
      ? [...new Set<string>(this.target.recurringDays)]
      : [];
  }

  hasValidRecurringDaysSelection(): boolean {
    const recurringDays = this.getRecurringDaysPayload();

    if (recurringDays === null) {
      return true;
    }

    return recurringDays.length > 0;
  }

  isNumberOfCollectionSelected(): boolean {
    return this.target?.selectedOption === 1 && this.target?.freqOption === 'Number of collections';
  }

  hasValidNumberOfCollectionsSelection(): boolean {
    if (!this.isNumberOfCollectionSelected()) {
      return true;
    }

    const numberOfCollections = Number(this.target?.noOfCollections);
    return Number.isInteger(numberOfCollections) && numberOfCollections >= 1;
  }

  onPurposeChange(option: any, selectedUseCase: any = null) {
    this.useCaseOption = null;
    this.target.useCase = null;
    if (option.purpose === 'Others') {
      this.others = true;
    } else {
      this.others = false;
      this.target.purposeOption = option;
    }
    if (this.taskStrategy === 'Help Select Sensor(s)') {
      this.userService.getUseCases(option._id).subscribe((res: any) => {
        this.useCaseOption = res.data.sort((a, b) => {
          return a.useCase.toLowerCase().localeCompare(b.useCase.toLowerCase());
        });

        if (selectedUseCase) {

          const useCaseFilter = this.useCaseOption.find(
              (el: any) => el.useCase === selectedUseCase.useCase
            );

          if (useCaseFilter) {
            this.formGroup.get('useCase')?.setValue(useCaseFilter);
            this.target.useCase = useCaseFilter;
          }
        }
        this.updateTarget(this.target, '0');
      });
    } else this.updateTarget(this.target, '0');
  }

  intentChange(option: any) {
    this.target.intent = option;
    this.showtleClick = false;
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.tleSensorForm.reset({
        scenario: 'T-Mins Ahead',
        minutesAhead: 90,
      });
      this.tleSensor = {
        resolution: [],
        sensor: [],
      };
      this.tleSensorTypes(this.userid, option._id);
      this.clearTLEOnly();
    }
    this.updateTarget(this.target, '0');
    if (this.budget) {
      this.budgetForm.patchValue({
        resolution: '',
        cloudCover: '',
        taskingTier: '',
        holdBack: '',
        sensorType: '',
        weatherResolution: '',
        weatherVariables: [],
      });
      this.updateFrequencyOption = false;
      this.weatherResolutionOptions = [];
      this.weatherVariableOptions = [];
      this.budgetInputs.resolutionArr = [];
      this.budgetInputs.tierArr = [];
      this.budgetInputs.cloudCoverKeys = [];
      this.budgetInputs.holdbackArr = [];
      this.budgetSensorType = [];
      let data = {
        intent: option,
        selectedCategory: this.selectedCategory,
        multiPoi:
          this.target.multiTarget && this.target.multiTarget.length > 0
            ? true
            : false,
      };
      of(data)
        .pipe(
          switchMap((payload) => this.apiService.getBudgetSensorType(payload)),
          takeUntil(this.destroy$)
        )
        .subscribe((res: any) => {
          if (res?.msg == 'Success') {
            this.budgetSensorType = res.response;
          } else {
            const message = WARNING_MESSAGES.NO_SENSORS_FOR_INTENT;
            const dialogRef = this.popupService.openPopup(
              WarningPopup,
              message,
              '',
              '50%'
            );
            dialogRef.afterClosed().subscribe((result) => {
              this.budgetForm.patchValue({ intent: '' });
            });
          }
        });
    }
  }

  outcomeIntentChange(option: any) {
    this.target.intent = option;
  }

  useCaseChange(option: any) {
    this.target.useCase = option;
    this.updateTarget(this.target, '0');
  }

  nameChng(e: any, i: number) {
    if (i === 1) {
      this.target.projectId = null;
      if (e.target.value.length > 3) {
        this.projName = e.target.value;
      } else {
        this.projName = undefined;
      }
    } else {
      if (e.target.value.length > 4) {
        this.taskName = e.target.value;
      } else {
        this.taskName = undefined;
      }
    }
    this.updateTarget(this.target, '0');
  }

  inValid() {
    if (!this.taskTarget) return true;
    if (
      this.taskName &&
      this.projName &&
      this.taskTarget.includes('P') &&
      this.selectedSensorTypes.length > 2
    ) {
      this.showSensors = true;
      return false;
    } else {
      this.showSensors = false;
      return true;
    }
  }

  isAreaOk(area) {
    this.target.area = area;
    if (this.target)
      if (
        (this.target.area > 2000 || this.target.area < 10) &&
        this.target.geoJSON?.includes('POLY')
      ) {
        const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
          width: '60%',
          backdropClass: 'blurr',
          data: this.target,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.proceed = true;
            this.buttonDisable = true;
            this.target.buttonDisable = true;
          } else {
            this.proceed = false;
            this.resetMap();
            this.disableEnableDrawControls(true, '');
          }
        });
        return this.proceed;
      }
    return;
  }

  getFileData() {
    this.drawingMode = 'fileUpload';
    const entities = this.viewer.entities.values;
    for (const entity of entities) {
      if (
        (entity.id == undefined || entity.id == null) &&
        entity?.name !== 'allowedArea'
      ) {
        this.viewer.entities.remove(entity);
      }
    }

    const doc = document.getElementById('filedatas');
    if (doc) {
      doc.click();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(CollectionPopupComponent, {
      width: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        message:
          'Multi-polygon AOI is not supported at this time. Please submit a single contiguous polygon with any internal boundaries dissolved.',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.resetMap();
    });
  }

  resetMe(parentVal: any) {
    if (parentVal === 'Reset') {
      this.formGroup.controls['taskname'].setValue('');
      this.target['taskname'] = '';
      this.target.polygon = false;
      this.apiService.updateTaskParams(this.target);
      this.formGroup.get('project')?.reset();
      this.formGroup.get('taskname')?.reset();
      this.formGroup.get('target')?.reset();
      this.formGroup.get('searchControl')?.reset();
      this.formGroup.get('priority')?.reset(this.isFeedTask ? 'fastest' : null);
    }
  }
  resetMap(task?: string, preserveSearchText = false) {
    this.removeDrawTooltip();
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }
    this.markersAndDivs.forEach((customDivs) => {
      customDivs.div.remove();
    });
    if (this.eventLayers.length > 0) {
      this.eventLayers.pop();
    }
    if (this.numberBadgeMarkers && this.numberBadgeMarkers.length > 0) {
      this.numberBadgeMarkers.forEach((badge) => {
        if (this.map && badge) {
          this.map.removeLayer(badge);
        }
      });
      this.numberBadgeMarkers = [];
    }
    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }

    this.position = null;
    this.layerData = null;
    this.clearSatllite();
    this.eventLayers = [];
    this.pointArray = [];
    this.pointEntities = [];
    this.target.multiTarget = [];
    this.resetStripState();
    this.buttonDisable = false;
    this.target.buttonDisable = false;
    this.target.area = null;
    this.target.geoJSON = null;
    this.target.geotargets = null;
    // These describe the geometry being cleared, so they must go with it —
    // otherwise a previous open-water target leaves openWater true and AIS
    // observations stay on offer for the next target, even on land.
    this.target.openWater = null;
    this.target.overOpenWater = null;
    this.target.place = null;
    this.target.country = null;
    this.target.countryCode = null;
    this.callCounter = 0;
    this.shapeSelected = false;
    this.markersAndDivs = [];
    this.target.targetPoints = null;
    this.searchedAoiDMS = null;
    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = null;
    }
    this.clearSearchResults(preserveSearchText);

    if (task === 'tle' || this.satLayer) {
      this.clearTLEOnly();
    }

    this.updateTarget(this.target, '0');
    if (this.selectedCategory === this.nonImagingSensor) {
      this.range?.reset({
        start: null,
        end: null,
      });
    }
  }

  polylines: any[] = [];

  receivedMessageHandler(result: any) {
    this.clearSatllite();
    let isUnchecked = false;
    let removeIndex = -1;
    this.satellites = result;
    for (let i = 0; i < this.satellites.length; i++) {
      let satelliteData = this.satellites[i];
      let modifiedArray = satelliteData.position.map((sub) => {
        return [sub[1], sub[0]];
      });
      modifiedArray = modifiedArray.slice(-70);
      const satelliteIcon = L.icon({
        iconUrl: 'assets/images/satellite.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
      let image = L.marker(modifiedArray[0], { icon: satelliteIcon }).addTo(
        this.map
      );
      let segments = this.splitPolylineAtMeridian(modifiedArray);
      let lineColor = this.getRandomHexColor();
      const textIcon = L.divIcon({
        className: 'text-marker',
        html: `<div style="color: ${lineColor}; font-weight: bold;">${satelliteData.name}</div>
         <div style="color: ${lineColor}; font-weight: bold;">${satelliteData.time}</div>
          `,
        iconSize: [130, 40],
        iconAnchor: [50, 20],
      });
      const textmarker = L.marker(modifiedArray[0], { icon: textIcon }).addTo(
        this.map
      );
      segments.forEach((segment) => {
        let polyline = L.polyline(segment, { color: lineColor }).addTo(
          this.map
        );
        polyline.arrowheads({
          size: '15px',
          frequency: 'endonly',
          yawn: 60,
        });
        this.polylines.push({
          image: image,
          polyline: polyline,
          text: textmarker,
        });
      });
    }
    this.mapLoading = false;
  }
  handleClearSensorCost(event: boolean) {
    this.sensorPanel.close();
    this.panelOpenState = false;
  }

  receiveHandler(data: any) {
    if (data?.length > 0) {

    let selectedRadius: number | null = null;
    let shouldUpdateTarget = false;

    data.forEach((item: any) => {
      if (item.key === OPERATORS.PIXXEL) {
        selectedRadius = PIXXEL_RADIUS;
      } else if (item.key === OPERATORS.LBAND) {
        selectedRadius = RF_RADIUS;
        shouldUpdateTarget = true;
      }
    });

    if (selectedRadius) {
      this.displayRFCircle(selectedRadius, shouldUpdateTarget);
    }
   }
 }


  displayRFCircle(radiusKm: number, shouldUpdateTarget: boolean = true) {
    if (this.rfCircleLayer.length == 0) {
      let cordinates: any[] = [];
      if (this.pointArray.length <= 3) {
        if (this.pointArray.length == 1) {
          this.target.targetPoints = this.pointArray;
          const coords = this.utilsService.extractCoordinates(
            this.pointArray[0]
          );
          this.drawRFCircle(coords, radiusKm * 1000, shouldUpdateTarget);
          this.dataService.setOverlapValue(0, 0);
        } else {
          this.target.targetPoints = null;
          this.pointArray.forEach((item, i) => {
            const coords = this.utilsService.extractCoordinates(item);
            cordinates.push(coords);
            this.drawRFCircle(coords, radiusKm * 1000, shouldUpdateTarget);
          });
          let overlapPercentage = this.findRFCircleOverlap(cordinates);
          let overlapCount = this.findOverlapCircleCount(cordinates);

          this.dataService.setOverlapValue(
            overlapPercentage.toFixed(2),
            overlapCount
          );
        }
        if (shouldUpdateTarget) {
          this.dataService.updateTarget(this.target);
        }
      }
    }
  }

  findRFCircleOverlap(coords: any[]) {
    const circleTurf1 = turf.circle([coords[0].lng, coords[0].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    const circleTurf2 = turf.circle([coords[1].lng, coords[1].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    const intersection = turf.intersect(circleTurf1, circleTurf2);
    if (intersection) {
      const overlapArea = turf.area(intersection);
      const area1 = turf.area(circleTurf1);
      const overlapPercentage1 = (overlapArea / area1) * 100;
      return overlapPercentage1;
    } else {
      return 0;
    }
  }

  findOverlapCircleCount(coords: any[]) {
    const turfCircleA = turf.circle([coords[0].lng, coords[0].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    const turfCircleB = turf.circle([coords[1].lng, coords[1].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    let overlapCount = 0;
    if (turf.intersect(turfCircleA, turfCircleB)) {
      overlapCount++;
    }
    if (coords.length == 3) {
      const turfCircleC = turf.circle(
        [coords[2].lng, coords[2].lat],
        RF_RADIUS,
        { steps: 64, units: 'kilometers' }
      );
      if (turf.intersect(turfCircleA, turfCircleC)) {
        overlapCount++;
      }
      if (turf.intersect(turfCircleB, turfCircleC)) {
        overlapCount++;
      }
      overlapCount = overlapCount >= 3 ? 2 : overlapCount;
    }
    return overlapCount;
  }

  drawRFCircle(coords, radius, shouldUpdateTarget: boolean = true) {
    const circle = L.circle(coords, {
      color: 'blue',
      fillColor: '#add8e6',
      fillOpacity: 0.5,
      radius: radius,
    }).addTo(this.map);
    this.map.fitBounds(circle.getBounds());
    if (this.pointArray.length == 1) {
      let aoiWkt: any = 'POLYGON ((';
      const accuracy = 15;
      let polyPts: any = [],
        aoi: any,
        lng0 = 0,
        lat0 = 0;
      const circleTurf = turf.circle([coords.lng, coords.lat], radius/1000, {
        steps: 64,
      });
      for (let i = 0; i < circleTurf.geometry.coordinates[0]?.length - 1; i++) {
        let lng = circleTurf.geometry.coordinates[0][i][0];
        let lat = circleTurf.geometry.coordinates[0][i][1];
        if (i === 0) {
          lng0 = lng;
          lat0 = lat;
        }
        polyPts.push([lng, lat]);
        aoiWkt = aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
      }
      polyPts.push([lng0, lat0]);
      aoi = turf.polygon([polyPts]);
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
      aoiWkt = aoiWkt + `))`;
      if(shouldUpdateTarget) {
      this.target.geoJSON = aoiWkt;
      this.target.area = (Math.PI * Math.pow(radius / 1000, 2)).toFixed(2);
      this.formGroup.get('target').setValue(aoiWkt);
      }
    }
    this.rfCircleLayer.push(circle);
  }

  removeCircles() {}

  splitPolylineAtMeridian(coords) {
    const segments: any[] = [];
    let currentSegment: any[] = [];
    for (let i = 0; i < coords.length - 1; i++) {
      const [lat1, lng1] = coords[i];
      const [lat2, lng2] = coords[i + 1];
      currentSegment.push([lat1, lng1]);
      if (Math.abs(lng1 - lng2) > 180) {
        const lngMeridian = lng1 > 0 ? 180 : -180;
        const latMeridian =
          lat1 + ((lat2 - lat1) * (lngMeridian - lng1)) / (lng2 - lng1);
        currentSegment.push([latMeridian, lngMeridian]);
        segments.push(currentSegment);
        currentSegment = [[latMeridian, lngMeridian > 0 ? -180 : 180]];
      }
    }
    currentSegment.push(coords[coords.length - 1]);
    segments.push(currentSegment);
    return segments;
  }

  getRandomHexColor() {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return `#${randomColor.padStart(6, '0')}`;
  }

  clearSatllite() {
    this.polylines.map((polyline) => {
      if (polyline?.image) {
        this.map.removeLayer(polyline?.image);
      }
      if (polyline?.polyline) {
        this.map.removeLayer(polyline?.polyline);
      }
      if (polyline?.text) {
        this.map.removeLayer(polyline?.text);
      }
    });
    this.polylines = [];
  }

  clearRFCircleLayers() {
    this.rfCircleLayer.forEach((circleLayer) => {
      this.map.removeLayer(circleLayer);
    });
    this.rfCircleLayer = [];
    this.target.targetPoints = null;
  }
/**
   * Check sensor eligibility for Tip-and-Cue workflow and sensor categories
   * Uses backend-calculated flags from single API call
   */
  async checkSensorEligibility(): Promise<void> {
    try {
      // Show loading indicator if in budget mode
      if (this.budget) {
        this.sensorCategoryCheckLoading = true;
      }

      const userSubs = this.currentUser?.subscriptionType || 'standard';
      
      // Get intent options and find the internalUse intent ID
      const intentOptions = await firstValueFrom(this.apiService.intentOption());
      const internalUseIntent = intentOptions.find((item: any) => item.intent_key === 'internalUse');
      const intent = internalUseIntent?._id || intentOptions[0]?._id;

      // Get all allocated sensors with eligibility flags - single API call
      const sensorResult: any = await firstValueFrom(
        this.userService.getSensors(userSubs, this.currentUser?.id, intent, {})
      );

      // Extract backend-calculated flags from response (maintains backward compatibility)
      // Only check Tip-and-Cue eligibility for user_plan === 4
      if (this.currentUser?.user_plan === 4) {
        this.tipAndCueEligible = sensorResult?.[0]?.isTipAndCueEnabled || false;
        this.tipAndCueEligibilityChecked = true;
      } else {
        // For other plans, default to eligible and mark as checked
        this.tipAndCueEligible = true;
        this.tipAndCueEligibilityChecked = true;
      }

      // Extract sensor category counts for budget mode
      if (this.budget) {
        const imagingCount = sensorResult?.[0]?.imagingSensorCount || 0;
        const nonImagingCount = sensorResult?.[0]?.nonImagingSensorCount || 0;
        
        this.hasImagingSensors = imagingCount > 0;
        this.hasNonImagingSensors = nonImagingCount > 0;

        this.ensureBudgetSensorCategorySelection();
      }

      // Extract operators array from response
      const allOperators = sensorResult?.[0]?.operators || [];

      // Resolve display label for TIR panel (obfuscated name takes priority)
      const vanzylOps = allOperators.filter((op: any) => op?.key === OPERATORS.SATELLITEVU_VANZYL);
      if (vanzylOps.length > 0) {
        const isObfuscated = this.currentUser?.obfuscated;
        const labels = vanzylOps.map((op: any) =>
          `${isObfuscated ? (op.obfuscateName || op.displayName || op.name) : (op.displayName || op.name)} ${op.sensor}`
        );
        this.tirSensorLabel = [...new Set(labels)].join(', ');
      }

      await this.hydratePlan4AisOperators(allOperators);

      this.refreshAisUpdateFrequencies();
      
      // Store allocated sensor types for filtering outcome sensor types dropdown
      // This ensures Plan 4 users only see their allocated sensor types
      this.allocatedSensorTypes = new Set(
        allOperators
          .map((op: any) => op?.sensortype || op?.sensorType || op?.sensor)
          .filter(Boolean),
      );
    } catch (error) {
      console.error('Error checking sensor eligibility:', error);
      
      // Set defaults on error
      this.hasTippingSensors = false;
      this.hasCueingSensors = false;
      
      // Only set tipAndCueEligible based on user plan
      if (this.currentUser?.user_plan === 4) {
        this.tipAndCueEligible = false;
      } else {
        this.tipAndCueEligible = true;
      }
      this.tipAndCueEligibilityChecked = true;

      if (this.budget) {
        // On error in budget mode, default to enabled to avoid blocking users
        this.hasImagingSensors = true;
        this.hasNonImagingSensors = true;

        this.ensureBudgetSensorCategorySelection();
      }
    } finally {
      if (this.budget) {
        this.sensorCategoryCheckLoading = false;
      }
    }
  }

  /**
   * Assigns the frequency list from one plan-filtered base. The budget and
   * outcome dropdowns both bind to it.
   */
  private applyUpdateFrequencyOptions(options: any[]): void {
    this.updateFrequencies = [...(options || [])];
  }

  private refreshAisUpdateFrequencies(): void {
    const all = [...(this.apiService.updateFrequencies || [])];
    const shouldFilterByPlan4 = this.currentUser?.user_plan === 4;
    if (shouldFilterByPlan4) {
      if (!this.aisAllocationFetched) {
        // Allocation not loaded/failed: keep list empty for Plan-4 users.
        // (Filtering requires allocations; without it we can't safely decide which options to show.)
        this.applyUpdateFrequencyOptions([]);
        return;
      }

      const allocatedNormalized = new Set(
        Array.from(this.allocatedAisOperators).map(normalizeOperatorKey).filter(Boolean)
      );

      // Plan-4 users should only see frequencies for their allocated AIS operator(s)
      this.applyUpdateFrequencyOptions(
        allocatedNormalized.size
          ? all.filter((f: any) => allocatedNormalized.has(normalizeOperatorKey(f?.operatorKey)) || allocatedNormalized.has(normalizeOperatorKey(f?.operator)))
          : []
      );
      return;
    }
    // Non-allocated users keep the legacy full list
    this.applyUpdateFrequencyOptions(all);
  }

  private async hydratePlan4AisOperators(allOperators: any[]): Promise<void> {
    // Plan-4 users: filter AIS update-frequency options based on allocated AIS sensors.
    // Seed AIS operators from the sensors response as a fallback.
    // This helps when allocation API uses display names (e.g., 'Clyde Space')
    // while UI frequency options use compact keys (e.g., 'ClydeSpace').
    if (this.currentUser?.user_plan !== 4) return;

    const normalizeSensorType = (value: any): string => String(value ?? '').trim().toLowerCase();
    const isAisSensorType = (value: any): boolean =>
      normalizeSensorType(value) === normalizeSensorType(this.aisType);

    const aisOperatorsFromSensors = new Set<string>(
      (allOperators || [])
        .filter(
          (op: any) =>
            isAisSensorType(op?.sensortype) ||
            isAisSensorType(op?.sensorType) ||
            isAisSensorType(op?.sensor),
        )
        .map((op: any) => op?.key || op?.operatorKey || op?.operator || op?.name)
        .filter(Boolean)
        .map((v: any) => String(v)),
    );

    this.allocatedAisOperators = aisOperatorsFromSensors;
    // Mark as fetched even if empty (means no AIS allocations)
    this.aisAllocationFetched = true;

    try {
      const allocationRes: any = await firstValueFrom(this.apiService.getAllocation());
      const allocatedSensors = allocationRes?.allocations?.[0]?.sensor || [];
      const aisOperatorsFromAllocation = new Set<string>(
        allocatedSensors
          .filter(
            (s: any) =>
              isAisSensorType(s?.sensor) ||
              isAisSensorType(s?.sensorType) ||
              isAisSensorType(s?.sensortype),
          )
          .map((s: any) => s?.operator)
          .filter(Boolean)
          .map((v: any) => String(v)),
      );

      // Only override if allocation API returns AIS operators.
      // If it returns nothing (schema mismatch / no AIS rows), keep the sensors-based fallback.
      if (aisOperatorsFromAllocation.size > 0) {
        this.allocatedAisOperators = aisOperatorsFromAllocation;
      }
    } catch (allocationError) {
      console.error('Error fetching allocated sensors for AIS frequencies:', allocationError);
      // Keep the sensors-based fallback; do not blank the list.
    }
  }

  private ensureBudgetSensorCategorySelection(): void {
    if (!this.budget) return;

    const sensorCategoryControl = this.budgetForm?.get('sensorCategory');
    if (!sensorCategoryControl) return;

    const currentValue = sensorCategoryControl.value;
    const imagingEnabled = this.hasImagingSensors;
    const nonImagingEnabled = this.hasNonImagingSensors;

    let nextValue: string = currentValue;

    if (currentValue === this.imagingSensor && !imagingEnabled) {
      nextValue = nonImagingEnabled ? this.nonImagingSensor : currentValue;
    } else if (currentValue === this.nonImagingSensor && !nonImagingEnabled) {
      nextValue = imagingEnabled ? this.imagingSensor : currentValue;
    } else if (!currentValue) {
      nextValue = imagingEnabled ? this.imagingSensor : (nonImagingEnabled ? this.nonImagingSensor : this.imagingSensor);
    }

    if (nextValue !== currentValue) {
      sensorCategoryControl.setValue(nextValue, { emitEvent: false });
    }

    this.selectedCategory = sensorCategoryControl.value;
    this.showResolution = (this.selectedCategory !== this.nonImagingSensor);
  }
  categoryChange(event) {
    const nextCategory = event?.value;
    this.selectedCategory = nextCategory;
    this.updateFrequencyOption = false;
    this.budgetSensorType = [];
    const sensorCategoryControl = this.budgetForm.get('sensorCategory');
    this.budgetForm.patchValue({
      resolution: '',
      cloudCover: '',
      taskingTier: '',
      holdBack: '',
      updateFrequency: '',
    });
    this.resetForm();
    this.disableEnableDrawControls(true, 'reset');
    sensorCategoryControl?.setValue(this.selectedCategory);
    this.resetForm(nextCategory);
    this.showResolution =
      this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
  }

  getCountryAndPlace(
    latitudes: number,
    longitudes: number,
    target: any,
    status: any = false
  ) {
    const waterCheckLocations = this.getWaterCheckLocations(
      latitudes,
      longitudes,
      target
    );
    const primaryLocation = waterCheckLocations[0];
    const longitude = primaryLocation?.longitude;
    const latitude = primaryLocation?.latitude;

    if (
      longitude === undefined ||
      latitude === undefined ||
      Number.isNaN(Number(longitude)) ||
      Number.isNaN(Number(latitude))
    ) {
      return;
    }
    if (this.budget && this.target.intent) {
      this.budgetForm.patchValue({
        resolution: '',
        cloudCover: '',
        taskingTier: '',
        holdBack: '',
        sensorType: '',
      });

      this.budgetInputs.resolutionArr = [];
      this.budgetInputs.tierArr = [];
      this.budgetInputs.cloudCoverKeys = [];
      this.budgetInputs.holdbackArr = [];
      this.budgetSensorType = [];

      let data = {
        intent: this.target.intent,
        selectedCategory: this.selectedCategory,
        multiPoi:
          this.target.multiTarget && this.target.multiTarget.length > 0
            ? true
            : false,
      };
      this.apiService.getBudgetSensorType(data).subscribe((res: any) => {
        if (res?.msg == 'Success') {
          this.budgetSensorType = res.response;
        } else {
          const message = `There are no sensors for the selected intent. Please change to continue for budget generation.`;
          const dialogRef = this.popupService.openPopup(
            WarningPopup,
            message,
            '',
            '50%'
          );
          dialogRef.afterClosed().subscribe((result) => {
            this.budgetForm.patchValue({ intent: '' });
          });
        }
      });
    }

    const apiKey = environment.openCageApiKey;
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    let place: any, country: any, countryCode: any;
    const waterChecks = waterCheckLocations.map((location) =>
      this.apiService.checkIsWater({ ...location })
    );

    forkJoin(waterChecks).subscribe((waterResults: any[]) => {
      const isWater = waterResults.some((res: any) => !!res?.water);
      if (status) {
        this.target.openWaterCue = isWater;
      } else {
        this.target.openWater = isWater;
        if (
          this.taskStrategy == 'Tip-and-Cue' &&
          this.subStrategy == 'Tip-and-Cue'
        )
          this.getObservationList(this.target.openWater);
      }

      if (
        !status &&
        isWater &&
        this.isChangeDetectionStrategy() &&
        this.geoJsonLayer
      ) {
        this.showChangeDetectionWaterUploadBlocker();
        return;
      }

      this.http.get(url).subscribe((response: any) => {
        if (response.results.length > 0) {
          const firstResult = response.results[0];

          if (firstResult.components?.body_of_water) {
            country = firstResult.components.body_of_water;
            place = firstResult.components.body_of_water;
            countryCode = firstResult.components.body_of_water;
            if (status) this.target.overOpenWaterCue = true;
            else this.target.overOpenWater = true;
          } else {
            country = firstResult.components.country;
            place =
              firstResult.components.city ||
              firstResult.components.state ||
              firstResult.components.county;
            countryCode = firstResult.components['ISO_3166-1_alpha-3'];
            if (status) this.target.overOpenWaterCue = isWater;
            else this.target.overOpenWater = isWater;
          }
          if (status) {
            this.target.placeCue = place;
            this.target.countryCue = country;
            this.target.countryCodeCue = countryCode;
          } else {
            this.target.place = place;
            this.target.country = country;
            this.target.countryCode = countryCode;
          }
          this.updateTarget(this.target, '0');
        }
      });
    });
  }

  private showChangeDetectionWaterUploadBlocker(): void {
    const message =
      'Change Detection is not supported over water at this time.';
    const dialogRef = this.popupService.openPopup(
      WarningPopup,
      message,
      '',
      '50%'
    );

    dialogRef.afterClosed().subscribe(() => {
      this.resetMap();
      this.clearInvalidChangeDetectionUpload();
    });
  }

  private getWaterCheckLocations(
    latitudes: number,
    longitudes: number,
    target: any
  ): Array<{ longitude: number; latitude: number }> {
    if (target === 'search') {
      return [{ longitude: longitudes, latitude: latitudes }];
    }

    if (target?.type === 'Point') {
      return [
        {
          longitude: target.coordinates?.[0],
          latitude: target.coordinates?.[1],
        },
      ];
    }

    if (target?.type === 'Polygon') {
      const centroid = this.getRingCentroid(target.coordinates?.[0]);
      return centroid ? [centroid] : [];
    }

    if (target?.type === 'MultiPolygon') {
      return (target.coordinates || [])
        .map((polygonCoordinates: any) =>
          this.getRingCentroid(polygonCoordinates?.[0])
        )
        .filter(
          (
            location: { longitude: number; latitude: number } | null
          ): location is { longitude: number; latitude: number } => !!location
        );
    }

    return [];
  }

  private getRingCentroid(
    ring: any[]
  ): { longitude: number; latitude: number } | null {
    if (!Array.isArray(ring) || ring.length === 0) {
      return null;
    }

    const validPoints = ring.filter(
      (coordinate: any) =>
        Array.isArray(coordinate) &&
        coordinate.length >= 2 &&
        !Number.isNaN(Number(coordinate[0])) &&
        !Number.isNaN(Number(coordinate[1]))
    );

    if (validPoints.length === 0) {
      return null;
    }

    const totals = validPoints.reduce(
      (acc, coordinate: any) => ({
        longitude: acc.longitude + Number(coordinate[0]),
        latitude: acc.latitude + Number(coordinate[1]),
      }),
      { longitude: 0, latitude: 0 }
    );

    return {
      longitude: totals.longitude / validPoints.length,
      latitude: totals.latitude / validPoints.length,
    };
  }

  isLatitudeInRange(geoJSON: any, minValue: number, maxValue: number): boolean {
    if (this.target?.multiTarget?.length > 0) {
      for (const targets of this.target.multiTarget) {
        const geoJson = geoParse(targets);
        const latitude = geoJson.coordinates[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    } else if (geoJSON.type === 'Point') {
      const latitude = geoJSON.coordinates[1];
      return latitude >= minValue && latitude <= maxValue;
    } else if (geoJSON.type === 'Polygon') {
      const coordinates = geoJSON.coordinates[0];
      for (const coordinate of coordinates) {
        const latitude = coordinate[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    }
    return false;
  }

  strategyChange(data: any) {
    if (this.isSatelliteFetchInProgress()) {
      this.clearSatelliteFetchState();
    }

    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
      this.satLayer = null;
    }
     this.clearTLEOnly();
    if (this.taskStrategy != null) {
      this.mapLoading = false;
    }
    this.satTrackingClicked = false;
    this.taskStrategy = data.value;
    const previousFrequency = this.formGroup.get('frequency')?.value;

    // clear outcome-specific temporary selections when switching away
    if (data.value === 'Outcome By Platform') {
      this.outcomeSensorTypes(this.userid);
      this.formGroup.get('intent')?.setValue(null);
      this.formGroup.get('intent')?.markAsPristine();
      this.formGroup.get('intent')?.markAsUntouched();
      this.target.intent = null;
    }
    this.resetOutcome();

    // if switching to Help Select Sensor(s), reload use-cases for selected purpose
    this.useCaseOption = null;
    if (data.value === 'Help Select Sensor(s)') {
      const purposeControl = this.formGroup.get('purpose')?.value;
      if (purposeControl) {
        this.userService.getUseCases(purposeControl._id).subscribe((res: any) => {
          this.useCaseOption = res.data.sort((a, b) => a.useCase.toLowerCase().localeCompare(b.useCase.toLowerCase()));
        });
      }
      this.formGroup.get('useCaseDescription').setValue(null);
    }

    // update form control to reflect chosen strategy, but don't reset whole form
    this.formGroup.get('strategyRadio').setValue(data.value);
    this.formGroup.get('tipAndCueBasedOn')?.setValue('Rules');
    this.tipAndCueBasedOn = 'Rules';
    this.target.tipAndCueBasedOn = 'Rules';
    this.target.taskStrategy = data.value;
    this.taskStrategy = data.value;
    this.clearUnsupportedFortnightlySelection();
    this.updateTarget(this.target, '0');
    this.updateSearchControlDisabledState();

    // strategy-specific behaviors that still require map/control changes
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.tleSensorForm.reset({
        scenario: 'T-Mins Ahead',
        minutesAhead: 90,
      });
      this.clearSelectedTleLocation();
      this.loadTleLocations();
      this.selectedSensorObfuscatedName = null;
      this.nearestTlePassTimestamp = null;
      this.tleAvailablePasses = [];
      this.tleSelectedPasses = [];
      this.tlePreviewOnlyMode = false;
      this.tleNearestFallbackPending = false;
      
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      this.minDate = this.tleMinDate;
      this.maxDate = new Date(year, month - 1, day + 3);
      this.date = new FormControl(new Date(year, month - 1, day + 1));
      this.range = new FormGroup({
        start: new FormControl(this.tleMinDate),
        end: new FormControl(new Date(year, month - 1, day + 3)),
      });
      this.resetMap();
      this.disableEnableDrawControls(false, '', 'TLE');
      
      const existingIntent = this.formGroup.get('intent')?.value ?? this.target?.intent;
      if (existingIntent) {
        let resolvedIntent: any = existingIntent;

        if (typeof existingIntent === 'string' && Array.isArray(this.intentOption)) {
          resolvedIntent = this.intentOption.find( (it: any) =>
                it?.name === existingIntent || it?.intent_key === existingIntent
            ) || null;
        }

        if (resolvedIntent) {
          this.formGroup.get('intent')?.setValue(resolvedIntent, { emitEvent: false });
          this.intentChange(resolvedIntent);
        }
      }
    } else if (this.isChangeDetectionStrategy()) {
      this.resetMap();
      this.clearTleDateRangeState();
      this.disableEnableDrawControls(false, '', 'change-detection');
      this.applyChangeDetectionFrequencyDefaults();
    } else {
      this.clearTleDateRangeState();
      const hasTarget = this.target?.geoJSON && this.target.geoJSON !== '';
      if (hasTarget) {
        this.resetMap('tle');
      }
      this.disableEnableDrawControls(true, '');
    }

    // If switching to Outcome By Platform, refresh available outcome sensor types
    if (this.taskStrategy === 'Outcome By Platform') {
      this.outcomeSensorTypes(this.userid);
    }

    // ensure tip-and-cue related UI state is reset appropriately when needed
    if (this.taskStrategy !== 'Tip-and-Cue') {
      this.target.rule = null;
      this.target.observation = null;
      this.target.feeds = null;
      this.subStrategy = null;
      this.formGroup.get('subStrategyRadio')?.setValue('');
    }

    if (this.taskStrategy === 'TLE Based Tasking') {
      this.formGroup.get('frequency')?.setValue(null);

      this.target.frequency = null;
      this.target.freqOption = null;

      this.clickFrequency = false;
      this.selectedOption = -1;
    } else if (this.isChangeDetectionStrategy()) {
      this.applyChangeDetectionFrequencyDefaults();
    }  else if (previousFrequency) {
      const frequencyOption = this.getFrequencyOption(previousFrequency);
      const frequencyName = frequencyOption?.name;

      if (frequencyName && this.isFrequencyOptionDisabled(frequencyName)) {
        this.formGroup.get('frequency')?.setValue(null);

        this.target.frequency = null;
        this.target.freqOption = null;

        this.clickFrequency = false;
        this.selectedOption = 0;
      } else {
        this.selectedOption = frequencyOption?.id ?? this.selectedOption;

        this.formGroup.get('frequency')?.setValue(previousFrequency);
      }
    }

    this.updateChangeDetectionToiRangeError(this.isChangeDetectionStrategy());

    // leave map drawings/target as-is unless explicit user action clears them
    this.selectedSensorTypes = '';
  }

  tipAndCueTypeChange(data: any) {
    if (this.tipAndCueTargetRequired) {
      this.onBasedOnInteraction();
      return;
    }
    this.tipAndCueBasedOn = data.value;
    this.target.tipAndCueBasedOn = data.value;
    this.observation = null;
    this.target.observation = null;
    this.rule = null;
    this.target.rule = null;
    this.feeds = null;
    this.target.feeds = null;
    this.updateTarget(this.target, '0');
  }

  private getTipAndCueFeedOptions(feeds: any): any[] {
    if (!Array.isArray(feeds)) {
      return [];
    }

    return [...feeds];
  }

  private resolveSelectedTipAndCueFeed(): any {
    const candidates: any[] = [];
    const appendCandidate = (value: any) => {
      if (Array.isArray(value)) {
        value.forEach(appendCandidate);
        return;
      }
      if (value !== null && value !== undefined && value !== '') {
        candidates.push(value);
      }
    };

    appendCandidate(this.feeds);
    appendCandidate(this.target?.feeds);
    appendCandidate(this.formGroup?.get('feeds')?.value);

    for (const candidate of candidates) {
      if (candidate && typeof candidate === 'object') {
        const candidateId = candidate._id ?? candidate.id;
        if (candidateId && feedsConfig[candidateId]) {
          return candidate;
        }

        const candidateName = candidate.name ?? candidate.feedName;
        if (candidateName && Array.isArray(this.feedList)) {
          const matchedFeed = this.feedList.find(
            (feed: any) => feed?.name === candidateName
          );
          if (matchedFeed) {
            return matchedFeed;
          }
        }
      }

      if (typeof candidate === 'string' && Array.isArray(this.feedList)) {
        const matchedFeed = this.feedList.find(
          (feed: any) => feed?._id === candidate || feed?.name === candidate
        );
        if (matchedFeed) {
          return matchedFeed;
        }
      }
    }

    return null;
  }

  private isSelectedSmallBoatFeed(): boolean {
    if (
      this.taskStrategy !== 'Tip-and-Cue' ||
      this.subStrategy !== 'Tip-and-Cue' ||
      this.tipAndCueBasedOn !== 'Feeds'
    ) {
      return false;
    }

    const selectedFeed = this.resolveSelectedTipAndCueFeed();
    const feedId = selectedFeed?._id ?? selectedFeed?.id;
    if (!feedId) {
      return false;
    }

    return feedsConfig[feedId]?.type === 'small-boat';
  }

  private getCurrentTipAndCueEndDateTime(): Date | null {
    const closeWindow = this.target?.closeWindow;

    if (
      closeWindow instanceof Date &&
      !Number.isNaN(closeWindow.getTime())
    ) {
      return closeWindow;
    }

    const endDate = this.range?.value?.end;
    if (!endDate) {
      return null;
    }

    const normalizedEndDate = new Date(endDate);
    if (Number.isNaN(normalizedEndDate.getTime())) {
      return null;
    }

    return normalizedEndDate;
  }

  private isSmallBoatEndWindowBeyondSevenDays(): boolean {
    if (!this.isSelectedSmallBoatFeed()) {
      return false;
    }

    const endDateTime = this.getCurrentTipAndCueEndDateTime();
    if (!endDateTime) {
      return false;
    }
    const maxAllowedUtcTime = moment.utc().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
    return endDateTime.getTime() > new Date(maxAllowedUtcTime).getTime();
  }

  private clearTipAndCueFeedSelection(): void {
    this.feeds = null;
    this.target.feeds = null;
    this.formGroup.get('feeds')?.setValue(null);
  }

  private enforceSmallBoatTipAndCueWindow(): void {
    if (
      this.smallBoatToiWarningOpen ||
      !this.isSmallBoatEndWindowBeyondSevenDays()
    ) {
      return;
    }

    this.clearTipAndCueFeedSelection();
    this.updateTarget(this.target, '0');
    this.smallBoatToiWarningOpen = true;

    const message =
      'The weather data is only available for the next seven days. The current task with the time of interest (TOI) exceeding the weather data availability could not be accepted at this time.';

    this.popupService
      .openPopup(WarningPopup, message, '', '50%')
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.smallBoatToiWarningOpen = false;
      });
  }

  onTleScenarioChange(event: any) {
    const scenario = typeof event === 'string' ? event : event?.value;

    this.tleSensorForm.patchValue({
      scenario,
      minutesAhead: this.tleSensorForm.get('minutesAhead')?.value || 90,
    });

    this.selectedSensorObfuscatedName = null;
    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.clearTLEOnly();
  }

  decrementTleMinutesAhead(): void {
    const currentValue = Number(this.tleSensorForm.get('minutesAhead')?.value);
    const nextValue = Number.isFinite(currentValue) ? currentValue - 5 : 90;
    this.setTleMinutesAhead(nextValue);
  }

  incrementTleMinutesAhead(): void {
    const currentValue = Number(this.tleSensorForm.get('minutesAhead')?.value);
    const nextValue = Number.isFinite(currentValue) ? currentValue + 5 : 90;
    this.setTleMinutesAhead(nextValue);
  }

  onTleMinutesAheadInput(): void {
    this.tleSensorForm.get('minutesAhead')?.markAsTouched();
    this.resetTlePassSelectionState();
  }

  setTleMinutesAhead(value: number): void {
    const safeValue = Math.min(
      this.tleMaxMinutesAhead,
      Math.max(90, Math.floor(Number(value) || 90))
    );
    this.tleSensorForm.patchValue({ minutesAhead: safeValue });
    this.tleSensorForm.get('minutesAhead')?.markAsTouched();
    this.resetTlePassSelectionState();
  }

  private resetTlePassSelectionState(): void {
    this.selectedSensorObfuscatedName = null;
    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.clearTLEOnly();
  }

  private clearTleNearestFallbackPreviewContext(): void {
    this.tleNearestFallbackPreviewContext = null;
  }

  onFeedsChange(option: any) {
    this.feeds = option;
    this.target.feeds = option;
    this.rule = null;
    this.target.rule = null;
    this.observation = null;
    this.target.observation = null;

    if (this.tipAndCueEndSelectedByUser) {
      this.enforceSmallBoatTipAndCueWindow();
    }

    this.updateTarget(this.target, '0');
  }

  onObservationChange(option: any) {
    if (this.tipAndCueTargetRequired) return;
    let previousvalue: any;
    let previousoperator: any;
    if (this.target.observation?.name === option.name) {
      previousvalue = this.target.observationData.value;
      previousoperator = this.target.observationData.action;
    }
    this.observation = option;
    this.target.observation = option;
    this.rule = null;
    this.target.rule = null;
    this.feeds = null;
    this.target.feeds = null;
    this.updateTarget(this.target, '0');
    // ONLY the location observation changed. Its value is a place inside the
    // tasked AOI, so it is MARKED on a map bounded by that AOI rather than
    // typed as `lng,lat` pairs — which is what removes the coordinate-order
    // trap, the shredded WKT paste, and the "outside the AOI" modal that used
    // to fire after the dialog closed and discard the whole selection.
    //
    // Every other kind — MMSI, IMO, name, vessel count, length, area — still
    // goes to FilterPopupComponent exactly as before, with the same data, the
    // same validation and the same result shape.
    const isLocationObservation =
      this.target.observation?.key === 'vessel_location' ||
      this.target.observation?.data_type === 'location';

    // Typed as `MatDialogRef<any>` rather than left as the union of the two
    // components' refs: both resolve `afterClosed()` to `Observable<any>`, and
    // saying so is cheaper to read than a union that has to be proved compatible.
    const dialogRef: MatDialogRef<any> = isLocationObservation
      ? this.dialog.open(MapLocationDialogComponent, {
          width: '660px',
          maxWidth: '94vw',
          backdropClass: 'blurr',
          autoFocus: false,
          data: {
            title: this.target.observation.name,
            subtitle:
              'The observation of interest is selected on the map.',
            // The boundary. `checkObservationInsideMap` below stays as the
            // backstop for an AOI the dialog cannot parse.
            aoi: this.target.geoJSON,
            value: previousvalue,
          },
        })
      : this.dialog.open(FilterPopupComponent, {
          width: '35%',
          backdropClass: 'blurr',
          data: {
            type: 'observation',
            name: this.target.observation.name,
            dataType: this.target.observation.data_type,
            // The stable predicate id ('vessel_mmsi', 'vessel_imo', …). The
            // dialog validates by this rather than by the display name, for the
            // same reason the server dispatches on it: a row rename must not
            // change behaviour. Absent on observations that predate the field.
            key: this.target.observation.key,
            value: previousvalue,
            operator: previousoperator,
          },
        });

    dialogRef.afterClosed().subscribe((raw) => {
      // The map picker answers with `{ value, kind }` and knows nothing about
      // observations; the action it implies is containment either way — a place
      // is matched within a tolerance radius and a ring by being inside it, and
      // neither is an ordering. `location.js` ignores the action; it is named
      // so the task record can still say how the value was meant to be read.
      const result = raw && isLocationObservation ? { value: raw.value, action: 'within' } : raw;
      if (result) {
        this.target.observationData = result;
        this.formGroup.get('observationData').setValue(result);
        // Coordinates only. This used to fire on ANY value containing a
        // comma, which meant a vessel name like 'MAERSK, DENVER' was parsed
        // as a coordinate pair and rejected as 'outside the AOI'.
        if (
          isLocationObservation &&
          result.value.split(',').map((s) => s.trim()).length > 1
        ) {
          if (this.calculateObservation(result.value)) {
            this.getCountryAndPlace(
              0,
              0,
              geoParse(this.target?.geoJSONCue),
              'cueing'
            );
          } else {
            const msg = ' The observation coordinates are outside the AOI.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              msg,
              '',
              '30%'
            );
            this.formGroup.get('observationData').setValue(null);
            this.formGroup.get('observation').setValue(null);
            this.observation = null;
            this.target.observation = null;
            return;
          }
        }
      } else {
        this.formGroup.get('observationData').setValue(null);
        this.formGroup.get('observation').setValue(null);
        this.observation = null;
        this.target.observation = null;
      }
    });
  }

  private toggleTlePassSelection(passId: string): void {
    const pass = this.tleAvailablePasses.find((item) => item.id === passId);
    if (!pass) {
      return;
    }

    if (pass.previewOnly) {
      return;
    }

    pass.selected = !pass.selected;
    this.tleSelectedPasses = this.tleAvailablePasses.filter(
      (item) => item.selected
    );

    if (pass.selected) {
      this.loadTlePassResolutions(pass);
    }

    this.refreshSelectedTlePassStyles();
    this.refreshPrimaryTlePass();
  }

  removeTlePass(passId: string): void {
    const pass = this.tleAvailablePasses.find((item) => item.id === passId);
    if (!pass) {
      return;
    }

    pass.selected = false;
    this.tleSelectedPasses = this.tleAvailablePasses.filter(
      (item) => item.selected
    );
    this.refreshSelectedTlePassStyles();
    this.refreshPrimaryTlePass();
  }

  clearSelectedTlePasses(): void {
    this.tleAvailablePasses.forEach((pass) => {
      pass.selected = false;
    });
    this.tleSelectedPasses = [];
    this.refreshSelectedTlePassStyles();
    this.refreshPrimaryTlePass();
  }

  private refreshPrimaryTlePass(): void {
    this.nearestTlePassTimestamp = this.tleSelectedPasses[0]?.timestamp || null;
  }

  private refreshSelectedTlePassStyles(): void {
    this.tleAvailablePasses.forEach((pass) => {
      if (pass.layers?.length) {
        pass.layers.forEach((layer) => {
          layer.setStyle({
            color: pass.lineColor,
            weight: pass.selected ? 5 : 3,
            opacity: pass.selected ? 1 : 0.8,
          });
        });
        return;
      }

      if (!pass.layer) {
        return;
      }

      pass.layer.setStyle({
        color: pass.lineColor,
        weight: pass.selected ? 5 : 3,
        opacity: pass.selected ? 1 : 0.8,
      });
    });
  }

  onRulesChange(option: any) {
    let previousvalue: any;
    if (this.target.rule === option && this.target.rule === 'rule-3') {
      previousvalue = this.target.cloudCover;
    }
    if (option === 'rule-3') {
      const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
        width: '60%',
        backdropClass: 'blurr',
        data: 'rule',
      });
      if (this.target.rule === option && this.target.rule === 'rule-3') {
        dialogRef.componentInstance.previousValue = this.target.cloudCover;
      }
      dialogRef.afterClosed().subscribe((result) => {
        if (result && !isNaN(result) && Number(result) >= 0) {
          this.formGroup.get('rule').setValue(option);
          this.rule = option;
          this.target.rule = option;
          this.observation = null;
          this.target.observation = null;
          this.feeds = null;
          this.target.feeds = null;
          this.target.cloudCover = result;
          this.updateTarget(this.target, '0');
        } else {
          this.formGroup.get('rule').setValue(null);
          this.target.cloudCover = '';
        }
      });
    } else {
      this.formGroup.get('rule').setValue(option);
      this.rule = option;
      this.target.rule = option;
      this.observation = null;
      this.target.observation = null;
      this.feeds = null;
      this.target.feeds = null;
      this.updateTarget(this.target, '0');
    }
  }

  drawPinOnMap() {}

  geoParsePoint(wkt: string) {
    const regex = /POINT \(([^)]+)\)/g;
    const points: { type: string; coordinates: [number, number] }[] = [];
    let match;

    while ((match = regex.exec(wkt)) !== null) {
      const coordinates = match[1].split(' ').map(parseFloat);
      points.push({
        type: 'Point',
        coordinates: [coordinates[0], coordinates[1]],
      });
    }

    return points;
  }

  sensorChange(event: any) {
    let target: any;
    const isSarSensor = event?.value === 'SAR';
    this.isOutcomeSarSensor = isSarSensor;
    this.outComeForm.patchValue({
      resolution: '',
      cloudCover: '',
      updateFrequency: '',
      latency: '',
      budget: '',
      intent: '',
    });

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';
    let sensorObj = {
      sensorType: event.value,
      target: target,
    };

    let intent = this.target?.intent?.key
      ? this.target?.intent.key
      : this.target?.intent;

    if (event.value !== 'AIS') {
      this.apiService.getSensorDetails(sensorObj).subscribe((res: any) => {
        this.outComesensor = res;
        const cloudC: any = [];
        if (res.cloudCover) {
          for (var key in res.cloudCover) {
            cloudC.push({ key, value: res.cloudCover[key] });
          }
          this.outComesensor.cloudCover = cloudC;

          if (isSarSensor) {
            this.outComeForm.get('cloudCover').setValue('');
            this.outComeForm.get('cloudCover').disable();
          } else if (this.outComesensor?.cloudCover?.length === 0) {
            this.outComeForm.get('cloudCover').disable();
          } else {
            this.outComeForm.get('cloudCover').enable();
          }
        }
      });
    }
  }
  sensorTypeChangeTle(event: any) {
    this.tleSensorForm.patchValue({
      sensorType: event,
      resolution: '',
      sensor: '',
    });
    this.showtleClick = false;
    this.showtleDisabled = false;
    this.apiService
      .getBudgetResolutionDetails(
        event,
        this.target.intent,
        this.currentUser.id,
        'TLE Based Tasking',
        this.target.area
      )
      .subscribe((res: any) => {
        if (res?.msg === 'Success') {
          const resolutions = Array.isArray(res?.response)
            ? res.response
                .sort((a, b) => this.sortResolutions(a, b))
                .filter((item) => item.key !== 'Both')
            : [];
          const message =
            'There are no sensors for the selected sensor type. Please select a different type to proceed with tasking.';

          if (!resolutions.length) {
            this.tleSensor.resolution = [];
            this.tleSensor.sensor = [];
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            return;
          }

          this.tleSensor.resolution = resolutions;
        }
      });
    this.clearTLEOnly();
  }
  resolutionChangeTle(event: any) {
    this.tleSensorForm.patchValue({
      resolution: event,
      sensor: '',
    });
    this.showtleClick = false;
    this.showtleDisabled = false;
    const sensorObj = {
      intent: this.target?.intent?._id,
      userid: this.userid,
      sensorType: this.tleSensorForm.value?.sensorType,
      resolution: event,
    };
    this.apiService.getSensorDetailsTle(sensorObj).subscribe((res: any) => {
      let sensors = res?.filteredSensors;
      if (sensors?.length > 0) {
        this.tleSensor.sensor = sensors;
      } else {
        const message =
          'No sensors are meeting the selected resolution. Please change the resolution and try again.';
        const dialogRef = this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        dialogRef.afterClosed().subscribe((result) => {
          this.tleSensorForm.get('resolution')?.setValue('');
          this.tleSensorForm.get('resolution')?.markAsPristine();
          this.tleSensorForm.get('resolution')?.markAsUntouched();
          this.tleSensor.sensor = [];
        });
      }
    });
    this.clearTLEOnly();
  }

  sensorWarning(event) {
    if (this.budgetForm?.value?.sensorType.sensor === 'HSI') {
      if (event.value.key === '5.3m') {
        const message = `
        <ol>
          <li>Each line in the area of interest (AOI) must be at least 5km and no more than 25km long.</li>
          <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
          <li>The start of the time of interest (TOI) must be at least three days after the submission date, and the end date must be at least 30 days after the start date of the TOI. Please change your TOI or choose an alternative provider.</li>
          <li>The AOI requested should at least be 100 sqkm for the standard tasking and 50 sqkm for the priority tasking.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      } else if (event.value.key === '10m') {
        const message = `
        <ol>
          <li> The sensor does not have holdback selection options.</li>
          <li> Only period-based collection orders are supported at this time. Recurrent, Specific Date and Specific Day orders are not available.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'GHG') {
      const message = `
      <ol>
        <li>Recurrence selection is limited to monthly at this time.</li>
        <li>The time of interest (TOI) must be at least 30 days.</li>
        <li>Specific Date and Specific Day tasking are not supported at this time.</li>
      </ol>`;
      this.popupService.openPopup(
        WarningPopup,
        message,
        'orderedWarning',
        '50%'
      );
      return;
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'SAR') {
      if (
        event.value.key === '0.25m' ||
        event.value.key === '0.5m' ||
        event.value.key === '1.2m'
      ) {
        const message = `
        <ol>
          <li>Standard tasking requires a minimum seven day time of interest (TOI).</li>
          <li>Priority tasking requires a minimum three day TOI.</li>
          <li>Rush tasking requires a minimum one day TOI.</li>
          <li>The start date must be within 90 days from today.</li>
          <li>TOI cannot exceed 30 days.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (event.value.key === '0.35m') {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      let resolutionArr = ['3m', '12m', '20m', '6m', '20m - 30m', '30m'];
      if (resolutionArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      let KomsatArr = [
        '0.85m',
        '2.5m',
        '20m/4 look',
        'Pan-sharpened:0.8m',
        'Bundle:0.8m PAN/3.2m MSI',
        'Pan-sharpened:1m',
        'Bundle:1m PAN/4m MSI',
      ];
      if (KomsatArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'MSI') {
      if (event.value.key === '0.5-0.7m') {
        const message = `
        <ol>
          <li>Only 2 sub-daily collections are allowed at this time.</li>
          <li>Only point of interest (POI) tasks over open waters are supported. Area of interest (AOI) tasks are not allowed.</li>
          <li>For areas smaller than 50 sqkm, please task with a single POI.</li>
          <li>Rush tasking tier is not supported for AOI tasks.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (
        event.value.key === 'Super Resolution (SR):0.5m' ||
        event.value.key === 'Ground Sample Distance (GSD):0.7m'
      ) {
        const message = `
        <ol>
          <li>Tasking over open waters is not supported.</li>
          <li>Only 2 sub-daily collections are allowed at this time.</li>
          <li>For areas smaller than 50 sqkm, please task with a single POI.</li>
          <li>Rush tasking tier is not supported for area of interest (AOI) tasks.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (event.value.key === '2.5m TCI' || event.value.key === '5m MS') {
        const message = `
        <ol>
          <li>Specific Date, Specific Day and Recurrent frequency are not supported at this time.</li>
          <li>Only area of interest (AOI) orders are supported.</li>
          <li>The start date must be more than or equal to 5 hours after the requested time, and the time of interest (TOI) must be 14 days or less from the current date.</li>
          <li>The minimum task area is 100 sqkm.</li>
          <li>If the AOI is greater than 250,000 sqkm, each AOI must be within 500 km in both length and width.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (event.value.key === '0.5m TCI') {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (
        event.value.key === 'Pan-sharpened:0.52m' ||
        event.value.key === 'Bundle:0.52m PAN+2.08m MS'
      ) {
        const message = `
        <ol>
          <li>Recurrency is not supported at this time.</li>
          <li>Only point of interest (POI) orders are supported.</li>
          <li>The start date must be at least 24 hours or 48 hours from the current date.</li>
          <li>Up to 2 sub-daily collections are allowed.</li>
          <li>Tasking is limited to the latitude range of -13 to 13.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (
        event.value.key === '2.5m' ||
        event.value.key === '0.4m' ||
        event.value.key === '0.92m'
      ) {
        const message = `
        <ol>
          <li>Recurrency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      let komsatArr = [
        '0.85m',
        '1m',
        '20m/4 look',
        'Pan-sharpened:0.8m',
        'Bundle:0.8m PAN/3.2m MSI',
        'Pan-sharpened:1m',
        'Bundle:1m PAN/4m MSI',
      ];
      if (komsatArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (
      this.budgetForm?.value?.sensorType.sensor === 'MSI' ||
      this.budgetForm?.value?.sensorType.sensor === 'Stereo'
    ) {
      if (event.value.key === '0.83-0.94m') {
        const message = `
        <ol>
          <li>Only point of interest (POI) orders are supported.</li>
          <li>Up to 4 sub-daily collections are allowed, and sub-daily tasking is only available for a minimum of seven days.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (
        event.value.key === 'Pan-sharpened:0.5m' ||
        event.value.key === 'Bundle:0.5m PAN/2m MS'
      ) {
        const message = `
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>Each line in the area of interest (AOI) must be at least 5 km long.</li>
        <ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      let resolutionArr = [
        'Pan-sharpened:0.59m',
        'Bundle:0.59m PAN/2.36m MS',
        '0.25m',
        'Pan-sharpened:0.3m',
        'Bundle:0.3m PAN/1.2m MS',
        '0.15m',
        'High Definition (HD):0.15m',
        'High Definition (HD):0.25m',
      ];
      if (resolutionArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Only period-based collection orders are supported at this time. Recurrent, Specific Date and Specific Day orders are not available.</li>
          <li>Each side of the area of interest (AOI) must be at least 5 km.</li>
        <ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      let msiArr = ['Pan-sharpened:0.4m', 'Bundle:0.4m PAN/1.6m MSI'];
      if (msiArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
          <li>Tasking is only allowed within the latitude range of -42 to 42.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'PAN') {
      if (event.value.key === '4.6m') {
        const message = `
        <ol>
          <li>Only open water tasking is supported, and it must be limited to a single point of interest (POI).</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The sensor can only be tasked within the next ten days.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (
      this.budgetForm?.value?.sensorType.sensor === 'InSAR' ||
      this.budgetForm?.value?.sensorType.sensor === 'Stereo'
    ) {
      let komsatArr = [
        '0.85m',
        '1m',
        '2.5m',
        '20m/4 look',
        'Pan-sharpened:0.8m',
        'Bundle:0.8m PAN/3.2m MSI',
        'Pan-sharpened:1m',
        'Bundle:1m PAN/4m MSI',
      ];
      if (komsatArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'TIR') {
      let resolutionArr = ['30m', '69m'];
      if (resolutionArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Recurrence selection is limited to weekly and monthly at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
      if (event.value.key === '3.5m') {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (
      this.budgetForm?.value?.sensorType.sensor === 'PAN' ||
      this.budgetForm?.value?.sensorType.sensor === 'Stereo'
    ) {
      let resolutionArr = [
        '0.5m',
        '0.4m',
        'Pan-sharpened:0.4m',
        'Bundle:0.4m PAN/1.6m MSI',
        '0.69m',
      ];
      if (resolutionArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
          <li>Tasking is only allowed within the latitude range of -42 to 42.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'InSAR') {
      let resolutionArr = ['3m', '12m', '20m', '6m', '20m - 30m', '30m'];
      if (resolutionArr.includes(event.value.key)) {
        const message = `
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
        return;
      }
    }
  }

  sensorChangeTle(event: any) {
    const matchedSensor = this.tleSensor.sensor?.find((s) => {
      return this.currentUser?.obfuscated
        ? s.obfuscateName === event
        : s.sensorName === event;
    });
    if (matchedSensor) {
      this.selectedSensorObfuscatedName = matchedSensor;
    }
    this.clearTLEOnly();
    this.showtleClick = false;
    this.showtleDisabled = false;
  }
  OpenSatTracking() {
    if (this.tleLeadTimeError) return;
    this.satTrackingClicked = true;
    this.mapLoading = true;
    this.isSatelliteFetchLoading = true;
    this.showtleClick = true;
    this.showtleDisabled = true;
    this.getSatelliteData();
  }
  cancelSatelliteDataFetch() {
    this.satTrackingClicked = false;
    this.clearSatelliteFetchState();
  }
  getSatelliteData() {
    const targetPoint = this.getSelectedTleLocationPoint();
    if (!targetPoint) {
      this.popupService.openPopup(
        WarningPopup,
        'Please select a location before fetching nearest passes.',
        '',
        '45%'
      );
      this.clearSatelliteFetchState();
      return;
    }

    if (!this.syncTleFetchWindowFromScenario()) {
      this.clearSatelliteFetchState();
      return;
    }

    const sensorObj = this.buildTaskSatelliteRequestPayload(
      'currentTLEPosition'
    );
    if (!sensorObj) {
      this.clearSatelliteFetchState();
      return;
    }

    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.tlePreviewOnlyMode = false;
    this.tleNearestFallbackPending = false;
    this.clearTleNearestFallbackPreviewContext();
    this.clearTleTargetHoverTooltip();

    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map?.removeLayer(this.satLayer);
      this.satLayer = null;
    }

    const requestId = this.satelliteDataRequestId + 1;
    this.clearSatelliteDataSubscription();
    this.satelliteDataRequestId = requestId;
    this.requestCurrentTaskTlePositions(sensorObj, requestId, targetPoint);
  }

  private requestCurrentTaskTlePositions(
    payload: Record<string, unknown>,
    requestId: number,
    targetPoint: { lat: number; lng: number }
  ): void {
    this.satelliteDataSubscription = this.apiService
      .getSatelliteData(payload)
      .subscribe({
        next: (res: any) => {
          if (!this.isSatelliteFetchActive(requestId)) {
            return;
          }

          if (res?.msg === 'Failed') {
            this.handleNoActiveSatellites();
            return;
          }

          const satellites = this.extractSatelliteResults(res);
          if (!satellites.length) {
            this.handleNoActiveSatellites();
            return;
          }

          const filteredSatellites = this.filterTaskSatellitesByCurrentPosition(
            satellites,
            targetPoint
          );
          if (!filteredSatellites.length) {
            const nearestPreviewSatellite =
              this.getNearestCurrentPositionSatellite(satellites, targetPoint);

            if (!nearestPreviewSatellite) {
              this.handleNoNearbyPass();
              return;
            }

            const popupRef = this.popupService.openPopup(
              WarningPopup,
              'No pass falls within the selected swath. Would you like to preview the nearest pass instead?',
              '',
              '50%',
              'Yes',
              true,
              'No'
            );

            popupRef.afterClosed().subscribe((result) => {
              if (result === 'cancel') {
                this.tleNearestFallbackPending = false;
                this.clearTleNearestFallbackPreviewContext();
                this.clearSatelliteFetchState();
                return;
              }

              this.tleNearestFallbackPending = true;
              this.tleNearestFallbackPreviewContext =
                this.buildNearestFallbackPreviewContext(nearestPreviewSatellite);
              const previewPayload = this.buildTaskSatelliteRequestPayload(
                'tlePreview',
                [nearestPreviewSatellite]
              );

              if (!previewPayload) {
                this.tleNearestFallbackPending = false;
                this.clearTleNearestFallbackPreviewContext();
                this.clearSatelliteFetchState();
                return;
              }

              this.queueTaskFilteredFullPassesRequest(
                previewPayload,
                requestId,
                targetPoint
              );
            });
            return;
          }

          const previewPayload = this.buildTaskSatelliteRequestPayload(
            'tlePreview',
            filteredSatellites
          );
          if (!previewPayload) {
            this.clearSatelliteFetchState();
            return;
          }

          this.queueTaskFilteredFullPassesRequest(
            previewPayload,
            requestId,
            targetPoint
          );
        },
        error: () => {
          if (!this.isSatelliteFetchActive(requestId)) {
            return;
          }

          this.handleSatelliteFetchError();
        },
      });
  }

  private queueTaskFilteredFullPassesRequest(
    payload: Record<string, unknown>,
    requestId: number,
    targetPoint: { lat: number; lng: number }
  ): void {
    setTimeout(() => {
      if (!this.isSatelliteFetchActive(requestId)) {
        return;
      }

      this.requestTaskFilteredFullPasses(payload, requestId, targetPoint);
    }, 0);
  }

  private requestTaskFilteredFullPasses(
    payload: Record<string, unknown>,
    requestId: number,
    targetPoint: { lat: number; lng: number }
  ): void {
    if (!this.isSatelliteFetchActive(requestId)) {
      return;
    }

    this.clearSatelliteDataSubscription();
    this.satelliteDataSubscription = this.apiService
      .getSatelliteData(payload)
      .subscribe({
        next: (res: any) => {
          if (!this.isSatelliteFetchActive(requestId)) {
            return;
          }

          if (res?.msg === 'Failed') {
            this.handleNoActiveSatellites();
            return;
          }

          this.plotSatellitePath(
            this.extractSatelliteResults(res),
            targetPoint.lat,
            targetPoint.lng,
            requestId
          );
        },
        error: () => {
          if (!this.isSatelliteFetchActive(requestId)) {
            return;
          }

          this.handleSatelliteFetchError();
        },
      });
  }

  private buildTaskSatelliteRequestPayload(
    action: 'currentTLEPosition' | 'tlePreview',
    filteredSatellites: TleTargetHoverEntry[] = []
  ): Record<string, unknown> | null {
    // First dropdown (parent) -> locationName, second dropdown (sub-location) -> subLocationName.
    const locationName = this.tleParentLocationControl?.value?.name?.trim() || 'custom-map-selection';
    const subLocationName = this.selectedTleLocation?.name?.trim() || 'custom-map-selection';
    const intent = this.target?.intent;

    if (action === 'currentTLEPosition') {
      const scenario = this.tleSensorForm?.get('scenario')?.value;

      if (scenario === 'T-Mins Ahead') {
        const interval = Number(this.tleSensorForm?.get('minutesAhead')?.value);

        return {
          sensorData: {
            action: 'currentOrbitalPath',
            locationName,
            subLocationName,
            interval,
            intent,
            userId: this.currentUser?.id,
          },
        };
      }

      if (scenario === 'Predicted (TOI)') {
        return {
          sensorData: {
            action: 'intervalTOIPath',
            locationName,
            subLocationName,
            openWindow: moment(this.target.openWindow).utcOffset(0, true).format(),
            closeWindow: moment(this.target.closeWindow).utcOffset(0, true).format(),
            intent,
            userId: this.currentUser?.id,
          },
        };
      }

      return {
        sensorData: {
          action,
          locationName,
          subLocationName,
          intent,
          userId: this.currentUser?.id,
        },
      };
    }

    if (!filteredSatellites.length) {
      return null;
    }

    return {
      sensorData: {
        action,
        locationName,
        subLocationName,
        intent,
        userId: this.currentUser?.id,
        sensors: filteredSatellites.map((satellite: TleTargetHoverEntry) => ({
          timeStamp: satellite.timestamp,
          noradId: satellite.noradId,
          sensor_ids: satellite.sensorIds,
          name: satellite.name,
          operatorKey: satellite.operatorKey,
        })),
      },
    };
  }

  private getSelectedTleLocationPoint(): { lat: number; lng: number } | null {
    const latitude = Number(this.selectedTleLocation?.latitude);
    const longitude = Number(this.selectedTleLocation?.longitude);

    if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
      return null;
    }

    return {
      lat: latitude,
      lng: longitude,
    };
  }

  private syncTleFetchWindowFromScenario(): boolean {
    if (this.tleLeadTimeError) return false;
    const scenario = this.tleSensorForm?.get('scenario')?.value;

    if (scenario === 'T-Mins Ahead') {
      const minutesAhead = Number(
        this.tleSensorForm?.get('minutesAhead')?.value
      );

      if (
        !Number.isFinite(minutesAhead) ||
        minutesAhead < 90 ||
        minutesAhead > this.tleMaxMinutesAhead
      ) {
        return false;
      }

      const openWindow = new Date();
      const closeWindow = new Date(
        openWindow.getTime() + minutesAhead * 60 * 1000
      );
      this.target['openWindow'] = openWindow;
      this.target['closeWindow'] = closeWindow;
      this.apiService.updateTaskParams(this.target);
      return true;
    }

    return !!this.target?.openWindow && !!this.target?.closeWindow;
  }

  private extractSatelliteResults(response: any): any[] {
    return this.tleHelperService.extractSatelliteResults(response);
  }

  private filterTaskSatellitesByCurrentPosition(
    satellites: any[],
    targetPoint: { lat: number; lng: number }
  ): TleTargetHoverEntry[] {
    const poi: L.LatLngTuple = [targetPoint.lat, targetPoint.lng];

    return satellites.flatMap((satellite: any) => {
      const sensorName = this.getTaskSatelliteSensorName(satellite);
      const displayName = this.getTaskSatelliteDisplayName(satellite, sensorName);
      const requestName = this.getTaskSatelliteRequestName(satellite, sensorName);
      const noradId = this.getTaskSatelliteNoradId(satellite);
      const sensorIds = this.getTaskSatelliteSensorIds(satellite);
      const operatorKey = this.getTaskSatelliteOperatorKey(satellite);
      const points = this.getSatelliteTrackPoints(satellite?.position);
      const captureWidthKm = this.getTaskSatelliteCaptureWidthKm(
        satellite
      );

      if (
        !sensorName ||
        !displayName ||
        !requestName ||
        !noradId ||
        !sensorIds.length ||
        !operatorKey ||
        !points.length ||
        captureWidthKm === null
      ) {
        return [];
      }

      const passGroups = this.buildTlePassGroups(points);
      let qualifyingPassOrder = 0;

      return passGroups
        .map((passGroup) => {
          const nearestPassPoint = this.getNearestQualifyingSatelliteTrackPoint(
            passGroup,
            poi,
            captureWidthKm
          );

          if (
            !nearestPassPoint ||
            !Number.isFinite(nearestPassPoint.distanceKm)
          ) {
            return null;
          }

          qualifyingPassOrder += 1;
          const timestamp = this.formatSatellitePassTimestamp(
            nearestPassPoint.timeStamp,
            this.getTlePreviewPassTimestamp(passGroup, satellite?.time)
          );

          return {
            sensorName,
            displayName,
            passOrder: qualifyingPassOrder,
            timestamp,
            name: requestName,
            noradId,
            sensorIds,
            operatorKey,
            distanceKm: nearestPassPoint.distanceKm,
          };
        })
        .filter((entry): entry is TleTargetHoverEntry => !!entry)
        .sort((left, right) => left.passOrder - right.passOrder);
    });
  }

  private buildNearestCurrentPositionSatellites(
    satellites: any[],
    targetPoint: { lat: number; lng: number }
  ): TleTargetHoverEntry[] {
    const poi: L.LatLngTuple = [targetPoint.lat, targetPoint.lng];

    return satellites
      .flatMap((satellite: any) => {
        const sensorName = this.getTaskSatelliteSensorName(satellite);
        const displayName = this.getTaskSatelliteDisplayName(
          satellite,
          sensorName
        );
        const requestName = this.getTaskSatelliteRequestName(
          satellite,
          sensorName
        );
        const noradId = this.getTaskSatelliteNoradId(satellite);
        const sensorIds = this.getTaskSatelliteSensorIds(satellite);
        const operatorKey = this.getTaskSatelliteOperatorKey(satellite);
        const points = this.getSatelliteTrackPoints(satellite?.position);

        if (
          !sensorName ||
          !displayName ||
          !requestName ||
          !noradId ||
          !sensorIds.length ||
          !operatorKey ||
          !points.length
        ) {
          return [];
        }

        return this.buildTlePassGroups(points)
          .map((passGroup): TleTargetHoverEntry | null => {
            const nearestTrackPoint = this.getNearestSatelliteTrackPoint(
              passGroup,
              poi
            );

            if (!nearestTrackPoint || !this.isFutureTlePassPoint(nearestTrackPoint)) {
              return null;
            }

            const timestamp = this.formatSatellitePassTimestamp(
              nearestTrackPoint.timeStamp,
              this.getTlePreviewPassTimestamp(passGroup, satellite?.time)
            );
            const distanceKm = this.tleHelperService.getDistanceKm(
              nearestTrackPoint.point,
              poi
            );

            return {
              sensorName,
              displayName,
              passOrder: this.getTlePassOrderForTrackPoint(
                points,
                nearestTrackPoint
              ),
              timestamp,
              name: requestName,
              noradId,
              sensorIds,
              operatorKey,
              distanceKm,
              obfuscateName: this.getTaskSatelliteObfuscatedName(
                satellite,
                sensorName
              ),
            };
          })
          .filter((entry): entry is TleTargetHoverEntry => !!entry);
      })
      .sort((left, right) => {
        if (left.distanceKm !== right.distanceKm) {
          return left.distanceKm - right.distanceKm;
        }

        if (left.timestamp !== right.timestamp) {
          return left.timestamp.localeCompare(right.timestamp);
        }

        return left.passOrder - right.passOrder;
      });
  }

  private getNearestCurrentPositionSatellite(
    satellites: any[],
    targetPoint: { lat: number; lng: number }
  ): TleTargetHoverEntry | null {
    return (
      this.buildNearestCurrentPositionSatellites(satellites, targetPoint)[0] ??
      null
    );
  }

  private buildNearestFallbackPreviewContext(
    nearestSatellite: TleTargetHoverEntry
  ): TleNearestFallbackPreviewContext {
    return {
      satelliteName: nearestSatellite.displayName,
      requestName: nearestSatellite.name,
      noradId: nearestSatellite.noradId,
      sensorIds: nearestSatellite.sensorIds,
      operatorKey: nearestSatellite.operatorKey,
      satellitePassKey: nearestSatellite.noradId || nearestSatellite.displayName,
      lineColor: this.getOperatorColor(nearestSatellite.operatorKey || ''),
      passTimestamp: nearestSatellite.timestamp,
      passTimeValue: this.getTlePreviewPassTimeValue([], nearestSatellite.timestamp),
      passDistance: nearestSatellite.distanceKm,
      obfuscateName: nearestSatellite.obfuscateName,
    };
  }

  private buildPreviewPassFromFallbackContext(
    satellite: any,
    poi: L.LatLngTuple
  ): TlePreviewPassCandidate | null {
    const fallbackContext = this.tleNearestFallbackPreviewContext;
    if (!fallbackContext) {
      return null;
    }

    const passGroup = this.getSatelliteTrackPoints(satellite?.position);
    if (!passGroup.length) {
      return null;
    }

    const displaySegments = this.buildTlePreviewDisplaySegments(passGroup);
    const nearestTrackPoint = this.getNearestSatelliteTrackPoint(passGroup, poi);
    if (!displaySegments.length || !nearestTrackPoint || !this.isFutureTlePassPoint(nearestTrackPoint)) {
      return null;
    }

    const passTimestamp =
      fallbackContext.passTimestamp ||
      this.formatSatellitePassTimestamp(
        nearestTrackPoint.timeStamp,
        this.getTlePreviewPassTimestamp(passGroup, satellite?.time)
      );

    return {
      satelliteName: fallbackContext.satelliteName,
      requestName: fallbackContext.requestName,
      noradId: fallbackContext.noradId,
      sensorIds: fallbackContext.sensorIds,
      operatorKey: fallbackContext.operatorKey,
      satellitePassKey: fallbackContext.satellitePassKey,
      lineColor: fallbackContext.lineColor,
      captureWidthKm: null,
      passGroup,
      displaySegments,
      passDistance: fallbackContext.passDistance,
      passTimestamp,
      passTimeValue: this.getTlePreviewPassTimeValue(passGroup, passTimestamp),
      obfuscateName: fallbackContext.obfuscateName,
      fallbackTime: satellite?.time,
    };
  }

  private getTlePassOrderForTrackPoint(
    points: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
    trackPoint: { point: L.LatLngTuple; timeStamp?: string }
  ): number {
    const passGroups = this.buildTlePassGroups(points);
    const passIndex = passGroups.findIndex((passGroup) =>
      passGroup.some((point) => this.isSameTleTrackPoint(point, trackPoint))
    );

    return passIndex >= 0 ? passIndex + 1 : 1;
  }

  private buildTlePassSelectionId(
    satellitePassKey: string,
    passOrder: number,
    passGroup: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
    fallbackTimestamp?: string
  ): string {
    const startPoint = passGroup[0];
    const endPoint = passGroup[passGroup.length - 1];
    const startTimestamp = this.formatSatellitePassTimestamp(
      startPoint?.timeStamp,
      fallbackTimestamp
    );
    const endTimestamp = this.formatSatellitePassTimestamp(
      endPoint?.timeStamp,
      fallbackTimestamp
    );
    const anchorPoint = startPoint?.point?.join(',') || 'unknown';

    return [
      satellitePassKey,
      passOrder,
      startTimestamp || 'no-start',
      endTimestamp || 'no-end',
      anchorPoint,
      passGroup.length,
    ].join('|');
  }

  private isSameTleTrackPoint(
    left: { point: L.LatLngTuple; timeStamp?: string },
    right: { point: L.LatLngTuple; timeStamp?: string }
  ): boolean {
    if (!left?.point || !right?.point) {
      return false;
    }

    const hasSameCoordinates =
      left.point[0] === right.point[0] && left.point[1] === right.point[1];

    if (!hasSameCoordinates) {
      return false;
    }

    if (!left.timeStamp || !right.timeStamp) {
      return true;
    }

    return left.timeStamp === right.timeStamp;
  }

  private getQualifyingSatelliteTrackPoints(
    trackPoints: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
    referencePoint: L.LatLngTuple,
    captureWidthKm: number
  ): Array<{
    point: L.LatLngTuple;
    timeStamp?: string;
    distanceKm: number;
  }> {
    return this.tleHelperService.getQualifyingSatelliteTrackPoints(
      trackPoints,
      referencePoint,
      captureWidthKm
    );
  }

  private getNearestQualifyingSatelliteTrackPoint(
    trackPoints: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
    referencePoint: L.LatLngTuple,
    captureWidthKm: number
  ): { point: L.LatLngTuple; timeStamp?: string; distanceKm: number } | null {
    const nearestPoint = this.tleHelperService.getNearestQualifyingSatelliteTrackPoint(
      trackPoints,
      referencePoint,
      captureWidthKm
    );
    return nearestPoint && this.isFutureTlePassPoint(nearestPoint)
      ? nearestPoint
      : null;
  }

  private isFutureTlePassPoint(trackPoint: { timeStamp?: string }): boolean {
    if (!trackPoint.timeStamp) {
      return false;
    }

    const passTime = moment.utc(trackPoint.timeStamp, moment.ISO_8601, true);
    return passTime.isValid() && passTime.valueOf() > Date.now();
  }

  private getTaskSatelliteSensorName(satellite: any): string | null {
    const sensorName =
      satellite?.sensorName ??
      satellite?.name ??
      satellite?.key ??
      satellite?.sensor?.name ??
      null;

    return typeof sensorName === 'string' && sensorName.trim()
      ? sensorName.trim()
      : null;
  }

  private getTaskSatelliteDisplayName(
    satellite: any,
    fallbackSensorName?: string | null
  ): string | null {
    let displayName: string | null = null;

    if (this.currentUser?.obfuscated) {
      const obfuscatedDisplayName = this.getTaskSatelliteObfuscatedName(
        satellite,
        fallbackSensorName
      );

      displayName =
        obfuscatedDisplayName ||
        satellite?.name ||
        satellite?.sensorDisplayName ||
        fallbackSensorName ||
        null;
    } else {
      displayName =
        satellite?.name || satellite?.sensorDisplayName || fallbackSensorName || null;
    }

    return typeof displayName === 'string' && displayName.trim()
      ? displayName.trim()
      : null;
  }

  private getTaskSatelliteRequestName(
    satellite: any,
    fallbackSensorName?: string | null
  ): string | null {
    const requestName = satellite?.name || fallbackSensorName || null;

    return typeof requestName === 'string' && requestName.trim()
      ? requestName.trim()
      : null;
  }

  private getTaskSatelliteNoradId(satellite: any): string | null {
    return this.tleHelperService.getSatelliteNoradId(satellite);
  }

  private getTaskSatelliteOperatorKey(satellite: any): string | null {
    return this.tleHelperService.getSatelliteOperatorKey(satellite);
  }

  private getTaskFilteredNearestPassTimestamp(satellite: any): string | null {
    const noradId = this.getTaskSatelliteNoradId(satellite);
    const requestName = this.getTaskSatelliteRequestName(
      satellite,
      this.getTaskSatelliteSensorName(satellite)
    );

    const matchedEntry = this.tleTargetHoverEntries.find(
      (entry) =>
        (!!noradId && entry.noradId === noradId) ||
        (!!requestName && entry.name === requestName)
    );

    return matchedEntry?.timestamp || null;
  }

  private getTaskSatelliteObfuscatedName(
    satellite: any,
    fallbackSensorName?: string | null
  ): string | null {
    const sensorName = this.getTaskSatelliteSensorName(satellite) ?? fallbackSensorName;
    const matchedSensor = sensorName
      ? this.tleSensor.sensor?.find(
          (sensor) => sensor?.sensorName === sensorName
        )
      : null;
    const selectedSensorObfuscatedName =
      sensorName && this.selectedSensorObfuscatedName?.sensorName === sensorName
        ? this.selectedSensorObfuscatedName?.obfuscateName
        : null;
    const obfuscatedName =
      satellite?.obfuscateName ||
      matchedSensor?.obfuscateName ||
      selectedSensorObfuscatedName ||
      satellite?.sensor?.obfuscateName ||
      null;

    return typeof obfuscatedName === 'string' && obfuscatedName.trim()
      ? obfuscatedName.trim()
      : null;
  }

  private getTaskSatelliteSensorIds(satellite: any): Array<string | number> {
    return this.tleHelperService.getSatelliteSensorIds(satellite);
  }

  private getTaskSatelliteCaptureWidthKm(satellite: any): number | null {
    return this.tleHelperService.getSatelliteCaptureWidthKm(satellite);
  }

  private getPlotSatelliteCaptureWidthKm(satellite: any): number | null {
    return (
      this.getTaskSatelliteCaptureWidthKm(satellite) ??
      this.getSelectedTleSensorCaptureWidthKm()
    );
  }

  private handleNoActiveSatellites(): void {
    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.tlePreviewOnlyMode = false;
    this.tleNearestFallbackPending = false;
    this.clearTleTargetHoverTooltip();
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map?.removeLayer(this.satLayer);
      this.satLayer = null;
    }

    this.clearSatelliteFetchState();
    const message =
      'There are no active satellites available for the selected target at this time. Please select another.';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }

  private handleNoNearbyPass(): void {
    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.tlePreviewOnlyMode = false;
    this.tleNearestFallbackPending = false;
    this.clearTleNearestFallbackPreviewContext();
    this.clearTleTargetHoverTooltip();
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map?.removeLayer(this.satLayer);
      this.satLayer = null;
    }

    this.clearSatelliteFetchState();
    const message =
      'There is no satellite pass closest to the target to collect within the time of interest (TOI).';
    this.popupService.openPopup(WarningPopup, message, '', '50%');
  }

  private handleSatelliteFetchError(): void {
    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.tlePreviewOnlyMode = false;
    this.tleNearestFallbackPending = false;
    this.clearTleNearestFallbackPreviewContext();
    this.clearTleTargetHoverTooltip();
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map?.removeLayer(this.satLayer);
      this.satLayer = null;
    }

    this.clearSatelliteFetchState();
    const message =
      'Unable to fetch satellite passes right now. Please try again.';
    this.popupService.openPopup(WarningPopup, message, '', '50%');
  }

  private clearSatelliteDataSubscription(): void {
    if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
      this.satelliteDataSubscription = null;
    }
  }

  private clearSatelliteFetchState(): void {
    this.clearSatelliteDataSubscription();
    this.satelliteDataRequestId += 1;
    this.isSatelliteFetchLoading = false;
    this.mapLoading = false;
    this.showtleClick = false;
    this.showtleDisabled = false;
    this.satTrackingClicked = false;
  }

  private finalizeSatelliteFetchSuccess(): void {
    this.clearSatelliteDataSubscription();
    this.satelliteDataRequestId += 1;
    this.isSatelliteFetchLoading = false;
    this.mapLoading = false;
    this.showtleClick = true;
    this.showtleDisabled = true;
    this.satTrackingClicked = false;
    this.tleNearestFallbackPending = false;
    this.clearTleNearestFallbackPreviewContext();
  }

  private isSatelliteFetchInProgress(): boolean {
    return (
      this.isSatelliteFetchLoading &&
      !!this.satelliteDataSubscription &&
      !this.satelliteDataSubscription.closed
    );
  }

  private isSatelliteFetchActive(requestId: number): boolean {
    return (
      this.isSatelliteFetchLoading &&
      this.satTrackingClicked &&
      this.satelliteDataRequestId === requestId
    );
  }

  private syncSatelliteOverlayPanes = (): void => {
    if (!this.map) {
      return;
    }

    const mapPane = this.map.getPane('mapPane');
    const satellitePassTooltipPane = this.map.getPane('satellitePassTooltipPane');
    const satelliteTargetPopupPane = this.map.getPane('satelliteTargetPopupPane');

    if (!mapPane || !satellitePassTooltipPane || !satelliteTargetPopupPane) {
      return;
    }

    const mapTransform = mapPane.style.transform;
    const mapWebkitTransform = mapPane.style.webkitTransform;
    const mapTransformOrigin = mapPane.style.transformOrigin;
    const mapWebkitTransformOrigin = mapPane.style.webkitTransformOrigin;

    satellitePassTooltipPane.style.transform = mapTransform;
    satellitePassTooltipPane.style.webkitTransform = mapWebkitTransform;
    satellitePassTooltipPane.style.transformOrigin = mapTransformOrigin;
    satellitePassTooltipPane.style.webkitTransformOrigin = mapWebkitTransformOrigin;

    satelliteTargetPopupPane.style.transform = mapTransform;
    satelliteTargetPopupPane.style.webkitTransform = mapWebkitTransform;
    satelliteTargetPopupPane.style.transformOrigin = mapTransformOrigin;
    satelliteTargetPopupPane.style.webkitTransformOrigin = mapWebkitTransformOrigin;
  };

  private bindSatellitePaneSync(): void {
    if (!this.map || this.satellitePaneSyncBound) {
      return;
    }

    this.map.on('move', this.syncSatelliteOverlayPanes);
    this.map.on('zoom', this.syncSatelliteOverlayPanes);
    this.map.on('zoomanim', this.syncSatelliteOverlayPanes);
    this.map.on('viewreset', this.syncSatelliteOverlayPanes);
    this.map.on('resize', this.syncSatelliteOverlayPanes);

    this.satellitePaneSyncBound = true;
    this.syncSatelliteOverlayPanes();
  }

  private unbindSatellitePaneSync(): void {
    if (!this.map || !this.satellitePaneSyncBound) {
      return;
    }

    this.map.off('move', this.syncSatelliteOverlayPanes);
    this.map.off('zoom', this.syncSatelliteOverlayPanes);
    this.map.off('zoomanim', this.syncSatelliteOverlayPanes);
    this.map.off('viewreset', this.syncSatelliteOverlayPanes);
    this.map.off('resize', this.syncSatelliteOverlayPanes);

    this.satellitePaneSyncBound = false;
  }

  private ensureSatellitePane() {
    if (!this.map.getPane('satellitePane')) {
      const pane = this.map.createPane('satellitePane');
      pane.style.zIndex = '650';
    }
    if (!this.map.getPane('satellitePassTooltipPane')) {
      const pane = this.map.createPane(
        'satellitePassTooltipPane',
        this.map.getContainer()
      );
      pane.style.zIndex = '1300';
      pane.style.pointerEvents = 'none';
    }
    if (!this.map.getPane('satelliteTargetPopupPane')) {
      const pane = this.map.createPane(
        'satelliteTargetPopupPane',
        this.map.getContainer()
      );
      pane.style.zIndex = '1301';
      pane.style.pointerEvents = 'auto';
    }
    if (!this.satRenderer) {
      this.satRenderer = L.svg({ pane: 'satellitePane' });
      this.satRenderer.addTo(this.map);
    }

    this.bindSatellitePaneSync();
  }

plotSatellitePath(
  result: any,
  targetLat?: number,
  targetLon?: number,
  requestId?: number
) {
  if (requestId && !this.isSatelliteFetchActive(requestId)) {
    return;
  }

  if (!this.map) {
    this.clearSatelliteFetchState();
    return;
  }

  const poi: L.LatLngTuple = [targetLat ?? 0, targetLon ?? 0];

  if (this.satLayer) {
    this.satLayer.clearLayers();
    this.map.removeLayer(this.satLayer);
  }

  this.ensureSatellitePane();
  this.satLayer = L.layerGroup([]);
  const availablePasses: TlePassSelection[] = [];
  const orderedPreviewPasses: TlePreviewPassCandidate[] = [];
  const fallbackPreviewPasses: TlePreviewPassCandidate[] = [];
  this.nearestTlePassTimestamp = null;
  this.tleAvailablePasses = [];
  this.tleSelectedPasses = [];
  this.tlePreviewOnlyMode = false;
  const fallbackPreviewContext = this.tleNearestFallbackPending
    ? this.tleNearestFallbackPreviewContext
    : null;

  if (Array.isArray(result)) {
    result.forEach((satellite: any) => {
      if (fallbackPreviewContext) {
        const fallbackPreviewPass = this.buildPreviewPassFromFallbackContext(
          satellite,
          poi
        );

        if (fallbackPreviewPass) {
          fallbackPreviewPasses.push(fallbackPreviewPass);
        }
        return;
      }

      const points = this.getSatelliteTrackPoints(satellite?.position);
      if (!points.length) return;

      const satelliteName = this.getTaskSatelliteDisplayName(
        satellite,
        this.getTaskSatelliteSensorName(satellite)
      );
      if (!satelliteName) {
        return;
      }

      const satellitePassKey =
        this.getTaskSatelliteNoradId(satellite) || satelliteName;
      const lineColor = this.getOperatorColor(
        this.getTaskSatelliteOperatorKey(satellite) || satellite?.name || ''
      );
      const captureWidthKm = this.getPlotSatelliteCaptureWidthKm(
        satellite
      );
      const requestName = this.getTaskSatelliteRequestName(
        satellite,
        this.getTaskSatelliteSensorName(satellite)
      );
      const noradId = this.getTaskSatelliteNoradId(satellite);
      const sensorIds = this.getTaskSatelliteSensorIds(satellite);
      const operatorKey = this.getTaskSatelliteOperatorKey(satellite) || '';
      const obfuscateName = this.getTaskSatelliteObfuscatedName(
        satellite,
        this.getTaskSatelliteSensorName(satellite)
      );

      if (!requestName || !noradId || !sensorIds.length || captureWidthKm === null) {
        return;
      }

      const passGroup = points;
      const displaySegments = this.buildTlePreviewDisplaySegments(passGroup);
      const nearestTrackPoint = this.getNearestSatelliteTrackPoint(passGroup, poi);
      const nearestPassPoint = this.getNearestQualifyingSatelliteTrackPoint(
        passGroup,
        poi,
        captureWidthKm
      );
      const firstPassPoint = passGroup[0]?.point;
      const firstPassPointDistanceKm = firstPassPoint
        ? this.tleHelperService.getDistanceKm(firstPassPoint, poi)
        : Number.NaN;

      if (!displaySegments.length || !nearestTrackPoint || !this.isFutureTlePassPoint(nearestTrackPoint)) {
        return;
      }

      const matchedPassTimestamp = this.getTaskFilteredNearestPassTimestamp(
        satellite
      );
      const passTimestamp =
        matchedPassTimestamp ||
        this.formatSatellitePassTimestamp(
          nearestTrackPoint.timeStamp,
          this.getTlePreviewPassTimestamp(passGroup, satellite?.time)
        );
      const nearestTrackPointDistanceKm = this.tleHelperService.getDistanceKm(
        nearestTrackPoint.point,
        poi
      );

      const basePreviewPass: TlePreviewPassCandidate = {
        satelliteName,
        requestName,
        noradId,
        sensorIds,
        operatorKey,
        satellitePassKey,
        lineColor,
        captureWidthKm,
        passGroup,
        displaySegments,
        passDistance: nearestTrackPointDistanceKm,
        passTimestamp,
        passTimeValue: this.getTlePreviewPassTimeValue(passGroup, passTimestamp),
        obfuscateName,
        fallbackTime: satellite?.time,
      };

      fallbackPreviewPasses.push(basePreviewPass);

      if (!nearestPassPoint) {
        return;
      }

      orderedPreviewPasses.push({
        ...basePreviewPass,
        passDistance: Number.isFinite(firstPassPointDistanceKm)
          ? firstPassPointDistanceKm
          : nearestPassPoint.distanceKm,
      });
    });

    orderedPreviewPasses
      .sort((left, right) => {
        if (left.noradId !== right.noradId) {
          return left.noradId.localeCompare(right.noradId);
        }

        if (left.passTimeValue !== right.passTimeValue) {
          return left.passTimeValue - right.passTimeValue;
        }

        return left.passTimestamp.localeCompare(right.passTimestamp);
      })
      .reduce((passOrdersByNoradId, previewPass) => {
        const passOrder = (passOrdersByNoradId.get(previewPass.noradId) || 0) + 1;
        passOrdersByNoradId.set(previewPass.noradId, passOrder);

        const passId = this.buildTlePassSelectionId(
          previewPass.satellitePassKey,
          passOrder,
          previewPass.passGroup,
          previewPass.passTimestamp
        );
        availablePasses.push(this.buildTleAvailablePass(previewPass, passOrder));

        return passOrdersByNoradId;
      }, new Map<string, number>());

    if (!availablePasses.length) {
      this.clearSatelliteFetchState();
      this.nearestTlePassTimestamp = null;

      const nearestFallbackPass = [...fallbackPreviewPasses].sort((left, right) => {
        if (left.passDistance !== right.passDistance) {
          return left.passDistance - right.passDistance;
        }

        if (left.passTimeValue !== right.passTimeValue) {
          return left.passTimeValue - right.passTimeValue;
        }

        return left.passTimestamp.localeCompare(right.passTimestamp);
      })[0];

      if (!nearestFallbackPass) {
        this.tleNearestFallbackPending = false;
        const message = `There is no satellite pass closest to the target to collect within the time of interest (TOI).`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return;
      }

      if (this.tleNearestFallbackPending) {
        this.tlePreviewOnlyMode = true;
        this.showTlePreviewBanner = true;
        this.tleAvailablePasses = [
          this.buildTleAvailablePass(nearestFallbackPass, 1, true),
        ];
        this.updateTleTargetHoverTooltip(
          this.buildTleTargetHoverEntriesFromPasses(this.tleAvailablePasses)
        );
        this.satLayer?.addTo(this.map);
        this.map.setView(poi, 4, { animate: false });
        this.finalizeSatelliteFetchSuccess();
        return;
      }

      const popupRef = this.popupService.openPopup(
        WarningPopup,
        'No pass falls within the selected swath. Would you like to preview the nearest pass instead?',
        '',
        '50%',
        'Yes',
        true,
        'No'
      );

      popupRef.afterClosed().subscribe((result) => {
        if (result !== 'cancel') {
          this.tlePreviewOnlyMode = true;
          this.showTlePreviewBanner = true;
          this.tleAvailablePasses = [
            this.buildTleAvailablePass(nearestFallbackPass, 1, true),
          ];
          this.updateTleTargetHoverTooltip(
            this.buildTleTargetHoverEntriesFromPasses(this.tleAvailablePasses)
          );
          this.satLayer?.addTo(this.map);
          this.map.setView(poi, 4, { animate: false });
          this.finalizeSatelliteFetchSuccess();
        }
      });
      return;
    }

    this.tleAvailablePasses = availablePasses;
    this.tlePreviewOnlyMode = false;
    this.tleNearestFallbackPending = false;
    this.updateTleTargetHoverTooltip(
      this.buildTleTargetHoverEntriesFromPasses(availablePasses)
    );

    this.satLayer.addTo(this.map);
    this.map.setView(poi, 4, { animate: false });
  }

  this.finalizeSatelliteFetchSuccess();
}


private buildTlePassGroups(
  points: Array<{ point: L.LatLngTuple; timeStamp?: string }>
): Array<Array<{ point: L.LatLngTuple; timeStamp?: string }>> {
  if (!points.length) {
    return [];
  }

  const bucketDurationMs = 90 * 60 * 1000;
  let anchorTime = Number.NaN;

  for (const trackPoint of points) {
    const trackPointTime = this.getTleTrackPointTimeValue(trackPoint?.timeStamp);

    if (Number.isFinite(trackPointTime)) {
      anchorTime = trackPointTime;
      break;
    }
  }

  if (!Number.isFinite(anchorTime)) {
    return [points];
  }

  const bucketedGroups = new Map<
    number,
    Array<{ point: L.LatLngTuple; timeStamp?: string }>
  >();
  let fallbackBucketIndex = 0;

  points.forEach((point) => {
    const pointTime = this.getTleTrackPointTimeValue(point?.timeStamp);
    const bucketIndex = Number.isFinite(pointTime)
      ? Math.max(0, Math.floor((pointTime - anchorTime) / bucketDurationMs))
      : fallbackBucketIndex;

    fallbackBucketIndex = bucketIndex;

    if (!bucketedGroups.has(bucketIndex)) {
      bucketedGroups.set(bucketIndex, []);
    }

    bucketedGroups.get(bucketIndex)!.push(point);
  });

  return Array.from(bucketedGroups.entries())
    .sort((left, right) => left[0] - right[0])
    .map(([, bucketPoints]) => bucketPoints)
    .filter((bucketPoints) => bucketPoints.length > 0);
}

private buildTlePassSegments(
  points: Array<{ point: L.LatLngTuple; timeStamp?: string }>
): Array<Array<{ point: L.LatLngTuple; timeStamp?: string }>> {
  if (!points.length) {
    return [];
  }

  const validSegments: Array<Array<{ point: L.LatLngTuple; timeStamp?: string }>> = [];
  let segment: Array<{ point: L.LatLngTuple; timeStamp?: string }> = [points[0]];

  for (let index = 1; index < points.length; index++) {
    const previousPoint = points[index - 1];
    const currentPoint = points[index];

    const isBadJump = this.isTleBadJump(previousPoint?.point, currentPoint?.point);

    if (isBadJump) {
      if (segment.length) {
        validSegments.push(segment);
      }
      segment = [];
    }

    segment.push(currentPoint);
  }

  if (segment.length) {
    validSegments.push(segment);
  }

  return validSegments;
}

private buildTleDisplaySegments(
  passGroups: Array<Array<{ point: L.LatLngTuple; timeStamp?: string }>>,
  passIndex: number
): TleDisplaySegment[] {
  const passGroup = passGroups[passIndex];
  const validSegments = this.buildTlePassSegments(passGroup);

  if (!validSegments.length) {
    return [];
  }

  return validSegments.map((segment) => {
    if (segment.length > 1) {
      return {
        points: segment.map((trackPoint) => trackPoint.point),
        trackPoints: segment,
      };
    }

    return {
      points: [segment[0].point],
      trackPoints: segment,
    };
  });
}

private buildTlePreviewDisplaySegments(
  passGroup: Array<{ point: L.LatLngTuple; timeStamp?: string }>
): TleDisplaySegment[] {
  if (!passGroup.length) {
    return [];
  }

  if (passGroup.length === 1) {
    return [
      {
        points: [passGroup[0].point],
        trackPoints: passGroup,
      },
    ];
  }

  return this.splitPolylineAtMeridian(
    passGroup.map((trackPoint) => trackPoint.point)
  )
    .filter((segment: L.LatLngTuple[]) => segment.length > 0)
    .map((segment: L.LatLngTuple[]) => ({
      points: segment,
      trackPoints: passGroup,
    }));
}

private getTlePreviewPassTimestamp(
  passGroup: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
  fallbackTimestamp?: string
): string {
  return this.tleHelperService.getPassGroupTimestamp(passGroup, fallbackTimestamp);
}

private getTlePreviewPassTimeValue(
  passGroup: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
  fallbackTimestamp?: string
): number {
  const passStartTime = new Date(
    this.getTlePreviewPassTimestamp(passGroup, fallbackTimestamp)
  ).getTime();

  return Number.isFinite(passStartTime) ? passStartTime : Number.MAX_SAFE_INTEGER;
}

private isTleBadJump(
  previousPoint?: L.LatLngTuple,
  currentPoint?: L.LatLngTuple
): boolean {
  if (!previousPoint || !currentPoint) {
    return false;
  }

  const lonDiff = Math.abs(currentPoint[1] - previousPoint[1]);

  // Only break the displayed pass when the track wraps across the world edge.
  return lonDiff > 180;
}

private isTlePassTimeGap(
  previousTimestamp?: string,
  currentTimestamp?: string
): boolean {
  if (!previousTimestamp || !currentTimestamp) {
    return false;
  }

  const previousTime = new Date(previousTimestamp).getTime();
  const currentTime = new Date(currentTimestamp).getTime();

  if (!Number.isFinite(previousTime) || !Number.isFinite(currentTime)) {
    return false;
  }

  // Retained for fallback/compatibility checks outside fixed 40-minute bucketing.
  return Math.abs(currentTime - previousTime) > 40 * 60 * 1000;
}

private getTleTrackPointTimeValue(timeStamp?: string): number {
  if (!timeStamp) {
    return Number.NaN;
  }

  return new Date(timeStamp).getTime();
}

private getSatelliteTrackPoints(
  positions: any
): Array<{ point: L.LatLngTuple; timeStamp?: string }> {
  return this.tleHelperService.getSatelliteTrackPoints(positions);
}

private formatSatellitePassTimestamp(timeStamp?: string, fallback?: string): string {
  return this.tleHelperService.formatSatellitePassTimestamp(timeStamp, fallback);
}

private formatSatellitePassTooltipTimestamp(
  timeStamp?: string,
  fallback?: string
): string {
  return this.tleHelperService.formatSatellitePassTooltipTimestamp(
    timeStamp,
    fallback
  );
}

private buildSatellitePassTooltipContent(
  satelliteName: string,
  passOrder: number,
  hoverTime: string,
  toiStartTime?: string | null,
  isSelected = false,
  previewOnly = false
): string {
  const toiStartTimeRow = toiStartTime
    ? `<div class="satellite-pass-tooltip-time">TOI start time: ${toiStartTime}</div>`
    : '';
  const actionRow = previewOnly
    ? '<div class="satellite-pass-tooltip-action">Preview only</div>'
    : isSelected
      ? '<div class="satellite-pass-tooltip-action">Click to remove selection</div>'
      : '<div class="satellite-pass-tooltip-action">Click to select</div>';

  return `<div class="satellite-pass-tooltip-content"><div class="satellite-pass-tooltip-name">${satelliteName}</div>${actionRow}${toiStartTimeRow}<div class="satellite-pass-tooltip-time">Pass order : ${passOrder}</div><div class="satellite-pass-tooltip-time">Pass time: ${hoverTime}</div></div>`;
}

private buildTleAvailablePass(
  previewPass: TlePreviewPassCandidate,
  passOrder: number,
  previewOnly = false
): TlePassSelection {
  const passId = this.buildTlePassSelectionId(
    previewPass.satellitePassKey,
    passOrder,
    previewPass.passGroup,
    previewPass.passTimestamp
  );
  const passLayers: Array<L.Polyline | L.CircleMarker> = [];

  previewPass.displaySegments.forEach((segment) => {
    const lineTooltip = L.tooltip({
      sticky: true,
      direction: 'top',
      opacity: 1,
      pane: 'satellitePassTooltipPane',
      className: 'satellite-pass-tooltip',
    });

    const passLayer =
      segment.points.length === 1
        ? L.circleMarker(segment.points[0], {
            color: previewPass.lineColor,
            weight: 3,
            radius: 5,
            fillColor: previewPass.lineColor,
            fillOpacity: 0.85,
            pane: 'satellitePane',
            interactive: true,
            renderer: this.satRenderer,
            className: 'satellite-pass-line',
          }).addTo(this.satLayer!)
        : L.polyline(segment.points, {
            color: previewPass.lineColor,
            weight: 3,
            pane: 'satellitePane',
            interactive: true,
            renderer: this.satRenderer,
            className: 'satellite-pass-line',
          }).addTo(this.satLayer!);

    passLayer.bindTooltip(lineTooltip);
    passLayer.on('mousemove', (event: L.LeafletMouseEvent) => {
      const nearestTrackPoint = this.getNearestSatelliteTrackPoint(
        segment.trackPoints,
        [event.latlng.lat, event.latlng.lng]
      );
      const hoverTime = this.formatSatellitePassTooltipTimestamp(
        nearestTrackPoint?.timeStamp,
        previewPass.passTimestamp || previewPass.fallbackTime
      );
      const toiStartTime = this.getTleHoverToiStartTime();
      const matchingPass = this.tleAvailablePasses.find((item) => item.id === passId);
      const isSelected = !!matchingPass?.selected;
      const isPreviewOnly = !!matchingPass?.previewOnly;
      passLayer.setTooltipContent(
        this.buildSatellitePassTooltipContent(
          previewPass.satelliteName,
          passOrder,
          hoverTime,
          toiStartTime,
          isSelected,
          isPreviewOnly
        )
      );

      const tooltipDirection = this.getSatellitePassTooltipDirection(
        this.map.latLngToContainerPoint(event.latlng),
        lineTooltip.getElement()
      );

      lineTooltip.options.direction = tooltipDirection;
      lineTooltip.options.offset = this.getTooltipOffset(tooltipDirection);
      passLayer.openTooltip(event.latlng);
    });
    passLayer.on('click', () => this.toggleTlePassSelection(passId));
    passLayers.push(passLayer);
  });

  const firstSegment = previewPass.displaySegments[0];
  const firstPassPath = firstSegment.points;
  const labelText = `<div class="satellite-label-text" style="color: ${previewPass.lineColor};">
                           <div class="satellite-label-line">${previewPass.satelliteName}</div>
                           <div class="satellite-label-line">${this.formatSatellitePassTooltipTimestamp(
                             previewPass.passTimestamp,
                             previewPass.fallbackTime
                           )}</div>
                         </div>`;

  L.marker(firstPassPath[0], {
    icon: L.icon({
      iconUrl: 'assets/images/satellite.png',
      iconSize: [25, 20],
      iconAnchor: [12.5, 20],
    }),
    pane: 'satellitePane',
    interactive: false,
    zIndexOffset: 1000,
  }).addTo(this.satLayer!);

  const labelLayer = L.marker(firstPassPath[0], {
    icon: L.divIcon({
      className: 'satellite-label',
      html: labelText,
      iconSize: [180, 52],
      iconAnchor: [-18, 26],
    }),
    pane: 'satellitePane',
    interactive: false,
  }).addTo(this.satLayer!);

  return {
    id: passId,
    satelliteName: previewPass.satelliteName,
    requestName: previewPass.requestName,
    noradId: previewPass.noradId,
    sensorIds: previewPass.sensorIds,
    operatorKey: previewPass.operatorKey,
    passOrder,
    timestamp: previewPass.passTimestamp,
    distanceKm: Number(previewPass.passDistance.toFixed(2)),
    lineColor: previewPass.lineColor,
    swathWidthKm: Number((previewPass.captureWidthKm || 0).toFixed(2)),
    onaDegrees: 15,
    selected: false,
    path: previewPass.passGroup.map((trackPoint) => trackPoint.point),
    layer: passLayers[0],
    layers: passLayers,
    labelLayer,
    obfuscateName: previewPass.obfuscateName,
    resolutionOptions: [],
    selectedResolution: null,
    selectedResolutionValue: null,
    resolutionLoading: false,
    resolutionError: null,
    resolutionLoaded: false,
    previewOnly,
  };
}

private getTleHoverToiStartTime(): string | null {
  const scenario = this.tleSensorForm?.get('scenario')?.value;

  if (scenario !== 'Predicted (TOI)') {
    return null;
  }

  const startDate = this.range?.value?.start;
  const startTime = this.tleSensorForm?.get('startTime')?.value;

  if (startDate && startTime) {
    return moment
      .utc(
        `${moment.utc(startDate).format('YYYY-MM-DD')} ${startTime}`,
        'YYYY-MM-DD HH:mm'
      )
      .format('DD/MM/YYYY HH:mm:ss [UTC]');
  }

  const normalizedOpenWindow = moment(this.target.openWindow).utcOffset(0, true).format();

  if (!normalizedOpenWindow) {
    return null;
  }

  return this.formatSatellitePassTooltipTimestamp(normalizedOpenWindow);
}

private pickMapOverlayDirection(
  point: L.Point,
  margin = 120,
  inset: { left?: number; right?: number; top?: number; bottom?: number } = {
    right: 100,
    top: 60,
  }
): 'left' | 'right' | 'top' | 'bottom' {
  const size = this.map.getSize();
  const leftMargin = (inset.left ?? 0) + margin;
  const rightMargin = (inset.right ?? 0) + margin;
  const topMargin = (inset.top ?? 0) + margin;
  const bottomMargin = (inset.bottom ?? 0) + margin;

  if (point.x >= size.x - rightMargin) {
    return 'left';
  }

  if (point.x <= leftMargin) {
    return 'right';
  }

  if (point.y <= topMargin) {
    return 'bottom';
  }

  if (point.y >= size.y - bottomMargin) {
    return 'top';
  }

  return 'top';
}

private clampLatLngInsideMap(
  latLng: L.LatLngExpression,
  padding: { x?: number; y?: number } = { x: 80, y: 80 }
): L.LatLng {
  const point = this.map.latLngToContainerPoint(latLng);
  const size = this.map.getSize();
  const paddingX = padding.x ?? 80;
  const paddingY = padding.y ?? 80;

  point.x = Math.max(paddingX, Math.min(size.x - paddingX, point.x));
  point.y = Math.max(paddingY, Math.min(size.y - paddingY, point.y));

  return this.map.containerPointToLatLng(point);
}

private getTooltipOffset(
  direction: 'left' | 'right' | 'top' | 'bottom'
): L.Point {
  switch (direction) {
    case 'left':
      return L.point(-8, 0);
    case 'right':
      return L.point(8, 0);
    case 'bottom':
      return L.point(0, 8);
    default:
      return L.point(0, -8);
  }
}

private getSatellitePassTooltipDirection(
  point: L.Point,
  tooltipElement?: HTMLElement | null
): 'left' | 'right' | 'top' | 'bottom' {
  if (!this.map) {
    return 'top';
  }

  const size = this.map.getSize();
  const tooltipMargin = 18;
  const tooltipWidth = Math.max(tooltipElement?.offsetWidth ?? 0, 260);
  const tooltipHeight = Math.max(tooltipElement?.offsetHeight ?? 0, 136);
  const halfTooltipWidth = Math.ceil(tooltipWidth / 2);
  const halfTooltipHeight = Math.ceil(tooltipHeight / 2);
  const directions: Array<'left' | 'right' | 'top' | 'bottom'> = [];
  const addDirection = (
    direction: 'left' | 'right' | 'top' | 'bottom'
  ): void => {
    if (!directions.includes(direction)) {
      directions.push(direction);
    }
  };

  if (point.x <= halfTooltipWidth + tooltipMargin) {
    addDirection('right');
  }

  if (point.x >= size.x - (halfTooltipWidth + tooltipMargin)) {
    addDirection('left');
  }

  if (point.y <= tooltipHeight + tooltipMargin) {
    addDirection('bottom');
  }

  if (point.y >= size.y - (tooltipHeight + tooltipMargin)) {
    addDirection('top');
  }

  addDirection('top');
  addDirection('right');
  addDirection('left');
  addDirection('bottom');

  const fitsDirection = (
    direction: 'left' | 'right' | 'top' | 'bottom'
  ): boolean => {
    switch (direction) {
      case 'left':
        return (
          point.x - tooltipMargin - tooltipWidth >= 0 &&
          point.y - halfTooltipHeight >= 0 &&
          point.y + halfTooltipHeight <= size.y
        );
      case 'right':
        return (
          point.x + tooltipMargin + tooltipWidth <= size.x &&
          point.y - halfTooltipHeight >= 0 &&
          point.y + halfTooltipHeight <= size.y
        );
      case 'bottom':
        return (
          point.y + tooltipMargin + tooltipHeight <= size.y &&
          point.x - halfTooltipWidth >= 0 &&
          point.x + halfTooltipWidth <= size.x
        );
      default:
        return (
          point.y - tooltipMargin - tooltipHeight >= 0 &&
          point.x - halfTooltipWidth >= 0 &&
          point.x + halfTooltipWidth <= size.x
        );
    }
  };

  return directions.find(fitsDirection) ?? directions[0] ?? 'top';
}

private getPopupOffset(
  direction: 'left' | 'right' | 'top' | 'bottom'
): L.Point {
  switch (direction) {
    case 'left':
      return L.point(-22, -6);
    case 'right':
      return L.point(22, -6);
    case 'bottom':
      return L.point(0, 16);
    default:
      return L.point(0, -12);
  }
}

private positionTleTargetPopup(
  popup: L.Popup,
  popupElement?: HTMLElement | null
): void {
  if (!this.map || !this.marker) {
    return;
  }

  const markerLatLng = this.marker.getLatLng();
  const markerPoint = this.map.latLngToContainerPoint(markerLatLng);
  const popupWidth = popupElement?.offsetWidth ?? 220;
  const popupHeight = popupElement?.offsetHeight ?? 140;
  const horizontalPadding = Math.ceil(popupWidth / 2) + 24;
  const verticalPadding = Math.ceil(popupHeight / 2) + 24;
  const direction = this.pickMapOverlayDirection(markerPoint, 30, {
    left: horizontalPadding,
    right: horizontalPadding,
    top: verticalPadding,
    bottom: verticalPadding,
  });
  const safeAnchor = this.clampLatLngInsideMap(markerLatLng, {
    x: horizontalPadding,
    y: verticalPadding,
  });

  popup.options.offset = this.getPopupOffset(direction);
  popup.setLatLng(safeAnchor);
  popup.update();
}

private updateTleTargetHoverTooltip(entries: TleTargetHoverEntry[]): void {
  this.tleTargetHoverEntries = entries;

  if (!this.marker || !entries.length) {
    this.clearBoundTleTargetTooltip();
    return;
  }

  const tooltipContent = this.buildTleTargetHoverTooltipContent(entries);

  this.clearBoundTleTargetTooltip();
  this.ensureSatellitePane();
  this.marker.bindPopup(tooltipContent, {
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    className: 'tle-target-hover-popup',
    offset: this.getPopupOffset('top'),
    pane: 'satelliteTargetPopupPane',
  });
  this.marker.on('mouseover', this.handleTleTargetMarkerMouseOver);
  this.marker.on('mouseout', this.handleTleTargetMarkerMouseOut);
  this.marker.on('popupopen', this.handleTleTargetPopupOpen);
  this.marker.on('popupclose', this.handleTleTargetPopupClose);
}

private buildTleTargetHoverEntriesFromPasses(
  passes: TlePassSelection[]
): TleTargetHoverEntry[] {
  return passes.map((pass) => ({
    sensorName: pass.satelliteName,
    displayName: pass.satelliteName,
    passOrder: pass.passOrder,
    timestamp: pass.timestamp,
    name: pass.requestName,
    noradId: pass.noradId,
    sensorIds: pass.sensorIds || [],
    operatorKey: pass.operatorKey,
    distanceKm: pass.distanceKm,
  }));
}

private buildTleTargetHoverTooltipContent(
  entries: TleTargetHoverEntry[]
): string {
  const rows = entries
    .map(
      (entry: TleTargetHoverEntry) =>
        `<div class="tle-target-hover-row"><span class="tle-target-hover-name">${entry.displayName} - Pass order : ${entry.passOrder}</span><span class="tle-target-hover-time">${this.formatSatellitePassTooltipTimestamp(
          entry.timestamp
        )}</span></div>`
    )
    .join('');

  return `<div class="tle-target-hover-content"><div class="tle-target-hover-list">${rows}</div></div>`;
}

private readonly handleTleTargetMarkerMouseOver = (): void => {
  this.cancelTleTargetHoverClose();

  if (this.marker && this.tleTargetHoverEntries.length) {
    const popup = this.marker.getPopup();
    if (popup) {
      this.positionTleTargetPopup(popup);
    }

    this.marker.openPopup();
  }
};

private readonly handleTleTargetMarkerMouseOut = (): void => {
  this.scheduleTleTargetHoverClose();
};

private readonly handleTleTargetPopupOpen = (event: L.PopupEvent): void => {
  const popupElement = event.popup.getElement();
  if (!popupElement) {
    return;
  }

  this.positionTleTargetPopup(event.popup, popupElement);

  popupElement.addEventListener(
    'mouseenter',
    this.handleTleTargetPopupMouseEnter
  );
  popupElement.addEventListener(
    'mouseleave',
    this.handleTleTargetPopupMouseLeave
  );
};

private readonly handleTleTargetPopupClose = (event: L.PopupEvent): void => {
  const popupElement = event.popup.getElement();
  if (popupElement) {
    popupElement.removeEventListener(
      'mouseenter',
      this.handleTleTargetPopupMouseEnter
    );
    popupElement.removeEventListener(
      'mouseleave',
      this.handleTleTargetPopupMouseLeave
    );
  }

  this.cancelTleTargetHoverClose();
};

private readonly handleTleTargetPopupMouseEnter = (): void => {
  this.cancelTleTargetHoverClose();
};

private readonly handleTleTargetPopupMouseLeave = (): void => {
  this.scheduleTleTargetHoverClose();
};

private cancelTleTargetHoverClose(): void {
  if (this.tleTargetHoverCloseTimeout) {
    clearTimeout(this.tleTargetHoverCloseTimeout);
    this.tleTargetHoverCloseTimeout = null;
  }
}

private scheduleTleTargetHoverClose(): void {
  this.cancelTleTargetHoverClose();
  this.tleTargetHoverCloseTimeout = setTimeout(() => {
    this.marker?.closePopup();
  }, 180);
}

private clearBoundTleTargetTooltip(): void {
  this.cancelTleTargetHoverClose();

  if (!this.marker) {
    return;
  }

  this.marker.off('mouseover', this.handleTleTargetMarkerMouseOver);
  this.marker.off('mouseout', this.handleTleTargetMarkerMouseOut);
  this.marker.off('popupopen', this.handleTleTargetPopupOpen);
  this.marker.off('popupclose', this.handleTleTargetPopupClose);

  if (this.marker.getTooltip?.()) {
    this.marker.unbindTooltip();
  }

  if (this.marker.getPopup?.()) {
    this.marker.closePopup();
    this.marker.unbindPopup();
  }
}

private clearTleTargetHoverTooltip(): void {
  this.tleTargetHoverEntries = [];
  this.clearBoundTleTargetTooltip();
}

private getNearestSatelliteTrackPoint(
  trackPoints: Array<{ point: L.LatLngTuple; timeStamp?: string }>,
  referencePoint: L.LatLngTuple
): { point: L.LatLngTuple; timeStamp?: string } | null {
  return this.tleHelperService.getNearestSatelliteTrackPoint(
    trackPoints,
    referencePoint
  );
}

private getSelectedTleSensorCaptureWidthKm(): number | null {
  const swath = this.selectedSensorObfuscatedName?.swath;

  if (
    swath === null ||
    swath === undefined ||
    swath === ''
  ) {
    return null;
  }

  const normalizedCaptureWidth = Number(
    typeof swath === 'string' ? swath.replace(/,/g, '') : swath
  );

  if (!Number.isFinite(normalizedCaptureWidth) || normalizedCaptureWidth <= 0) {
    return null;
  }

  return normalizedCaptureWidth;
}


  updateRfSignalsControl(event: any) {
    if (
      this.selectedCategory === this.nonImagingSensor &&
      event?.value?.sensor === this.rfType
    ) {
      if (!this.budgetForm.contains('rfSignals')) {
        this.budgetForm.addControl('rfSignals', new FormControl([]));
      }
    } else {
      if (this.budgetForm.contains('rfSignals')) {
        this.budgetForm.removeControl('rfSignals');
      }
    }
  }

  private getOperatorColor(key: string): string {
    return this.tleHelperService.getOperatorColor(key);
  }

  budgetSensorChange(event: any) {
    if (
      event?.value?.sensor === 'GHG' &&
      this.target?.multiTarget?.length > 1
    ) {
      const message = `GHG is only available for a point of interest (POI).`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.outComeSubmit = false;
      this.budgetForm.get('sensorType')?.reset();
      return;
    }
    this.closePanels();
    let target: any;
    this.budgetForm.patchValue({
      resolution: '',
      cloudCover: '',
      taskingTier: '',
      holdBack: '',
      updateFrequency: '',
      weatherResolution: '',
      weatherVariables: [],
    });
    this.resetRfSignals();
    this.updateRfSignalsControl(event);
    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';
    this.updateFrequencyOption =
      event?.value?.sensor === this.aisType ||
      event?.value?.sensor === this.weatherType;
    if (event?.value?.sensor === this.weatherType) {
      this.applyUpdateFrequencyOptions(
        this.apiService.weatherUpdateFrequencies || []
      );
      this.weatherResolutionOptions = [
        ...(this.apiService.weatherResolutions || []),
      ];
      // Hide ocean-specific variables when the task is on land (not over open water), for both POI and AOI.
      this.weatherVariableOptions = (this.apiService.weatherVariables || []).filter(
        (v: any) => !v.hideIfPoiOnLand || this.target?.openWater
      );
    } else if (event?.value?.sensor === this.aisType) {
      this.refreshAisUpdateFrequencies();
    }
    let intent = this.target?.intent;

    if (
      this.budgetForm.value.sensorCategory === STRINGCONSTANTS.IMAGING_SENSOR
    ) {
      of(event)
        .pipe(
          switchMap((ev) =>
            this.apiService.getBudgetResolutionDetails(
              ev.value,
              intent,
              this.userid,
              false,
              this.target.area,
              this.target.multiTarget
            )
          ),
          takeUntil(this.destroy$)
        )
        .subscribe((res: any) => {
          if (res?.msg === 'Success') {
            let resolutions = res.response;
            this.budgetInputs.resolutionArr = resolutions.sort((a, b) =>
              this.sortResolutions(a, b)
            );
            this.budgetInputs.resolutionArr =
              this.budgetInputs.resolutionArr.filter(
                (item) => item.key !== 'Both'
              );
          }
        });
    } else {
      if (event?.value?.sensor === this.rfType) {
        if (this.target?.geoJSON == null || this.target?.geoJSON == '') {
          const message = `Please select a target location to proceed with RF Signals selection.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return;
        }
        let targetType = this.target?.geoJSON?.includes('POINT')
          ? 'POI'
          : 'AOI';
        const sensorObj = {
          target: targetType,
        };
        this.apiService.getRFSignals(sensorObj).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            this.budgetInputs.rfSignals = res.response;
            this.updateOptions();
          }
        });
      }
      let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
      of(event)
        .pipe(
          switchMap((ev) =>
            this.apiService.getBudgetTierDetails(
              this.budgetForm?.value?.sensorType,
              null,
              this.selectedCategory,
              this.target.selectedOption,
              this.target.multiTarget,
              targetType,
              this.target.freqOption === 'Days' ? 'Days' : undefined
            )
          ),
          takeUntil(this.destroy$)
        )
        .subscribe((res: any) => {
          if (res?.msg === 'Success') {
            let seen = new Map();
            res.response.forEach((item) => {
              let lowerItem = item?.name.toLowerCase();
              if (!seen.has(lowerItem)) {
                seen.set(lowerItem, item);
              }
            });
            let uniqueTierArr = Array.from(seen.values());
            this.budgetInputs.tierArr = uniqueTierArr;
            this.updateOptions();
          }
        });
    }
  }

  sortResolutions(a, b) {
    const aIsNumeric = /^[0-9.]+m$/.test(a.key);
    const bIsNumeric = /^[0-9.]+m$/.test(b.key);
    if (aIsNumeric && bIsNumeric) {
      return this.extractNumericValue(a.key) - this.extractNumericValue(b.key);
    } else if (aIsNumeric) {
      return -1;
    } else if (bIsNumeric) {
      return 1;
    } else {
      return this.extractNumericValue(a.key) - this.extractNumericValue(b.key);
    }
  }

  extractNumericValue(text: string): number {
    const match = text.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[0]) : Number.MAX_VALUE;
  }

  budgetResolutionChange(event: any) {
    this.closePanels();
    this.budgetForm.patchValue({
      cloudCover: '',
      taskingTier: '',
      holdBack: '',
    });

    let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
    this.apiService
      .getBudgetTierDetails(
        this.budgetForm?.value?.sensorType,
        event?.value?.key,
        this.selectedCategory,
        this.target.selectedOption,
        this.target.multiTarget,
        targetType,
        this.target.freqOption === 'Days' ? 'Days' : undefined
      )
      .pipe(
        takeUntil(this.destroy$),
        map((res: any) => {
          if (res?.msg !== 'Success') return [];

          return Array.from(
            new Map(
              res.response.map((item: any) => [item.name.toLowerCase(), item])
            ).values()
          );
        })
      )
      .subscribe((uniqueTierArr) => {
        this.budgetInputs.tierArr = uniqueTierArr;
        this.updateOptions();
      });
  }

  budgetTierChange(event: any) {
    this.closePanels();
    this.budgetForm.patchValue({
      cloudCover: '',
      holdBack: '',
    });

    of(event)
      .pipe(
        switchMap(() =>
          this.apiService.getBudgetCcandHoldbackDetails(
            this.budgetForm?.value?.sensorType,
            this.budgetForm?.value?.resolution,
            event.value.key,
            this.selectedCategory,
            this.target.multiTarget
          )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((res: any) => {
        if (res?.msg === 'Success') {
          res.response.cloudCoverKeys = res.response.cloudCoverKeys.sort(
            (a, b) => parseInt(a) - parseInt(b)
          );
          this.budgetInputs.cloudCoverKeys = res.response.cloudCoverKeys.sort(
            (a, b) => parseInt(a) - parseInt(b)
          );
          this.budgetInputs.holdbackArr = this.sortArray([
            ...res.response.holdbackArr,
          ]);
          this.updateOptions();
        }
      });
  }

  isAnyFieldEmpty(): boolean {
    const requiredFields =
      this.target.taskStrategy === 'Outcome By Platform' &&
      this.outComeForm?.value?.sensorType?.name === 'AIS'
        ? ['sensorType', 'updateFrequency', 'budget', 'latency']
        : this.target.taskStrategy === 'Outcome By Platform' &&
          this.outComeForm?.value?.sensorType?.name !== 'AIS'
        ? ['sensorType', 'resolution', 'budget', 'latency', 'intent']
        : Object.keys(this.outComeForm.controls).filter(
            (key) => key !== 'cloudCover'
          );

    for (const key of requiredFields) {
      if (key != 'cloudCover') {
        const controlValue = this.outComeForm.get(key).value;
        if (
          controlValue === null ||
          controlValue === undefined ||
          controlValue === ''
        ) {
          return true;
        }
      }
    }
    return false;
  }

  submit(feedData?) {
    if (this.tleLeadTimeError) return;
    let newTaskParams = {};
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let recurringWeekDates: Array<Record<string, string[]>> = [];
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate = moment(this.target.closeWindow).utcOffset(0, true).format();
    let time_difference =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    const currentDate: any = new Date();
    this.outComeSubmit = true;
    let userTimezone = this.utilsService.getUserTimezone(this.currentUser);

    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Fortnightly') {
        no_of_repeats = Math.ceil(days_difference / 14);
        this.expectedAge = '14 days, 00:00:00';
      } else if (this.target.freqOption === 'Number of collections') {
        no_of_repeats = Number(this.target.noOfCollections) || 1;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      } else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.freqOption === 'Days') {
        recurringWeekDates = buildRecurringWeekDates(
          this.target?.openWindow,
          this.target?.closeWindow,
          Array.isArray(this.target.recurringDays) ? this.target.recurringDays : []
        );
        no_of_weeks = recurringWeekDates.length;
        no_of_repeats = recurringWeekDates.reduce((sum, week) => sum + Object.values(week)[0].length, 0);
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }
    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['taskname'] = this.target.taskname;
    newTaskParams['purpose'] = this.target?.purposeOption;
    newTaskParams['area'] = this.target.area;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    if (
      this.target.geotargets != null &&
      this.target.geotargets !== '[]' &&
      this.target.geotargets.trim() !== ''
    ) {
      newTaskParams['target'] = this.target.geotargets;
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    const isUmbraScanRetask = (this.selectedTasks?.request ?? []).some(
      (s: any) => s.operatorKey === OPERATORS.UMBRA &&
        isUmbraScanMode({ key: s.operatorKey }, s.collectionMode)
    );
    if (
      isUmbraScanRetask &&
      Array.isArray(this.target?.multiTarget) &&
      this.target.multiTarget.length === 2
    ) {
      newTaskParams['scanArea'] = Number(this.target.scanArea);
    }
    if (this.taskStrategy !== 'TLE Based Tasking') {
      newTaskParams['geometryCentroid'] = this.target?.geometryCentroid;
    }
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['frequency'] =
      this.taskStrategy === 'TLE Based Tasking'
        ? 2
        : this.target.selectedOption;
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else if (this.target.selectedOption === 3) {
      const specificDay = this.formGroup.get('specificDay').value;
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['specificDay'] = specificDay.toLowerCase();
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }
    const recurringDays = this.getRecurringDaysPayload();
    if (recurringDays !== null) {
      newTaskParams['recurringDays'] = recurringDays;
      newTaskParams['recurringWeekDates'] = recurringWeekDates;
    }
    if (this.taskStrategy !== 'TLE Based Tasking') {
      newTaskParams['mode'] = this.target.mode;
      newTaskParams['expected_age'] = this.expectedAge;
      newTaskParams['circleCordinates'] = this.target.circleCordinates;
    }

    if (
      this.taskStrategy === 'TLE Based Tasking' &&
      this.nearestTlePassTimestamp
    ) {
      newTaskParams['openWindow'] = this.nearestTlePassTimestamp;
      newTaskParams['closeWindow'] = this.nearestTlePassTimestamp;
    } else {
      newTaskParams['openWindow'] = moment(this.target.openWindow)
        .utcOffset(0, true)
        .format();
      newTaskParams['closeWindow'] = moment(this.target.closeWindow)
        .utcOffset(0, true)
        .format();
    }
    newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
      .tz(userTimezone)
      .format();

    newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
      .tz(userTimezone)
      .format();
    newTaskParams['projectid'] = this.target?.projectId;
    newTaskParams['taskStrategy'] = this.target?.taskStrategy;
    newTaskParams['tipAndCueBasedOn'] = this.target?.tipAndCueBasedOn;
    newTaskParams['observation'] =
      this.target?.observation?.length > 0 ? this.target?.observation[0] : null;
    newTaskParams['rule'] = this.target?.rule;
    newTaskParams['intent'] = this.target?.intent;
    if (this.taskStrategy !== 'TLE Based Tasking') {
      newTaskParams['cloudCover'] = this.target?.cloudCover;
      newTaskParams['taskSubStrategy'] = this.target?.taskSubStrategy;
    }
    newTaskParams['openWater'] = this.target?.openWater;

    newTaskParams['feeds'] = this.target?.feeds;
    newTaskParams['observationData'] = this.target?.observationData;
    newTaskParams['isReTask'] = this.target?.isRetask;
    if (this.taskStrategy === 'TLE Based Tasking') {
      newTaskParams['sensorId'] = this.retask
        ? this.selectedTasks?.request[0]?.sensorId
        : this.selectedSensorObfuscatedName?.sensorId;
    }
    if (this.target?.taskStrategy == 'Help Select Sensor(s)') {
      newTaskParams['useCase'] = this.target?.useCase;
      newTaskParams['useCaseDescription'] = this.target?.useCaseDescription;
    }
    if (this.retask && this.taskStrategy !== 'TLE Based Tasking' && !this.isFeedTask) {
      let totalAmount = 0;
      for (const item of this.selectedTasks.request) {
        item.feasibilityId = null;
        item.firstCapture = null;
        item.isQueuedTime = null;
        item.lastCapture = null;
        item.orderStatus = null;
        item.queuedTime = null;
        item.uuid = null;
        item.status = null;
        item.statusHistory = null;
        item.taskid = null;
        (item.operatorKey === OPERATORS.WEATHEREX
          ? (item.resolution =
              typeof item?.resolution === 'string'
                ? item.resolution || null
                : item?.resolution?.value || item?.resolution?.resolution_value || null)
          : (item.resolution = {
              value:
                item?.name === 'GRUS'
                  ? item?.originalResolution
                  : typeof item?.resolution === 'string'
                    ? item?.resolution
                    : item?.resolution?.resolution_value || item?.resolution?.value,
              mode_value: item?.resolutionTooltip,
              resolution_value:
                item?.name === 'GRUS'
                  ? item?.originalResolution
                  : typeof item?.resolution === 'string'
                    ? item?.resolution
                    : item?.resolution?.resolution_value || item?.resolution?.value,
              originalResolution: item?.originalResolution,
              ...(item?.originalResolution === 'Both'
                ? {
                    combinedResolution:
                      typeof item?.resolution === 'string'
                        ? item?.resolution
                        : item?.resolution?.combinedResolution ||
                          item?.resolution?.resolution_value ||
                          item?.resolution?.value,
                  }
                : {}),
            })),
          (item.retaskingTooltip = []);
        item.feedData = [];
        item.pay = false;
        item.refund = false;
        item.orderNumber = null;

        [
          'approverDetails',
          'ordererDetails',
          'cancelerDetails',
          'rejecterDetails',
          'approved_by',
          'ordered_by',
          'canceled_by',
          'approval_rejected_details',
        ].forEach((key) => {
          if (item.hasOwnProperty(key)) {
            delete item[key];
          }
        });

        if (item.sensortype === 'GHG') {
          this.recalculateGhgRetaskCost(item, noOfMonths);
        } else if (this.target.selectedOption === 1 && item.multiplierCost) {
          item.cost = parseFloat(
            (item.multiplierCost * no_of_repeats).toFixed(2)
          );
        }
      }

      let retaskTotalTaskNumber = 0;

      this.selectedTasks.request = this.selectedTasks.request.map((sensor) => {
        let tNumber = 0;
        if (this.currentUser?.allocated) {
          if (sensor.operatorKey === OPERATORS.LBAND) {
            tNumber = Number(sensor.taskNumber) || 0;
          } else if (sensor.isPoint === true) {
            tNumber = 1 * no_of_repeats;
          } else {
            if (
              sensor.unit === 'sqkm' ||
              sensor.unit === 'scene' ||
              sensor.unit === 'week' ||
              sensor.unit === 'day'
            ) {
              tNumber =
                Math.ceil(sensor.areacalc / sensor.minimumArea) * no_of_repeats;
            }
          }

          retaskTotalTaskNumber += tNumber;
        }
        const p = this.currentUser.pointsEligible
          ? this.convertCostToPoints(sensor.cost, false)
          : 0;
        return {
          ...sensor,
          point: p,
          taskNumber: tNumber,
        };
      });

      this.totalTaskNumber = retaskTotalTaskNumber;

      totalAmount = this.selectedTasks.request.reduce(
        (a, { cost }) => a + cost,
        0
      );
      this.taskPoint = this.currentUser.pointsEligible
        ? this.selectedTasks.request.reduce((total, sensor) => {
            return total + this.convertCostToPoints(sensor.cost, false);
          }, 0)
        : 0;
      newTaskParams['taskcost'] = totalAmount.toFixed(2);
      newTaskParams['sensors'] = JSON.stringify(this.selectedTasks.request);
      newTaskParams['feasibilityTask'] = this.selectedTasks?.feasibilityTask;
      newTaskParams['collectionStart'] = this.selectedTasks?.collectionStart;
      newTaskParams['collectionEnd'] = this.selectedTasks?.collectionEnd;
      newTaskParams['taskPoints'] = this.taskPoint;
      newTaskParams['totalTaskNumber'] = this.totalTaskNumber;

      if (this.target?.taskStrategy === 'Outcome By Platform') {
        newTaskParams['outComeBudgetPoint'] = this.currentUser.pointsEligible
          ? this.selectedTasks?.outComeBudget
          : 0;
        newTaskParams['outComeBudget'] = this.currentUser.pointsEligible
          ? this.convertToCost(this.selectedTasks?.outComeBudget)
          : this.selectedTasks?.outComeBudget;
        // newTaskParams['outComeBudget'] = this.selectedTasks?.outComeBudget;
        newTaskParams['outComeCloudCover'] =
          this.selectedTasks?.outComeCloudCover;
        newTaskParams['outComeLatency'] = this.selectedTasks?.outComeLatency;
        newTaskParams['outComeResolution'] =
          this.selectedTasks?.outComeResolution;
        newTaskParams['outComesensorType'] =
          this.selectedTasks?.outComesensorType;
        newTaskParams['outcomeUpdateFrequency'] =
          this.outComeForm?.value?.updateFrequency;
        newTaskParams['outcomeIntent'] = this.target?.intent;

        //Popup details
        newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
        newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
        newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
        newTaskParams['noOfHistoricalData'] =
          this.outcomePopUpData?.noOfHistoricalData;
      }
      newTaskParams['isSameSensor'] = this.isSameSensorRetask();
      newTaskParams['sendParentTaskId'] = this.sendParentTaskId;
      if (this.sendParentTaskId) {
        newTaskParams['parentTaskId'] = this.selectedTasks?.parentTaskId;
      }

      this.submitNewTaskWithToiValidation(newTaskParams, {
        submitRequest: isUmbraScanRetask
          ? this.apiService.multiPoiTaskSubmit(newTaskParams)
          : this.getTaskSubmitRequest(newTaskParams),
        taskName: this.target.taskname,
        from: 'task',
        onError: (error: any) => {
          this.outComeSubmit = false;
          this.showTaskSubmissionErrors(error);
        },
        onCancel: () => {
          this.outComeSubmit = false;
          this.isFeedTaskSubmitted = false;
        },
      });
    } else {
      const isOutcomeScanSAR = this.outComeForm?.value?.sensorType?.value === 'ScanSAR';
      if (this.target?.multiTarget?.length > 1 && !isOutcomeScanSAR) {
        const message = !this.isFeedTask ? `Multiple points of interest (POIs) tasking is only available for User Initiated and Sensor Type Based tasking strategies at this time.` :
                                           `Multiple points of interest (POIs) tasking is not available for question based tasking.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.outComeSubmit = false;
        this.isFeedTaskSubmitted = false;
        return;
      }

      this.outComeForm.value.budget = parseFloat(
        this.outComeForm?.value?.budget
      );
      this.outComeForm.value.sensorType && (this.outComeForm.value.sensorType = this.outComeForm?.value?.sensorType.name);

      if (isOutcomeScanSAR && this.target?.multiTarget?.length === 2) {
        newTaskParams['scanArea'] = Number(this.target.scanArea);
      }

      newTaskParams['outComeBudgetPoint'] = this.currentUser.pointsEligible
        ? parseFloat(this.outComeForm.value.budget.toFixed(2))
        : 0;
      newTaskParams['outComeBudget'] = this.currentUser.pointsEligible
        ? this.convertToCost(
            parseFloat(this.outComeForm.value.budget.toFixed(2))
          )
        : parseFloat(this.outComeForm.value.budget.toFixed(2));
      // newTaskParams['outComeBudget'] = parseFloat(this.outComeForm.value.budget.toFixed(2));
      if (this.taskStrategy !== 'TLE Based Tasking') {
        newTaskParams['outComeCloudCover'] =
          this.outComeForm?.value?.cloudCover;
      }
      newTaskParams['outComeLatency'] =
        this.taskStrategy !== 'TLE Based Tasking'
          ? this.outComeForm?.value?.latency
          : this.getWindowDiffInHours(
              this.target.openWindow,
              this.target.closeWindow
            );
      newTaskParams['outComeResolution'] =
        this.taskStrategy === 'TLE Based Tasking'
          ? this.parseResolutionValues()
          : this.outComeForm?.value?.resolution;
      newTaskParams['outComesensorType'] =
        this.taskStrategy === 'TLE Based Tasking'
          ? this.tleSensorForm?.value?.sensorType
          : this.outComeForm?.value?.sensorType;
      if (
        this.taskStrategy === 'Tip-and-Cue' &&
        this.subStrategy === 'Tip-and-Cue-Outcome'
      ) {
        newTaskParams['outComesensorType'] = [
          {
            sensor: this.outComeForm?.value?.cueingSensorType?.name,
            sensorType: 'Cueing',
          },
          {
            sensor: this.outComeForm?.value?.tippingSensorType?.name,
            sensorType: 'Tipping',
          },
        ];
        newTaskParams['tippingSensorResolution'] =
          this.outComeForm?.value?.tippingSensorResolution;
        newTaskParams['cueingSensorResolution'] =
          this.outComeForm?.value?.cueingSensorResolution;
        newTaskParams['tippingSensorCloudCover'] =
          this.outComeForm?.value?.tippingCloudCover;
        newTaskParams['cueingSensorCloudCover'] =
          this.outComeForm?.value?.cueingCloudCover;
      }
      if (this.taskStrategy !== 'TLE Based Tasking') {
        newTaskParams['taskStrategy'] = this.subStrategy
          ? this.subStrategy
          : this.target?.taskStrategy;
      }
      newTaskParams['outcomeUpdateFrequency'] =
        this.outComeForm?.value?.updateFrequency;
      newTaskParams['outcomeIntent'] = this.target?.intent;
      if (this.target.taskStrategy !== 'TLE Based Tasking') {
        //Popup details
        newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
        newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
        newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
        newTaskParams['noOfHistoricalData'] =
          this.outcomePopUpData?.noOfHistoricalData;
      }
      if(this.isFeedTask){
        const selectedQuestion: QuestionItem =
        this.formGroup.value.searchControl;
        newTaskParams['question'] = { id: selectedQuestion?.id };
        newTaskParams['sensors'] = feedData?.sensors;
        newTaskParams['isAnswerFirst'] = true;
        newTaskParams['question'] = selectedQuestion;
        newTaskParams['taskPriority'] = feedData?.taskPriority;
      }

      if (this.taskStrategy === 'TLE Based Tasking') {
        this.submitTleOutcomeTaskWithValidation(newTaskParams);
      } else {
        this.submitOutcomeTaskRequest(newTaskParams);
      }
    }
  }

  private submitTleOutcomeTaskWithValidation(newTaskParams: any): void {
    const sensorsPayload = this.buildTleOutcomeSensorsPayload();

    if (!sensorsPayload) {
      this.outComeSubmit = false;
      this.isFeedTaskSubmitted = false;
      return;
    }

    const validationPayload = {
      ...newTaskParams,
      sensors: sensorsPayload,
      tleValidation: true,
    };

    this.apiService.outcomeTaskSubmit(validationPayload).subscribe(
      (res: any) => {
        this.isFeedTaskSubmitted = false;

        this.openTleValidationDialog(
          this.getTleValidationMessage(res),
          this.getTleValidationPopupType(res),
          () => {
            this.submitOutcomeTaskRequest({
              ...validationPayload,
              tleValidation: false,
            });
          },
          () => {
            this.outComeSubmit = false;
            this.isFeedTaskSubmitted = false;
          }
        );
      },
      (error: any) => {
        this.outComeSubmit = false;
        this.isFeedTaskSubmitted = false;
        this.showTaskSubmissionErrors(error);
      }
    );
  }

  private buildTleOutcomeSensorsPayload(): any[] | null {
    if (!Array.isArray(this.tleSelectedPasses) || this.tleSelectedPasses.length === 0) {
      this.popupService.openPopup(
        WarningPopup,
        'Please select at least one TLE pass before submitting.',
        '',
        '50%'
      );
      return null;
    }

    const sensorsPayload: any[] = [];

    for (const pass of this.tleSelectedPasses) {
      const timeStamp = pass?.timestamp;
      const noradId = pass?.noradId;
      const sensorIds = pass?.sensorIds || [];
      const resolution = pass?.selectedResolution?.raw;
      const operatorKey = pass?.operatorKey;
      const obfuscateName =
        pass?.obfuscateName ||
        this.selectedSensorObfuscatedName?.obfuscateName;

      if (!resolution) {
        this.popupService.openPopup(
          WarningPopup,
          'Please select a resolution for each TLE pass before submitting.',
          '',
          '50%'
        );
        return null;
      }

      sensorsPayload.push({
        timeStamp,
        noradId,
        sensor_ids: sensorIds,
        resolution,
        obfuscateName,
        operatorKey,
      });
    }

    return sensorsPayload;
  }

  private getTleValidationMessage(res: any): string {
    const responseMessage = this.extractMessageValue(res?.msg);

    return (
      responseMessage
    );
  }

  private getTleValidationPopupType(res: any): string {
    const status = `${res?.status ?? ''}`.trim().toLowerCase();

    return status === 'success' ? 'success' : '';
  }

  private extractMessageValue(value: any): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        return '';
      }

      try {
        const parsedValue = JSON.parse(trimmedValue);
        return this.extractMessageValue(parsedValue);
      } catch (error) {
        return trimmedValue;
      }
    }

    if (typeof value?.message === 'string' && value.message.trim().length > 0) {
      return value.message.trim();
    }

    if (typeof value?.msg === 'string' && value.msg.trim().length > 0) {
      return value.msg.trim();
    }

    if (typeof value?.response === 'string' || typeof value?.response === 'object') {
      return this.extractMessageValue(value.response);
    }

    if (typeof value?.data?.message === 'string' && value.data.message.trim().length > 0) {
      return value.data.message.trim();
    }

    return '';
  }

  private openTleValidationDialog(
    message: string,
    popupType: string,
    onComplete: () => void,
    onCancel?: () => void
  ): void {
    const popupRef = this.popupService.openPopup(
      WarningPopup,
      message,
      popupType,
      '50%',
      'Submit',
      true,
      'Cancel'
    );

    popupRef.afterClosed().pipe(take(1)).subscribe((result) => {
      if (result === 1) {
        onComplete();
        return;
      }

      onCancel?.();
    });
  }

  private submitOutcomeTaskRequest(newTaskParams: any): void {
    this.apiService.outcomeTaskSubmit(newTaskParams).subscribe(
      (res: any) => {
        this.isFeedTaskSubmitted = false;
        if (res?.msg === 'Success') {
          let taskid;
          taskid = res?.taskid;
          newTaskParams['taskId'] = taskid;

          const dialogRef = this.dialog.open(ConfirmDialog, {
            backdropClass: 'blurr',
            disableClose: true,
            width: '40%',
            data: {
              taskid: taskid,
              taskname: this.target.taskname,
              response: res,
              type: 'outcome',
              from: 'outcome',
              isFeedTask:this.isFeedTask?? false,
            },
          });
        } else if (res?.msg === 'Failed' && res?.message) {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              message: 'outcomeFail',
              response: res?.message,
              url: '/task',
            },
          });
          if (this.target?.taskStrategy === 'Outcome By Platform') {
            this.resetOutcomeDefined();
          } else {
            this.resetOutcome();
          }
        } else {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { message: 'fail', url: '/task' },
          });
        }
        if (this.target?.taskStrategy === 'Outcome By Platform') {
          this.resetOutcomeDefined();
        } else {
          this.resetOutcome();
        }
      },
      (error: any) => {
        const dialogRef = this.dialog.open(CountrycheckComponent, {
          width: '40%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { message: 'fail', url: '/task' },
        });
        this.resetOutcome();
      }
    );
  }

  getWindowDiffInHours(
    openWindow: string | Date,
    closeWindow: string | Date
  ): number {
    const openWindowMoment = moment(openWindow).utcOffset(0, true);
    const closeWindowMoment = moment(closeWindow).utcOffset(0, true);
    return closeWindowMoment.diff(openWindowMoment, 'hours', true);
  }
  parseResolutionValues() {
    const resolution = this.tleSensorForm?.value?.resolution;

    if (!resolution) {
      return {
        key: resolution,
        minValue: resolution,
        maxValue: resolution,
      };
    }
    if (resolution.includes('-')) {
      const rangeMatch = resolution.match(/(\d+\.?\d*)-(\d+\.?\d*)/);

      if (rangeMatch) {
        const minVal = parseFloat(rangeMatch[1]);
        const maxVal = parseFloat(rangeMatch[2]);

        return {
          key: resolution,
          minValue: minVal,
          maxValue: maxVal,
        };
      }
    }

    return {
      key: resolution,
      minValue: resolution,
      maxValue: resolution,
    };
  }

  private recalculateGhgRetaskCost(item: any, noOfMonths: number): void {
    const collectionMode = item?.collectionMode?.[0];
    const keyToMatch = item?.latency?.key;

    if (!collectionMode || !keyToMatch || !Array.isArray(collectionMode?.cost)) {
      return;
    }

    let ghgCost: number | null = null;
    for (const costItem of collectionMode.cost) {
      if (costItem?.[keyToMatch] !== undefined) {
        ghgCost = Number(costItem[keyToMatch]);
        break;
      }
    }

    if (!Number.isFinite(ghgCost)) {
      return;
    }

    const baseGhgCost = ghgCost as number;
    const captureMode = collectionMode?.captureMode || '';
    let annualCost = 0;

    if (captureMode.includes('annual')) {
      const monthlyCost = baseGhgCost / 12;
      if (noOfMonths > 12) {
        annualCost = noOfMonths % 12 === 0
          ? (noOfMonths / 12) * baseGhgCost
          : baseGhgCost + (noOfMonths - 12) * monthlyCost;
      } else {
        annualCost = baseGhgCost;
      }
    } else {
      annualCost = baseGhgCost * noOfMonths;
    }

    const targetLength = this.target?.multiTarget?.length > 0
      ? this.target.multiTarget.length
      : 1;

    if (!captureMode.includes('Complex')) {
      annualCost = annualCost * targetLength;
    }

    const sceneCount = this.getGhgRetaskSceneCount(item);
    const calculatedCost = parseFloat((annualCost * sceneCount).toFixed(2));
    const calculatedArea = this.getGhgRetaskCalculatedArea(item);
    const minimumArea = this.getGhgRetaskMinimumArea(item);

    item.cost = calculatedCost;
    item.unitCost = calculatedCost;
    item.noOfMonths = noOfMonths;
    item.isPoint = !!this.target?.geoJSON?.includes('POINT');
    item.areacalc = calculatedArea;
    item.minimumArea = minimumArea;
    item.isCalculatedAreaSmaller = minimumArea > calculatedArea;
  }

  private getGhgRetaskSceneCount(item: any): number {
    const calculatedArea = this.getGhgRetaskCalculatedArea(item);
    const minimumArea = this.getGhgRetaskMinimumArea(item);

    if (!Number.isFinite(calculatedArea) || calculatedArea <= 0) {
      return 1;
    }

    if (!Number.isFinite(minimumArea) || minimumArea <= 0) {
      return 1;
    }

    return calculatedArea < minimumArea
      ? 1
      : Math.ceil(calculatedArea / minimumArea);
  }

  private getGhgRetaskCalculatedArea(item: any): number {
    const targetArea = Number(this.target?.area);
    if (Number.isFinite(targetArea) && targetArea > 0) {
      return targetArea;
    }

    const itemArea = Number(item?.areacalc);
    return Number.isFinite(itemArea) ? itemArea : 0;
  }

  private getGhgRetaskMinimumArea(item: any): number {
    const minimumArea = Number(item?.minimumArea);
    if (Number.isFinite(minimumArea) && minimumArea > 0) {
      return minimumArea;
    }

    const itemArea = Number(item?.areacalc);
    return Number.isFinite(itemArea) ? itemArea : 0;
  }

  private isSameSensorRetask(): boolean {
    const retaskOption =
      this.route.snapshot.queryParamMap.get('option') || this.retaskOption;

    return retaskOption === 'existing-sensor';
  }

  private getTaskSubmitRequest(newTaskParams: any): Observable<any> {
    // VesselFinder covers the whole world, so a multi-point retask must still
    // go through the single newTaskSubmit call, never the multi-point endpoint
    // (mirrors the same-named guard in taskcost.component.ts's submit flow).
    const isVesselFinderIncluded = (this.selectedTasks?.request ?? []).some(
      (s: any) => s?.operatorKey === OPERATORS.VESSELFINDER
    );

    return !isVesselFinderIncluded && this.target?.multiTarget?.length > 0
      ? this.apiService.multiPoiTaskSubmit(newTaskParams)
      : this.apiService.newTaskSubmit(newTaskParams);
  }

  private submitNewTaskWithToiValidation(
    newTaskParams: any,
    options: {
      submitRequest?: Observable<any>;
      taskName: string;
      from: string;
      onNonSuccess?: (res: any) => void;
      onError?: (error: any) => void;
      onCancel?: () => void;
    }
  ): void {
    const request =
      options.submitRequest ?? this.getTaskSubmitRequest(newTaskParams);

    request.subscribe(
      (res: any) => {
        const toiWarnings = this.getToiValidationMessages(res);

        if (toiWarnings.length > 0 && !newTaskParams['skipToiValidation']) {
          this.openCombinedToiWarningDialog(
            toiWarnings,
            () => {
              this.submitNewTaskWithToiValidation(
                { ...newTaskParams, skipToiValidation: true },
                {
                  taskName: options.taskName,
                  from: options.from,
                  onNonSuccess: options.onNonSuccess,
                  onError: options.onError,
                  onCancel: options.onCancel,
                }
              );
            },
            options.onCancel
          );
          return;
        }

        if (res?.msg === 'Success') {
          this.handleNewTaskSubmitSuccess(
            res,
            newTaskParams,
          );
          return;
        }

        options.onNonSuccess?.(res);
      },
      (error: any) => {
        options.onError?.(error);
      }
    );
  }

  private handleNewTaskSubmitSuccess(
    res: any,
    newTaskParams: any,
  ): void {
    let data = JSON.parse(res?.response);
    let taskid;
    let sensorList = this.matchUUIDs(newTaskParams['sensors'], data);

    newTaskParams['sensors'] = JSON.stringify(sensorList);

    if (data && data.length > 0) {
      taskid = res?.taskid;
      newTaskParams['taskId'] = taskid;
      this.apiService
        .genCollection(this.currentUser.id, this.currentUser.email, newTaskParams)
        .subscribe(() => {
        });
    }

    this.dialog.open(ConfirmDialog, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        taskid: taskid,
        taskname: this.target.taskname,
        response: res,
        type: 'normal',
        from: 'task',
      },
    });
  }

  private parseTaskSubmitResponseData(
    res: any,
    nestedKey?: string
  ): any[] {
    if (Array.isArray(res)) {
      return res;
    }

    const responsePayload = res;

    if (nestedKey && Array.isArray(responsePayload?.[nestedKey])) {
      return responsePayload[nestedKey];
    }

    if (Array.isArray(responsePayload)) {
      return responsePayload;
    }

    if (!nestedKey && Array.isArray(responsePayload?.data)) {
      return responsePayload.data;
    }

    if (typeof responsePayload === 'string') {
      try {
        const parsedPayload = JSON.parse(responsePayload);
        if (nestedKey && Array.isArray(parsedPayload?.[nestedKey])) {
          return parsedPayload[nestedKey];
        }
        if (!nestedKey && Array.isArray(parsedPayload?.data)) {
          return parsedPayload.data;
        }
        return Array.isArray(parsedPayload) ? parsedPayload : [];
      } catch {
        return [];
      }
    }

    return [];
  }

  private getToiValidationMessages(res: any): string[] {
    const responsePayload = this.parseTaskSubmitResponseData(
      res,
      'advisoryWarnings'
    );

    return responsePayload
      .filter(
        (item: any) =>
          item?.type === 'latencyMinimum' &&
          typeof item?.message === 'string' &&
          item.message.trim().length > 0
      )
      .map((item: any) => item.message.trim());
  }

  private openCombinedToiWarningDialog(
    messages: string[],
    onComplete: () => void,
    onCancel?: () => void
  ): void {
    const popupMessage = this.formatPopupMessageList(messages);
    const popupRef = this.popupService.openPopup(
      WarningPopup,
      popupMessage,
      'orderedWarning',
      '50%',
      'Continue',
      true,
      'Cancel'
    );

    popupRef.afterClosed().pipe(take(1)).subscribe((result) => {
      if (result === 1) {
        onComplete();
        return;
      }

      onCancel?.();
    });
  }

  private formatPopupMessageList(messages: string[]): string {
    if (messages.length <= 1) {
      return messages[0] || '';
    }

    const listItems = messages.map((message) => `<li>${message}</li>`).join('');
    return `<ol>${listItems}</ol>`;
  }

  private showTaskSubmissionErrors(error: any): void {
    const violationMessages = this.getTaskSubmissionViolationMessages(error);

    if (violationMessages.length > 0) {
      this.openCombinedTaskViolationDialog(violationMessages);
      return;
    }

    this.dialog.open(CountrycheckComponent, {
      width: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: { message: 'fail', url: '/task' },
    });
  }

  private getTaskSubmissionViolationMessages(error: any): string[] {
    const errorPayload = error?.error || error;
    const violations = Array.isArray(errorPayload?.violations)
      ? errorPayload.violations
      : [];

    return violations
      .map((violation: any) => violation?.message)
      .filter(
        (message: any) => typeof message === 'string' && message.trim().length > 0
      );
  }

  private openCombinedTaskViolationDialog(messages: string[]): void {
    const popupMessage = this.formatPopupMessageList(messages);

    this.popupService.openPopup(
      WarningPopup,
      popupMessage,
      'orderedWarning',
      '50%',
      'Ok, Thanks'
    );
  }

  convertCostToPoints(cost: number, includeLabel: boolean = true) {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor = parseFloat(parts[1]) / parseFloat(parts[0]);
    const points = Math.round(cost * conversionFactor);
    return includeLabel == true ? points + ' Points' : points;
  }

  getCloudData(panelOpenState, index) {
    let type;
    if (this.target.geoJSON && panelOpenState) {
      let sensorData = {};
      if (index === 0) {
        this.isChecked = false;
      }
      const currentDate: any = new Date();
      sensorData['target'] = JSON.stringify(geoParse(this.target.geoJSON));
      sensorData['openWindow'] = moment(this.target.openWindow)
        .utcOffset(0, true)
        .format();
      sensorData['closeWindow'] = moment(this.target.closeWindow)
        .utcOffset(0, true)
        .format();

      sensorData['type'] = 'days';

      const sensorObj = { sensorData: sensorData };
      this.cloudclicked = false;

      if (
        sensorObj?.sensorData['openWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['closeWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['target'] != 'null'
      ) {
        this.apiService.getCloudCoverData(sensorObj).subscribe((res: any) => {
          this.weatherData = res?.result;
          this.hourly = true;
          this.cloudclicked = true;
        });
      }
    }
  }

  getHourlyCloudData(panelOpenState, item) {
    if (this.target.geoJSON && panelOpenState) {
      let sensorData = {};
      sensorData['target'] = JSON.stringify(geoParse(this.target.geoJSON));
      sensorData['openWindow'] = item?.date;
      sensorData['closeWindow'] = item?.date;
      sensorData['type'] = 'hours';

      const sensorObj = { sensorData: sensorData };
      this.cloudclicked = false;

      if (
        sensorObj?.sensorData['openWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['closeWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['target'] != 'null'
      ) {
        this.apiService.getCloudCoverData(sensorObj).subscribe((res: any) => {
          this.weatherData = res?.result;
          this.hourly = false;
          this.cloudclicked = true;
        });
      }
    }
  }

  public openLocalTimeDialog(field: 'start' | 'end'): void {
    if (this.mapLoading) {
      return;
    }

    const timezone =
      this.userTimezone ||
      this.utilsService.getUserTimezone(this.currentUser);
    const isStartField = field === 'start';
    const dialogRef = this.dialog.open(LocalTimePickerDialogComponent, {
      width: '420px',
      disableClose: true,
      data: {
        title: `${isStartField ? 'Start' : 'End'} Time (Local)`,
        description:
          'Enter the registered local time. The UTC field will update only after you apply the conversion.',
        date: isStartField ? this.range.value.start : this.range.value.end,
        timezone,
      },
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe((selectedTime) => {
      if (!selectedTime) {
        return;
      }

      if (isStartField) {
        this.onTimeSet(selectedTime);
        return;
      }

      this.onEndTimeSet(selectedTime);
    });
  }

  onTimeSet(event: any) {
    let ustDateTime = this.onStartTimeChange(event, this.range.value.start);
    this.date = new FormControl(ustDateTime.utcStartDate);
    this.range.patchValue({
      start: ustDateTime.utcStartDate,
      end: this.range.value.end,
    });

    this.range.value.start = ustDateTime.utcStartDate;
    this.target['openWindow'] = this.range.value.start;
    const selectedTimeStr = ustDateTime.utcTime;
    const selectedTime = new Date('2000-01-01 ' + selectedTimeStr);

    const startHours = selectedTime.getHours();
    const startMinutes = selectedTime.getMinutes();
    const startSeconds = selectedTime.getSeconds();

    const openWindow = moment(this.target['openWindow']);
    const combinedDateTime = openWindow
      .set({ hour: startHours, minute: startMinutes, second: startSeconds })
      .toDate();

    this.target['openWindow'] = combinedDateTime;
    this.isPast = this.isPastDateTime(combinedDateTime);
    this.getHoursDifference();
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.clearTLEOnly();
      this.showtleClick = false;
      this.showtleDisabled = false;
    }
    this.apiService.updateTaskParams(this.target);

    setTimeout(() => {
      this.formGroup.patchValue({
        startTime: ustDateTime.utcTime,
      });

      this.budgetForm.patchValue({
        startTime: ustDateTime.utcTime,
      });

      if (this.taskStrategy === 'TLE Based Tasking') {
        this.tleSensorForm.patchValue({
          startTime: ustDateTime.utcTime,
        });
      }
    }, 0);
    this.updateTarget(this.target, '0');
  }

  onEndTimeSet(event: any) {
    let ustDateTime = this.onEndTimeChange(event, this.range.value.end);
    this.range.patchValue({
      end: ustDateTime.utcEndDate,
    });
    this.range.value.end = ustDateTime.utcEndDate;
    if (this.selectedOption === 0 || this.selectedOption === 3  ) {
      this.range.value.end = this.range.value.start;
    }
    this.target['closeWindow'] = this.range.value.end;
    const selectedTimeStr = ustDateTime.utcTime;
    const selectedTime = new Date('2000-01-01 ' + selectedTimeStr);

    const startHours = selectedTime.getHours();
    const startMinutes = selectedTime.getMinutes();
    const startSeconds = selectedTime.getSeconds();

    const closeWindow = moment(this.target['closeWindow']);
    const combinedDateTime = closeWindow
      .set({ hour: startHours, minute: startMinutes, second: startSeconds })
      .toDate();

    this.target['closeWindow'] = combinedDateTime;
    this.tipAndCueEndSelectedByUser = true;
    this.isEndPast = this.isEarlierThan(
      this.target['closeWindow'],
      this.target['openWindow']
    );

    this.getHoursDifference();
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.clearTLEOnly();
      this.showtleClick = false;
      this.showtleDisabled = false;
      if (this.getHoursDifference() > 72) {
        this.tleToiError = true;
      } else {
        this.tleToiError = false;
      }
    }
    this.apiService.updateTaskParams(this.target);
    this.enforceSmallBoatTipAndCueWindow();

    setTimeout(() => {
      this.formGroup.patchValue({
        endTime: ustDateTime.utcTime,
      });

      this.budgetForm.patchValue({
        endTime: ustDateTime.utcTime,
      });

      if (this.taskStrategy === 'TLE Based Tasking') {
        this.tleSensorForm.patchValue({
          endTime: ustDateTime.utcTime,
        });
      }
    }, 0);
    this.updateTarget(this.target, '0');
  }

  getHoursDifference(): number {
    const millisecondsPerHour = 1000 * 60 * 60;
    const differenceInMilliseconds =
      this.target['closeWindow']?.getTime() -
      this.target['openWindow']?.getTime();
    if (this.taskStrategy !== 'TLE Based Tasking') {
      this.timeError = differenceInMilliseconds / millisecondsPerHour;
    }
    return differenceInMilliseconds / millisecondsPerHour;
  }

  isPastDateTime(dateTime: Date): boolean {
    const givenDate = new Date(dateTime);

    // Get the current date and time in UTC
    const nowUtc = new Date();

    // Convert the current date and time to UTC
    const currentUtcDate = new Date(
      nowUtc.getUTCFullYear(),
      nowUtc.getUTCMonth(),
      nowUtc.getUTCDate(),
      nowUtc.getUTCHours(),
      nowUtc.getUTCMinutes(),
      nowUtc.getUTCSeconds()
    );

    const hasPassed = givenDate.getTime() < currentUtcDate.getTime();
    return hasPassed;
  }

  // Method to check if one date-time is earlier than another
  isEarlierThan(end: Date, start: Date): boolean {
    const date1 = new Date(end);
    const date2 = new Date(start);

    return date1.getTime() < date2.getTime();
  }

  drawTaskableAOI(positionArray: any) {
    const modifiedArray = positionArray[0].map((sub: any) => [sub[1], sub[0]]);
    const polygon = L.polygon(modifiedArray, {
      color: 'yellow',
      fill: false,
      weight: 2,
    });
    this.taskableGroup.addLayer(polygon);

    /* ---------- LABEL LOGIC ---------- */
    const polygonPoints = positionArray[0]; // [lon, lat]

    const bottomLonLat = polygonPoints.reduce(
      (lowest, current) => (current[1] < lowest[1] ? current : lowest),
      polygonPoints[0]
    );

    const latitudes = polygonPoints.map((p) => p[1]);
    const maxLat = Math.max(...latitudes);
    const minLat = Math.min(...latitudes);
    const latRange = maxLat - minLat;
    const shiftDegrees = latRange * 0.05;
    const labelLat = bottomLonLat[1] - shiftDegrees;
    const labelLon = bottomLonLat[0];
    const labelLatLng = L.latLng(labelLat, labelLon);

    const textMarker = L.marker(labelLatLng, {
      icon: L.divIcon({
        className: 'polygon-text',
        html: 'This is your allowed tasking area',
        iconSize: [220, 30],
        iconAnchor: [110, 0], // center horizontally, top aligned
      }),
      interactive: false,
    });
    this.taskableGroup.addLayer(textMarker);
  }

  removeEntity() {
    const entities = this.viewer.entities.values;
    for (let i = entities.length - 1; i >= 0; i--) {
      if (entities[i]?.name !== 'allowedArea') {
        this.viewer.entities.remove(entities[i]);
      }
    }
  }
  removeEntityTle() {
    const entities = this.viewer.entities.values;
    for (let i = entities.length - 1; i >= 0; i--) {
      if (entities[i]?.name !== 'allowedArea') {
        this.viewer.entities.remove(entities[i]);
      }
    }
  }

  checkPointInsidePolygon(mousePoint) {
    this.shapeSelected = true;

    let isInside = this.currentUser.taskableAoi.some((aoi) =>
      this.utilsService.pointInPolygon(
        mousePoint,
        aoi.taskableAoi.coordinates[0]
      )
    );
    if (!isInside) {
      const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
      const dialogRef = this.popupService.openPopup(
        WarningPopup,
        message,
        '',
        '50%'
      );

      dialogRef.afterClosed().subscribe(() => {
        this.resetMap();
      });
    }
  }

  loadTaskCostDetails() {
    let tipAndCueObservation = true;
    let tipAndCueRule = true;
    let tipAndCueFeed = true;

    const validDate =
      (this.dateFlag && this.selectedOption != 0 && this.selectedOption != 3) ||
      this.fortnightlyRangeError ||
      this.changeDetectionToiRangeError ||
      this.range.value.end === null ||
      this.isPast ||
      this.isEndPast;
      
    if (this.taskStrategy === 'Tip-and-Cue') {
      if (this.subStrategy === 'Tip-and-Cue') {
        tipAndCueObservation =
          this.target.observation && this.tipAndCueBasedOn === 'Observation';
        tipAndCueRule = this.target.rule && this.tipAndCueBasedOn === 'Rules';
        tipAndCueFeed = this.target.feeds && this.tipAndCueBasedOn === 'Feeds';
      }
    }
    const toiRange =
      (this.timeError < 4 && (this.selectedOption === 0 || this.selectedOption === 3)) ||
      (this.timeError < 24 && (this.selectedOption != 0 && this.selectedOption != 3));
    const noUsecase =
      this.taskStrategy === 'Help Select Sensor(s)' && !this.target.useCase;
    const validRecurringDays = this.hasValidRecurringDaysSelection();
    const validNumberOfCollections = this.hasValidNumberOfCollectionsSelection();

    return (
      this.formGroup.valid &&
      this.target.geoJSON?.length > 10 &&
      !validDate &&
      (tipAndCueObservation ||
        tipAndCueRule ||
        tipAndCueFeed ||
        this.taskStrategy != 'Tip-and-Cue') &&
      !toiRange &&
      !noUsecase &&
      validRecurringDays &&
      validNumberOfCollections
    );
  }

  matchUUIDs(selectedSensors, taskResponse) {
    let sensorList = JSON.parse(selectedSensors);

    const minLength = Math.min(sensorList.length, taskResponse.length);
    for (let i = 0; i < minLength; i++) {
      sensorList[i].uuid = taskResponse[i].uuid;
    }

    return sensorList;
  }

  budgetEnable() {
    const validDate =
      (this.dateFlag && this.selectedOption != 0 && this.selectedOption != 3) ||
      this.fortnightlyRangeError ||
      this.changeDetectionToiRangeError ||
      this.range.value.end === null ||
      this.isPast;
    const toiRange =
      (this.timeError < 4 && (this.selectedOption === 0 || this.selectedOption === 3)) ||
      (this.timeError < 24 && this.selectedOption != 0 && this.selectedOption != 3);
    const frequencyUpdate =
      this.budget &&
      this.displayUpdateFrequency() &&
      !this.budgetForm.value.updateFrequency.value;
    const recurringDaysInvalid = !this.hasValidRecurringDaysSelection();
    const numberOfCollectionsInvalid = !this.hasValidNumberOfCollectionsSelection();
    const weatherFieldsInvalid =
      this.budget &&
      this.displayWeatherFields() &&
      (!this.budgetForm.value.weatherVariables?.length ||
        (this.target.area > 0 && !this.budgetForm.value.weatherResolution));
    return (
      validDate ||
      toiRange ||
      frequencyUpdate ||
      recurringDaysInvalid || numberOfCollectionsInvalid ||
      weatherFieldsInvalid
    );
  }

  displayWeatherFields() {
    return (
      this.budget &&
      this.budgetForm?.get('sensorType')?.value?.sensor === this.weatherType
    );
  }

  displayUpdateFrequency() {
    const sensor = this.budgetForm?.get('sensorType')?.value?.sensor;
    return (
      this.updateFrequencyOption &&
      (sensor === this.aisType || sensor === this.weatherType)
    );
  }

resetForm (sensorCategoryOverride?: string) {
    this.budgetForm.reset();
    const rfSignalsControl = this.budgetForm.get('rfSignals');
    rfSignalsControl?.setValue([], { emitEvent: false });

    if (sensorCategoryOverride) {
      const sensorCategoryControl = this.budgetForm.get('sensorCategory');
      sensorCategoryControl?.setValue(sensorCategoryOverride, { emitEvent: false });
    }

    this.range.reset();
    this.resetMap();
    this.target.geoJSON = null;
    this.selectedOption = 0;
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    this.date = new FormControl(new Date(year, month - 1, day + 1));
    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });
    this.clickFrequency = false;
    // const sensorCategoryControl = this.budgetForm.get('sensorCategory');
    // sensorCategoryControl?.setValue(STRINGCONSTANTS.IMAGING_SENSOR);
  }
  resetFormTle() {
    if (this.retask) {
      this.clearSatelliteFetchState();
      this.router.navigate(['/task']);
    } else {
      this.clearSatelliteFetchState();
      this.showtleClick = false;
      this.showtleDisabled = false;
      this.formGroup.reset();
      this.selectedOption = 2;
      this.range.reset();
      this.mapLoading = false;
      this.tleSensorForm.reset({
        scenario: 'T-Mins Ahead',
        minutesAhead: 90,
      });
      this.clearSelectedTleLocation();
      this.setTleParentLocationOptions([]);
      this.tleSensor = {
        resolution: [],
        sensor: [],
      };
      this.selectedSensorObfuscatedName = null;
      this.nearestTlePassTimestamp = null;
      this.tleAvailablePasses = [];
      this.tleSelectedPasses = [];
      this.tlePreviewOnlyMode = false;
      this.tleNearestFallbackPending = false;
      this.resetMap('tle');
      this.target.geoJSON = null;
      this.selectedOption = 0;
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      this.date = new FormControl(new Date(year, month - 1, day + 1));
      this.range = new FormGroup({
        start: new FormControl(new Date(year, month - 1, day)),
        end: new FormControl(new Date(year, month - 1, day + 3)),
      });
      this.target = { geoJSON: '', area: 0 };
      this.taskStrategy = '';
      this.clickFrequency = false;
    }
    this.disableEnableDrawControls(true, '');
  }

  submitBudgetandFeed(isFeed) {
    let newTaskParams = {};
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let recurringWeekDates: Array<Record<string, string[]>> = [];
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate = moment(this.target.closeWindow)
      .utcOffset(0, true)
      .add(86399, 'seconds')
      .format();
    let time_difference =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    this.outComeSubmit = true;
    let userTimezone = this.utilsService.getUserTimezone(this.currentUser);

    // if (this.target?.multiTarget?.length > 1) {
    //   const message = `Budgeting is only available for a point of interest (POI) or an area of interest (AOI).`;
    //   this.popupService.openPopup(WarningPopup, message, '', '50%');
    //   this.outComeSubmit = false;
    //   return;
    // }
    if (this.target?.multiTarget?.length > 1 && this.isFeedTask) {
        const message = `Multiple points of interest (POIs) tasking is not available for question based tasking.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.outComeSubmit = false;
        this.isFeedTaskSubmitted = false;
        return;
    }

    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Fortnightly') {
        no_of_repeats = Math.ceil(days_difference / 14);
        this.expectedAge = '14 days, 00:00:00';
      } else if (this.target.freqOption === 'Number of collections') {
        no_of_repeats = Number(this.target.noOfCollections) || 1;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      } else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.freqOption === 'Days') {
        recurringWeekDates = buildRecurringWeekDates(
          this.target?.openWindow,
          this.target?.closeWindow,
          Array.isArray(this.target.recurringDays) ? this.target.recurringDays : []
        );
        no_of_weeks = recurringWeekDates.length;
        no_of_repeats = recurringWeekDates.reduce((sum, week) => sum + Object.values(week)[0].length, 0);
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }

    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['area'] = this.target.area;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    if (
      this.target.geotargets &&
      this.target.geotargets.trim() !== '' &&
      this.target.geotargets.trim() !== '[]'
    ) {
      newTaskParams['target'] = this.target.geotargets;
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    if (
      isUmbraScanMode({ key: OPERATORS.UMBRA }, this.budgetForm.value.sensorType?.sensor) &&
      Array.isArray(this.target?.multiTarget) &&
      this.target.multiTarget.length === 2
    ) {
      newTaskParams['scanArea'] = Number(this.target.scanArea);
    }
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['frequency'] = this.target.selectedOption;
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      if (this.target.freqOption === 'Number of collections') {
        newTaskParams['noOfRepeats'] = this.target.noOfCollections;
      } else {
        newTaskParams['noOfRepeats'] = no_of_repeats;
      }
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else if (this.target.selectedOption === 3) {
      const specificDay = this.budgetForm.get('specificDay').value;
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['specificDay'] = specificDay.toLowerCase();
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }
    const recurringDays = this.getRecurringDaysPayload();
    if (recurringDays !== null) {
      newTaskParams['recurringDays'] = recurringDays;
      newTaskParams['recurringWeekDates'] = recurringWeekDates;
    }
    newTaskParams['mode'] = this.target.mode;
    newTaskParams['expected_age'] = this.expectedAge;
    newTaskParams['circleCordinates'] = this.target.circleCordinates;

    newTaskParams['openWindow'] = moment(this.target.openWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['closeWindow'] = moment(this.target.closeWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
      .tz(userTimezone)
      .format();
    newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
      .tz(userTimezone)
      .format();
    newTaskParams['resolution'] = this.budgetForm.value.resolution;
    newTaskParams['taskingTier'] = this.budgetForm.value.taskingTier;
    newTaskParams['cloudCover'] = this.budgetForm.value.cloudCover;
    newTaskParams['holdBack'] = this.budgetForm.value.holdBack;
    newTaskParams['sensorType'] = this.budgetForm.value.sensorType;
    newTaskParams['numOfWeeks'] = no_of_weeks;
    newTaskParams['noOfMonths'] = noOfMonths;
    newTaskParams['intent'] = this.budgetForm.value?.intent;
    newTaskParams['sensorCategory'] = this.budgetForm.value?.sensorCategory;
    newTaskParams['openWater'] = this.target?.openWater;
    newTaskParams['updateFrequency'] =
      this.budgetForm.value.updateFrequency.value;
    if (this.budgetForm.value.sensorType.sensor === this.aisType) {
      newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
      newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
      newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
      newTaskParams['noOfHistoricalData'] =
        this.outcomePopUpData?.noOfHistoricalData;
    }
    if (this.budgetForm.value.sensorType.sensor === this.weatherType) {
      newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
      newTaskParams['refreshRate'] =
        this.budgetForm.value.updateFrequency?.value ?? null;
      if (this.target.area > 0) {
        newTaskParams['resolution'] = this.budgetForm.value.weatherResolution;
      }
      newTaskParams['collectionMode'] = this.budgetForm.value.weatherVariables;
    }
    if (this.budgetForm.value.sensorType.sensor === this.rfType) {
      newTaskParams['rfSignals'] = this.budgetForm.value?.rfSignals;
      newTaskParams['rawIQData'] = this.budgetForm.value?.rawIQData;
    }
    if(isFeed) {
      newTaskParams['isAnswerFirst'] = true;
      const selectedQuestion: QuestionItem =
        this.formGroup.value.searchControl;
      newTaskParams['question'] = { id: selectedQuestion?.id };
      this.isFeedTaskSubmitted = true;
      newTaskParams['intent'] = this.target.intent;
      newTaskParams['taskPriority'] = this.formGroup.value.priority;
    }
    this.apiService.createBudgetOrFeed(newTaskParams).subscribe(
      (res: any) => {
        newTaskParams['budgetRange'] = res?.response?.minMaxCost;
        newTaskParams['sensors'] = res?.response?.sensors;
        newTaskParams['budget'] = res?.response?.budget;
        newTaskParams['budgetPoints'] = res?.response?.budgetPoints;
        if (res?.msg === 'Success') {
          const openBudgetPopup = () => {
            let targetInMap: any[] = [];

            if (this.target?.multiTarget?.length > 0) {
              targetInMap = this.target?.multiTarget;
            } else {
              targetInMap.push(this.target.geoJSON);
            }
            newTaskParams['targetInMap'] = targetInMap;
            const dialogRef = this.dialog.open(BudgetpopupComponent, {
            backdropClass: 'blurr',
            disableClose: true,
            width: '40%',
            data: {
              data: res.response,
              strategy: this.strategyOptions[0],
              intent: this.budgetForm.value?.intent,
              purpose: this.purposeOption[0],
              pointUser: this.currentUser.pointsEligible,
              currentUser: this.currentUser,
              isBroRF: this.isBroRF(),
              rfSignals:
                this.budgetForm.value.sensorType.sensor === this.rfType
                  ? this.budgetForm.value?.rfSignals
                  : null,
              targetInMap: targetInMap,
              frequency: this.target.selectedOption,
              repeatFrequency: this.target?.freqOption,
              differenceInDays: days_difference,
              numberOfRepeats: no_of_repeats,
              audioSelections: this.audioSelections,
              isFeedTask: this.isFeedTask
            },
          });

            dialogRef
            .afterClosed()
            .subscribe((result: { action: string; data?: any }) => {
              let pointCount = this.countPoints(this.target.geoJSON);
              this.selectedTasks;
              if (
                pointCount === 1 &&
                this.budgetForm.value.sensorType.sensor === this.rfType
              ) {
                const coords = this.utilsService.extractCoordinates(
                  this.pointArray[0]
                );
                const radius = RF_RADIUS * 1000;
                let coordinates = this.utilsService.getCirclePolygon(
                  coords,
                  radius
                );
                newTaskParams['target'] = JSON.stringify(geoParse(coordinates));
              }

              if (result.action === 'save') {
                const budgetName = result.data;
                newTaskParams['budgetName'] = result?.data?.budgetName;
                if (
                  this.budgetForm.value.sensorType.sensor === this.rfType &&
                  this.isBroRFSelected === false
                ) {
                  const sensorsArray = newTaskParams['sensors'];
                  const siteDataArray =
                    result?.data?.rfSiteAndCollection?.siteData;
                  if (Array.isArray(siteDataArray)) {
                    sensorsArray.forEach((sensor: any) => {
                      if (
                        sensor.sensor === 'RF' ||
                        sensor.sensortype === 'RF'
                      ) {
                        sensor.siteData = siteDataArray;
                      }
                    });
                  }
                  newTaskParams['sensors'] = sensorsArray;
                }
                this.apiService
                  .saveBudget(newTaskParams)
                  .subscribe((res: any) => {
                    if (res?.msg === 'Success') {
                      this.router.navigate(['/budget']);
                    } else {
                      const dialogRef = this.dialog.open(
                        CountrycheckComponent,
                        {
                          width: '40%',
                          backdropClass: 'blurred',
                          disableClose: true,
                          data: {
                            message: 'budgetFail',
                            url: '/budget',
                            response: this.extractBudgetErrorMessage(res?.response),
                          },
                        }
                      );
                    }
                  });
              } else if (result.action === 'save_task') {
                newTaskParams['project'] = result?.data?.project;
                newTaskParams['taskname'] = result?.data?.taskname;
                newTaskParams['taskStrategy'] =
                  result?.data?.taskStrategy?.value;
                newTaskParams['sensors'] =
                  this.budgetForm.value.sensorType.sensor === 'RF'
                    ? this.updateCostsByCount(result?.data?.sensors, pointCount)
                    : result?.data?.sensors;
                newTaskParams['intent'] = result?.data?.intent;
                newTaskParams['purpose'] = result?.data?.purpose;
                newTaskParams['projectid'] = null;
                newTaskParams['feasibilityTask'] = false;
                newTaskParams['observation'] = null;
                newTaskParams['tipAndCueBasedOn'] = '';
                newTaskParams['openWater'] = this.target?.openWater;
                if (
                  this.budgetForm.value.sensorType.sensor === this.rfType &&
                  this.isBroRFSelected === false
                ) {
                  const sensorsArray = JSON.parse(
                    newTaskParams['sensors'] || '[]'
                  );
                  const siteDataArray =
                    result?.data?.rfSiteAndCollection?.siteData;
                  if (Array.isArray(siteDataArray)) {
                    sensorsArray.forEach((sensor: any) => {
                      if (
                        sensor.sensor === 'RF' ||
                        sensor.sensortype === 'RF'
                      ) {
                        sensor.siteData = siteDataArray;
                      }
                    });
                  }
                  newTaskParams['sensors'] = JSON.stringify(sensorsArray);
                }

                delete newTaskParams['cloudCover'];
                const submitApi =
                  this.target?.multiTarget?.length > 0
                    ? this.apiService.multiPoiTaskSubmit(newTaskParams)
                    : this.apiService.newTaskSubmit(newTaskParams);
                submitApi.subscribe((res: any) => {
                  if (res?.msg === 'Success') {
                    let data = JSON.parse(res?.response);
                    let taskid;
                    let sensorList = this.matchUUIDs(
                      newTaskParams['sensors'],
                      data
                    );
                    newTaskParams['sensors'] = JSON.stringify(sensorList);
                    if (data && data.length > 0) {
                      taskid = res?.taskid;
                      newTaskParams['taskId'] = taskid;
                      this.apiService
                        .genCollection(
                          this.currentUser.id,
                          this.currentUser.email,
                          newTaskParams
                        )
                        .subscribe((res: any) => {
                          const taskid = res?.id;
                        });
                    }
                    const dialogRef = this.dialog.open(ConfirmDialog, {
                      backdropClass: 'blurr',
                      disableClose: true,
                      data: {
                        taskid: taskid,
                        taskname: newTaskParams['taskname'],
                        response: res,
                        type: 'normal',
                        from: 'budget',
                      },
                    });
                  } else {
                    this.outComeSubmit = false;
                    const dialogRef = this.dialog.open(CountrycheckComponent, {
                      width: '40%',
                      backdropClass: 'blurred',
                      disableClose: true,
                      data: {
                        message: 'budgetFail',
                        url: '/budget',
                        response: this.extractBudgetErrorMessage(res?.response),
                      },
                    });
                  }
                });
              } else if( result.action === 'feed_task'){
                this.submit(result.data);
              } else {
                this.outComeSubmit = false;
                this.isFeedTaskSubmitted = false;
              }
            });
          };

          if (
            this.handleSentinelAgreementGeojsonFlow(
              res?.response,
              newTaskParams,
              openBudgetPopup
            )
          ) {
            return;
          }

          openBudgetPopup();
        } else {
          this.outComeSubmit = false;
          this.isFeedTaskSubmitted = false;
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              message: 'budgetFail',
              url: '/budget',
              response: this.extractBudgetErrorMessage(res?.response),
            },
          });
        }
      },
      (error: any) => {
        this.outComeSubmit = false;
        this.isFeedTaskSubmitted = false;
        const dialogRef = this.dialog.open(CountrycheckComponent, {
          width: '40%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { message: 'budgetFail', url: '/budget', response: 'An error occurred. Please try again.' },
        });
      }
    );
  }

  private handleSentinelAgreementGeojsonFlow(
    response: any,
    newTaskParams: any,
    continueFlow: () => void
  ): boolean {
    if (!this.isFeedTask || !this.isSentinelAgreementFeed(response, newTaskParams)) {
      return false;
    }

    const sensorCount = this.getFeedSensorCount(response?.sensors);
    if (sensorCount === 1) {
      const agreementDialogRef = this.dialog.open(
        FeedSentinelAgreementDialogComponent,
        {
          backdropClass: 'blurr',
          disableClose: true,
          width: '40%',
          data: {
            message: this.getSentinelAgreementMessage(response?.sensors),
          },
        }
      );

      agreementDialogRef.afterClosed().subscribe((result) => {
        if (result === 'agree') {
          this.openFeedGeojsonUploadDialog(continueFlow);
        } else {
          this.cancelSentinelAgreementFeedSelection();
        }
      });
      return true;
    }

    this.openFeedGeojsonUploadDialog(continueFlow);
    return true;
  }

  private getSentinelAgreementMessage(sensors: any): string {
    if (!this.currentUser?.obfuscated) {
      return 'The selected feed requires both Sentinel-1 (SAR) and Sentinel-2 (MSI) data. Do you want to continue?';
    }

    const sensorList = this.parseFeedSensors(sensors);
    const sarSensor = sensorList.find((sensor: any) => this.normalizeSensorValue(sensor?.sensor) === 'sar');
    const msiSensor = sensorList.find((sensor: any) => this.normalizeSensorValue(sensor?.sensor) === 'msi');
    const sarLabel = sarSensor?.obfuscateName ? `${sarSensor.obfuscateName} (SAR)` : 'SAR data';
    const msiLabel = msiSensor?.obfuscateName ? `${msiSensor.obfuscateName} (MSI)` : 'MSI data';

    return `The selected feed requires both ${sarLabel} and ${msiLabel}. Do you want to continue?`;
  }

  private parseFeedSensors(sensors: any): any[] {
    if (typeof sensors === 'string') {
      try {
        return this.parseFeedSensors(JSON.parse(sensors));
      } catch {
        return [];
      }
    }

    return Array.isArray(sensors) ? sensors : [];
  }

  private normalizeSensorValue(value: any): string {
    return String(value || '').trim().toLowerCase();
  }

  private isSentinelAgreementFeed(response: any, newTaskParams: any): boolean {
    const matchingFeedId = SENTINEL_AGREEMENT_FEED_IDS.find(
      (feedId) =>
        this.containsFeedId(response, feedId) ||
        this.containsFeedId(newTaskParams?.question, feedId) ||
        this.containsFeedId(this.formGroup.value.searchControl, feedId)
    );

    if (!matchingFeedId) {
      return false;
    }

    const configuredFeed = (feedsConfig as Record<string, any>)[matchingFeedId];

    return (
      configuredFeed?.requiresSentinelMsiSarAgreement === true &&
      configuredFeed?.type === 'Mining changes monitoring'
    );
  }

  private containsFeedId(value: any, feedId: string, visited = new WeakSet<object>()): boolean {
    if (value == null) {
      return false;
    }

    if (typeof value === 'string') {
      return value === feedId;
    }

    if (typeof value !== 'object') {
      return false;
    }

    if (visited.has(value)) {
      return false;
    }
    visited.add(value);

    if (
      value._id === feedId ||
      value.id === feedId ||
      value.feedId === feedId ||
      value.feed_id === feedId
    ) {
      return true;
    }

    return Object.values(value).some((item) =>
      this.containsFeedId(item, feedId, visited)
    );
  }

  private getFeedSensorCount(sensors: any): number {
    if (typeof sensors === 'string') {
      try {
        return this.getFeedSensorCount(JSON.parse(sensors));
      } catch {
        return 0;
      }
    }

    if (Array.isArray(sensors)) {
      return sensors.length;
    }

    return 0;
  }

  private openFeedGeojsonUploadDialog(continueFlow: () => void): void {
    const uploadDialogRef = this.dialog.open(FeedGeojsonUploadDialogComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      width: '42%',
      data: { target: this.target },
    });

    uploadDialogRef.afterClosed().subscribe((result: FeedGeojsonUploadResult | null) => {
      if (!result) {
        this.cancelSentinelAgreementFeedSelection();
        return;
      }

      if (this.applyFeedGeojsonUpload(result)) {
        continueFlow();
      } else {
        this.isFeedTaskSubmitted = false;
      }
    });
  }

  private applyFeedGeojsonUpload(result: FeedGeojsonUploadResult): boolean {
    try {
      if (this.geoJsonLayer) {
        this.map.removeLayer(this.geoJsonLayer);
        this.geoJsonLayer = null;
        this.eventLayers = [];
      }

      const extension = result.fileName.split('.').pop()?.toLowerCase();
      this.fileName = extension;
      const geoJson = JSON.parse(result.content);
      this.geoJsonLayer = L.geoJSON(geoJson);
      this.position = this.geoJsonLayer;
      this.layerData = this.geoJsonLayer;

      if (!this.validateChangeDetectionUploadedAoi(this.geoJsonLayer)) {
        return false;
      }

      const layers = this.geoJsonLayer.getLayers();
      const geometryType = layers[0]?.feature?.geometry?.type;

      if (layers.length > 1 && !this.isChangeDetectionStrategy()) {
        this.openDialog();
        this.geoJsonLayer = null;
        this.disableEnableDrawControls(true, '');
        return false;
      }

      if (this.isChangeDetectionStrategy()) {
        if (!this.applyChangeDetectionUploadedAoiTarget(this.geoJsonLayer)) {
          return false;
        }
      } else if (geometryType === 'Point') {
        this.createPoints(layers);
      } else if (geometryType === 'MultiPolygon') {
        this.createCZML('MultiPolygon', layers[0]);
      } else if (geometryType === 'Polygon') {
        this.createCZML('polygon', layers[0]);
      } else {
        this.popupService.openPopup(
          WarningPopup,
          'Please upload a GeoJSON file with Point, Polygon, or MultiPolygon geometry.',
          '',
          '50%'
        );
        this.geoJsonLayer = null;
        return false;
      }

      this.map.fitBounds(this.geoJsonLayer.getBounds());
      this.eventLayers = [this.geoJsonLayer.getBounds()];
      this.geoJsonLayer.addTo(this.map);
      this.disableEnableDrawControls(true, 'fileupload');
      return true;
    } catch {
      this.popupService.openPopup(
        WarningPopup,
        'Please upload a valid GeoJSON file.',
        '',
        '50%'
      );
      return false;
    }
  }

  private cancelSentinelAgreementFeedSelection(): void {
    this.outComeSubmit = false;
    this.isFeedTaskSubmitted = false;
    this.formGroup.get('searchControl')?.reset();
  }

  countPoints(wkt: string): number {
    if (!wkt) return 0;
    return (wkt.match(/POINT\s*\(/g) || []).length;
  }

  updateCostsByCount(jsonString: string, count: number): string {
    if (!jsonString || count <= 0) {
      return jsonString;
    }

    const data = JSON.parse(jsonString);

    const updatedData = data.map((item: any) => {
      const hasSOI = Array.isArray(item?.signalOfInterest);

      return {
        ...item,
        cost: item.cost / count,
        unitCost: item.unitCost / count,
        multiplierCost: item.multiplierCost / count,
        minimumArea:
          typeof item.minimumArea === 'string'
            ? item.minimumArea.replace(/,/g, '')
            : item.minimumArea,
        isPoint: count >= 1,
        noOfCollections: 1,
        targetPoints: count === 1 ? item.targetPoints : null,
        ...(hasSOI && {
          signalOfInterest: item.signalOfInterest.map((soi: any) => {
            const audioMatch = this.audioSelections?.find(
              (a: any) => a.value === soi.value
            );

            return {
              ...soi,
              collectionDuration: audioMatch?.audioChecked
                ? 60
                : soi.collection_duration?.[0]?.value ?? null,
              isAudio: audioMatch?.audioChecked ?? false,
            };
          }),
        }),
      };
    });

    return JSON.stringify(updatedData);
  }

  sortArray(array: string[]): string[] {
    return array.sort((a, b) => {
      return this.getPriority(a) - this.getPriority(b);
    });
  }
  sortResolution(
    a: { key: string; name: string },
    b: { key: string; name: string }
  ): number {
    const isNumeric = (value: string): boolean =>
      !isNaN(parseFloat(value.charAt(0)));

    const parseResolution = (res: string): { value: number; text: string } => {
      const match = res.match(/(\d+(\.\d+)?)(.*)/);
      const value = match ? parseFloat(match[1]) : NaN;
      const text = match ? match[3].trim() : res;
      return { value, text };
    };

    const resA = parseResolution(a.name);
    const resB = parseResolution(b.name);

    if (isNumeric(a.name) && isNumeric(b.name)) {
      if (resA.value !== resB.value) {
        return resA.value - resB.value;
      }
      return resA.text.localeCompare(resB.text);
    } else if (isNumeric(a.name)) {
      return -1;
    } else if (isNumeric(b.name)) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  }

  getPriority(value: string): number {
    if (value.includes('days')) {
      return 1;
    } else if (value.includes('months')) {
      return 2;
    } else {
      return 3;
    }
  }
  setUTCTodayDate() {
    const now = new Date();
    const utcYear = now.getUTCFullYear();
    const utcMonth = now.getUTCMonth();
    const utcDate = now.getUTCDate();
    this.todayDate = new Date(Date.UTC(utcYear, utcMonth, utcDate));
  }

  convertToPoints(cost: number): number {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor = parseFloat(parts[1]) / parseFloat(parts[0]);
    return Math.round(cost * conversionFactor);
  }
  convertToCost(point: number): number {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor = parseFloat(parts[1]) / parseFloat(parts[0]);
    return Math.round(point / conversionFactor);
  }
  capitalizeFirstLetter(value: string): string {
    if (!value) {
      return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  updateOptions() {
    this.cloudCoverOptions = this.budgetInputs.cloudCoverKeys || [];
    this.resolutionOptions = this.budgetInputs.resolutionArr || [];
    this.taskingTierOptions = this.budgetInputs.tierArr || [];
    this.holdBackOptions = this.budgetInputs.holdbackArr || [];
    this.rfSignalOptions = this.budgetInputs.rfSignals || [];

    this.updateFormControlValidators('cloudCover', this.cloudCoverOptions);

    this.updateFormControlValidators('resolution', this.resolutionOptions);
    this.updateFormControlValidators('taskingTier', this.taskingTierOptions);
    this.updateFormControlValidators('rfSignals', this.rfSignalOptions);
  }
  updateFormControlValidators(controlName: string, options: any[]) {
    const control = this.budgetForm.get(controlName);
    if (!control) return;

    if (options.length > 0) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
    }

    control.updateValueAndValidity();
  }

  resetDateDefault() {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });
  }

  onStartTimeChange(event: any, date: any) {
    let utcEndDate;
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(
      localTime,
      'YYYY-MM-DD HH:mm',
      this.userTimezone
    ); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcStartDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('HH:mm');
    if (this.selectedFrequencyID !== 0 && this.selectedFrequencyID !== 3) {
      utcEndDate = moment(utcStartDate).add(30, 'days').toDate();
    } else {
      utcEndDate = utcStartDate;
    }
    return { utcTime, utcStartDate, utcEndDate };
  }

  onEndTimeChange(event: any, date: any) {
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(
      localTime,
      'YYYY-MM-DD HH:mm',
      this.userTimezone
    ); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcEndDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('HH:mm');
    return { utcTime, utcEndDate };
  }
  updateCurrentLocalTime() {
    this.currentLocalTime = this.utilsService.getCurrentLocalTime(
      this.currentUser
    );
  }

  resetOutcome() {
    this.outComeForm.patchValue({
      sensorType: '',
      resolution: '',
      cloudCover: '',
      latency: '',
      budget: '',
      updateFrequency: '',
      intent: '',
    });
    this.outComesensor = [];
    this.outComeSubmit = false;
    this.showResolution =
      this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
  }
  subStrategyChange(event: any) {
    this.subStrategy = event.value;
    this.formGroup.get('subStrategyRadio').setValue(event.value);
    this.target.taskSubStrategy = event.value;
    let openWater = this.target.openWater ? this.target.openWater : false;
    if (event.value === 'Tip-and-Cue') this.getObservationList(openWater);
  }
  tipAndCueTypeSelectChange(data: any) {
    if (this.tipAndCueTargetRequired) {
      this.onBasedOnInteraction();
      return;
    }
    this.tipAndCueBasedOn = data.value;

    this.target.tipAndCueBasedOn = data.value;

    this.observation = null;

    this.target.observation = null;

    this.rule = null;

    this.target.rule = null;

    this.updateTarget(this.target, '0');
  }
  tippingSensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      tippingSensorResolution: '',
      tippingCloudCover: '',
    });

    this.tippingSensorResolution = [];
    this.tippingSensorCloudCover = [];

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';

    let intent = this.target?.intent?.key
      ? this.target?.intent.key
      : this.target?.intent;
    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent,
      type: 'tipping',
    };
    this.apiService
      .getTippingCueingSensorDetails(sensorObj)
      .subscribe((res: any) => {
        this.tippingSensorCloudCover.length = 0;
        this.outComesensor = res;
        this.tippingSensorResolution = res.tippingSensorResolution;
        const cloudC: any = [];
        if (res.tippingSensorCloudCover) {
          for (var key in res.tippingSensorCloudCover) {
            cloudC.push({ key, value: res.tippingSensorCloudCover[key] });
          }
          this.tippingSensorCloudCover = cloudC;

          if (this.tippingSensorCloudCover?.length === 0) {
            this.outComeForm.get('tippingCloudCover').disable();
          } else {
            this.outComeForm.get('tippingCloudCover').enable();
          }

          if (!this.tippingSensorResolution) {
            this.outComeForm.get('tippingSensorResolution').disable();
          } else {
            this.outComeForm.get('tippingSensorResolution').enable();
          }
        }
      });
  }
  cueingSensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      cueingSensorResolution: '',
      cueingCloudCover: '',
    });

    this.cueingSensorResolution = [];
    this.cueingSensorCloudCover = [];

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';

    let intent = this.target?.intent?.key
      ? this.target?.intent.key
      : this.target?.intent;
    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent,
      type: 'cueing',
    };
    this.apiService
      .getTippingCueingSensorDetails(sensorObj)
      .subscribe((res: any) => {
        this.cueingSensorCloudCover.length = 0;
        this.outComesensor = res;
        this.cueingSensorResolution = res.cueingSensorResolution;
        const cloudC: any = [];
        if (res.cueingSensorCloudCover) {
          for (var key in res.cueingSensorCloudCover) {
            cloudC.push({ key, value: res.cueingSensorCloudCover[key] });
          }
          this.cueingSensorCloudCover = cloudC;

          if (this.cueingSensorCloudCover?.length === 0) {
            this.outComeForm.get('cueingCloudCover').disable();
          } else {
            this.outComeForm.get('cueingCloudCover').enable();
          }

          if (!this.cueingSensorResolution) {
            this.outComeForm.get('cueingSensorResolution').disable();
          } else {
            this.outComeForm.get('cueingSensorResolution').enable();
          }
        }
      });
  }

  resetOutcomeDefined() {
    this.outComeForm.patchValue({
      resolution: '',
      budget: '',
      intent: '',
    });
    this.outComeSubmit = false;
  }

  updateFrequencyChange(value: any): void {
    const startTime = moment(this.target.openWindow).utcOffset(0, true);
    const endTime = moment(this.target.closeWindow).utcOffset(0, true);
    const clydePeriodDuration = endTime.diff(startTime, 'days', true);
    if (value.operatorKey === 'ClydeSpace') {
      if (clydePeriodDuration < 90) {
        const message = `We are unable to accept this task as this sensor requires TOI should be minimum 3 months. Please change your time of interest or choose an alternative provider.`;
        this.showWarningPopup(message);
        this.outComeForm.patchValue({ updateFrequency: '' });
        this.budgetForm.patchValue({ updateFrequency: '' });
        return;
      }
    }
    this.outcomePopUpData = {};
    // Voyage Radar is deliberately absent. It is excluded from outcome tasking
    // (checkAvailableOperators no longer matches it), and on the budget side its
    // credit purchase is collected later by the taskcost operator popup — not
    // here — so there is nothing for this dialog to gather in either flow.
    if (
      ['ClydeSpace', 'Spire', OPERATORS.WEATHEREX].includes(value.operatorKey)
    ) {
      this.openOperatorDialog(value.operatorKey);
    }
  }

  private showWarningPopup(message: string): void {
    this.popupService.openPopup(WarningPopup, message, '', '50%');
  }

  private extractBudgetErrorMessage(err: any): string {
    if (!err) return 'An error occurred. Please try again.';
    if (typeof err === 'string') return err;
    return err?.message || 'An error occurred. Please try again.';
  }

  private openOperatorDialog(operatorKey: string): void {
    const dialog = this.dialog.open(OperatorPopupComponent, {
      minWidth: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        selectedRow: {},
        operatorKey,
        daysCount: '',
        subscriptionAmount: null,
        hideTooltip: true,
      },
    });
    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        const historicalCost = result.isHistorical ? 25 : 0;
        if (operatorKey === 'Spire') {
          this.outcomePopUpData.noOfRefreshes = result?.refreshCount;
          this.outcomePopUpData.isHistorical = result?.isHistorical;
          this.outcomePopUpData.historicalCost = historicalCost;
          this.outcomePopUpData.noOfHistoricalData = result?.fetchCount;
        } else if (operatorKey === 'ClydeSpace') {
          this.outcomePopUpData.isHistorical = result?.isHistorical;
          this.outcomePopUpData.noOfHistoricalData = result?.daysCount;
        } else if (operatorKey === OPERATORS.WEATHEREX) {
          this.outcomePopUpData.noOfRefreshes = result?.refreshCount;
        }
      } else {
        this.outComeForm.patchValue({ updateFrequency: '' });
        this.budgetForm.patchValue({ updateFrequency: '' });
      }
    });
  }

  private handleSearchDisable(): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    /** Search disable when click on layer */
    const layerEl: any = document.querySelector(
      '.leaflet-control-layers-toggle'
    ) as HTMLElement;
    layerEl.addEventListener('click', (event: any) => {
      this.resetSearchInput(false);
    });

    /** Search disable when click on draw icons */
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.resetSearchInput(false);
      });
    });
  }


  isAnyFieldNull(): boolean {
    const requiredFields = [
      'tipAndCueBasedOn',
      'latency',
      'budget',
      'tippingSensorType',
      'cueingSensorType',
      'tippingSensorResolution',
      'cueingSensorResolution',
      'tippingCloudCover',
      'cueingCloudCover',
    ];

    for (const key of requiredFields) {
      const controlValue = this.outComeForm.get(key).value;
      if (key === 'cueingCloudCover') {
        if (
          this.cueingSensorCloudCover?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (key === 'tippingCloudCover') {
        if (
          this.tippingSensorCloudCover?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (key === 'cueingSensorResolution') {
        if (
          this.cueingSensorResolution?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (key === 'tippingSensorResolution') {
        if (
          this.tippingSensorResolution?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (
        controlValue === null ||
        controlValue === undefined ||
        controlValue === ''
      ) {
        return true;
      }
    }
    return false;
  }

  closePanels() {
    if (this.sensorPanel) this.sensorPanel.close();
    if (this.cloudPanel) this.cloudPanel.close();
  }

  onSensorPanelClosed(): void {
    this.panelOpenState = false;
    const blockingKey = this.getFirstBlockingFieldKey();
    if (blockingKey) {
      this.formGroup.markAllAsTouched();
      this.formGroup.updateValueAndValidity();
      this.scrollToFirstInvalidField(blockingKey);
    }
  }

  onCloudPanelClosed(): void {
    this.panelOpenState = false;
    const blockingKey = this.getFirstBlockingFieldKey();
    if (blockingKey) {
      this.formGroup.markAllAsTouched();
      this.formGroup.updateValueAndValidity();
      this.scrollToFirstInvalidField(blockingKey);
    }
  }

  onSensorPanelOpen() {
    this.openPanel();
    if (this.getFirstBlockingFieldKey()) {
      setTimeout(() => this.sensorPanel?.close());
      return;
    }
    if (
      this.sensorList &&
      this.loadTaskCostDetails() &&
      this.taskStrategy != 'Tip-and-Cue'
    ) {
      this.sensorList.loadTaskingSensors(this.target);
    }
    if (
      this.sensorList &&
      this.loadTaskCostDetails() &&
      this.taskStrategy === 'Tip-and-Cue' &&
      this.subStrategy == 'Tip-and-Cue'
    ) {
      this.sensorList.loadTipAndCueingSensors(this.target);
    }
  }

  onOutcomePanelOpen(): void {
    this.openPanel();
    if (this.getFirstBlockingFieldKey()) {
      setTimeout(() => this.outcomePanel?.close());
      return;
    }
  }

  onOutcomePanelClosed(): void {
    this.panelOpenState = false;
    const blockingKey = this.getFirstBlockingFieldKey();
    if (blockingKey) {
      this.formGroup.markAllAsTouched();
      this.formGroup.updateValueAndValidity();
      this.scrollToFirstInvalidField(blockingKey);
    }
  }

  getObservationList(openWater?: any) {
    this.rule = null;
    this.target.rule = null;
    this.observation = null;
    this.target.observation = null;
    this.feeds = null;
    this.target.feeds = null;
    this.apiService.getObservations(openWater).subscribe((res: any) => {
      this.observationOptions = res?.observations;
      this.rulesOptions = res?.ruleBased;
      this.feedList = this.getTipAndCueFeedOptions(res?.feeds);
    });
  }

  openPanel() {
    this.formGroup.get('target')?.enable(); // Enable control
    this.syncTargetControlWithState();
    this.formGroup.markAllAsTouched(); // This will make all controls show validation errors if any
    this.formGroup.updateValueAndValidity();

    const blockingKey = this.getFirstBlockingFieldKey();
    if (blockingKey) {
      this.scrollToFirstInvalidField(blockingKey);
    }
  }

  /**
   * Returns the key of the first field that is blocking form submission,
   * covering both Angular-validated controls (formGroup.invalid) and
   * non-validator mandatory fields such as Use Case / Application.
   */
  private getFirstBlockingFieldKey(): string | null {
    this.syncTargetControlWithState();

    const controlSelectorMap: Record<string, string> = {
      project:          'input[formcontrolname="project"]',
      taskname:         'input[formcontrolname="taskname"]',
      strategyRadio:    'mat-select[formcontrolname="strategyRadio"], input[formcontrolname="strategyRadio"]',
      subStrategyRadio: 'mat-select[formcontrolname="subStrategyRadio"]',
      intent:           'mat-select[formcontrolname="intent"], input[formcontrolname="intent"]',
      purpose:          'mat-select[formcontrolname="purpose"], input[formcontrolname="purpose"]',
      frequency:        'mat-select[formcontrolname="frequency"], input[formcontrolname="frequency"]',
      target:           '#select-target-field',
      startTime:        'input[formcontrolname="startTime"]',
      endTime:          'input[formcontrolname="endTime"]',
      specificDay:      'mat-select[formcontrolname="specificDay"], input[formcontrolname="specificDay"]',
      searchControl:    'input[formcontrolname="searchControl"]',
      useCase:          'mat-select[formcontrolname="useCase"]',
    };

    // Standard Angular-validated controls
    const firstInvalidKey = Object.keys(controlSelectorMap).find((key) => {
      if (key === 'useCase') return false; // handled separately below
      const ctrl = this.formGroup.get(key);
      return ctrl && ctrl.invalid && ctrl.enabled;
    });

    if (firstInvalidKey) {
      return firstInvalidKey;
    }

    // useCase has no Angular validator but is required by loadTaskCostDetails()
    if (this.taskStrategy === 'Help Select Sensor(s)' && !this.target.useCase) {
      return 'useCase';
    }

    // Time-range errors that block loadTaskCostDetails() but are not Angular validator errors.
    // Mirror the toiRange / validDate checks from loadTaskCostDetails() exactly.
    const isToiRangeError =
      (this.timeError < 4 && (this.selectedOption === 0 || this.selectedOption === 3)) ||
      (this.timeError < 24 && this.selectedOption != 0 && this.selectedOption != 3);
    if (isToiRangeError || this.isEndPast) {
      return 'endTime';
    }

    return null;
  }

  /**
   * Scrolls the project-setup pane to the field identified by blockingKey
   * and briefly applies a pulsing red-border highlight so the user immediately
   * sees which field needs to be filled.
   */
  private scrollToFirstInvalidField(blockingKey: string): void {
    const controlSelectorMap: Record<string, string> = {
      project:          'input[formcontrolname="project"]',
      taskname:         'input[formcontrolname="taskname"]',
      strategyRadio:    'mat-select[formcontrolname="strategyRadio"], input[formcontrolname="strategyRadio"]',
      subStrategyRadio: 'mat-select[formcontrolname="subStrategyRadio"]',
      intent:           'mat-select[formcontrolname="intent"], input[formcontrolname="intent"]',
      purpose:          'mat-select[formcontrolname="purpose"], input[formcontrolname="purpose"]',
      frequency:        'mat-select[formcontrolname="frequency"], input[formcontrolname="frequency"]',
      target:           '#select-target-field',
      startTime:        'input[formcontrolname="startTime"]',
      endTime:          'input[formcontrolname="endTime"]',
      specificDay:      'mat-select[formcontrolname="specificDay"], input[formcontrolname="specificDay"]',
      searchControl:    'input[formcontrolname="searchControl"]',
      useCase:          'mat-select[formcontrolname="useCase"]',
    };

    const selector = controlSelectorMap[blockingKey];
    if (!selector) return;

    const openedTaskingPanel = this.ensureTaskingPanelOpen();
    const scrollDelayMs = openedTaskingPanel ? 220 : 50;

    setTimeout(() => {
      try {
        const scrollPane = document.querySelector('.left.scrollbar') as HTMLElement | null;
        const selectors = selector.split(',').map((s) => s.trim());
        let fieldEl: HTMLElement | null = null;
        for (const sel of selectors) {
          fieldEl = (scrollPane || document).querySelector(sel) as HTMLElement | null;
          if (fieldEl) break;
        }

        if (!fieldEl) return;

        fieldEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const applyHighlight = (el: HTMLElement, cssClass: string) => {
          this.renderer.addClass(el, cssClass);
          setTimeout(() => this.renderer.removeClass(el, cssClass), 1600);
        };

        const matFormField = fieldEl.closest('mat-form-field') as HTMLElement | null;
        if (matFormField) {
          applyHighlight(matFormField, 'mat-form-field-highlight');
        } else {
          applyHighlight(fieldEl, 'field-highlight');
        }
      } catch (_) {
        // Never let scroll/highlight errors affect form functionality.
      }
    }, scrollDelayMs);
  }

  private ensureTaskingPanelOpen(): boolean {
    if (!this.taskingPanel || this.taskingPanel.expanded) {
      return false;
    }

    this.taskingPanel.open();
    return true;
  }

  private syncTargetControlWithState(): void {
    const targetControl = this.formGroup?.get('target');
    if (!targetControl) {
      return;
    }

    const normalizedTargetValue = this.target?.geoJSON || null;
    if (targetControl.value !== normalizedTargetValue) {
      targetControl.setValue(normalizedTargetValue, { emitEvent: false });
    }

    targetControl.updateValueAndValidity({ emitEvent: false });
  }

  showTipAndCueTargetHint = false;

  onBasedOnInteraction(): void {
    if (this.tipAndCueTargetRequired) {
      this.clearTipAndCueSelectionWithoutTarget();
    }
    this.showTipAndCueTargetHint = this.tipAndCueTargetRequired;
  }

  private clearTipAndCueSelectionWithoutTarget(): void {
    this.showTipAndCueTargetHint = false;
    if (!this.tipAndCueTargetRequired) return;

    this.tipAndCueBasedOn = '';
    this.observation = null;
    this.observationData = null;
    this.rule = null;
    this.feeds = null;

    for (const key of ['tipAndCueBasedOn', 'observation', 'observationData', 'rule', 'feeds']) {
      this.target[key] = null;
      this.formGroup?.get(key)?.reset(null, { emitEvent: false });
      this.outComeForm?.get(key)?.reset(null, { emitEvent: false });
    }
  }

  get tipAndCueTargetRequired(): boolean {
    return this.taskStrategy === 'Tip-and-Cue' && !this.hasSelectedTargetValue();
  }

  private hasSelectedTargetValue(): boolean {
    const geoJSON = this.target?.geoJSON;
    if (Array.isArray(geoJSON)) {
      return geoJSON.length > 0;
    }
    if (typeof geoJSON === 'string') {
      return geoJSON.trim().length > 0;
    }
    return !!geoJSON;
  }

  openCloudCover() {
    this.openPanel();
    if (this.getFirstBlockingFieldKey()) {
      setTimeout(() => this.cloudPanel?.close());
      return;
    }
    if (this.budget) {
      this.budgetForm.markAllAsTouched();
    }
    this.cloudclicked = false;
    if (this.loadTaskCostDetails() || !this.budgetForm?.invalid) {
      this.getCloudData(true, 0);
    }
    this.panelOpenState = true;
  }

  confirmLocation() {
    setTimeout(() => {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'location' },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'no') {
          this.resetMap();
        }
      });
    }, 2000); //2second
  }

  loadUserDetails(userId): void {
    if (userId) {
      this.userService.personalInfo(userId).subscribe({
        next: (res: any) => {
          this.currentUser = res;
          this.currentLocalTime = this.utilsService.getCurrentLocalTime(
            this.currentUser
          );
          this.userTimezone = this.utilsService.getUserTimezone(
            this.currentUser
          );

          // Plan-4 users: AIS update-frequency options must be filtered by allocations.
          // Clear the list until allocations are fetched to avoid briefly showing unallocated options.
          if (this.currentUser?.user_plan === 4) {
            this.aisAllocationFetched = false;
            this.allocatedAisOperators = new Set();
            this.applyUpdateFrequencyOptions([]);
          }
          
          // Check all sensor eligibility in a single call
          this.checkSensorEligibility();
        },
        error: (error) => {
            console.error('Error loading user details:', error);
        },
      });
    }
  }
  outcomeSensorTypes(userId: string) {
    this.apiService.getOutcomeSensorTypes(userId).subscribe((res: any) => {
      if (res) {
        this.SensorsTypes = this.apiService.SENSORSTYPE.filter((sensor) =>
          res?.sensorTypes.includes(sensor.value)
        );
      }
      // Filter by feasibility
      this.filteredSensorTypes = this.SensorsTypes.filter(item => item.feasibility === true);
      
      // Additionally filter by allocated sensor types (for Plan 4 users)
      // If allocatedSensorTypes is not empty, only show sensor types that are allocated
      if (this.allocatedSensorTypes.size > 0) {
        this.filteredSensorTypes = this.filteredSensorTypes.filter(item => 
          this.allocatedSensorTypes.has(item.value)
        );
      }
    });
  }
  tleSensorTypes(userId: string, intentId?: string) {
    this.apiService
      .getOutcomeSensorTypes(userId, intentId)
      .subscribe((res: any) => {
        if (res?.sensorTypes?.length > 0) {
          this.SensorsTypes = this.apiService.SENSORSTYPE.filter((sensor) =>
            res?.sensorTypes.includes(sensor.value)
          );
           this.filteredSensorTypes = this.SensorsTypes.filter(item => item.feasibility === true);
        
          // Additionally filter by allocated sensor types (for Plan 4 users)
          // If allocatedSensorTypes is not empty, only show sensor types that are allocated
          if (this.allocatedSensorTypes.size > 0) {
            this.filteredSensorTypes = this.filteredSensorTypes.filter(item => 
              this.allocatedSensorTypes.has(item.value)
            );
          }
        } else {
          const message =
            'No sensors are meeting the selected intent. Please change the intent and try again.';
          const dialogRef = this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          dialogRef.afterClosed().subscribe((result) => {
            this.formGroup.get('intent')?.setValue(null);
            this.formGroup.get('intent')?.markAsPristine();
            this.formGroup.get('intent')?.markAsUntouched();
            this.target.intent = null;
          });
          this.filteredSensorTypes = [];
        }
      });
  }
  get tleMinDate(): Date {
    const now = new Date(Date.now());
    // The calendar displays UTC dates using local Date fields.
    return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1);
  }

  get tleLeadTimeError(): boolean {
    if (
      this.taskStrategy !== 'TLE Based Tasking' ||
      this.tleSensorForm?.get('scenario')?.value !== 'Predicted (TOI)' ||
      !this.tleSensorForm?.get('startTime')?.value ||
      !this.range?.value?.start ||
      !this.target?.openWindow
    ) {
      return false;
    }

    // openWindow stores the selected UTC clock time in local Date fields,
    // matching the normalization used when building the task payload.
    const startUtc = moment(this.target.openWindow).utcOffset(0, true);
    return startUtc.isValid() && startUtc.valueOf() - Date.now() < 24 * 60 * 60 * 1000;
  }

  shouldEnableCancelButton(data: any, formData: FormGroup): boolean {
    const isValid = (value: any): boolean => {
      return value !== null && value !== undefined && value !== '';
    };

    const scenario = formData?.get('scenario')?.value;
    const minutesAhead = Number(formData?.get('minutesAhead')?.value);
    const startTimeValid = isValid(this.formGroup?.get('startTime')?.value);
    const endTimeValid = isValid(this.formGroup?.get('endTime')?.value);

    const scenarioValid =
      scenario === 'T-Mins Ahead'
        ? Number.isFinite(minutesAhead) &&
          minutesAhead >= 90 &&
          minutesAhead <= this.tleMaxMinutesAhead
        : scenario === 'Predicted (TOI)'
        ? !!this.range?.value?.start &&
          !!this.range?.value?.end &&
          startTimeValid &&
          endTimeValid &&
          !this.isPast &&
          !this.tleLeadTimeError &&
          !this.tleRangeError &&
          !this.tleStartRangeError
          && !this.tleToiError
        : false;

    const requiredDataFields = [
      data.geoJSON,
      data.project,
      data.taskname,
      data.taskStrategy,
      data.purposeOption,
      data.intent,
      data.openWindow,
      data.closeWindow,
    ];

    const dataFieldsValid = requiredDataFields.every((field) => isValid(field));
    const additionalConditions =
      this.mapLoading === false &&
      this.showtleClick === true &&
      this.hasSelectedTlePasses &&
      this.hasValidSelectedTlePassResolutions();

    return (
      dataFieldsValid && scenarioValid && additionalConditions
    );
  }
  private hasRequiredTlePrefetchFields(): boolean {
    const isValid = (value: any): boolean => {
      return value !== null && value !== undefined && value !== '';
    };

    const requiredPrefetchFields = [
      this.selectedTleLocation,
      this.formGroup?.get('project')?.value,
      this.formGroup?.get('taskname')?.value,
      this.taskStrategy,
      this.formGroup?.get('purpose')?.value,
      this.formGroup?.get('intent')?.value,
    ];

    return requiredPrefetchFields.every((field) => isValid(field));
  }
  get isTleTrackingEnabled(): boolean {
    const isValid = (value: any): boolean => {
      return value !== null && value !== undefined && value !== '';
    };

    const scenario = this.tleSensorForm?.get('scenario')?.value;
    const minutesAhead = Number(this.tleSensorForm?.get('minutesAhead')?.value);
    const startTimeValid = isValid(this.formGroup?.get('startTime')?.value);
    const endTimeValid = isValid(this.formGroup?.get('endTime')?.value);

    const scenarioValid =
      scenario === 'T-Mins Ahead'
        ? Number.isFinite(minutesAhead) &&
          minutesAhead >= 90 &&
          minutesAhead <= this.tleMaxMinutesAhead
        : scenario === 'Predicted (TOI)'
        ? !!this.range?.value?.start &&
          !!this.range?.value?.end &&
          startTimeValid &&
          endTimeValid &&
          !this.isPast &&
          !this.tleLeadTimeError &&
          !this.tleRangeError &&
          !this.tleStartRangeError
          && !this.tleToiError
        : false;

    return (
      this.hasRequiredTlePrefetchFields() &&
      scenarioValid &&
      !this.showtleDisabled
    );
  }
  clearTLEOnly(): void {
    this.satTrackingClicked = false;
    this.nearestTlePassTimestamp = null;
    this.tleAvailablePasses = [];
    this.tleSelectedPasses = [];
    this.tlePreviewOnlyMode = false;
    this.tleNearestFallbackPending = false;
    this.clearTleNearestFallbackPreviewContext();
    this.clearTleTargetHoverTooltip();
    this.clearSatelliteFetchState();

    if (!this.map) return;
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
      this.satLayer = null;
    }
  }

  private clearTleDateRangeState(clearSelectedRange: boolean = false): void {
    this.minDate = null;
    this.maxDate = null;
    this.tleRangeError = false;
    this.tleStartRangeError = false;
    this.tleToiError = false;
    this.showtleClick = false;
    this.showtleDisabled = false;

    if (!clearSelectedRange) {
      return;
    }

    this.date = new FormControl(null);
    this.range = new FormGroup({
      start: new FormControl(null),
      end: new FormControl(null),
    });
    this.target.openWindow = null;
    this.target.closeWindow = null;
    this.formGroup.get('startTime')?.setValue(null);
    this.formGroup.get('endTime')?.setValue(null);
    this.budgetForm.get('startTime')?.setValue(null);
    this.budgetForm.get('endTime')?.setValue(null);
    this.changeDetectionToiRangeError = false;
    this.lastChangeDetectionToiWarningKey = null;
  }
  calculateObservation(data) {
    this.target.geoJSONCue = this.utilsService.getGeoJsonData(data);
    if (!this.checkObservationInsideMap()) {
      return false;
    }
    this.setObservationValues(data);
    return true;
  }

  setObservationValues(data) {
    let geoJsonType = this.target.geoJSONCue.includes('POINT')
      ? 'Point'
      : 'Polygon';
    this.target.observationTypeCue = geoJsonType;
    if (geoJsonType === 'Point') {
      this.target.areaCue = 0;
    } else {
      const points: [number, number][] = data
        .split(';')
        .map((item) => item.split(',').map(Number) as [number, number]);
      let areaCue = this.utilsService.calculateAreaUsingTurf(points);
      this.target.areaCue = (areaCue / 1e6).toFixed(2);
    }
  }

  checkObservationInsideMap(): boolean {
    let observationCoordinate = '';
    let mapCoordinate = '';
    if (this.target.geoJSON.includes('POINT'))
      mapCoordinate = geoParse(this.target.geoJSON).coordinates;
    else mapCoordinate = geoParse(this.target.geoJSON).coordinates[0];

    if (this.target.geoJSONCue.includes('POINT'))
      observationCoordinate = geoParse(this.target.geoJSONCue).coordinates;
    else
      observationCoordinate = geoParse(this.target.geoJSONCue).coordinates[0];

     if (this.target.geoJSONCue.includes('POINT')) {
      // observation in POI
        // map is AOI
        return true;
    } else {
      //observation is AOI
      if (
        this.target.geoJSON.includes('POINT') &&
        this.utilsService.pointAllInPolygon(
          mapCoordinate,
          observationCoordinate
        )
      ) {
        //map is POI
        return true;
      } else if (
        this.utilsService.comparePolygons(observationCoordinate, mapCoordinate)
      ) {
        //map is AOI
        return true;
      }
    }
    return false;
  }

  resetControlsBelow(controlName: string) {
    if (this.selectedCategory === STRINGCONSTANTS.NON_IMAGING_SENSOR) {
      if (
        this.target.geoJSON?.includes('POINT') &&
        this.target.geoJSON?.match(/POINT/g).length > 0
      )
        return;
      const startIndex = this.controlOrder.indexOf(controlName);
      if (startIndex === -1) return;

      for (let i = startIndex + 1; i < this.controlOrder.length; i++) {
        const ctrl = this.budgetForm.get(this.controlOrder[i]);
        if (ctrl) {
          ctrl.setValue(null, { emitEvent: false });
        }
      }
    }
  }

  keepOpen(event: Event) {
    event.stopPropagation(); // Prevent select from closing
  }

  onSignalToggle(option: any, event: MatCheckboxChange) {
    if (event.checked) {
      // Add
      if (!this.selectedSignals.includes(option)) {
        this.selectedSignals.push(option);
      }

      if (!this.checkSelection()) {
        // Selection rule failed → revert
        this.selectedSignals = this.selectedSignals.filter((o) => o !== option);
        event.source.checked = false;
        return;
      }
    } else {
      // Remove
      this.selectedSignals = this.selectedSignals.filter((o) => o !== option);
      this.audioSelections = this.audioSelections.filter((a) => a !== option);
    }

    this.updateDisplay(event.checked);
  }

  uncheckSignal(option: any, event: MatCheckboxChange) {
    event.source.checked = !event.source.checked;
    this.selectedSignals = this.selectedSignals.filter((o) => o !== option);
    this.audioSelections = this.audioSelections.filter((a) => a !== option);
  }

  onAudioToggle(option: any, event: any) {
    option.audioChecked = event.checked;
    if (event.checked) {
      this.audioSelections.push(option);
    } else {
      this.audioSelections = this.audioSelections.filter((a) => a !== option);
    }
    this.updateDisplay(event.checked); // refresh trigger text
  }

  getSelectedDisplay(): string {
    const result = this.selectedSignals
      .map((opt) => {
        const hasAudio = this.audioSelections.includes(opt);
        return hasAudio ? `${opt.value} (Audio)` : opt.value;
      })
      .join(', ');
    this.selectedDisplay = result;
    this.cdr.detectChanges();
    return result;
  }
  updateDisplay(isOpen: boolean) {
    this.selectedDisplay = this.getSelectedDisplay();
    const control = this.budgetForm.get('rfSignals');
    if (control) {
      control.setValue(this.selectedSignals, { emitEvent: false });
      control.markAsTouched();
    }
    this.budgetForm.get('rfSignals')?.setValue(this.selectedSignals);
    if (isOpen) {
      this.keepRfSignalSelectOpen();
    }
  }

  showRfSignals(): boolean {
    let showRF =
      this.selectedCategory === this.nonImagingSensor &&
      this.budgetForm.get('sensorType')?.value?.sensor === this.rfType;
    if (showRF) {
      this.generateRFCollections();
    }
    return showRF;
  }

  resetRfSignals() {
    this.selectedDisplay = '';
    this.selectedSignals = [];
    this.budgetForm.patchValue({
      rfSignals: [],
      rawIQData: false,
    });
  }

  checkSelection(): boolean {
    let selectedSignals = this.selectedSignals.filter((sensor) => {
      return (
        Array.isArray(sensor.collection_duration) &&
        sensor.collection_duration.length > 0
      );
    });

    // Define categories
    const gps = ['GPS L1', 'GPS L2', 'GPS L5'];
    const vhf = ['VHF'];
    const uhf = ['UHF'];
    const lBand = ['L-band (ADS-B)', 'L-band (GNSS)', 'L-band (SATCOM)'];
    const sBand = ['S-band'];
    // Separate signals into categories
    const selectedGPS = selectedSignals.filter((s) => gps.includes(s.value));
    const selectedVHF = selectedSignals.filter((s) => vhf.includes(s.value));
    const selectedUHF = selectedSignals.filter((s) => uhf.includes(s.value));
    const selectedLBand = selectedSignals.filter((s) =>
      lBand.includes(s.value)
    );
    const selectedsBand = selectedSignals.filter((s) =>
      sBand.includes(s.value)
    );
    // Rule: Only one GPS signal can be selected at a time
    if (selectedGPS.length > 1) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
      //this.selectedSignals = this.selectedSignals.filter(o => o !== option);
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    if (selectedSignals.length > 1 && selectedsBand.length > 0) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                  L-Band, charged individually, for the same price in a single task. You can
                  request all the other signals individually.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    // Check for invalid combinations
    if (selectedGPS.length > 0) {
      if (selectedSignals.length > selectedGPS.length) {
        const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        // this.selectedSignals = this.selectedSignals.filter(o => o !== option);
        return false;
      }
    } else {
      // Validate non-GPS selections
      if (selectedVHF.length + selectedUHF.length + selectedLBand.length > 3) {
        const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return false;
      }
      if (
        selectedVHF.length > 1 ||
        selectedUHF.length > 1 ||
        selectedLBand.length > 1
      ) {
        const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return false;
      }
    }
    return true;
  }

  generateRFCollections() {
    this.RFCollections = Array.from(
      { length: this.maxRFCollection - this.minRFCollection + 1 },
      (_, i) => this.minRFCollection + i
    );
  }

  isBroRF() {
    this.isBroRFSelected =
      this.budgetInputs?.rfSignals &&
      this.budgetInputs?.rfSignals?.some((item) =>
        item.value.includes('S-band, X-band')
      );
    return this.isBroRFSelected;
  }

  private keepRfSignalSelectOpen() {
    if (!this.signalSelect || this.rfSignalSelectOriginalClose) {
      return;
    }

    this.rfSignalSelectOriginalClose = this.signalSelect.close;
    this.signalSelect.close = () => {};
  }

  closeRfSignalSelect(event: Event): void {
    event.stopPropagation(); // Prevent propagation
    this.restoreRfSignalSelectClose();
    this.signalSelect?.close();
  }

  private restoreRfSignalSelectClose() {
    if (this.signalSelect && this.rfSignalSelectOriginalClose) {
      this.signalSelect.close = this.rfSignalSelectOriginalClose;
      this.rfSignalSelectOriginalClose = null;
    }
  }

  navigateToDashboard() {
    this.router.navigate(['/task']);
  }

  resetCategory() {
    this.selectedCategory = this.imagingSensor;
    this.updateFrequencyOption = false;
    this.budgetSensorType = [];
    this.resetForm(this.selectedCategory);
    this.disableEnableDrawControls(true, 'reset');
    this.showResolution = this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
  }

  displayBudgetPopup(event: any) {
    if (this.budgetForm?.value?.sensorType.sensor === 'HSI') {
      if (event.value.key === '5.3m') {
        const message = `
        <ol>
          <li>The task needs to be an area of interest (AOI). Please draw a polygon.</li>
          <li>Each side of the polygon must be at least 5 km.</li>
          <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
          <li>The start of the time of interest (TOI) must be at least three days after the submission date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
      } else if (
        event.value.key === '10m' &&
        this.budgetForm?.value?.sensorType.sensor === 'HSI'
      ) {
        const message = `
        <ol>
          <li> The sensor does not have cloud cover and holdback selection options.</li>
          <li> The start of the time of interest (TOI) must be at least three days after the submission date and the end date is within 14 days from the submission date.</li>
        </ol>`;
        this.popupService.openPopup(
          WarningPopup,
          message,
          'orderedWarning',
          '50%'
        );
      }
    }
  }

  hasFeature(key: string): boolean {
    return this.currentUser?.planDetails?.features?.some(
      (feature) => feature.key === key
    );
  }

  filterInsights(value: string | QuestionItem | null) {
    const searchText =
      typeof value === 'string' ? value : value?.question || '';

    const val = searchText.toLowerCase();

    this.filteredInsights = this.questionsData.filter((question) =>
      question.question.toLowerCase().includes(val)
    );
  }

  clearSelectedQuestion() {
    const searchControl = this.formGroup.get('searchControl');

    searchControl?.reset('');
    searchControl?.markAsUntouched();
    searchControl?.markAsPristine();
    this.filteredInsights = [...this.questionsData];
  }

  updateQuestionValidator() {
    const control = this.formGroup.get('searchControl');
    control?.setValidators([allowedValueValidator(this.questionsData)]);
    control?.updateValueAndValidity();
  }

  loadInsightsList() {
    this.apiService
      .getQuestionList(this.currentUser.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: QuestionsData) => {
          this.questionsData = res.questions;
          this.insightsList = (res?.questions || []).map(
            (question) => question.question
          );
          this.filteredInsights = this.questionsData;
          this.updateQuestionValidator();
        },
        error: () => {
          this.insightsList = [];
          this.filteredInsights = [];
        },
      });
  }

  get sortedFrequencyOptions() {
    return [...this.frequencyOption].sort(
      (a, b) => DISPLAYORDER.indexOf(a.name) - DISPLAYORDER.indexOf(b.name)
    );
  }

  private canUseFortnightlyRecurrence(): boolean {
    return (
      this.taskStrategy === 'User Initiated' ||
      this.taskStrategy === 'Sensor Type Based' ||
      this.taskStrategy === 'Help Select Sensor(s)'
    );
  }

  private isFortnightlySelected(): boolean {
    return this.target?.selectedOption === 1 && this.target?.freqOption === 'Fortnightly';
  }

  get changeDetectionToiRangeMessage(): string {
    return `Change Detection ${this.getChangeDetectionRepeatName().toLowerCase()} recurrence requires a minimum time of interest (TOI) of ${this.getChangeDetectionMinimumToiLabel()}.`;
  }

  get changeDetectionInlineToiRangeMessage(): string {
    return `The selected time of interest (TOI) must be at least ${this.getChangeDetectionInlineMinimumToiLabel()}.`;
  }

  private getSelectedToiDurationInDays(): number {
    const start = this.range?.value?.start ? new Date(this.range.value.start) : null;
    const end = this.range?.value?.end ? new Date(this.range.value.end) : null;

    if (!start || !end) {
      return 0;
    }

    return Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  }

  private updateFortnightlyRangeError(): void {
    this.fortnightlyRangeError =
      !this.isChangeDetectionStrategy() &&
      this.isFortnightlySelected() &&
      this.getSelectedToiDurationInDays() < 14;
  }

  private updateChangeDetectionToiRangeError(showPopup: boolean = false): void {
    const start = this.range?.value?.start;
    const end = this.range?.value?.end;
    const isDateRangeOption = this.selectedOption === 1 || this.selectedOption === 2;

    this.changeDetectionToiRangeError =
      this.isChangeDetectionStrategy() &&
      isDateRangeOption &&
      !!start &&
      !!end &&
      !this.isChangeDetectionToiRangeValid(new Date(start), new Date(end));

    if (!this.changeDetectionToiRangeError) {
      this.lastChangeDetectionToiWarningKey = null;
      return;
    }

    const warningKey = `${this.getChangeDetectionRepeatName()}_${new Date(start).getTime()}_${new Date(end).getTime()}`;
    if (!showPopup || this.lastChangeDetectionToiWarningKey === warningKey) {
      return;
    }

    this.lastChangeDetectionToiWarningKey = warningKey;
    this.popupService.openPopup(
      CollectionPopupComponent,
      this.changeDetectionToiRangeMessage,
      '',
      '40%'
    );
  }

  private isChangeDetectionToiRangeValid(start: Date, end: Date): boolean {
    const minimumEndDate = this.getChangeDetectionMinimumEndDate(start);

    return !!minimumEndDate && this.startOfDay(end).getTime() >= minimumEndDate.getTime();
  }

  private getChangeDetectionMinimumEndDate(start: Date): Date | null {
    if (Number.isNaN(start.getTime())) {
      return null;
    }

    const normalizedStart = this.startOfDay(start);
    switch (this.getChangeDetectionRepeatName()) {
      case 'Weekly':
        return this.addDays(normalizedStart, 14);
      case 'Fortnightly':
        return this.addMonths(normalizedStart, 1);
      case 'Monthly':
        return this.addMonths(normalizedStart, 2);
      default:
        return null;
    }
  }

  private getChangeDetectionRepeatName(): string {
    return ['Weekly', 'Fortnightly', 'Monthly'].includes(this.target?.freqOption)
      ? this.target.freqOption
      : this.getDefaultChangeDetectionRepeatOption().name;
  }

  private getChangeDetectionMinimumToiLabel(): string {
    switch (this.getChangeDetectionRepeatName()) {
      case 'Fortnightly':
        return '1 month';
      case 'Monthly':
        return '2 months';
      case 'Weekly':
      default:
        return '14 days';
    }
  }

  private getChangeDetectionInlineMinimumToiLabel(): string {
    switch (this.getChangeDetectionRepeatName()) {
      case 'Fortnightly':
        return '1 month';
      case 'Monthly':
        return '2 months';
      case 'Weekly':
      default:
        return '2 weeks';
    }
  }

  private startOfDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private addDays(date: Date, days: number): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  }

  private addMonths(date: Date, months: number): Date {
    const result = new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
    if (result.getDate() !== date.getDate()) {
      result.setDate(0);
    }
    return this.startOfDay(result);
  }

  private clearUnsupportedFortnightlySelection(): void {
    if (this.target?.freqOption !== 'Fortnightly' || this.canUseFortnightlyRecurrence()) {
      this.updateFortnightlyRangeError();
      return;
    }

    this.target.freqOption = 'Daily';
    this.target.repeatOption = 1;
    this.subDaily = false;
    this.recurrentDays = false;
    this.target.subDailyCount = '';
    this.target.recurringDays = [];
    this.fortnightlyRangeError = false;
  }

  private getFrequencyOption(value: number | string | null | undefined) {
    return this.frequencyOption.find(
      (option) => option.id === value || option.name === value
    );
  }

  private applyChangeDetectionFrequencyDefaults(): void {
    const recurrentOption = this.getFrequencyOption('Recurrent');
    const repeatOption = this.isRepeatOptionDisabled({ name: this.target?.freqOption })
      ? this.getDefaultChangeDetectionRepeatOption()
      : this.TASKFREQUENCY?.find((option: any) => option.name === this.target?.freqOption) ||
        this.getDefaultChangeDetectionRepeatOption();

    this.selectedFrequencyID = recurrentOption?.id ?? 1;
    this.selectedOption = recurrentOption?.id ?? 1;
    this.clickFrequency = true;
    this.subDaily = false;
    this.recurrentDays = false;
    this.target.selectedOption = this.selectedOption;
    this.target.freqOption = repeatOption.name;
    this.target.repeatOption = repeatOption.value;
    this.target.subDailyCount = '';
    this.target.recurringDays = [];
    this.formGroup.get('frequency')?.setValue('Recurrent', { emitEvent: false });
    this.budgetForm.get('frequency')?.setValue('Recurrent', { emitEvent: false });
    this.applyChangeDetectionDateRangeDefaults();
    this.syncSpecificDayValidators();
  }

  private applyChangeDetectionDateRangeDefaults(): void {
    const start = this.range?.value?.start ? new Date(this.range.value.start) : null;
    const end = this.range?.value?.end ? new Date(this.range.value.end) : null;
    const hasValidChangeDetectionRange =
      !!start &&
      !!end &&
      !Number.isNaN(start.getTime()) &&
      !Number.isNaN(end.getTime()) &&
      this.isChangeDetectionToiRangeValid(start, end);

    if (hasValidChangeDetectionRange) {
      return;
    }

    const today = new Date();
    const defaultStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1
    );
    const defaultEnd =
      this.getChangeDetectionMinimumEndDate(defaultStart) ??
      new Date(
        defaultStart.getFullYear(),
        defaultStart.getMonth(),
        defaultStart.getDate() + 14
      );

    this.date = new FormControl(defaultStart);
    this.range = new FormGroup({
      start: new FormControl(defaultStart),
      end: new FormControl(defaultEnd),
    });
    this.target.openWindow = defaultStart;
    this.target.closeWindow = defaultEnd;
    this.changeDetectionToiRangeError = false;
    this.lastChangeDetectionToiWarningKey = null;
  }

  private syncSpecificDayValidators(): void {
    const isSpecificDayRequired =
      this.selectedOption === 3 && !this.isChangeDetectionStrategy();

    [this.formGroup.get('specificDay'), this.budgetForm.get('specificDay')].forEach(
      (control) => {
        if (isSpecificDayRequired) {
          control?.setValidators([Validators.required]);
        } else {
          control?.clearValidators();
          control?.setValue(null, { emitEvent: false });
        }

        control?.updateValueAndValidity({ emitEvent: false });
      }
    );
  }

  isFrequencyOptionDisabled(optionName: string): boolean {
    const frequencyOption = this.getFrequencyOption(optionName);

    if (this.isChangeDetectionStrategy() && optionName !== 'Recurrent') {
      return true;
    }

    if (
      (this.taskStrategy === 'Tip-and-Cue' ||
        this.taskStrategy === 'Outcome By Platform') &&
      optionName === 'Recurrent'
    ) {
      return true;
    }

    if (
      this.taskStrategy === 'AIS Included' &&
      ['Specific Date', 'Specific Day', 'Recurrent'].includes(optionName)
    ) {
      return true;
    }

    if (this.isFeedTask && frequencyOption?.id === 1) {
      return true;
    }

    return false;
  }

  isCloudCoverEligible(cloudCover: unknown): boolean {
    return typeof cloudCover === 'number' && Number.isFinite(cloudCover) && cloudCover < 20;
  }

  isDateEligible(date: Date | null): boolean {
    if (!date || this.cloudCoverLoading || this.cloudCoverLoadError) return false;
    const key = moment(date).format('YYYY-MM-DD');
    const today = moment.utc().format('YYYY-MM-DD');
    if (key < today || key > moment.utc().add(environment.cloudCoverForecastDays, 'days').format('YYYY-MM-DD')) return false;
    return this.isCloudCoverEligible(this.cloudCoverByDate.get(key)?.cloudcover);
  }

  get cloudCoverMessage(): string {
    if (!this.target?.geoJSON) return '';
    if (this.cloudCoverLoading) return 'Loading cloud cover data…';
    if (this.cloudCoverLoadError) return 'Unable to retrieve cloud cover data. Please try again.';
    return '';
  }

  loadCloudCoverEligibility(retry = false): void {
    const activeForm = this.budget ? this.budgetForm : this.formGroup;
    const frequency = this.getFrequencyOption(activeForm?.get?.('frequency')?.value);
    if ((!this.budget && this.taskStrategy === 'TLE Based Tasking') ||
      (frequency?.id !== 0 && frequency?.id !== 3)) {
      // Map changes and the timer must not fetch forecasts for other frequencies.
      // Detach the aggregate so queued targets cannot start new requests.
      this.cloudCoverSubscription?.unsubscribe();
      this.cloudCoverRequestKey = '';
      this.cloudCoverByDate.clear();
      this.eligibleWeekDays.clear();
      this.cloudCoverLoading = false;
      this.cloudCoverLoadError = false;
      this.refreshCloudCoverCalendar();
      return;
    }
    const start = moment.utc().startOf('day');
    const end = start.clone().add(environment.cloudCoverForecastDays, 'days');
    const target = this.target?.geoJSON || '';
    const key = JSON.stringify([start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), target, this.target?.multiTarget || []]);
    if (!retry && key === this.cloudCoverRequestKey) return;
    this.cloudCoverSubscription?.unsubscribe();
    this.cloudCoverRequestKey = key;
    this.cloudCoverByDate.clear();
    this.eligibleWeekDays.clear();
    this.cloudCoverLoadError = false;
    this.cloudCoverLoading = false;
    this.setUTCTodayDate();
    if (!target) {
      this.refreshCloudCoverCalendar();
      return;
    }
    let geometries: any[];
    try { geometries = this.getCloudCoverGeometries(target); } catch {
      this.cloudCoverLoadError = true;
      this.refreshCloudCoverCalendar();
      return;
    }
    this.cloudCoverLoading = true;
    this.refreshCloudCoverCalendar();
    this.cloudCoverSubscription = from(geometries).pipe(
      mergeMap((geometry) => this.getCachedCloudCoverForecast(geometry, start, end), 4),
      // Publish only after every target succeeds; cancellation cannot publish a partial set.
      toArray(),
      takeUntil(this.destroy$),
    ).subscribe({
      next: (forecasts) => {
        this.cloudCoverByDate = this.combineCloudCoverForecasts(forecasts);
        // Use the same current-week date as Specific Day scheduling.
        // A forecast for the same weekday in a later week must not add an icon.
        this.specificDayOptions.forEach((day, dayIndex) => {
          const dateKey = moment(this.getDateFromDay(day)).format('YYYY-MM-DD');
          if (this.isCloudCoverEligible(this.cloudCoverByDate.get(dateKey)?.cloudcover)) {
            this.eligibleWeekDays.add(dayIndex);
          }
        });
        this.cloudCoverLoading = false;
        this.refreshCloudCoverCalendar();
      },
      error: () => this.handleCloudCoverError(),
    });
  }

  private getCachedCloudCoverForecast(
    geometry: any, start: moment.Moment, end: moment.Moment,
  ): Observable<Map<string, CloudCoverItem>> {
    const sensorData = {
      target: JSON.stringify(geometry),
      openWindow: start.format(),
      closeWindow: end.clone().endOf('day').format(),
      type: 'hours',
    };
    const key = JSON.stringify(sensorData);
    let forecast = this.cloudCoverForecastCache.get(key);
    if (!forecast) {
      forecast = this.apiService.getCloudCoverData({ sensorData }).pipe(
        map((response) => this.normalizeCloudCoverResponse(response, start, end)),
        catchError((error) => {
          // Retry only failed targets; retain successful forecasts for the others.
          this.cloudCoverForecastCache.delete(key);
          throw error;
        }),
        takeUntil(this.destroy$),
        // Target changes reuse even an in-flight request without cancelling it.
        shareReplay({ bufferSize: 1, refCount: false }),
      );
      this.cloudCoverForecastCache.set(key, forecast);
    }
    return forecast;
  }

  private getCloudCoverGeometries(target: string): any[] {
    let geometries: any[];
    const multiplePoints = this.target?.multiTarget;
    if (/^\s*POINT\b/i.test(target) && Array.isArray(multiplePoints) && multiplePoints.length > 1) {
      geometries = multiplePoints.map((point: string) => geoParse(point));
    } else if (this.countPoints(target) > 1) {
      geometries = this.geoParsePoint(target);
      if (geometries.length !== this.countPoints(target)) throw new Error('Invalid point target');
    } else {
      const geometry = geoParse(target);
      if (!geometry) throw new Error('Invalid target');
      if (geometry.type !== 'MultiPoint') return [geometry];
      geometries = geometry.coordinates.map((coordinates: number[]) => ({ type: 'Point', coordinates }));
    }
    if (!geometries.length || geometries.some((geometry) =>
      geometry?.type !== 'Point' || !Array.isArray(geometry.coordinates) ||
      geometry.coordinates.length < 2 ||
      !geometry.coordinates.every((coordinate: unknown) => typeof coordinate === 'number' && Number.isFinite(coordinate))
    )) throw new Error('Invalid point target');
    return geometries;
  }

  private normalizeCloudCoverResponse(
    response: any, start: moment.Moment, end: moment.Moment,
  ): Map<string, CloudCoverItem> {
    if (!Array.isArray(response?.result)) throw new Error('Invalid cloud cover response');
    const forecast = new Map<string, CloudCoverItem>();
    const hoursByDate = new Map<string, Map<number, number>>();
    const invalidDates = new Set<string>();
    for (const item of response.result as HourlyCloudCoverItem[]) {
      // These are target-local calendar labels, not instants to convert to browser time.
      const date = moment.utc(item?.datetime, 'YYYY-MM-DD', true);
      if (!date.isValid() || date.isBefore(start, 'day') || date.isAfter(end, 'day')) continue;
      const key = date.format('YYYY-MM-DD');
      const time = typeof item.time === 'string'
        ? /^(0?[1-9]|1[0-2]):00 (AM|PM)$/.exec(item.time.trim()) : null;
      if (!time) {
        invalidDates.add(key);
        continue;
      }
      const hour = Number(time[1]) % 12 + (time[2] === 'PM' ? 12 : 0);
      if (hour < 6 || hour > 18) continue;
      if (typeof item.cloudcover !== 'number' || !Number.isFinite(item.cloudcover) ||
        item.cloudcover < 0 || item.cloudcover > 100) {
        invalidDates.add(key);
        continue;
      }
      const hours = hoursByDate.get(key) || new Map<number, number>();
      hours.set(hour, Math.max(hours.get(hour) ?? 0, item.cloudcover));
      hoursByDate.set(key, hours);
    }
    hoursByDate.forEach((hours, date) => {
      // Require all 13 hourly readings, including noon and 6 PM.
      if (!invalidDates.has(date) && hours.size === 13) {
        forecast.set(date, { date, cloudcover: Math.max(...hours.values()) });
      }
    });
    return forecast;
  }

  private combineCloudCoverForecasts(forecasts: Map<string, CloudCoverItem>[]): Map<string, CloudCoverItem> {
    const combined = new Map<string, CloudCoverItem>();
    forecasts[0]?.forEach((firstItem, date) => {
      let maximum = firstItem;
      for (const forecast of forecasts.slice(1)) {
        const item = forecast.get(date);
        if (!item) return;
        if (item.cloudcover > maximum.cloudcover) maximum = item;
      }
      combined.set(date, maximum);
    });
    return combined;
  }

  private handleCloudCoverError(): void {
    this.cloudCoverLoading = false;
    this.cloudCoverLoadError = true;
    this.refreshCloudCoverCalendar();
    this.popupService.openPopup(WarningPopup,
      'Unable to retrieve cloud cover data. Please try again.',
      'orderedWarning', '50%', 'Ok, Thanks');
  }

  private refreshCloudCoverCalendar(): void {
    this.cloudCoverDateClass = (date: Date, view: string) => this.getCloudCoverDateClass(date, view);
  }

  getCloudCoverDateClass(date: Date, view: string): string {
    if (!this.target?.geoJSON) return '';
    if (view !== 'month' || this.cloudCoverLoading || this.cloudCoverLoadError) return '';
    if (!this.cloudCoverByDate.has(moment(date).format('YYYY-MM-DD'))) return '';
    return this.isDateEligible(date) ? 'task-cloud-eligible' : '';
  }

  isSpecificDayDisabled(day: string): boolean {
    if (!this.todayDate) {
      return true;
    }

    return this.specificDayOptions.indexOf(day) <= this.todayDate.getDay();
  }

  isSpecificDayUnavailable(): boolean {
    if (!this.todayDate) {
      return false;
    }

    return this.specificDayOptions.every((day) =>
      this.isSpecificDayDisabled(day)
    );
  }

  getDateFromDay(dayName: string): Date {
    const today = this.todayDate ? new Date(this.todayDate) : new Date();
    const todayIndex = today.getDay();
    const diff = this.specificDayOptions.indexOf(dayName) - todayIndex;
    const result = new Date(today);
    result.setDate(today.getDate() + diff);
    result.setHours(0, 0, 0, 0);
    return result;
  }

  onDaysSelect(dayValue: string[]) {
    this.sensorList?.handleToiChangedReactionTimeWarnings();
    this.updateTarget(this.target, '0');
  }
  
  openSensorPreview() {
    this.showPreview = true;
    const url = this.router.url.includes('?') ? `${this.router.url}&preview=true` : `${this.router.url}?preview=true`;
    this.location.replaceState(url);

  }

  closePreview() {
    this.showPreview = false;
    const url = this.router.url.replace('&preview=true', '');
    this.location.replaceState(url);
  }

}
